// Dropdown filter options
export const dateFilterOptions = [
  { label: "Last 3 days", value: "last_3_days" },
  { label: "Last 7 days", value: "last_7_days" },
  { label: "Last 30 days", value: "last_30_days" },
  { label: "Custom", value: "custom" }
];

// Table columns
export const intakeTableColumns = [
  { key: "customer_name", label: "Applicant Name" },
  { key: "lob", label: "Line Of Business" },
  { key: "agent_name", label: "Agent" },
  {
    key: "application_classification",
    label: "Classification"
  },
  { key: "application_status", label: "Status" },
  { key: "priority", label: "Priority" },
  { key: "date", label: "Effective Date" },
  { key: "application_id", label: "Application ID" },
  { key: "dnw_decision", label: "DNW decision" }
];

// excludedKeys
export const excludedKeys = ["company_details"];

export const dateFilterData = {
  selected: "date",
  text: "",
  filterBy: "",
  startDate: null,
  endDate: null
};

export const detailsKeywords = ["summary", "snapshot"];

export const lobMap = {
  property: "Property",
  casualty: "Casualty",
  workers_compensation: "Workers Compensation",
  business_auto: "Business Auto",
  health: "Health",
  general_liability: "General Liability",
  professional_liability: "Professional Liability",
  crime: "Crime",
  umbrella: "Umbrella"
};

//   doc_id: 4388,
//   coordinates: {
//     document_info: {
//       total_pages: 21
//     },
//     pages: [
//       {
//         page_number: 1,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "04/04/2025",
//               coordinates: {
//                 x: 532.9550170898438,
//                 y: 43.188751220703125,
//                 width: 36.2645263671875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   532.9550170898438, 43.188751220703125, 569.2195434570312,
//                   51.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "UIS Insurance & Investments",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 67.18875122070312,
//                 width: 93.81499099731445,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 67.18875122070312, 116.614990234375,
//                   75.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "990 W Poe Road, Suite 11",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 79.18875122070312,
//                 width: 85.23098373413086,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 79.18875122070312, 108.0309829711914,
//                   87.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "Bowling Green",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 103.18875122070312,
//                 width: 47.52376174926758,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 103.18875122070312, 70.32376098632812,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "OH 43402",
//               coordinates: {
//                 x: 241.46249389648438,
//                 y: 103.18875122070312,
//                 width: 35.492523193359375,
//                 height: 8.098251342773438,
//                 bbox: [
//                   241.46249389648438, 103.18875122070312, 276.95501708984375,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "Rachel Strausbaugh",
//               coordinates: {
//                 x: 55.20000076293945,
//                 y: 127.18875122070312,
//                 width: 65.66322708129883,
//                 height: 8.098251342773438,
//                 bbox: [
//                   55.20000076293945, 127.18875122070312, 120.86322784423828,
//                   135.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "(419) 806-4770 1727",
//               coordinates: {
//                 x: 69.5999984741211,
//                 y: 139.18875122070312,
//                 width: 67.69324493408203,
//                 height: 8.098251342773438,
//                 bbox: [
//                   69.5999984741211, 139.18875122070312, 137.29324340820312,
//                   147.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "rstrausbaugh@uisprotect.com",
//               coordinates: {
//                 x: 58.79999923706055,
//                 y: 163.18875122070312,
//                 width: 96.7802619934082,
//                 height: 8.098251342773438,
//                 bbox: [
//                   58.79999923706055, 163.18875122070312, 155.58026123046875,
//                   171.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 98.4000015258789,
//                 y: 187.18875122070312,
//                 width: 32.24799346923828,
//                 height: 8.098251342773438,
//                 bbox: [
//                   98.4000015258789, 187.18875122070312, 130.6479949951172,
//                   195.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "Submissions",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 67.18875122070312,
//                 width: 41.08575439453125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 67.18875122070312, 351.8857421875,
//                   75.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "25-26",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 115.18875122070312,
//                 width: 18.53826904296875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 115.18875122070312, 329.3382568359375,
//                   123.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "05/18/2025",
//               coordinates: {
//                 x: 439.3550109863281,
//                 y: 187.18875122070312,
//                 width: 36.2645263671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   439.3550109863281, 187.18875122070312, 475.6195373535156,
//                   195.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "12:01",
//               coordinates: {
//                 x: 509.62750244140625,
//                 y: 187.18875122070312,
//                 width: 18.13226318359375,
//                 height: 8.098251342773438,
//                 bbox: [
//                   509.62750244140625, 187.18875122070312, 527.759765625,
//                   195.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "05/18/2025",
//               coordinates: {
//                 x: 34.35499954223633,
//                 y: 463.1887512207031,
//                 width: 36.2645149230957,
//                 height: 8.098236083984375,
//                 bbox: [
//                   34.35499954223633, 463.1887512207031, 70.61951446533203,
//                   471.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "05/18/2026",
//               coordinates: {
//                 x: 104.55500030517578,
//                 y: 463.1887512207031,
//                 width: 36.264503479003906,
//                 height: 8.098236083984375,
//                 bbox: [
//                   104.55500030517578, 463.1887512207031, 140.8195037841797,
//                   471.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "0.00",
//               coordinates: {
//                 x: 544.7999877929688,
//                 y: 463.1887512207031,
//                 width: 14.10125732421875,
//                 height: 8.098236083984375,
//                 bbox: [
//                   544.7999877929688, 463.1887512207031, 558.9012451171875,
//                   471.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "Buckeye Premier Cleaning, LLC",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 505.1887512207031,
//                 width: 103.10222244262695,
//                 height: 8.098236083984375,
//                 bbox: [
//                   22.799999237060547, 505.1887512207031, 125.9022216796875,
//                   513.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "8484 Huffman  Rd",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 517.188720703125,
//                 width: 58.666996002197266,
//                 height: 8.0982666015625,
//                 bbox: [
//                   22.799999237060547, 517.188720703125, 81.46699523925781,
//                   525.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "Cygnet",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 541.188720703125,
//                 width: 22.960758209228516,
//                 height: 8.0982666015625,
//                 bbox: [
//                   22.799999237060547, 541.188720703125, 45.76075744628906,
//                   549.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "OH 43413",
//               coordinates: {
//                 x: 241.46249389648438,
//                 y: 541.188720703125,
//                 width: 35.492523193359375,
//                 height: 8.0982666015625,
//                 bbox: [
//                   241.46249389648438, 541.188720703125, 276.95501708984375,
//                   549.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "4193083621",
//               coordinates: {
//                 x: 375.6000061035156,
//                 y: 517.188720703125,
//                 width: 40.31005859375,
//                 height: 8.0982666015625,
//                 bbox: [
//                   375.6000061035156, 517.188720703125, 415.9100646972656,
//                   525.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content:
//                 "NAME (Other Named Insured) AND MAILING ADDRESS (including ZIP+4)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 663.1400146484375,
//                 width: 197.92647743225098,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 663.1400146484375, 219.82647705078125,
//                   669.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "NAICS",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 662.5400390625,
//                 width: 17.876708984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 662.5400390625, 471.7767028808594,
//                   668.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "BUSINESS PHONE #:",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 686.5400390625,
//                 width: 58.0921630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   309.8999938964844, 686.5400390625, 367.9921569824219,
//                   692.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "TRUST",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 734.8400268554688,
//                 width: 19.147491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 734.8400268554688, 357.8475036621094,
//                   741.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content: "AND MANAGERS:",
//               coordinates: {
//                 x: 129.89999389648438,
//                 y: 737.239990234375,
//                 width: 48.19648742675781,
//                 height: 6.4227294921875,
//                 bbox: [
//                   129.89999389648438, 737.239990234375, 178.0964813232422,
//                   743.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: 'SUBCHAPTER "S" CORPORATION',
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 722.8400268554688,
//                 width: 92.68984985351562,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 722.8400268554688, 431.3898620605469,
//                   729.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content: "NO. OF MEMBERS",
//               coordinates: {
//                 x: 129.89999389648438,
//                 y: 731.239990234375,
//                 width: 50.421722412109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   129.89999389648438, 731.239990234375, 180.32171630859375,
//                   737.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content: "NOT FOR PROFIT ORG",
//               coordinates: {
//                 x: 241.5,
//                 y: 722.8400268554688,
//                 width: 62.96820068359375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   241.5, 722.8400268554688, 304.46820068359375,
//                   729.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content: "JOINT VENTURE",
//               coordinates: {
//                 x: 111.9000015258789,
//                 y: 722.8400268554688,
//                 width: 45.534263610839844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   111.9000015258789, 722.8400268554688, 157.43426513671875,
//                   729.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content: "CORPORATION",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 722.8400268554688,
//                 width: 42.34299850463867,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 722.8400268554688, 78.64299774169922,
//                   729.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content: "PARTNERSHIP",
//               coordinates: {
//                 x: 241.5,
//                 y: 734.8400268554688,
//                 width: 40.32470703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   241.5, 734.8400268554688, 281.82470703125, 741.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content: "INDIVIDUAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 734.8400268554688,
//                 width: 32.24025344848633,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 734.8400268554688, 68.54025268554688,
//                   741.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content: "LLC",
//               coordinates: {
//                 x: 111.9000015258789,
//                 y: 734.8400268554688,
//                 width: 10.545494079589844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   111.9000015258789, 734.8400268554688, 122.44549560546875,
//                   741.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content: "WEBSITE ADDRESS",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 698.5400390625,
//                 width: 55.636932373046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   309.8999938964844, 698.5400390625, 365.53692626953125,
//                   704.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content: "SIC",
//               coordinates: {
//                 x: 381.8999938964844,
//                 y: 662.5400390625,
//                 width: 9.57373046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   381.8999938964844, 662.5400390625, 391.4737243652344,
//                   668.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content: "GL CODE",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 662.5400390625,
//                 width: 26.064727783203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   309.8999938964844, 662.5400390625, 335.9647216796875,
//                   668.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content: "FEIN OR SOC SEC #",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 662.5400390625,
//                 width: 55.52801513671875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 662.5400390625, 581.4280395507812,
//                   668.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content:
//                 "NAME (Other Named Insured) AND MAILING ADDRESS (including ZIP+4)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 579.1400146484375,
//                 width: 197.92647743225098,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 579.1400146484375, 219.82647705078125,
//                   585.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content: "NAICS",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 578.5400390625,
//                 width: 17.876708984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 578.5400390625, 471.7767028808594,
//                   584.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content: "BUSINESS PHONE #:",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 602.5400390625,
//                 width: 58.0921630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   309.8999938964844, 602.5400390625, 367.9921569824219,
//                   608.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content: "TRUST",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 650.8400268554688,
//                 width: 19.147491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 650.8400268554688, 357.8475036621094,
//                   657.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content: "AND MANAGERS:",
//               coordinates: {
//                 x: 129.89999389648438,
//                 y: 653.239990234375,
//                 width: 48.19648742675781,
//                 height: 6.4227294921875,
//                 bbox: [
//                   129.89999389648438, 653.239990234375, 178.0964813232422,
//                   659.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content: 'SUBCHAPTER "S" CORPORATION',
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 638.8400268554688,
//                 width: 92.68984985351562,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 638.8400268554688, 431.3898620605469,
//                   645.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content: "NO. OF MEMBERS",
//               coordinates: {
//                 x: 129.89999389648438,
//                 y: 647.239990234375,
//                 width: 50.421722412109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   129.89999389648438, 647.239990234375, 180.32171630859375,
//                   653.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content: "NOT FOR PROFIT ORG",
//               coordinates: {
//                 x: 241.5,
//                 y: 638.8400268554688,
//                 width: 62.96820068359375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   241.5, 638.8400268554688, 304.46820068359375,
//                   645.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content: "JOINT VENTURE",
//               coordinates: {
//                 x: 111.9000015258789,
//                 y: 638.8400268554688,
//                 width: 45.534263610839844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   111.9000015258789, 638.8400268554688, 157.43426513671875,
//                   645.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content: "CORPORATION",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 638.8400268554688,
//                 width: 42.34299850463867,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 638.8400268554688, 78.64299774169922,
//                   645.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content: "PARTNERSHIP",
//               coordinates: {
//                 x: 241.5,
//                 y: 650.8400268554688,
//                 width: 40.32470703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   241.5, 650.8400268554688, 281.82470703125, 657.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content: "INDIVIDUAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 650.8400268554688,
//                 width: 32.24025344848633,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 650.8400268554688, 68.54025268554688,
//                   657.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content: "LLC",
//               coordinates: {
//                 x: 111.9000015258789,
//                 y: 650.8400268554688,
//                 width: 10.545494079589844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   111.9000015258789, 650.8400268554688, 122.44549560546875,
//                   657.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content: "WEBSITE ADDRESS",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 614.5400390625,
//                 width: 55.636932373046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   309.8999938964844, 614.5400390625, 365.53692626953125,
//                   620.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 52,
//               type: "text",
//               content: "SIC",
//               coordinates: {
//                 x: 381.8999938964844,
//                 y: 578.5400390625,
//                 width: 9.57373046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   381.8999938964844, 578.5400390625, 391.4737243652344,
//                   584.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 53,
//               type: "text",
//               content: "GL CODE",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 578.5400390625,
//                 width: 26.064727783203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   309.8999938964844, 578.5400390625, 335.9647216796875,
//                   584.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 54,
//               type: "text",
//               content: "FEIN OR SOC SEC #",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 578.5400390625,
//                 width: 55.52801513671875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 578.5400390625, 581.4280395507812,
//                   584.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 55,
//               type: "text",
//               content: "VEHICLE SCHEDULE",
//               coordinates: {
//                 x: 421.5,
//                 y: 356.84002685546875,
//                 width: 57.46539306640625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   421.5, 356.84002685546875, 478.96539306640625,
//                   363.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 56,
//               type: "text",
//               content: "VACANT BUILDING SUPPLEMENT",
//               coordinates: {
//                 x: 421.5,
//                 y: 344.84002685546875,
//                 width: 92.03436279296875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   421.5, 344.84002685546875, 513.5343627929688,
//                   351.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 57,
//               type: "text",
//               content: "STATE SUPPLEMENT (If applicable)",
//               coordinates: {
//                 x: 421.5,
//                 y: 332.84002685546875,
//                 width: 94.17340087890625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   421.5, 332.84002685546875, 515.6734008789062,
//                   339.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 58,
//               type: "text",
//               content: "STATEMENT / SCHEDULE OF VALUES",
//               coordinates: {
//                 x: 421.5,
//                 y: 320.84002685546875,
//                 width: 103.2987060546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   421.5, 320.84002685546875, 524.7987060546875,
//                   327.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 59,
//               type: "text",
//               content: "RESTAURANT / TAVERN SUPPLEMENT",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 428.84002685546875,
//                 width: 106.07020568847656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 428.84002685546875, 336.77020263671875,
//                   435.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 60,
//               type: "text",
//               content: "PROFESSIONAL LIABILITY SUPPLEMENT",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 416.84002685546875,
//                 width: 112.66542053222656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 416.84002685546875, 343.36541748046875,
//                   423.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 61,
//               type: "text",
//               content: "PREMIUM PAYMENT SUPPLEMENT",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 404.84002685546875,
//                 width: 96.07673645019531,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 404.84002685546875, 326.7767333984375,
//                   411.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 62,
//               type: "text",
//               content: "LOSS SUMMARY",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 380.84002685546875,
//                 width: 46.18400573730469,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 380.84002685546875, 276.8840026855469,
//                   387.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 63,
//               type: "text",
//               content: "INTERNATIONAL PROPERTY EXPOSURE SUPPLEMENT",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 368.84002685546875,
//                 width: 152.35191345214844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 368.84002685546875, 383.0519104003906,
//                   375.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 64,
//               type: "text",
//               content: "INTERNATIONAL LIABILITY EXPOSURE SUPPLEMENT",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 356.84002685546875,
//                 width: 147.0273895263672,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 356.84002685546875, 377.7273864746094,
//                   363.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 65,
//               type: "text",
//               content: "ADDITIONAL INTEREST SCHEDULE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 332.84002685546875,
//                 width: 97.03122329711914,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 332.84002685546875, 133.3312225341797,
//                   339.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 66,
//               type: "text",
//               content: "ATTACHMENTS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 308.3799743652344,
//                 width: 57.79174995422363,
//                 height: 8.656768798828125,
//                 bbox: [
//                   21.899999618530273, 308.3799743652344, 79.6917495727539,
//                   317.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 67,
//               type: "text",
//               content: "CONTRACTORS SUPPLEMENT",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 381.44000244140625,
//                 width: 84.80097579956055,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 381.44000244140625, 121.1009750366211,
//                   387.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 68,
//               type: "text",
//               content: "CONDO ASSN BYLAWS (for D&O Coverage only)",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 368.84002685546875,
//                 width: 128.44926834106445,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 368.84002685546875, 164.749267578125,
//                   375.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 69,
//               type: "text",
//               content: "APARTMENT BUILDING SUPPLEMENT",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 356.84002685546875,
//                 width: 104.0577278137207,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 356.84002685546875, 140.35772705078125,
//                   363.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 70,
//               type: "text",
//               content: "ADDITIONAL PREMISES INFORMATION SCHEDULE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 344.84002685546875,
//                 width: 139.7939796447754,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 344.84002685546875, 176.09397888183594,
//                   351.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 71,
//               type: "text",
//               content: "COVERAGES SCHEDULE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 392.84002685546875,
//                 width: 69.27022171020508,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 392.84002685546875, 105.57022094726562,
//                   399.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 72,
//               type: "text",
//               content: "DRIVER INFORMATION SCHEDULE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 416.84002685546875,
//                 width: 95.96747207641602,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 416.84002685546875, 132.26747131347656,
//                   423.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 73,
//               type: "text",
//               content:
//                 "NAME (First Named Insured) AND MAILING ADDRESS (including ZIP+4)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 495.1400146484375,
//                 width: 195.05147743225098,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 495.1400146484375, 216.95147705078125,
//                   501.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 74,
//               type: "text",
//               content: "NAICS",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 494.5400085449219,
//                 width: 17.876708984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 494.5400085449219, 471.7767028808594,
//                   500.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 75,
//               type: "text",
//               content: "BUSINESS PHONE #:",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 518.5400390625,
//                 width: 58.0921630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   309.8999938964844, 518.5400390625, 367.9921569824219,
//                   524.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 76,
//               type: "text",
//               content: "TRUST",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 566.8400268554688,
//                 width: 19.147491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 566.8400268554688, 357.8475036621094,
//                   573.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 77,
//               type: "text",
//               content: "AND MANAGERS:",
//               coordinates: {
//                 x: 129.89999389648438,
//                 y: 569.239990234375,
//                 width: 48.19648742675781,
//                 height: 6.4227294921875,
//                 bbox: [
//                   129.89999389648438, 569.239990234375, 178.0964813232422,
//                   575.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 78,
//               type: "text",
//               content: 'SUBCHAPTER "S" CORPORATION',
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 554.8400268554688,
//                 width: 92.68984985351562,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 554.8400268554688, 431.3898620605469,
//                   561.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 79,
//               type: "text",
//               content: "NO. OF MEMBERS",
//               coordinates: {
//                 x: 129.89999389648438,
//                 y: 563.239990234375,
//                 width: 50.421722412109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   129.89999389648438, 563.239990234375, 180.32171630859375,
//                   569.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 80,
//               type: "text",
//               content: "NOT FOR PROFIT ORG",
//               coordinates: {
//                 x: 241.5,
//                 y: 554.8400268554688,
//                 width: 62.96820068359375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   241.5, 554.8400268554688, 304.46820068359375,
//                   561.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 81,
//               type: "text",
//               content: "JOINT VENTURE",
//               coordinates: {
//                 x: 111.9000015258789,
//                 y: 554.8400268554688,
//                 width: 45.534263610839844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   111.9000015258789, 554.8400268554688, 157.43426513671875,
//                   561.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 82,
//               type: "text",
//               content: "CORPORATION",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 554.8400268554688,
//                 width: 42.34299850463867,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 554.8400268554688, 78.64299774169922,
//                   561.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 83,
//               type: "text",
//               content: "PARTNERSHIP",
//               coordinates: {
//                 x: 241.5,
//                 y: 566.8400268554688,
//                 width: 40.32470703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   241.5, 566.8400268554688, 281.82470703125, 573.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 84,
//               type: "text",
//               content: "INDIVIDUAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 566.8400268554688,
//                 width: 32.24025344848633,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 566.8400268554688, 68.54025268554688,
//                   573.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 85,
//               type: "text",
//               content: "LLC",
//               coordinates: {
//                 x: 111.9000015258789,
//                 y: 566.8400268554688,
//                 width: 10.545494079589844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   111.9000015258789, 566.8400268554688, 122.44549560546875,
//                   573.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 86,
//               type: "text",
//               content: "WEBSITE ADDRESS",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 530.5400390625,
//                 width: 55.636932373046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   309.8999938964844, 530.5400390625, 365.53692626953125,
//                   536.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 87,
//               type: "text",
//               content: "SIC",
//               coordinates: {
//                 x: 381.8999938964844,
//                 y: 494.5400085449219,
//                 width: 9.57373046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   381.8999938964844, 494.5400085449219, 391.4737243652344,
//                   500.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 88,
//               type: "text",
//               content: "GL CODE",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 494.5400085449219,
//                 width: 26.064727783203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   309.8999938964844, 494.5400085449219, 335.9647216796875,
//                   500.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 89,
//               type: "text",
//               content: "FEIN OR SOC SEC #",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 494.5400085449219,
//                 width: 55.52801513671875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 494.5400085449219, 581.4280395507812,
//                   500.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 90,
//               type: "text",
//               content: "ACORD 125 (2016/03)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 745.780029296875,
//                 width: 78.78650093078613,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 745.780029296875, 100.6865005493164,
//                   754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 91,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 536.7000122070312,
//                 y: 464.5400085449219,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   536.7000122070312, 464.5400085449219, 539.8970336914062,
//                   470.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 92,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 479.1000061035156,
//                 y: 464.5400085449219,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   479.1000061035156, 464.5400085449219, 482.2969970703125,
//                   470.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 93,
//               type: "text",
//               content: "METHOD OF PAYMENT",
//               coordinates: {
//                 x: 319.3737487792969,
//                 y: 452.5400085449219,
//                 width: 63.198211669921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   319.3737487792969, 452.5400085449219, 382.57196044921875,
//                   458.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 94,
//               type: "text",
//               content: "PREMIUM",
//               coordinates: {
//                 x: 490.7237548828125,
//                 y: 455.5400085449219,
//                 width: 27.13421630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   490.7237548828125, 455.5400085449219, 517.8579711914062,
//                   461.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 95,
//               type: "text",
//               content: "MINIMUM",
//               coordinates: {
//                 x: 491.364990234375,
//                 y: 450.1400146484375,
//                 width: 25.85772705078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   491.364990234375, 450.1400146484375, 517.2227172851562,
//                   456.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 96,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 421.5,
//                 y: 464.5400085449219,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   421.5, 464.5400085449219, 424.6969909667969, 470.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 97,
//               type: "text",
//               content: "DEPOSIT",
//               coordinates: {
//                 x: 433.7799987792969,
//                 y: 452.5400085449219,
//                 width: 25.207977294921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   433.7799987792969, 452.5400085449219, 458.98797607421875,
//                   458.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 98,
//               type: "text",
//               content: "POLICY PREMIUM",
//               coordinates: {
//                 x: 538.373779296875,
//                 y: 452.5400085449219,
//                 width: 50.00213623046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   538.373779296875, 452.5400085449219, 588.3759155273438,
//                   458.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 99,
//               type: "text",
//               content: "AUDIT",
//               coordinates: {
//                 x: 394.71624755859375,
//                 y: 452.5400085449219,
//                 width: 17.554718017578125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   394.71624755859375, 452.5400085449219, 412.2709655761719,
//                   458.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 100,
//               type: "text",
//               content: "PAYMENT PLAN",
//               coordinates: {
//                 x: 258.896240234375,
//                 y: 452.5400085449219,
//                 width: 44.372711181640625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   258.896240234375, 452.5400085449219, 303.2689514160156,
//                   458.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 101,
//               type: "text",
//               content: "BILLING PLAN",
//               coordinates: {
//                 x: 183.2762451171875,
//                 y: 452.5400085449219,
//                 width: 40.204010009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   183.2762451171875, 452.5400085449219, 223.48025512695312,
//                   458.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 102,
//               type: "text",
//               content: "DIRECT",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 470.84002685546875,
//                 width: 21.384262084960938,
//                 height: 6.4227294921875,
//                 bbox: [
//                   176.6999969482422, 470.84002685546875, 198.08425903320312,
//                   477.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 103,
//               type: "text",
//               content: "AGENCY",
//               coordinates: {
//                 x: 219.89999389648438,
//                 y: 470.84002685546875,
//                 width: 24.259246826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   219.89999389648438, 470.84002685546875, 244.15924072265625,
//                   477.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 104,
//               type: "text",
//               content: "PROPOSED EXP DATE",
//               coordinates: {
//                 x: 91.4937515258789,
//                 y: 452.5400085449219,
//                 width: 62.34148406982422,
//                 height: 6.4227294921875,
//                 bbox: [
//                   91.4937515258789, 452.5400085449219, 153.83523559570312,
//                   458.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 105,
//               type: "text",
//               content: "PROPOSED EFF DATE",
//               coordinates: {
//                 x: 21.565000534057617,
//                 y: 452.5400085449219,
//                 width: 61.80098915100098,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.565000534057617, 452.5400085449219, 83.3659896850586,
//                   458.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 106,
//               type: "text",
//               content: "POLICY INFORMATION",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 440.3799743652344,
//                 width: 84.87800025939941,
//                 height: 8.656768798828125,
//                 bbox: [
//                   21.899999618530273, 440.3799743652344, 106.77799987792969,
//                   449.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 107,
//               type: "text",
//               content: "LINES OF BUSINESS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 200.37998962402344,
//                 width: 77.41474342346191,
//                 height: 8.656753540039062,
//                 bbox: [
//                   21.899999618530273, 200.37998962402344, 99.31474304199219,
//                   209.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 108,
//               type: "text",
//               content: "COMMERCIAL GENERAL LIABILITY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 261.44000244140625,
//                 width: 95.33498001098633,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 261.44000244140625, 131.63497924804688,
//                   267.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 109,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 536.7000122070312,
//                 y: 248.54002380371094,
//                 width: 3.197021484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   536.7000122070312, 248.54002380371094, 539.8970336914062,
//                   254.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 110,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 536.7000122070312,
//                 y: 236.54002380371094,
//                 width: 3.197021484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   536.7000122070312, 236.54002380371094, 539.8970336914062,
//                   242.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 111,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 536.7000122070312,
//                 y: 224.54002380371094,
//                 width: 3.197021484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   536.7000122070312, 224.54002380371094, 539.8970336914062,
//                   230.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 112,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 345.8999938964844,
//                 y: 296.5400085449219,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   345.8999938964844, 296.5400085449219, 349.09698486328125,
//                   302.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 113,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 345.8999938964844,
//                 y: 284.5400085449219,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   345.8999938964844, 284.5400085449219, 349.09698486328125,
//                   290.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 114,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 151.5,
//                 y: 284.5400085449219,
//                 width: 3.1970062255859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   151.5, 284.5400085449219, 154.69700622558594,
//                   290.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 115,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 345.8999938964844,
//                 y: 248.54002380371094,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   345.8999938964844, 248.54002380371094, 349.09698486328125,
//                   254.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 116,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 345.8999938964844,
//                 y: 224.54002380371094,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   345.8999938964844, 224.54002380371094, 349.09698486328125,
//                   230.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 117,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 151.5,
//                 y: 296.5400085449219,
//                 width: 3.1970062255859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   151.5, 296.5400085449219, 154.69700622558594,
//                   302.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 118,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 151.5,
//                 y: 260.5400390625,
//                 width: 3.1970062255859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   151.5, 260.5400390625, 154.69700622558594, 266.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 119,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 151.5,
//                 y: 248.54002380371094,
//                 width: 3.1970062255859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   151.5, 248.54002380371094, 154.69700622558594,
//                   254.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 120,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 151.5,
//                 y: 236.54002380371094,
//                 width: 3.1970062255859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   151.5, 236.54002380371094, 154.69700622558594,
//                   242.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 121,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 151.5,
//                 y: 224.54002380371094,
//                 width: 3.1970062255859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   151.5, 224.54002380371094, 154.69700622558594,
//                   230.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 122,
//               type: "text",
//               content: "PREMIUM",
//               coordinates: {
//                 x: 536.7000122070312,
//                 y: 212.54002380371094,
//                 width: 27.13427734375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   536.7000122070312, 212.54002380371094, 563.8342895507812,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 123,
//               type: "text",
//               content: "PREMIUM",
//               coordinates: {
//                 x: 345.8999938964844,
//                 y: 212.54002380371094,
//                 width: 27.134246826171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   345.8999938964844, 212.54002380371094, 373.03424072265625,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 124,
//               type: "text",
//               content: "PREMIUM",
//               coordinates: {
//                 x: 151.5,
//                 y: 212.54002380371094,
//                 width: 27.134246826171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   151.5, 212.54002380371094, 178.63424682617188,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 125,
//               type: "text",
//               content: "BUSINESS OWNERS",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 248.8400115966797,
//                 width: 56.48798751831055,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 248.8400115966797, 92.7879867553711,
//                   255.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 126,
//               type: "text",
//               content: "BUSINESS AUTO",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 236.8400115966797,
//                 width: 46.172489166259766,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 236.8400115966797, 82.47248840332031,
//                   243.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 127,
//               type: "text",
//               content: "UMBRELLA",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 296.84002685546875,
//                 width: 30.975265502929688,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 296.84002685546875, 261.6752624511719,
//                   303.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 128,
//               type: "text",
//               content: "BOILER & MACHINERY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 224.8400115966797,
//                 width: 62.456478118896484,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 224.8400115966797, 98.75647735595703,
//                   231.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 129,
//               type: "text",
//               content: "GARAGE AND DEALERS",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 248.8400115966797,
//                 width: 66.39515686035156,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   230.6999969482422, 248.8400115966797, 297.09515380859375,
//                   255.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 130,
//               type: "text",
//               content: "CRIME",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 296.84002685546875,
//                 width: 18.514999389648438,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 296.84002685546875, 54.814998626708984,
//                   303.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 131,
//               type: "text",
//               content: "COMMERCIAL PROPERTY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 284.84002685546875,
//                 width: 71.8232307434082,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 284.84002685546875, 108.12322998046875,
//                   291.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 132,
//               type: "text",
//               content: "INDICATE LINES OF BUSINESS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 212.54002380371094,
//                 width: 85.73248481750488,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 212.54002380371094, 107.63248443603516,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 133,
//               type: "text",
//               content: "YACHT",
//               coordinates: {
//                 x: 421.5,
//                 y: 224.8400115966797,
//                 width: 19.043975830078125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   421.5, 224.8400115966797, 440.5439758300781,
//                   231.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 134,
//               type: "text",
//               content: "© 1993-2015 ACORD CORPORATION.  All rights reserved.",
//               coordinates: {
//                 x: 377.61749267578125,
//                 y: 745.780029296875,
//                 width: 211.10992431640625,
//                 height: 8.65673828125,
//                 bbox: [
//                   377.61749267578125, 745.780029296875, 588.7274169921875,
//                   754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 135,
//               type: "text",
//               content: "Page 1 of 4",
//               coordinates: {
//                 x: 285.84124755859375,
//                 y: 745.780029296875,
//                 width: 40.873504638671875,
//                 height: 8.65673828125,
//                 bbox: [
//                   285.84124755859375, 745.780029296875, 326.7147521972656,
//                   754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 136,
//               type: "text",
//               content: "The ACORD name and logo are registered marks of ACORD",
//               coordinates: {
//                 x: 196.4737548828125,
//                 y: 757.780029296875,
//                 width: 218.86770629882812,
//                 height: 8.65673828125,
//                 bbox: [
//                   196.4737548828125, 757.780029296875, 415.3414611816406,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 137,
//               type: "text",
//               content: "APPLICANT INFORMATION",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 482.3799743652344,
//                 width: 100.50975227355957,
//                 height: 8.656768798828125,
//                 bbox: [
//                   21.899999618530273, 482.3799743652344, 122.40975189208984,
//                   491.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 138,
//               type: "text",
//               content: "UNDERWRITER OFFICE",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 128.54002380371094,
//                 width: 65.63619995117188,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 128.54002380371094, 519.5361938476562,
//                   134.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 139,
//               type: "text",
//               content: "UNDERWRITER",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 128.54002380371094,
//                 width: 42.9869384765625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   309.8999938964844, 128.54002380371094, 352.8869323730469,
//                   134.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 140,
//               type: "text",
//               content: "DATE (MM/DD/YYYY)",
//               coordinates: {
//                 x: 522.563720703125,
//                 y: 32.54002380371094,
//                 width: 57.02288818359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   522.563720703125, 32.54002380371094, 579.5866088867188,
//                   38.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 141,
//               type: "text",
//               content: "COMMERCIAL INSURANCE APPLICATION",
//               coordinates: {
//                 x: 161.0449981689453,
//                 y: 24.701271057128906,
//                 width: 275.28868103027344,
//                 height: 15.358749389648438,
//                 bbox: [
//                   161.0449981689453, 24.701271057128906, 436.33367919921875,
//                   40.060020446777344
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 13.75,
//                 color: 0
//               }
//             },
//             {
//               id: 142,
//               type: "text",
//               content: "APPLICANT INFORMATION SECTION",
//               coordinates: {
//                 x: 212.8000030517578,
//                 y: 41.22001266479492,
//                 width: 172.43846130371094,
//                 height: 10.890750885009766,
//                 bbox: [
//                   212.8000030517578, 41.22001266479492, 385.23846435546875,
//                   52.11076354980469
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 9.75,
//                 color: 0
//               }
//             },
//             {
//               id: 143,
//               type: "text",
//               content: "FAX",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 150.73997497558594,
//                 width: 11.172250747680664,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 150.73997497558594, 33.07225036621094,
//                   157.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 144,
//               type: "text",
//               content: "(A/C, No):",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 156.13999938964844,
//                 width: 26.484498977661133,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 156.13999938964844, 48.384498596191406,
//                   162.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 145,
//               type: "text",
//               content: "AGENCY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 58.34001159667969,
//                 width: 24.58125114440918,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 58.34001159667969, 46.48125076293945,
//                   64.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 146,
//               type: "text",
//               content: "NAME:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 132.13999938964844,
//                 width: 18.836999893188477,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 132.13999938964844, 40.73699951171875,
//                   138.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 147,
//               type: "text",
//               content: "CONTACT",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 126.73997497558594,
//                 width: 27.663251876831055,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 126.73997497558594, 49.56325149536133,
//                   133.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 148,
//               type: "text",
//               content: "(A/C, No, Ext):",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 144.13999938964844,
//                 width: 38.61124610900879,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 144.13999938964844, 60.51124572753906,
//                   150.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 149,
//               type: "text",
//               content: "PHONE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 138.73997497558594,
//                 width: 20.429750442504883,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 138.73997497558594, 42.329750061035156,
//                   145.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 150,
//               type: "text",
//               content: "SUBCODE:",
//               coordinates: {
//                 x: 165.89999389648438,
//                 y: 178.3400115966797,
//                 width: 30.647506713867188,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   165.89999389648438, 178.3400115966797, 196.54750061035156,
//                   184.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 151,
//               type: "text",
//               content: "CODE:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 178.3400115966797,
//                 width: 18.514997482299805,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 178.3400115966797, 40.41499710083008,
//                   184.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 152,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 190.9399871826172,
//                 width: 68.09723854064941,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 190.9399871826172, 89.99723815917969,
//                   197.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 153,
//               type: "text",
//               content: "ADDRESS:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 167.54002380371094,
//                 width: 30.009244918823242,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 167.54002380371094, 51.909244537353516,
//                   173.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 154,
//               type: "text",
//               content: "E-MAIL",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 162.13999938964844,
//                 width: 19.785749435424805,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 162.13999938964844, 41.68574905395508,
//                   168.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 155,
//               type: "text",
//               content: "STATUS OF",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 160.9399871826172,
//                 width: 31.6939697265625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   309.8999938964844, 160.9399871826172, 341.5939636230469,
//                   167.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 156,
//               type: "text",
//               content: "TRANSACTION",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 168.13999938964844,
//                 width: 41.813934326171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   309.8999938964844, 168.13999938964844, 351.71392822265625,
//                   174.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 157,
//               type: "text",
//               content: "RENEW",
//               coordinates: {
//                 x: 551.0999755859375,
//                 y: 153.4399871826172,
//                 width: 21.38427734375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   551.0999755859375, 153.4399871826172, 572.4842529296875,
//                   159.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 158,
//               type: "text",
//               content: "QUOTE",
//               coordinates: {
//                 x: 396.29998779296875,
//                 y: 153.4399871826172,
//                 width: 20.423980712890625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   396.29998779296875, 153.4399871826172, 416.7239685058594,
//                   159.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 159,
//               type: "text",
//               content: "ISSUE POLICY",
//               coordinates: {
//                 x: 475.5,
//                 y: 153.4399871826172,
//                 width: 39.8934326171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   475.5, 153.4399871826172, 515.3934326171875,
//                   159.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 160,
//               type: "text",
//               content: "BOUND (Give Date and/or Attach Copy):",
//               coordinates: {
//                 x: 396.29998779296875,
//                 y: 164.8400115966797,
//                 width: 103.77578735351562,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   396.29998779296875, 164.8400115966797, 500.0757751464844,
//                   171.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 161,
//               type: "text",
//               content: "CANCEL",
//               coordinates: {
//                 x: 396.29998779296875,
//                 y: 188.8400115966797,
//                 width: 23.310455322265625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   396.29998779296875, 188.8400115966797, 419.6104431152344,
//                   195.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 162,
//               type: "text",
//               content: "CHANGE",
//               coordinates: {
//                 x: 396.29998779296875,
//                 y: 176.8400115966797,
//                 width: 24.581207275390625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   396.29998779296875, 176.8400115966797, 420.8811950683594,
//                   183.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 163,
//               type: "text",
//               content: "DATE",
//               coordinates: {
//                 x: 445.98748779296875,
//                 y: 174.13999938964844,
//                 width: 15.2144775390625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   445.98748779296875, 174.13999938964844, 461.20196533203125,
//                   180.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 164,
//               type: "text",
//               content: "TIME",
//               coordinates: {
//                 x: 511.5,
//                 y: 174.13999938964844,
//                 width: 13.71954345703125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   511.5, 174.13999938964844, 525.2195434570312, 180.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 165,
//               type: "text",
//               content: "AM",
//               coordinates: {
//                 x: 564.4874877929688,
//                 y: 176.8400115966797,
//                 width: 8.6192626953125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   564.4874877929688, 176.8400115966797, 573.1067504882812,
//                   183.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 166,
//               type: "text",
//               content: "PM",
//               coordinates: {
//                 x: 564.4874877929688,
//                 y: 188.8400115966797,
//                 width: 8.6192626953125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   564.4874877929688, 188.8400115966797, 573.1067504882812,
//                   195.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 167,
//               type: "text",
//               content: "NAIC CODE",
//               coordinates: {
//                 x: 547.5,
//                 y: 55.34001159667969,
//                 width: 32.24029541015625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   547.5, 55.34001159667969, 579.7402954101562, 61.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 168,
//               type: "text",
//               content: "CARRIER",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 55.17997741699219,
//                 width: 35.28570556640625,
//                 height: 8.656749725341797,
//                 bbox: [
//                   309.8999938964844, 55.17997741699219, 345.1856994628906,
//                   63.836727142333984
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 169,
//               type: "text",
//               content: "POLICY NUMBER",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 104.54002380371094,
//                 width: 48.09295654296875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   309.8999938964844, 104.54002380371094, 357.9929504394531,
//                   110.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 170,
//               type: "text",
//               content: "COMPANY POLICY OR PROGRAM NAME",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 80.54002380371094,
//                 width: 112.03863525390625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   309.8999938964844, 80.54002380371094, 421.9386291503906,
//                   86.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 171,
//               type: "text",
//               content: "PROGRAM CODE",
//               coordinates: {
//                 x: 529.5,
//                 y: 80.54002380371094,
//                 width: 48.20233154296875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   529.5, 80.54002380371094, 577.7023315429688, 86.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 172,
//               type: "text",
//               content: "HOTEL / MOTEL SUPPLEMENT",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 332.84002685546875,
//                 width: 83.83497619628906,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 332.84002685546875, 314.53497314453125,
//                   339.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 173,
//               type: "text",
//               content: "CYBER AND PRIVACY",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 224.8400115966797,
//                 width: 59.58143615722656,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   230.6999969482422, 224.8400115966797, 290.28143310546875,
//                   231.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 174,
//               type: "text",
//               content: "FIDUCIARY LIABILITY",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 236.8400115966797,
//                 width: 58.51197814941406,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   230.6999969482422, 236.8400115966797, 289.21197509765625,
//                   243.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 175,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 345.8999938964844,
//                 y: 236.54002380371094,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   345.8999938964844, 236.54002380371094, 349.09698486328125,
//                   242.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 176,
//               type: "text",
//               content: "LIQUOR LIABILITY",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 260.84002685546875,
//                 width: 49.78919982910156,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 260.84002685546875, 280.48919677734375,
//                   267.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 177,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 345.8999938964844,
//                 y: 260.5400390625,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   345.8999938964844, 260.5400390625, 349.09698486328125,
//                   266.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 178,
//               type: "text",
//               content: "COMMERCIAL INLAND MARINE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 272.84002685546875,
//                 width: 85.34147262573242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 272.84002685546875, 121.64147186279297,
//                   279.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 179,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 151.5,
//                 y: 272.5400390625,
//                 width: 3.1970062255859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   151.5, 272.5400390625, 154.69700622558594, 278.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 180,
//               type: "text",
//               content: "TRUCKERS",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 284.84002685546875,
//                 width: 31.602005004882812,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 284.84002685546875, 262.302001953125,
//                   291.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 181,
//               type: "text",
//               content: "MOTOR CARRIER",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 272.84002685546875,
//                 width: 48.73118591308594,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 272.84002685546875, 279.4311828613281,
//                   279.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 182,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 345.8999938964844,
//                 y: 272.5400390625,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   345.8999938964844, 272.5400390625, 349.09698486328125,
//                   278.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 183,
//               type: "text",
//               content: "ACCOUNTS RECEIVABLE / VALUABLE PAPERS",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 320.84002685546875,
//                 width: 127.98921585083008,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 320.84002685546875, 164.28921508789062,
//                   327.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 184,
//               type: "text",
//               content: "DEALERS SECTION",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 404.84002685546875,
//                 width: 53.940731048583984,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 404.84002685546875, 90.24073028564453,
//                   411.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 185,
//               type: "text",
//               content: "ELECTRONIC DATA PROCESSING SECTION",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 428.84002685546875,
//                 width: 119.78970718383789,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 428.84002685546875, 156.08970642089844,
//                   435.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 186,
//               type: "text",
//               content: "GLASS AND SIGN SECTION",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 320.84002685546875,
//                 width: 75.31913757324219,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 320.84002685546875, 306.0191345214844,
//                   327.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 187,
//               type: "text",
//               content: "INSTALLATION / BUILDERS RISK SECTION",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 344.84002685546875,
//                 width: 115.63233947753906,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 344.84002685546875, 346.33233642578125,
//                   351.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 188,
//               type: "text",
//               content: "OPEN CARGO SECTION",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 392.84002685546875,
//                 width: 66.06169128417969,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 392.84002685546875, 296.7616882324219,
//                   399.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 189,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 536.7000122070312,
//                 y: 260.5400390625,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   536.7000122070312, 260.5400390625, 539.8970336914062,
//                   266.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 190,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 536.7000122070312,
//                 y: 272.5400390625,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   536.7000122070312, 272.5400390625, 539.8970336914062,
//                   278.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 191,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 536.7000122070312,
//                 y: 284.5400085449219,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   536.7000122070312, 284.5400085449219, 539.8970336914062,
//                   290.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 192,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 536.7000122070312,
//                 y: 296.5400085449219,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   536.7000122070312, 296.5400085449219, 539.8970336914062,
//                   302.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 29.271129960618055,
//                 width: 577.68,
//                 height: 169.38867009996966,
//                 bbox: [
//                   17.28, 29.271129960618055, 594.9599999999999,
//                   198.6598000605877
//                 ]
//               },
//               properties: {
//                 rows: 10,
//                 columns: 15,
//                 accuracy: 80.781
//               }
//             },
//             {
//               id: 1,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 209.2166010299909,
//                 width: 577.4399999999999,
//                 height: 97.41048167222056,
//                 bbox: [
//                   17.52, 209.2166010299909, 594.9599999999999,
//                   306.62708270221145
//                 ]
//               },
//               properties: {
//                 rows: 8,
//                 columns: 9,
//                 accuracy: 97.813
//               }
//             },
//             {
//               id: 2,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 317.4238109663738,
//                 width: 577.4399999999999,
//                 height: 121.16328385337778,
//                 bbox: [
//                   17.52, 317.4238109663738, 594.9599999999999, 438.5870948197516
//                 ]
//               },
//               properties: {
//                 rows: 10,
//                 columns: 6,
//                 accuracy: 100
//               }
//             },
//             {
//               id: 3,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 449.38382308391397,
//                 width: 577.68,
//                 height: 31.1905483186913,
//                 bbox: [
//                   17.28, 449.38382308391397, 594.9599999999999,
//                   480.57437140260527
//                 ]
//               },
//               properties: {
//                 rows: 2,
//                 columns: 12,
//                 accuracy: 96.434
//               }
//             },
//             {
//               id: 4,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 491.37109966676763,
//                 width: 577.4399999999999,
//                 height: 253.36322326567705,
//                 bbox: [
//                   17.52, 491.37109966676763, 594.9599999999999,
//                   744.7343229324447
//                 ]
//               },
//               properties: {
//                 rows: 15,
//                 columns: 14,
//                 accuracy: 78.4
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 193,
//           table_count: 5,
//           total_elements: 198
//         }
//       },
//       {
//         page_number: 2,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 415.20001220703125,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   415.20001220703125, 25.188751220703125, 447.44805908203125,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "Agent",
//               coordinates: {
//                 x: 76.80000305175781,
//                 y: 43.188751220703125,
//                 width: 18.92974090576172,
//                 height: 8.098247528076172,
//                 bbox: [
//                   76.80000305175781, 43.188751220703125, 95.72974395751953,
//                   51.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "Mason Lowery",
//               coordinates: {
//                 x: 76.80000305175781,
//                 y: 55.188751220703125,
//                 width: 47.132240295410156,
//                 height: 8.098247528076172,
//                 bbox: [
//                   76.80000305175781, 55.188751220703125, 123.93224334716797,
//                   63.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "(419) 806-4770 1734",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 79.18875122070312,
//                 width: 67.6932487487793,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 79.18875122070312, 90.49324798583984,
//                   87.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "mlowery@uisprotect.com",
//               coordinates: {
//                 x: 116.4000015258789,
//                 y: 91.18875122070312,
//                 width: 81.4610366821289,
//                 height: 8.098251342773438,
//                 bbox: [
//                   116.4000015258789, 91.18875122070312, 197.8610382080078,
//                   99.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "Accounts Manager",
//               coordinates: {
//                 x: 368.3999938964844,
//                 y: 43.188751220703125,
//                 width: 60.4215087890625,
//                 height: 8.098247528076172,
//                 bbox: [
//                   368.3999938964844, 43.188751220703125, 428.8215026855469,
//                   51.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "Rachel Strausbaugh",
//               coordinates: {
//                 x: 368.3999938964844,
//                 y: 55.188751220703125,
//                 width: 65.66326904296875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   368.3999938964844, 55.188751220703125, 434.0632629394531,
//                   63.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "(419) 806-4770 1727",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 79.18875122070312,
//                 width: 67.69329833984375,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 79.18875122070312, 378.4932861328125,
//                   87.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "rstrausbaugh@uisprotect.com",
//               coordinates: {
//                 x: 404.3999938964844,
//                 y: 91.18875122070312,
//                 width: 96.7802734375,
//                 height: 8.098251342773438,
//                 bbox: [
//                   404.3999938964844, 91.18875122070312, 501.1802673339844,
//                   99.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "1",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 139.18875122070312,
//                 width: 4.031000137329102,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 139.18875122070312, 26.83099937438965,
//                   147.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "1",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 163.18875122070312,
//                 width: 4.031000137329102,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 163.18875122070312, 26.83099937438965,
//                   171.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "8484 Huffman  Rd",
//               coordinates: {
//                 x: 80.4000015258789,
//                 y: 127.18875122070312,
//                 width: 58.66698455810547,
//                 height: 8.098251342773438,
//                 bbox: [
//                   80.4000015258789, 127.18875122070312, 139.06698608398438,
//                   135.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "Cygnet",
//               coordinates: {
//                 x: 73.19999694824219,
//                 y: 151.18875122070312,
//                 width: 22.960739135742188,
//                 height: 8.098251342773438,
//                 bbox: [
//                   73.19999694824219, 151.18875122070312, 96.16073608398438,
//                   159.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "Wood",
//               coordinates: {
//                 x: 84,
//                 y: 163.18875122070312,
//                 width: 18.799240112304688,
//                 height: 8.098251342773438,
//                 bbox: [
//                   84, 163.18875122070312, 102.79924011230469, 171.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 231.60000610351562,
//                 y: 151.18875122070312,
//                 width: 10.867752075195312,
//                 height: 8.098251342773438,
//                 bbox: [
//                   231.60000610351562, 151.18875122070312, 242.46775817871094,
//                   159.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "43413",
//               coordinates: {
//                 x: 213.60000610351562,
//                 y: 163.18875122070312,
//                 width: 20.155029296875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   213.60000610351562, 163.18875122070312, 233.75503540039062,
//                   171.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "1500",
//               coordinates: {
//                 x: 508.79998779296875,
//                 y: 139.18875122070312,
//                 width: 16.1240234375,
//                 height: 8.098251342773438,
//                 bbox: [
//                   508.79998779296875, 139.18875122070312, 524.9240112304688,
//                   147.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "15000",
//               coordinates: {
//                 x: 523.2000122070312,
//                 y: 163.18875122070312,
//                 width: 20.155029296875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   523.2000122070312, 163.18875122070312, 543.3550415039062,
//                   171.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 566.4824829101562,
//                 y: 175.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   566.4824829101562, 175.18875122070312, 571.7169799804688,
//                   183.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "05/01/2018",
//               coordinates: {
//                 x: 531.155029296875,
//                 y: 391.1887512207031,
//                 width: 36.2645263671875,
//                 height: 8.098236083984375,
//                 bbox: [
//                   531.155029296875, 391.1887512207031, 567.4195556640625,
//                   399.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "Commerical cleaning/ Janitorial Service",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 415.1887512207031,
//                 width: 126.86047744750977,
//                 height: 8.098236083984375,
//                 bbox: [
//                   22.799999237060547, 415.1887512207031, 149.6604766845703,
//                   423.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content: "E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 746.5400390625,
//                 width: 51.071502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 746.5400390625, 350.1715087890625,
//                   752.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "REASON FOR INTEREST:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 746.5400390625,
//                 width: 69.57499122619629,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 746.5400390625, 91.47499084472656,
//                   752.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 714.1400146484375,
//                 width: 22.022499084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 714.1400146484375, 58.3224983215332,
//                   720.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "LEASEBACK",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 708.1400146484375,
//                 width: 35.75349044799805,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 708.1400146484375, 72.0534896850586,
//                   714.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content: "WARRANTY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 678.1400146484375,
//                 width: 33.200504302978516,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 678.1400146484375, 69.50050354003906,
//                   684.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: "BREACH OF",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 672.1400146484375,
//                 width: 34.15500259399414,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 672.1400146484375, 70.45500183105469,
//                   678.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content: "TRUSTEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 722.5400390625,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 722.5400390625, 124.30648803710938, 728.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content: "REGISTRANT",
//               coordinates: {
//                 x: 97.5,
//                 y: 710.5400390625,
//                 width: 37.34049987792969,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 710.5400390625, 134.8404998779297, 716.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content: "FAX (A/C, No):",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 734.5400390625,
//                 width: 39.249481201171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 734.5400390625, 493.14947509765625,
//                   740.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content: "PHONE (A/C, No, Ext):",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 734.5400390625,
//                 width: 60.633697509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 734.5400390625, 359.73370361328125,
//                   740.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content: "LIEN AMOUNT:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 734.5400390625,
//                 width: 40.96299743652344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 734.5400390625, 185.26300048828125,
//                   740.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content: "INTEREST END DATE:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 722.5400390625,
//                 width: 60.846435546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 722.5400390625, 359.9464416503906,
//                   728.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content: "ITEM:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 698.5400390625,
//                 width: 15.63427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 698.5400390625, 541.5343017578125,
//                   704.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content: "CLASS:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 701.5400390625,
//                 width: 21.384246826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 701.5400390625, 475.28424072265625,
//                   707.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content: "AIRPORT:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 686.5400390625,
//                 width: 27.13421630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 686.5400390625, 481.0342102050781,
//                   692.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content: "AIRCRAFT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 686.5400390625,
//                 width: 30.6474609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 686.5400390625, 556.5474853515625,
//                   692.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content: "CO-OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 686.5400390625,
//                 width: 32.55649948120117,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 686.5400390625, 68.85649871826172,
//                   692.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 97.5,
//                 y: 698.5400390625,
//                 width: 22.022491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 698.5400390625, 119.52249145507812, 704.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content: "SEND BILL",
//               coordinates: {
//                 x: 417.8999938964844,
//                 y: 651.739990234375,
//                 width: 30.31396484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   417.8999938964844, 651.739990234375, 448.2139587402344,
//                   658.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content: "POLICY",
//               coordinates: {
//                 x: 374.70001220703125,
//                 y: 651.739990234375,
//                 width: 21.37847900390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   374.70001220703125, 651.739990234375, 396.0784912109375,
//                   658.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 259.5,
//                 y: 651.739990234375,
//                 width: 31.27996826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   259.5, 651.739990234375, 290.77996826171875, 658.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content: "AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 702.1400146484375,
//                 width: 33.18899154663086,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 702.1400146484375, 69.4889907836914,
//                   708.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content: "INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 666.1400146484375,
//                 width: 25.857749938964844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 666.1400146484375, 62.15774917602539,
//                   672.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content: "ITEM DESCRIPTION",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 710.5400390625,
//                 width: 54.56744384765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 710.5400390625, 508.4674377441406,
//                   716.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 651.739990234375,
//                 width: 28.399248123168945,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 651.739990234375, 50.29924774169922,
//                   658.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 651.739990234375,
//                 width: 18.520767211914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   212.6999969482422, 651.739990234375, 231.22076416015625,
//                   658.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 651.739990234375,
//                 width: 60.23126220703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 651.739990234375, 204.53126525878906,
//                   658.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 722.5400390625,
//                 width: 63.1925048828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 722.5400390625, 207.4925079345703,
//                   728.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 313.5,
//                 y: 651.739990234375,
//                 width: 37.547454833984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   313.5, 651.739990234375, 351.0474548339844, 658.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 651.1400146484375,
//                 width: 77.8665771484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   483.3275146484375, 651.1400146484375, 561.194091796875,
//                   657.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content: "ADDITIONAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 660.1400146484375,
//                 width: 35.42574691772461,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 660.1400146484375, 71.72574615478516,
//                   666.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 52,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 674.5400390625,
//                 width: 35.74774169921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 674.5400390625, 133.24774169921875, 680.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 53,
//               type: "text",
//               content: "MORTGAGEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 686.5400390625,
//                 width: 37.66249084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 686.5400390625, 135.16249084472656, 692.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 54,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 97.5,
//                 y: 662.5400390625,
//                 width: 37.34049987792969,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 662.5400390625, 134.8404998779297, 668.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 55,
//               type: "text",
//               content: "EMPLOYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 696.1400146484375,
//                 width: 31.912494659423828,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 696.1400146484375, 68.21249389648438,
//                   702.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 56,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 662.5400390625,
//                 width: 31.486968994140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 662.5400390625, 485.386962890625,
//                   668.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 57,
//               type: "text",
//               content: "BUILDING:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 662.5400390625,
//                 width: 29.6815185546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 662.5400390625, 555.58154296875,
//                   668.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 58,
//               type: "text",
//               content: "VEHICLE:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 674.5400390625,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 674.5400390625, 480.70648193359375,
//                   680.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 59,
//               type: "text",
//               content: "BOAT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 674.5400390625,
//                 width: 17.135009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 674.5400390625, 543.0350341796875,
//                   680.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 60,
//               type: "text",
//               content: "ITEM",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 696.1400146484375,
//                 width: 13.719512939453125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 696.1400146484375, 467.6195068359375,
//                   702.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 61,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 511.5,
//                 y: 308.5400085449219,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   511.5, 308.5400085449219, 514.697021484375, 314.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 62,
//               type: "text",
//               content: "SQ FT",
//               coordinates: {
//                 x: 571.969970703125,
//                 y: 344.84002685546875,
//                 width: 16.90509033203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   571.969970703125, 344.84002685546875, 588.8750610351562,
//                   351.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 63,
//               type: "text",
//               content: "ANY AREA LEASED TO OTHERS? Y / N",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 356.5400085449219,
//                 width: 107.01910400390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   446.70001220703125, 356.5400085449219, 553.7191162109375,
//                   362.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 64,
//               type: "text",
//               content: "TOTAL BUILDING AREA:",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 344.5400085449219,
//                 width: 67.44744873046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   446.70001220703125, 344.5400085449219, 514.1474609375,
//                   350.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 65,
//               type: "text",
//               content: "SQ FT",
//               coordinates: {
//                 x: 571.969970703125,
//                 y: 332.84002685546875,
//                 width: 16.90509033203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   571.969970703125, 332.84002685546875, 588.8750610351562,
//                   339.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 66,
//               type: "text",
//               content: "OPEN TO PUBLIC AREA:",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 332.5400085449219,
//                 width: 68.29840087890625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   446.70001220703125, 332.5400085449219, 514.9984130859375,
//                   338.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 67,
//               type: "text",
//               content: "ANNUAL REVENUES:",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 308.5400085449219,
//                 width: 59.27093505859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   446.70001220703125, 308.5400085449219, 505.970947265625,
//                   314.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 68,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 313.5,
//                 y: 308.5400085449219,
//                 width: 28.39923095703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   313.5, 308.5400085449219, 341.89923095703125,
//                   314.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 69,
//               type: "text",
//               content: "CITY LIMITS",
//               coordinates: {
//                 x: 266.70001220703125,
//                 y: 308.5400085449219,
//                 width: 33.3902587890625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   266.70001220703125, 308.5400085449219, 300.09027099609375,
//                   314.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 70,
//               type: "text",
//               content: "OCCUPIED AREA:",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 320.5400085449219,
//                 width: 49.9041748046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   446.70001220703125, 320.5400085449219, 496.60418701171875,
//                   326.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 71,
//               type: "text",
//               content: "SQ FT",
//               coordinates: {
//                 x: 571.969970703125,
//                 y: 320.84002685546875,
//                 width: 16.90509033203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   571.969970703125, 320.84002685546875, 588.8750610351562,
//                   327.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 72,
//               type: "text",
//               content: "BLD #",
//               coordinates: {
//                 x: 24.393749237060547,
//                 y: 332.5400085449219,
//                 width: 16.600250244140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   24.393749237060547, 332.5400085449219, 40.99399948120117,
//                   338.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 73,
//               type: "text",
//               content: "LOC #",
//               coordinates: {
//                 x: 23.93375015258789,
//                 y: 308.5400085449219,
//                 width: 16.916500091552734,
//                 height: 6.4227294921875,
//                 bbox: [
//                   23.93375015258789, 308.5400085449219, 40.850250244140625,
//                   314.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 74,
//               type: "text",
//               content: "DESCRIPTION OF OPERATIONS:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 356.5400085449219,
//                 width: 89.88398933410645,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 356.5400085449219, 111.78398895263672,
//                   362.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 75,
//               type: "text",
//               content: "ZIP:",
//               coordinates: {
//                 x: 201.89999389648438,
//                 y: 344.5400085449219,
//                 width: 10.844497680664062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   201.89999389648438, 344.5400085449219, 212.74449157714844,
//                   350.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 76,
//               type: "text",
//               content: "STATE:",
//               coordinates: {
//                 x: 201.89999389648438,
//                 y: 332.5400085449219,
//                 width: 19.889251708984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   201.89999389648438, 332.5400085449219, 221.78924560546875,
//                   338.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 77,
//               type: "text",
//               content: "COUNTY:",
//               coordinates: {
//                 x: 50.70000076293945,
//                 y: 344.5400085449219,
//                 width: 25.74850082397461,
//                 height: 6.4227294921875,
//                 bbox: [
//                   50.70000076293945, 344.5400085449219, 76.44850158691406,
//                   350.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 78,
//               type: "text",
//               content: "CITY:",
//               coordinates: {
//                 x: 50.70000076293945,
//                 y: 332.5400085449219,
//                 width: 14.570499420166016,
//                 height: 6.4227294921875,
//                 bbox: [
//                   50.70000076293945, 332.5400085449219, 65.27050018310547,
//                   338.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 79,
//               type: "text",
//               content: "STREET",
//               coordinates: {
//                 x: 50.70000076293945,
//                 y: 308.5400085449219,
//                 width: 22.65499496459961,
//                 height: 6.4227294921875,
//                 bbox: [
//                   50.70000076293945, 308.5400085449219, 73.35499572753906,
//                   314.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 80,
//               type: "text",
//               content: "# PART TIME EMPL",
//               coordinates: {
//                 x: 383.9387512207031,
//                 y: 332.5400085449219,
//                 width: 52.865478515625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   383.9387512207031, 332.5400085449219, 436.8042297363281,
//                   338.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 81,
//               type: "text",
//               content: "# FULL TIME EMPL",
//               coordinates: {
//                 x: 384.5587463378906,
//                 y: 308.5400085449219,
//                 width: 52.221527099609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   384.5587463378906, 308.5400085449219, 436.7802734375,
//                   314.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 82,
//               type: "text",
//               content: "INSIDE",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 320.84002685546875,
//                 width: 19.1474609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 320.84002685546875, 300.2474670410156,
//                   327.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 83,
//               type: "text",
//               content: "OUTSIDE",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 332.84002685546875,
//                 width: 25.52996826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 332.84002685546875, 306.6299743652344,
//                   339.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 84,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 327.8999938964844,
//                 y: 320.84002685546875,
//                 width: 22.0224609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   327.8999938964844, 320.84002685546875, 349.9224548339844,
//                   327.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 85,
//               type: "text",
//               content: "TENANT",
//               coordinates: {
//                 x: 327.8999938964844,
//                 y: 332.84002685546875,
//                 width: 22.97698974609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   327.8999938964844, 332.84002685546875, 350.8769836425781,
//                   339.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 86,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 511.5,
//                 y: 248.54002380371094,
//                 width: 3.197021484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   511.5, 248.54002380371094, 514.697021484375, 254.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 87,
//               type: "text",
//               content: "SQ FT",
//               coordinates: {
//                 x: 571.969970703125,
//                 y: 284.84002685546875,
//                 width: 16.90509033203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   571.969970703125, 284.84002685546875, 588.8750610351562,
//                   291.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 88,
//               type: "text",
//               content: "ANY AREA LEASED TO OTHERS? Y / N",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 296.5400085449219,
//                 width: 107.01910400390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   446.70001220703125, 296.5400085449219, 553.7191162109375,
//                   302.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 89,
//               type: "text",
//               content: "TOTAL BUILDING AREA:",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 284.5400085449219,
//                 width: 67.44744873046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   446.70001220703125, 284.5400085449219, 514.1474609375,
//                   290.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 90,
//               type: "text",
//               content: "SQ FT",
//               coordinates: {
//                 x: 571.969970703125,
//                 y: 272.84002685546875,
//                 width: 16.90509033203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   571.969970703125, 272.84002685546875, 588.8750610351562,
//                   279.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 91,
//               type: "text",
//               content: "OPEN TO PUBLIC AREA:",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 272.5400390625,
//                 width: 68.29840087890625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   446.70001220703125, 272.5400390625, 514.9984130859375,
//                   278.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 92,
//               type: "text",
//               content: "ANNUAL REVENUES:",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 248.54002380371094,
//                 width: 59.27093505859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   446.70001220703125, 248.54002380371094, 505.970947265625,
//                   254.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 93,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 313.5,
//                 y: 248.54002380371094,
//                 width: 28.39923095703125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   313.5, 248.54002380371094, 341.89923095703125,
//                   254.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 94,
//               type: "text",
//               content: "CITY LIMITS",
//               coordinates: {
//                 x: 266.70001220703125,
//                 y: 248.54002380371094,
//                 width: 33.3902587890625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   266.70001220703125, 248.54002380371094, 300.09027099609375,
//                   254.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 95,
//               type: "text",
//               content: "OCCUPIED AREA:",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 260.5400390625,
//                 width: 49.9041748046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   446.70001220703125, 260.5400390625, 496.60418701171875,
//                   266.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 96,
//               type: "text",
//               content: "SQ FT",
//               coordinates: {
//                 x: 571.969970703125,
//                 y: 260.84002685546875,
//                 width: 16.90509033203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   571.969970703125, 260.84002685546875, 588.8750610351562,
//                   267.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 97,
//               type: "text",
//               content: "BLD #",
//               coordinates: {
//                 x: 24.393749237060547,
//                 y: 272.5400390625,
//                 width: 16.600250244140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   24.393749237060547, 272.5400390625, 40.99399948120117,
//                   278.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 98,
//               type: "text",
//               content: "LOC #",
//               coordinates: {
//                 x: 23.93375015258789,
//                 y: 248.54002380371094,
//                 width: 16.916500091552734,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   23.93375015258789, 248.54002380371094, 40.850250244140625,
//                   254.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 99,
//               type: "text",
//               content: "DESCRIPTION OF OPERATIONS:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 296.5400085449219,
//                 width: 89.88398933410645,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 296.5400085449219, 111.78398895263672,
//                   302.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 100,
//               type: "text",
//               content: "ZIP:",
//               coordinates: {
//                 x: 201.89999389648438,
//                 y: 284.5400085449219,
//                 width: 10.844497680664062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   201.89999389648438, 284.5400085449219, 212.74449157714844,
//                   290.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 101,
//               type: "text",
//               content: "STATE:",
//               coordinates: {
//                 x: 201.89999389648438,
//                 y: 272.5400390625,
//                 width: 19.889251708984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   201.89999389648438, 272.5400390625, 221.78924560546875,
//                   278.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 102,
//               type: "text",
//               content: "COUNTY:",
//               coordinates: {
//                 x: 50.70000076293945,
//                 y: 284.5400085449219,
//                 width: 25.74850082397461,
//                 height: 6.4227294921875,
//                 bbox: [
//                   50.70000076293945, 284.5400085449219, 76.44850158691406,
//                   290.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 103,
//               type: "text",
//               content: "CITY:",
//               coordinates: {
//                 x: 50.70000076293945,
//                 y: 272.5400390625,
//                 width: 14.570499420166016,
//                 height: 6.4227294921875,
//                 bbox: [
//                   50.70000076293945, 272.5400390625, 65.27050018310547,
//                   278.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 104,
//               type: "text",
//               content: "STREET",
//               coordinates: {
//                 x: 50.70000076293945,
//                 y: 248.54002380371094,
//                 width: 22.65499496459961,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   50.70000076293945, 248.54002380371094, 73.35499572753906,
//                   254.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 105,
//               type: "text",
//               content: "# PART TIME EMPL",
//               coordinates: {
//                 x: 383.9387512207031,
//                 y: 272.5400390625,
//                 width: 52.865478515625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   383.9387512207031, 272.5400390625, 436.8042297363281,
//                   278.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 106,
//               type: "text",
//               content: "# FULL TIME EMPL",
//               coordinates: {
//                 x: 384.5587463378906,
//                 y: 248.54002380371094,
//                 width: 52.221527099609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   384.5587463378906, 248.54002380371094, 436.7802734375,
//                   254.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 107,
//               type: "text",
//               content: "INSIDE",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 260.84002685546875,
//                 width: 19.1474609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 260.84002685546875, 300.2474670410156,
//                   267.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 108,
//               type: "text",
//               content: "OUTSIDE",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 272.84002685546875,
//                 width: 25.52996826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 272.84002685546875, 306.6299743652344,
//                   279.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 109,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 327.8999938964844,
//                 y: 260.84002685546875,
//                 width: 22.0224609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   327.8999938964844, 260.84002685546875, 349.9224548339844,
//                   267.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 110,
//               type: "text",
//               content: "TENANT",
//               coordinates: {
//                 x: 327.8999938964844,
//                 y: 272.84002685546875,
//                 width: 22.97698974609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   327.8999938964844, 272.84002685546875, 350.8769836425781,
//                   279.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 111,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 511.5,
//                 y: 188.54002380371094,
//                 width: 3.197021484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   511.5, 188.54002380371094, 514.697021484375, 194.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 112,
//               type: "text",
//               content: "SQ FT",
//               coordinates: {
//                 x: 571.969970703125,
//                 y: 224.8400115966797,
//                 width: 16.90509033203125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   571.969970703125, 224.8400115966797, 588.8750610351562,
//                   231.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 113,
//               type: "text",
//               content: "ANY AREA LEASED TO OTHERS? Y / N",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 236.54002380371094,
//                 width: 107.01910400390625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   446.70001220703125, 236.54002380371094, 553.7191162109375,
//                   242.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 114,
//               type: "text",
//               content: "TOTAL BUILDING AREA:",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 224.54002380371094,
//                 width: 67.44744873046875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   446.70001220703125, 224.54002380371094, 514.1474609375,
//                   230.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 115,
//               type: "text",
//               content: "SQ FT",
//               coordinates: {
//                 x: 571.969970703125,
//                 y: 212.8400115966797,
//                 width: 16.90509033203125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   571.969970703125, 212.8400115966797, 588.8750610351562,
//                   219.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 116,
//               type: "text",
//               content: "OPEN TO PUBLIC AREA:",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 212.54002380371094,
//                 width: 68.29840087890625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   446.70001220703125, 212.54002380371094, 514.9984130859375,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 117,
//               type: "text",
//               content: "ANNUAL REVENUES:",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 188.54002380371094,
//                 width: 59.27093505859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   446.70001220703125, 188.54002380371094, 505.970947265625,
//                   194.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 118,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 313.5,
//                 y: 188.54002380371094,
//                 width: 28.39923095703125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   313.5, 188.54002380371094, 341.89923095703125,
//                   194.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 119,
//               type: "text",
//               content: "CITY LIMITS",
//               coordinates: {
//                 x: 266.70001220703125,
//                 y: 188.54002380371094,
//                 width: 33.3902587890625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   266.70001220703125, 188.54002380371094, 300.09027099609375,
//                   194.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 120,
//               type: "text",
//               content: "OCCUPIED AREA:",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 200.54002380371094,
//                 width: 49.9041748046875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   446.70001220703125, 200.54002380371094, 496.60418701171875,
//                   206.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 121,
//               type: "text",
//               content: "SQ FT",
//               coordinates: {
//                 x: 571.969970703125,
//                 y: 200.8400115966797,
//                 width: 16.90509033203125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   571.969970703125, 200.8400115966797, 588.8750610351562,
//                   207.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 122,
//               type: "text",
//               content: "BLD #",
//               coordinates: {
//                 x: 24.393749237060547,
//                 y: 212.54002380371094,
//                 width: 16.600250244140625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   24.393749237060547, 212.54002380371094, 40.99399948120117,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 123,
//               type: "text",
//               content: "LOC #",
//               coordinates: {
//                 x: 23.93375015258789,
//                 y: 188.54002380371094,
//                 width: 16.916500091552734,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   23.93375015258789, 188.54002380371094, 40.850250244140625,
//                   194.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 124,
//               type: "text",
//               content: "DESCRIPTION OF OPERATIONS:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 236.54002380371094,
//                 width: 89.88398933410645,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 236.54002380371094, 111.78398895263672,
//                   242.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 125,
//               type: "text",
//               content: "ZIP:",
//               coordinates: {
//                 x: 201.89999389648438,
//                 y: 224.54002380371094,
//                 width: 10.844497680664062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   201.89999389648438, 224.54002380371094, 212.74449157714844,
//                   230.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 126,
//               type: "text",
//               content: "STATE:",
//               coordinates: {
//                 x: 201.89999389648438,
//                 y: 212.54002380371094,
//                 width: 19.889251708984375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   201.89999389648438, 212.54002380371094, 221.78924560546875,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 127,
//               type: "text",
//               content: "COUNTY:",
//               coordinates: {
//                 x: 50.70000076293945,
//                 y: 224.54002380371094,
//                 width: 25.74850082397461,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   50.70000076293945, 224.54002380371094, 76.44850158691406,
//                   230.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 128,
//               type: "text",
//               content: "CITY:",
//               coordinates: {
//                 x: 50.70000076293945,
//                 y: 212.54002380371094,
//                 width: 14.570499420166016,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   50.70000076293945, 212.54002380371094, 65.27050018310547,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 129,
//               type: "text",
//               content: "STREET",
//               coordinates: {
//                 x: 50.70000076293945,
//                 y: 188.54002380371094,
//                 width: 22.65499496459961,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   50.70000076293945, 188.54002380371094, 73.35499572753906,
//                   194.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 130,
//               type: "text",
//               content: "# PART TIME EMPL",
//               coordinates: {
//                 x: 383.9387512207031,
//                 y: 212.54002380371094,
//                 width: 52.865478515625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   383.9387512207031, 212.54002380371094, 436.8042297363281,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 131,
//               type: "text",
//               content: "# FULL TIME EMPL",
//               coordinates: {
//                 x: 384.5587463378906,
//                 y: 188.54002380371094,
//                 width: 52.221527099609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   384.5587463378906, 188.54002380371094, 436.7802734375,
//                   194.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 132,
//               type: "text",
//               content: "INSIDE",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 200.8400115966797,
//                 width: 19.1474609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   281.1000061035156, 200.8400115966797, 300.2474670410156,
//                   207.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 133,
//               type: "text",
//               content: "OUTSIDE",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 212.8400115966797,
//                 width: 25.52996826171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   281.1000061035156, 212.8400115966797, 306.6299743652344,
//                   219.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 134,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 327.8999938964844,
//                 y: 200.8400115966797,
//                 width: 22.0224609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   327.8999938964844, 200.8400115966797, 349.9224548339844,
//                   207.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 135,
//               type: "text",
//               content: "TENANT",
//               coordinates: {
//                 x: 327.8999938964844,
//                 y: 212.8400115966797,
//                 width: 22.97698974609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   327.8999938964844, 212.8400115966797, 350.8769836425781,
//                   219.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 136,
//               type: "text",
//               content:
//                 "ADDITIONAL INTEREST (Not all fields apply to all scenarios - provide only the necessary data)  Attach ACORD 45 for more Additional Interests",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 638.3800048828125,
//                 width: 523.8457279205322,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 638.3800048828125, 545.7457275390625,
//                   647.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 137,
//               type: "text",
//               content: "PHONE #",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 71.54002380371094,
//                 width: 25.219451904296875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   453.8999938964844, 71.54002380371094, 479.11944580078125,
//                   77.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 138,
//               type: "text",
//               content: "SECONDARY",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 66.13999938964844,
//                 width: 36.500946044921875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   453.8999938964844, 66.13999938964844, 490.40093994140625,
//                   72.56275177001953
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 139,
//               type: "text",
//               content: "CELL",
//               coordinates: {
//                 x: 569.0999755859375,
//                 y: 68.54002380371094,
//                 width: 14.99603271484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   569.0999755859375, 68.54002380371094, 584.0960083007812,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 140,
//               type: "text",
//               content: "HOME",
//               coordinates: {
//                 x: 507.8999938964844,
//                 y: 68.54002380371094,
//                 width: 17.238555908203125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   507.8999938964844, 68.54002380371094, 525.1385498046875,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 141,
//               type: "text",
//               content: "BUS",
//               coordinates: {
//                 x: 540.2999877929688,
//                 y: 68.54002380371094,
//                 width: 12.13250732421875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   540.2999877929688, 68.54002380371094, 552.4324951171875,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 142,
//               type: "text",
//               content: "PHONE #",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 71.54002380371094,
//                 width: 25.219451904296875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   309.8999938964844, 71.54002380371094, 335.11944580078125,
//                   77.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 143,
//               type: "text",
//               content: "CELL",
//               coordinates: {
//                 x: 425.1000061035156,
//                 y: 68.54002380371094,
//                 width: 14.996002197265625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   425.1000061035156, 68.54002380371094, 440.09600830078125,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 144,
//               type: "text",
//               content: "HOME",
//               coordinates: {
//                 x: 363.8999938964844,
//                 y: 68.54002380371094,
//                 width: 17.238494873046875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   363.8999938964844, 68.54002380371094, 381.13848876953125,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 145,
//               type: "text",
//               content: "BUS",
//               coordinates: {
//                 x: 396.29998779296875,
//                 y: 68.54002380371094,
//                 width: 12.132476806640625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   396.29998779296875, 68.54002380371094, 408.4324645996094,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 146,
//               type: "text",
//               content: "PRIMARY",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 66.13999938964844,
//                 width: 26.283233642578125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   309.8999938964844, 66.13999938964844, 336.1832275390625,
//                   72.56275177001953
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 147,
//               type: "text",
//               content: "PHONE #",
//               coordinates: {
//                 x: 165.89999389648438,
//                 y: 71.54002380371094,
//                 width: 25.219497680664062,
//                 height: 6.422752380371094,
//                 bbox: [
//                   165.89999389648438, 71.54002380371094, 191.11949157714844,
//                   77.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 148,
//               type: "text",
//               content: "SECONDARY",
//               coordinates: {
//                 x: 165.89999389648438,
//                 y: 66.13999938964844,
//                 width: 36.501007080078125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   165.89999389648438, 66.13999938964844, 202.4010009765625,
//                   72.56275177001953
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 149,
//               type: "text",
//               content: "CELL",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 68.54002380371094,
//                 width: 14.996002197265625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   281.1000061035156, 68.54002380371094, 296.09600830078125,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 150,
//               type: "text",
//               content: "HOME",
//               coordinates: {
//                 x: 219.89999389648438,
//                 y: 68.54002380371094,
//                 width: 17.238494873046875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   219.89999389648438, 68.54002380371094, 237.13848876953125,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 151,
//               type: "text",
//               content: "BUS",
//               coordinates: {
//                 x: 252.3000030517578,
//                 y: 68.54002380371094,
//                 width: 12.132492065429688,
//                 height: 6.422752380371094,
//                 bbox: [
//                   252.3000030517578, 68.54002380371094, 264.4324951171875,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 152,
//               type: "text",
//               content: "PHONE #",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 71.54002380371094,
//                 width: 25.219499588012695,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 71.54002380371094, 47.11949920654297,
//                   77.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 153,
//               type: "text",
//               content: "CELL",
//               coordinates: {
//                 x: 137.10000610351562,
//                 y: 68.54002380371094,
//                 width: 14.996017456054688,
//                 height: 6.422752380371094,
//                 bbox: [
//                   137.10000610351562, 68.54002380371094, 152.0960235595703,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 154,
//               type: "text",
//               content: "HOME",
//               coordinates: {
//                 x: 75.9000015258789,
//                 y: 68.54002380371094,
//                 width: 17.238494873046875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   75.9000015258789, 68.54002380371094, 93.13849639892578,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 155,
//               type: "text",
//               content: "BUS",
//               coordinates: {
//                 x: 108.30000305175781,
//                 y: 68.54002380371094,
//                 width: 12.132492065429688,
//                 height: 6.422752380371094,
//                 bbox: [
//                   108.30000305175781, 68.54002380371094, 120.4324951171875,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 156,
//               type: "text",
//               content: "PRIMARY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 66.13999938964844,
//                 width: 26.28325080871582,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 66.13999938964844, 48.183250427246094,
//                   72.56275177001953
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 157,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 511.5,
//                 y: 128.54002380371094,
//                 width: 3.197021484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   511.5, 128.54002380371094, 514.697021484375, 134.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 158,
//               type: "text",
//               content: "SQ FT",
//               coordinates: {
//                 x: 571.969970703125,
//                 y: 164.8400115966797,
//                 width: 16.90509033203125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   571.969970703125, 164.8400115966797, 588.8750610351562,
//                   171.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 159,
//               type: "text",
//               content: "ANY AREA LEASED TO OTHERS? Y / N",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 176.54002380371094,
//                 width: 107.01910400390625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   446.70001220703125, 176.54002380371094, 553.7191162109375,
//                   182.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 160,
//               type: "text",
//               content: "TOTAL BUILDING AREA:",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 164.54002380371094,
//                 width: 67.44744873046875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   446.70001220703125, 164.54002380371094, 514.1474609375,
//                   170.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 161,
//               type: "text",
//               content: "SQ FT",
//               coordinates: {
//                 x: 571.969970703125,
//                 y: 152.8400115966797,
//                 width: 16.90509033203125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   571.969970703125, 152.8400115966797, 588.8750610351562,
//                   159.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 162,
//               type: "text",
//               content: "OPEN TO PUBLIC AREA:",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 152.54002380371094,
//                 width: 68.29840087890625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   446.70001220703125, 152.54002380371094, 514.9984130859375,
//                   158.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 163,
//               type: "text",
//               content: "ANNUAL REVENUES:",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 128.54002380371094,
//                 width: 59.27093505859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   446.70001220703125, 128.54002380371094, 505.970947265625,
//                   134.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 164,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 313.5,
//                 y: 128.54002380371094,
//                 width: 28.39923095703125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   313.5, 128.54002380371094, 341.89923095703125,
//                   134.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 165,
//               type: "text",
//               content: "CITY LIMITS",
//               coordinates: {
//                 x: 266.70001220703125,
//                 y: 128.54002380371094,
//                 width: 33.3902587890625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   266.70001220703125, 128.54002380371094, 300.09027099609375,
//                   134.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 166,
//               type: "text",
//               content: "OCCUPIED AREA:",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 140.54002380371094,
//                 width: 49.9041748046875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   446.70001220703125, 140.54002380371094, 496.60418701171875,
//                   146.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 167,
//               type: "text",
//               content: "SQ FT",
//               coordinates: {
//                 x: 571.969970703125,
//                 y: 140.8400115966797,
//                 width: 16.90509033203125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   571.969970703125, 140.8400115966797, 588.8750610351562,
//                   147.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 168,
//               type: "text",
//               content: "BLD #",
//               coordinates: {
//                 x: 24.393749237060547,
//                 y: 152.54002380371094,
//                 width: 16.600250244140625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   24.393749237060547, 152.54002380371094, 40.99399948120117,
//                   158.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 169,
//               type: "text",
//               content: "LOC #",
//               coordinates: {
//                 x: 23.93375015258789,
//                 y: 128.54002380371094,
//                 width: 16.916500091552734,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   23.93375015258789, 128.54002380371094, 40.850250244140625,
//                   134.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 170,
//               type: "text",
//               content: "DESCRIPTION OF OPERATIONS:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 176.54002380371094,
//                 width: 89.88398933410645,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 176.54002380371094, 111.78398895263672,
//                   182.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 171,
//               type: "text",
//               content: "ZIP:",
//               coordinates: {
//                 x: 201.89999389648438,
//                 y: 164.54002380371094,
//                 width: 10.844497680664062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   201.89999389648438, 164.54002380371094, 212.74449157714844,
//                   170.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 172,
//               type: "text",
//               content: "STATE:",
//               coordinates: {
//                 x: 201.89999389648438,
//                 y: 152.54002380371094,
//                 width: 19.889251708984375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   201.89999389648438, 152.54002380371094, 221.78924560546875,
//                   158.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 173,
//               type: "text",
//               content: "COUNTY:",
//               coordinates: {
//                 x: 50.70000076293945,
//                 y: 164.54002380371094,
//                 width: 25.74850082397461,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   50.70000076293945, 164.54002380371094, 76.44850158691406,
//                   170.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 174,
//               type: "text",
//               content: "CITY:",
//               coordinates: {
//                 x: 50.70000076293945,
//                 y: 152.54002380371094,
//                 width: 14.570499420166016,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   50.70000076293945, 152.54002380371094, 65.27050018310547,
//                   158.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 175,
//               type: "text",
//               content: "STREET",
//               coordinates: {
//                 x: 50.70000076293945,
//                 y: 128.54002380371094,
//                 width: 22.65499496459961,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   50.70000076293945, 128.54002380371094, 73.35499572753906,
//                   134.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 176,
//               type: "text",
//               content: "# PART TIME EMPL",
//               coordinates: {
//                 x: 383.9387512207031,
//                 y: 152.54002380371094,
//                 width: 52.865478515625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   383.9387512207031, 152.54002380371094, 436.8042297363281,
//                   158.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 177,
//               type: "text",
//               content: "# FULL TIME EMPL",
//               coordinates: {
//                 x: 384.5587463378906,
//                 y: 128.54002380371094,
//                 width: 52.221527099609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   384.5587463378906, 128.54002380371094, 436.7802734375,
//                   134.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 178,
//               type: "text",
//               content: "INSIDE",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 140.8400115966797,
//                 width: 19.1474609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   281.1000061035156, 140.8400115966797, 300.2474670410156,
//                   147.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 179,
//               type: "text",
//               content: "OUTSIDE",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 152.8400115966797,
//                 width: 25.52996826171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   281.1000061035156, 152.8400115966797, 306.6299743652344,
//                   159.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 180,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 327.8999938964844,
//                 y: 140.8400115966797,
//                 width: 22.0224609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   327.8999938964844, 140.8400115966797, 349.9224548339844,
//                   147.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 181,
//               type: "text",
//               content: "TENANT",
//               coordinates: {
//                 x: 327.8999938964844,
//                 y: 152.8400115966797,
//                 width: 22.97698974609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   327.8999938964844, 152.8400115966797, 350.8769836425781,
//                   159.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 182,
//               type: "text",
//               content: "%",
//               coordinates: {
//                 x: 512.5437622070312,
//                 y: 524.5400390625,
//                 width: 5.11175537109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   512.5437622070312, 524.5400390625, 517.655517578125,
//                   530.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 183,
//               type: "text",
//               content: "%",
//               coordinates: {
//                 x: 314.54376220703125,
//                 y: 524.5400390625,
//                 width: 5.11175537109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   314.54376220703125, 524.5400390625, 319.655517578125,
//                   530.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 184,
//               type: "text",
//               content: "DESCRIPTION OF OPERATIONS OF OTHER NAMED INSUREDS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 536.5400390625,
//                 width: 173.18425941467285,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 536.5400390625, 195.08425903320312,
//                   542.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 185,
//               type: "text",
//               content: "OFF PREMISES INSTALLATION, SERVICE OR REPAIR WORK",
//               coordinates: {
//                 x: 407.1000061035156,
//                 y: 512.5400390625,
//                 width: 166.78457641601562,
//                 height: 6.4227294921875,
//                 bbox: [
//                   407.1000061035156, 512.5400390625, 573.8845825195312,
//                   518.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 186,
//               type: "text",
//               content: "DESCRIPTION OF PRIMARY OPERATIONS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 404.5400085449219,
//                 width: 115.74172401428223,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 404.5400085449219, 137.6417236328125,
//                   410.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 187,
//               type: "text",
//               content: "RETAIL STORES OR SERVICE OPERATIONS % OF TOTAL SALES:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 524.5400390625,
//                 width: 180.40621376037598,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 524.5400390625, 202.30621337890625,
//                   530.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 188,
//               type: "text",
//               content: "INSTALLATION, SERVICE OR REPAIR WORK",
//               coordinates: {
//                 x: 237.89999389648438,
//                 y: 512.5400390625,
//                 width: 122.4345703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   237.89999389648438, 512.5400390625, 360.3345642089844,
//                   518.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 189,
//               type: "text",
//               content: "NATURE OF BUSINESS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 368.97998046875,
//                 width: 86.31949043273926,
//                 height: 8.656768798828125,
//                 bbox: [
//                   21.899999618530273, 368.97998046875, 108.21949005126953,
//                   377.6367492675781
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 190,
//               type: "text",
//               content: "MANUFACTURING",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 383.2400207519531,
//                 width: 50.11701965332031,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 383.2400207519531, 241.21702575683594,
//                   389.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 191,
//               type: "text",
//               content: "INSTITUTIONAL",
//               coordinates: {
//                 x: 115.5,
//                 y: 395.2400207519531,
//                 width: 43.079010009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   115.5, 395.2400207519531, 158.57901000976562,
//                   401.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 192,
//               type: "text",
//               content: "DATE BUSINESS",
//               coordinates: {
//                 x: 507.8999938964844,
//                 y: 378.1400146484375,
//                 width: 46.172698974609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   507.8999938964844, 378.1400146484375, 554.0726928710938,
//                   384.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 193,
//               type: "text",
//               content: "STARTED (MM/DD/YYYY)",
//               coordinates: {
//                 x: 507.8999938964844,
//                 y: 384.1400146484375,
//                 width: 68.51138305664062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   507.8999938964844, 384.1400146484375, 576.411376953125,
//                   390.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 194,
//               type: "text",
//               content: "CONTRACTOR",
//               coordinates: {
//                 x: 115.5,
//                 y: 383.2400207519531,
//                 width: 40.43402099609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   115.5, 383.2400207519531, 155.93402099609375,
//                   389.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 195,
//               type: "text",
//               content: "RESTAURANT",
//               coordinates: {
//                 x: 273.8999938964844,
//                 y: 383.2400207519531,
//                 width: 38.513458251953125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   273.8999938964844, 383.2400207519531, 312.4134521484375,
//                   389.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 196,
//               type: "text",
//               content: "CONDOMINIUMS",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 395.2400207519531,
//                 width: 46.28749465942383,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 395.2400207519531, 82.58749389648438,
//                   401.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 197,
//               type: "text",
//               content: "APARTMENTS",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 383.2400207519531,
//                 width: 38.72623825073242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 383.2400207519531, 75.02623748779297,
//                   389.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 198,
//               type: "text",
//               content: "WHOLESALE",
//               coordinates: {
//                 x: 345.8999938964844,
//                 y: 395.2400207519531,
//                 width: 35.753448486328125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   345.8999938964844, 395.2400207519531, 381.6534423828125,
//                   401.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 199,
//               type: "text",
//               content: "RETAIL",
//               coordinates: {
//                 x: 273.8999938964844,
//                 y: 395.2400207519531,
//                 width: 19.682220458984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   273.8999938964844, 395.2400207519531, 293.58221435546875,
//                   401.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 200,
//               type: "text",
//               content: "SERVICE",
//               coordinates: {
//                 x: 345.8999938964844,
//                 y: 383.2400207519531,
//                 width: 25.1102294921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   345.8999938964844, 383.2400207519531, 371.0102233886719,
//                   389.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 201,
//               type: "text",
//               content: "OFFICE",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 395.2400207519531,
//                 width: 21.056503295898438,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 395.2400207519531, 212.15650939941406,
//                   401.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 202,
//               type: "text",
//               content:
//                 "PREMISES INFORMATION  (Attach ACORD 823 for Additional Premises)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 116.37998962402344,
//                 width: 263.86419105529785,
//                 height: 8.656745910644531,
//                 bbox: [
//                   21.899999618530273, 116.37998962402344, 285.7641906738281,
//                   125.03673553466797
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 203,
//               type: "text",
//               content: "CONTACT NAME:",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 58.93998718261719,
//                 width: 48.09295654296875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   309.8999938964844, 58.93998718261719, 357.9929504394531,
//                   65.36273956298828
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 204,
//               type: "text",
//               content: "SECONDARY E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 106.93998718261719,
//                 width: 89.06170654296875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   309.8999938964844, 106.93998718261719, 398.9617004394531,
//                   113.36273956298828
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 205,
//               type: "text",
//               content: "PRIMARY E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 94.93998718261719,
//                 width: 78.843994140625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   309.8999938964844, 94.93998718261719, 388.7439880371094,
//                   101.36273956298828
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 206,
//               type: "text",
//               content: "CONTACT TYPE:",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 46.93998718261719,
//                 width: 46.166717529296875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   309.8999938964844, 46.93998718261719, 356.06671142578125,
//                   53.36273956298828
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 207,
//               type: "text",
//               content: "CONTACT INFORMATION",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 32.37998962402344,
//                 width: 93.48825263977051,
//                 height: 8.656749725341797,
//                 bbox: [
//                   21.899999618530273, 32.37998962402344, 115.38825225830078,
//                   41.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 208,
//               type: "text",
//               content: "SECONDARY E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 106.93998718261719,
//                 width: 89.06172370910645,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 106.93998718261719, 110.96172332763672,
//                   113.36273956298828
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 209,
//               type: "text",
//               content: "PRIMARY E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 94.93998718261719,
//                 width: 78.84397315979004,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 94.93998718261719, 100.74397277832031,
//                   101.36273956298828
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 210,
//               type: "text",
//               content: "CONTACT NAME:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 58.93998718261719,
//                 width: 48.09300422668457,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 58.93998718261719, 69.99300384521484,
//                   65.36273956298828
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 211,
//               type: "text",
//               content: "CONTACT TYPE:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 46.93998718261719,
//                 width: 46.16674995422363,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 46.93998718261719, 68.0667495727539,
//                   53.36273956298828
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 212,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 317.0350036621094,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   317.0350036621094, 26.379987716674805, 408.8182373046875,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 213,
//               type: "text",
//               content: "ACORD 125 (2016/03)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 757.780029296875,
//                 width: 78.78650093078613,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 757.780029296875, 100.6865005493164,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 214,
//               type: "text",
//               content: "LENDER'S",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 720.8200073242188,
//                 width: 23.802257537841797,
//                 height: 5.3057861328125,
//                 bbox: [
//                   36.29999923706055, 720.8200073242188, 60.102256774902344,
//                   726.1257934570312
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 4.75,
//                 color: 0
//               }
//             },
//             {
//               id: 215,
//               type: "text",
//               content: "LOSS PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 726.8200073242188,
//                 width: 35.69150161743164,
//                 height: 5.3057861328125,
//                 bbox: [
//                   36.29999923706055, 726.8200073242188, 71.99150085449219,
//                   732.1257934570312
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 4.75,
//                 color: 0
//               }
//             },
//             {
//               id: 216,
//               type: "text",
//               content: "Page 2 of 4",
//               coordinates: {
//                 x: 285.84124755859375,
//                 y: 757.780029296875,
//                 width: 40.873504638671875,
//                 height: 8.65673828125,
//                 bbox: [
//                   285.84124755859375, 757.780029296875, 326.7147521972656,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 41.26749469857623,
//                 width: 577.4399999999999,
//                 height: 73.41775219630415,
//                 bbox: [
//                   17.52, 41.26749469857623, 594.9599999999999,
//                   114.68524689488038
//                 ]
//               },
//               properties: {
//                 rows: 5,
//                 columns: 4,
//                 accuracy: 97.47
//               }
//             },
//             {
//               id: 1,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 125.24204786428356,
//                 width: 577.4399999999999,
//                 height: 241.36685852771888,
//                 bbox: [
//                   17.52, 125.24204786428356, 594.9599999999999,
//                   366.60890639200244
//                 ]
//               },
//               properties: {
//                 rows: 20,
//                 columns: 9,
//                 accuracy: 92.662
//               }
//             },
//             {
//               id: 2,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 377.4056346561648,
//                 width: 577.4399999999999,
//                 height: 259.3614056346562,
//                 bbox: [
//                   17.52, 377.4056346561648, 594.9599999999999, 636.767040290821
//                 ]
//               },
//               properties: {
//                 rows: 5,
//                 columns: 15,
//                 accuracy: 81.333
//               }
//             },
//             {
//               id: 3,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 647.3238412602242,
//                 width: 577.68,
//                 height: 109.40684641017867,
//                 bbox: [
//                   17.28, 647.3238412602242, 594.9599999999999, 756.7306876704029
//                 ]
//               },
//               properties: {
//                 rows: 9,
//                 columns: 14,
//                 accuracy: 94.964
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 217,
//           table_count: 4,
//           total_elements: 221
//         }
//       },
//       {
//         page_number: 3,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 415.20001220703125,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   415.20001220703125, 25.188751220703125, 447.44805908203125,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 55.188751220703125,
//                 width: 5.2344970703125,
//                 height: 8.098247528076172,
//                 bbox: [
//                   580.8825073242188, 55.188751220703125, 586.1170043945312,
//                   63.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 91.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 91.18875122070312, 586.1170043945312,
//                   99.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 127.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 127.18875122070312, 586.1170043945312,
//                   135.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 151.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 151.18875122070312, 586.1170043945312,
//                   159.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 187.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 187.18875122070312, 586.1170043945312,
//                   195.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 235.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 235.18875122070312, 586.1170043945312,
//                   243.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 277.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 277.1887512207031, 586.1170043945312,
//                   285.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 319.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 319.1887512207031, 586.1170043945312,
//                   327.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 373.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 373.1887512207031, 586.1170043945312,
//                   381.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 421.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 421.1887512207031, 586.1170043945312,
//                   429.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 469.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 469.1887512207031, 586.1170043945312,
//                   477.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 517.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 517.188720703125, 586.1170043945312,
//                   525.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 529.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 529.188720703125, 586.1170043945312,
//                   537.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 547.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 547.188720703125, 586.1170043945312,
//                   555.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 583.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 583.188720703125, 586.1170043945312,
//                   591.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 607.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 607.188720703125, 586.1170043945312,
//                   615.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "2024",
//               coordinates: {
//                 x: 22.834999084472656,
//                 y: 721.188720703125,
//                 width: 16.124004364013672,
//                 height: 8.0982666015625,
//                 bbox: [
//                   22.834999084472656, 721.188720703125, 38.95900344848633,
//                   729.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "Grange",
//               coordinates: {
//                 x: 120,
//                 y: 697.188720703125,
//                 width: 24.171524047851562,
//                 height: 8.0982666015625,
//                 bbox: [
//                   120, 697.188720703125, 144.17152404785156, 705.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "CT275857106",
//               coordinates: {
//                 x: 120,
//                 y: 709.188720703125,
//                 width: 45.93605041503906,
//                 height: 8.0982666015625,
//                 bbox: [
//                   120, 709.188720703125, 165.93605041503906, 717.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "1,598.00",
//               coordinates: {
//                 x: 127.19999694824219,
//                 y: 721.188720703125,
//                 width: 28.202545166015625,
//                 height: 8.0982666015625,
//                 bbox: [
//                   127.19999694824219, 721.188720703125, 155.4025421142578,
//                   729.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content: "05/18/2024",
//               coordinates: {
//                 x: 156.7550048828125,
//                 y: 733.188720703125,
//                 width: 36.264556884765625,
//                 height: 8.0982666015625,
//                 bbox: [
//                   156.7550048828125, 733.188720703125, 193.01956176757812,
//                   741.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "05/18/2025",
//               coordinates: {
//                 x: 156.7550048828125,
//                 y: 745.188720703125,
//                 width: 36.264556884765625,
//                 height: 8.0982666015625,
//                 bbox: [
//                   156.7550048828125, 745.188720703125, 193.01956176757812,
//                   753.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "Grange",
//               coordinates: {
//                 x: 238.8000030517578,
//                 y: 697.188720703125,
//                 width: 24.171524047851562,
//                 height: 8.0982666015625,
//                 bbox: [
//                   238.8000030517578, 697.188720703125, 262.9715270996094,
//                   705.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "CA2839697",
//               coordinates: {
//                 x: 238.8000030517578,
//                 y: 709.188720703125,
//                 width: 38.28004455566406,
//                 height: 8.0982666015625,
//                 bbox: [
//                   238.8000030517578, 709.188720703125, 277.0800476074219,
//                   717.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content: "5,600.00",
//               coordinates: {
//                 x: 246,
//                 y: 721.188720703125,
//                 width: 28.2025146484375,
//                 height: 8.0982666015625,
//                 bbox: [
//                   246, 721.188720703125, 274.2025146484375, 729.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: "05/18/2024",
//               coordinates: {
//                 x: 275.55499267578125,
//                 y: 733.188720703125,
//                 width: 36.2645263671875,
//                 height: 8.0982666015625,
//                 bbox: [
//                   275.55499267578125, 733.188720703125, 311.81951904296875,
//                   741.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content: "05/18/2025",
//               coordinates: {
//                 x: 275.55499267578125,
//                 y: 745.188720703125,
//                 width: 36.2645263671875,
//                 height: 8.0982666015625,
//                 bbox: [
//                   275.55499267578125, 745.188720703125, 311.81951904296875,
//                   753.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 475.5,
//                 y: 722.5400390625,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   475.5, 722.5400390625, 478.6969909667969, 728.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 356.70001220703125,
//                 y: 722.5400390625,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   356.70001220703125, 722.5400390625, 359.8970031738281,
//                   728.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 237.89999389648438,
//                 y: 722.5400390625,
//                 width: 3.1970062255859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   237.89999389648438, 722.5400390625, 241.0970001220703,
//                   728.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 119.0999984741211,
//                 y: 722.5400390625,
//                 width: 3.1969985961914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   119.0999984741211, 722.5400390625, 122.2969970703125,
//                   728.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content: "EFFECTIVE DATE",
//               coordinates: {
//                 x: 47.099998474121094,
//                 y: 734.8400268554688,
//                 width: 48.069984436035156,
//                 height: 6.4227294921875,
//                 bbox: [
//                   47.099998474121094, 734.8400268554688, 95.16998291015625,
//                   741.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content: "YEAR",
//               coordinates: {
//                 x: 22.612499237060547,
//                 y: 688.9400024414062,
//                 width: 15.96200180053711,
//                 height: 6.4227294921875,
//                 bbox: [
//                   22.612499237060547, 688.9400024414062, 38.574501037597656,
//                   695.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content: "EXPIRATION DATE",
//               coordinates: {
//                 x: 47.099998474121094,
//                 y: 746.8400268554688,
//                 width: 50.84148406982422,
//                 height: 6.4227294921875,
//                 bbox: [
//                   47.099998474121094, 746.8400268554688, 97.94148254394531,
//                   753.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content: "PREMIUM",
//               coordinates: {
//                 x: 47.099998474121094,
//                 y: 722.8400268554688,
//                 width: 27.134239196777344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   47.099998474121094, 722.8400268554688, 74.23423767089844,
//                   729.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content: "POLICY NUMBER",
//               coordinates: {
//                 x: 47.099998474121094,
//                 y: 710.8400268554688,
//                 width: 47.460479736328125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   47.099998474121094, 710.8400268554688, 94.56047821044922,
//                   717.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content: "CARRIER",
//               coordinates: {
//                 x: 47.099998474121094,
//                 y: 698.8400268554688,
//                 width: 25.857742309570312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   47.099998474121094, 698.8400268554688, 72.9577407836914,
//                   705.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content: "OTHER:",
//               coordinates: {
//                 x: 475.5,
//                 y: 688.9400024414062,
//                 width: 22.022491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   475.5, 688.9400024414062, 497.5224914550781, 695.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content: "PROPERTY",
//               coordinates: {
//                 x: 396.68499755859375,
//                 y: 688.9400024414062,
//                 width: 31.596221923828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   396.68499755859375, 688.9400024414062, 428.2812194824219,
//                   695.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content: "AUTOMOBILE",
//               coordinates: {
//                 x: 274.427490234375,
//                 y: 688.9400024414062,
//                 width: 38.51348876953125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   274.427490234375, 688.9400024414062, 312.94097900390625,
//                   695.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content: "GENERAL LIABILITY",
//               coordinates: {
//                 x: 146.3625030517578,
//                 y: 688.9400024414062,
//                 width: 57.011260986328125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   146.3625030517578, 688.9400024414062, 203.37376403808594,
//                   695.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content: "CATEGORY",
//               coordinates: {
//                 x: 47.099998474121094,
//                 y: 688.9400024414062,
//                 width: 31.918243408203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   47.099998474121094, 688.9400024414062, 79.01824188232422,
//                   695.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content: "PRIOR CARRIER INFORMATION",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 674.9800415039062,
//                 width: 118.1564884185791,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 674.9800415039062, 140.05648803710938,
//                   683.6367797851562
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content:
//                 "REMARKS / PROCESSING INSTRUCTIONS (ACORD 101, Additional Remarks Schedule, may be attached if more space is required)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 632.3800048828125,
//                 width: 480.2984256744385,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 632.3800048828125, 502.19842529296875,
//                   641.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content:
//                 "13. DOES APPLICANT HAVE OTHER BUSINESS VENTURES FOR WHICH COVERAGE IS NOT REQUESTED?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 548.1599731445312,
//                 width: 344.83965492248535,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 548.1599731445312, 366.7396545410156,
//                   555.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content: "3.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 152.1599884033203,
//                 width: 5.622751235961914,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 152.1599884033203, 27.522750854492188,
//                   159.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content: "ANY EXPOSURE TO FLAMMABLES, EXPLOSIVES, CHEMICALS?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 152.1599884033203,
//                 width: 204.20778274536133,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   36.29999923706055, 152.1599884033203, 240.50778198242188,
//                   159.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content: "SAFETY POSITION",
//               coordinates: {
//                 x: 137.10000610351562,
//                 y: 140.54002380371094,
//                 width: 51.58323669433594,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   137.10000610351562, 140.54002380371094, 188.68324279785156,
//                   146.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content: "OSHA",
//               coordinates: {
//                 x: 320.70001220703125,
//                 y: 140.54002380371094,
//                 width: 16.6002197265625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   320.70001220703125, 140.54002380371094, 337.30023193359375,
//                   146.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content: "MONTHLY MEETINGS",
//               coordinates: {
//                 x: 223.5,
//                 y: 140.54002380371094,
//                 width: 59.368743896484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   223.5, 140.54002380371094, 282.8687438964844,
//                   146.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content: "SAFETY MANUAL",
//               coordinates: {
//                 x: 54.29999923706055,
//                 y: 140.54002380371094,
//                 width: 49.047481536865234,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   54.29999923706055, 140.54002380371094, 103.34748077392578,
//                   146.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 52,
//               type: "text",
//               content: "2.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 128.1599884033203,
//                 width: 5.622751235961914,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 128.1599884033203, 27.522750854492188,
//                   135.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 53,
//               type: "text",
//               content: "IS A FORMAL SAFETY PROGRAM IN OPERATION?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 128.1599884033203,
//                 width: 159.84677505493164,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   36.29999923706055, 128.1599884033203, 196.1467742919922,
//                   135.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 54,
//               type: "text",
//               content: "Y / N",
//               coordinates: {
//                 x: 577.1612548828125,
//                 y: 44.54002380371094,
//                 width: 12.65582275390625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   577.1612548828125, 44.54002380371094, 589.8170776367188,
//                   50.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 55,
//               type: "text",
//               content: 'EXPLAIN ALL "YES" RESPONSES',
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 44.54002380371094,
//                 width: 93.20748329162598,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 44.54002380371094, 115.10748291015625,
//                   50.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 56,
//               type: "text",
//               content: "SUBSIDIARY COMPANY NAME",
//               coordinates: {
//                 x: 39.900001525878906,
//                 y: 104.54002380371094,
//                 width: 84.06497192382812,
//                 height: 6.422752380371094,
//                 bbox: [
//                   39.900001525878906, 104.54002380371094, 123.96497344970703,
//                   110.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 57,
//               type: "text",
//               content: "RELATIONSHIP DESCRIPTION",
//               coordinates: {
//                 x: 363.8999938964844,
//                 y: 104.54002380371094,
//                 width: 83.08163452148438,
//                 height: 6.422752380371094,
//                 bbox: [
//                   363.8999938964844, 104.54002380371094, 446.98162841796875,
//                   110.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 58,
//               type: "text",
//               content: "% OWNED",
//               coordinates: {
//                 x: 522.0250244140625,
//                 y: 104.54002380371094,
//                 width: 28.72705078125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   522.0250244140625, 104.54002380371094, 550.7520751953125,
//                   110.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 59,
//               type: "text",
//               content: "PARENT COMPANY NAME",
//               coordinates: {
//                 x: 39.900001525878906,
//                 y: 68.54002380371094,
//                 width: 72.14522552490234,
//                 height: 6.422752380371094,
//                 bbox: [
//                   39.900001525878906, 68.54002380371094, 112.04522705078125,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 60,
//               type: "text",
//               content: "RELATIONSHIP DESCRIPTION",
//               coordinates: {
//                 x: 363.8999938964844,
//                 y: 68.54002380371094,
//                 width: 83.08163452148438,
//                 height: 6.422752380371094,
//                 bbox: [
//                   363.8999938964844, 68.54002380371094, 446.98162841796875,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 61,
//               type: "text",
//               content: "% OWNED",
//               coordinates: {
//                 x: 522.0250244140625,
//                 y: 68.54002380371094,
//                 width: 28.72705078125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   522.0250244140625, 68.54002380371094, 550.7520751953125,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 62,
//               type: "text",
//               content: "DOES THE APPLICANT HAVE ANY SUBSIDIARIES?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 92.15998840332031,
//                 width: 160.98750686645508,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   36.29999923706055, 92.15998840332031, 197.28750610351562,
//                   99.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 63,
//               type: "text",
//               content: "IS THE APPLICANT A SUBSIDIARY OF ANOTHER ENTITY ?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 56.15998840332031,
//                 width: 185.57776260375977,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   36.29999923706055, 56.15998840332031, 221.8777618408203,
//                   63.699737548828125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 64,
//               type: "text",
//               content: "1a.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 55.56001281738281,
//                 width: 9.375749588012695,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 55.56001281738281, 31.27574920654297,
//                   63.099761962890625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 65,
//               type: "text",
//               content: "1b.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 92.15998840332031,
//                 width: 9.375749588012695,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 92.15998840332031, 31.27574920654297,
//                   99.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 66,
//               type: "text",
//               content: "4.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 188.1599884033203,
//                 width: 5.622751235961914,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 188.1599884033203, 27.522750854492188,
//                   195.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 67,
//               type: "text",
//               content:
//                 "ANY OTHER INSURANCE WITH THIS COMPANY?  (List policy numbers)",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 188.1599884033203,
//                 width: 222.21684646606445,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   36.29999923706055, 188.1599884033203, 258.516845703125,
//                   195.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 68,
//               type: "text",
//               content: "POLICY NUMBER",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 202.9399871826172,
//                 width: 48.09300231933594,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   144.3000030517578, 202.9399871826172, 192.39300537109375,
//                   209.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 69,
//               type: "text",
//               content: "POLICY NUMBER",
//               coordinates: {
//                 x: 417.8999938964844,
//                 y: 202.9399871826172,
//                 width: 48.09295654296875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   417.8999938964844, 202.9399871826172, 465.9929504394531,
//                   209.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 70,
//               type: "text",
//               content: "LINE OF BUSINESS",
//               coordinates: {
//                 x: 39.900001525878906,
//                 y: 202.9399871826172,
//                 width: 53.60723114013672,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   39.900001525878906, 202.9399871826172, 93.50723266601562,
//                   209.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 71,
//               type: "text",
//               content: "LINE OF BUSINESS",
//               coordinates: {
//                 x: 302.70001220703125,
//                 y: 202.9399871826172,
//                 width: 53.607177734375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   302.70001220703125, 202.9399871826172, 356.30718994140625,
//                   209.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 72,
//               type: "text",
//               content: "NAME OF TRUST:",
//               coordinates: {
//                 x: 187.5,
//                 y: 518.5400390625,
//                 width: 48.51275634765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   187.5, 518.5400390625, 236.01275634765625, 524.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 73,
//               type: "text",
//               content: "HAS BUSINESS BEEN PLACED IN A TRUST?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 518.1599731445312,
//                 width: 141.12903213500977,
//                 height: 7.539794921875,
//                 bbox: [
//                   36.29999923706055, 518.1599731445312, 177.4290313720703,
//                   525.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 74,
//               type: "text",
//               content: "11.",
//               coordinates: {
//                 x: 22.5,
//                 y: 518.1599731445312,
//                 width: 8.876251220703125,
//                 height: 7.539794921875,
//                 bbox: [
//                   22.5, 518.1599731445312, 31.376251220703125, 525.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 75,
//               type: "text",
//               content:
//                 "HAS APPLICANT HAD A JUDGEMENT OR LIEN DURING THE LAST FIVE (5) YEARS?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 470.15997314453125,
//                 width: 264.6608467102051,
//                 height: 7.539764404296875,
//                 bbox: [
//                   36.29999923706055, 470.15997314453125, 300.9608459472656,
//                   477.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 76,
//               type: "text",
//               content: "10.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 470.15997314453125,
//                 width: 9.375749588012695,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 470.15997314453125, 31.27574920654297,
//                   477.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 77,
//               type: "text",
//               content:
//                 "HAS APPLICANT HAD A FORECLOSURE, REPOSSESSION, BANKRUPTCY OR FILED FOR BANKRUPTCY DURING THE LAST FIVE (5) YEARS?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 422.15997314453125,
//                 width: 449.2330207824707,
//                 height: 7.539764404296875,
//                 bbox: [
//                   36.29999923706055, 422.15997314453125, 485.53302001953125,
//                   429.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 78,
//               type: "text",
//               content: "9.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 421.55999755859375,
//                 width: 5.622751235961914,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 421.55999755859375, 27.522750854492188,
//                   429.0997619628906
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 79,
//               type: "text",
//               content: "CONDITION CORRECTED (Describe):",
//               coordinates: {
//                 x: 219.89999389648438,
//                 y: 266.5400390625,
//                 width: 101.83242797851562,
//                 height: 6.4227294921875,
//                 bbox: [
//                   219.89999389648438, 266.5400390625, 321.732421875,
//                   272.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 80,
//               type: "text",
//               content: "UNDERWRITING",
//               coordinates: {
//                 x: 133.5,
//                 y: 266.5400390625,
//                 width: 45.218017578125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   133.5, 266.5400390625, 178.718017578125, 272.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 81,
//               type: "text",
//               content: "AGENT NO LONGER REPRESENTS CARRIER",
//               coordinates: {
//                 x: 133.5,
//                 y: 254.54002380371094,
//                 width: 124.792236328125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   133.5, 254.54002380371094, 258.292236328125, 260.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 82,
//               type: "text",
//               content: "NON-RENEWAL",
//               coordinates: {
//                 x: 54.29999923706055,
//                 y: 266.5400390625,
//                 width: 43.412479400634766,
//                 height: 6.4227294921875,
//                 bbox: [
//                   54.29999923706055, 266.5400390625, 97.71247863769531,
//                   272.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 83,
//               type: "text",
//               content: "NON-PAYMENT",
//               coordinates: {
//                 x: 54.29999923706055,
//                 y: 254.54002380371094,
//                 width: 41.82548904418945,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   54.29999923706055, 254.54002380371094, 96.12548828125,
//                   260.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 84,
//               type: "text",
//               content:
//                 "ANY POLICY OR COVERAGE DECLINED, CANCELLED OR NON-RENEWED DURING THE PRIOR THREE (3) YEARS FOR ANY PREMISES OR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 234.95997619628906,
//                 width: 444.38664627075195,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   36.29999923706055, 234.95997619628906, 480.6866455078125,
//                   242.49972534179688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 85,
//               type: "text",
//               content: "OPERATIONS?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 243.36000061035156,
//                 width: 47.4592399597168,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   36.29999923706055, 243.36000061035156, 83.75923919677734,
//                   250.89974975585938
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 86,
//               type: "text",
//               content: " (Missouri Applicants - Do not answer this question)",
//               coordinates: {
//                 x: 83.75923919677734,
//                 y: 243.36000061035156,
//                 width: 167.78609466552734,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   83.75923919677734, 243.36000061035156, 251.5453338623047,
//                   250.89974975585938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 87,
//               type: "text",
//               content: "5.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 234.36000061035156,
//                 width: 5.622751235961914,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 234.36000061035156, 27.522750854492188,
//                   241.89974975585938
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 88,
//               type: "text",
//               content: "GENERAL INFORMATION",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 32.98002624511719,
//                 width: 93.92225074768066,
//                 height: 8.656749725341797,
//                 bbox: [
//                   21.899999618530273, 32.98002624511719, 115.82225036621094,
//                   41.636775970458984
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 89,
//               type: "text",
//               content:
//                 "ANY PAST LOSSES OR CLAIMS RELATING TO SEXUAL ABUSE OR MOLESTATION ALLEGATIONS, DISCRIMINATION OR NEGLIGENT HIRING?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 278.15997314453125,
//                 width: 449.0978889465332,
//                 height: 7.539764404296875,
//                 bbox: [
//                   36.29999923706055, 278.15997314453125, 485.39788818359375,
//                   285.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 90,
//               type: "text",
//               content: "6.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 278.15997314453125,
//                 width: 5.622751235961914,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 278.15997314453125, 27.522750854492188,
//                   285.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 91,
//               type: "text",
//               content:
//                 "DURING THE LAST FIVE YEARS (TEN IN RI), HAS ANY APPLICANT BEEN INDICTED FOR OR CONVICTED OF ANY DEGREE OF THE CRIME OF FRAUD,",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 313.55999755859375,
//                 width: 479.3987922668457,
//                 height: 7.539764404296875,
//                 bbox: [
//                   36.29999923706055, 313.55999755859375, 515.6987915039062,
//                   321.0997619628906
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 92,
//               type: "text",
//               content:
//                 "BRIBERY, ARSON OR ANY OTHER ARSON-RELATED CRIME IN CONNECTION WITH THIS OR ANY OTHER PROPERTY?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 321.9599914550781,
//                 width: 377.9260139465332,
//                 height: 7.539764404296875,
//                 bbox: [
//                   36.29999923706055, 321.9599914550781, 414.22601318359375,
//                   329.499755859375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 93,
//               type: "text",
//               content:
//                 "(In RI, this question must be answered by any applicant for property insurance.  Failure to disclose the existence of an arson conviction is a misdemeanor punishable",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 330.3599853515625,
//                 width: 491.93303298950195,
//                 height: 7.539764404296875,
//                 bbox: [
//                   36.29999923706055, 330.3599853515625, 528.2330322265625,
//                   337.8997497558594
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 94,
//               type: "text",
//               content: "by a sentence of up to one year of imprisonment).",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 338.15997314453125,
//                 width: 148.47307205200195,
//                 height: 7.539764404296875,
//                 bbox: [
//                   36.29999923706055, 338.15997314453125, 184.7730712890625,
//                   345.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 95,
//               type: "text",
//               content: "7.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 314.15997314453125,
//                 width: 5.622751235961914,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 314.15997314453125, 27.522750854492188,
//                   321.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 96,
//               type: "text",
//               content: "RESOLUTION",
//               coordinates: {
//                 x: 353.1000061035156,
//                 y: 386.5400085449219,
//                 width: 37.656707763671875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   353.1000061035156, 386.5400085449219, 390.7567138671875,
//                   392.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 97,
//               type: "text",
//               content: "RESOLVE DATE",
//               coordinates: {
//                 x: 507.2637634277344,
//                 y: 386.5400085449219,
//                 width: 43.826690673828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   507.2637634277344, 386.5400085449219, 551.0904541015625,
//                   392.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 98,
//               type: "text",
//               content: "EXPLANATION",
//               coordinates: {
//                 x: 90.30000305175781,
//                 y: 386.5400085449219,
//                 width: 40.74449157714844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   90.30000305175781, 386.5400085449219, 131.04449462890625,
//                   392.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 99,
//               type: "text",
//               content: "OCCUR DATE",
//               coordinates: {
//                 x: 42.54750061035156,
//                 y: 386.5400085449219,
//                 width: 37.88099670410156,
//                 height: 6.4227294921875,
//                 bbox: [
//                   42.54750061035156, 386.5400085449219, 80.42849731445312,
//                   392.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 100,
//               type: "text",
//               content: "ANY UNCORRECTED FIRE AND/OR SAFETY CODE VIOLATIONS?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 374.15997314453125,
//                 width: 207.9405403137207,
//                 height: 7.539764404296875,
//                 bbox: [
//                   36.29999923706055, 374.15997314453125, 244.24053955078125,
//                   381.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 101,
//               type: "text",
//               content: "8.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 373.55999755859375,
//                 width: 5.622751235961914,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 373.55999755859375, 27.522750854492188,
//                   381.0997619628906
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 102,
//               type: "text",
//               content:
//                 "ANY FOREIGN OPERATIONS, FOREIGN PRODUCTS DISTRIBUTED IN USA, OR US PRODUCTS SOLD / DISTRIBUTED IN FOREIGN COUNTRIES?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 528.9599609375,
//                 width: 459.4120063781738,
//                 height: 7.539794921875,
//                 bbox: [
//                   36.29999923706055, 528.9599609375, 495.7120056152344,
//                   536.499755859375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 103,
//               type: "text",
//               content:
//                 '(If "YES", attach ACORD 815 for Liability Exposure and/or ACORD 816 for Property Exposure)',
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 537.3599853515625,
//                 width: 281.42107009887695,
//                 height: 7.539794921875,
//                 bbox: [
//                   36.29999923706055, 537.3599853515625, 317.7210693359375,
//                   544.8997802734375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 104,
//               type: "text",
//               content: "12.",
//               coordinates: {
//                 x: 22.5,
//                 y: 528.9599609375,
//                 width: 9.375751495361328,
//                 height: 7.539794921875,
//                 bbox: [
//                   22.5, 528.9599609375, 31.875751495361328, 536.499755859375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 105,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 317.0350036621094,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   317.0350036621094, 26.379987716674805, 408.8182373046875,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 106,
//               type: "text",
//               content: "Page 3 of 4",
//               coordinates: {
//                 x: 285.84124755859375,
//                 y: 757.780029296875,
//                 width: 40.873504638671875,
//                 height: 8.65673828125,
//                 bbox: [
//                   285.84124755859375, 757.780029296875, 326.7147521972656,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 107,
//               type: "text",
//               content: "ACORD 125 (2016/03)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 757.780029296875,
//                 width: 78.78650093078613,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 757.780029296875, 100.6865005493164,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 108,
//               type: "text",
//               content: "OCCUR DATE",
//               coordinates: {
//                 x: 42.54750061035156,
//                 y: 434.5400085449219,
//                 width: 37.88099670410156,
//                 height: 6.4227294921875,
//                 bbox: [
//                   42.54750061035156, 434.5400085449219, 80.42849731445312,
//                   440.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 109,
//               type: "text",
//               content: "EXPLANATION",
//               coordinates: {
//                 x: 90.30000305175781,
//                 y: 434.5400085449219,
//                 width: 40.74449157714844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   90.30000305175781, 434.5400085449219, 131.04449462890625,
//                   440.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 110,
//               type: "text",
//               content: "RESOLUTION",
//               coordinates: {
//                 x: 353.1000061035156,
//                 y: 434.5400085449219,
//                 width: 37.656707763671875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   353.1000061035156, 434.5400085449219, 390.7567138671875,
//                   440.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 111,
//               type: "text",
//               content: "RESOLVE DATE",
//               coordinates: {
//                 x: 507.2637634277344,
//                 y: 434.5400085449219,
//                 width: 43.826690673828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   507.2637634277344, 434.5400085449219, 551.0904541015625,
//                   440.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 112,
//               type: "text",
//               content: "OCCUR DATE",
//               coordinates: {
//                 x: 42.54750061035156,
//                 y: 482.5400085449219,
//                 width: 37.88099670410156,
//                 height: 6.4227294921875,
//                 bbox: [
//                   42.54750061035156, 482.5400085449219, 80.42849731445312,
//                   488.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 113,
//               type: "text",
//               content: "EXPLANATION",
//               coordinates: {
//                 x: 90.30000305175781,
//                 y: 482.5400085449219,
//                 width: 40.74449157714844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   90.30000305175781, 482.5400085449219, 131.04449462890625,
//                   488.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 114,
//               type: "text",
//               content: "RESOLUTION",
//               coordinates: {
//                 x: 353.1000061035156,
//                 y: 482.5400085449219,
//                 width: 37.656707763671875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   353.1000061035156, 482.5400085449219, 390.7567138671875,
//                   488.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 115,
//               type: "text",
//               content: "RESOLVE DATE",
//               coordinates: {
//                 x: 507.2637634277344,
//                 y: 482.5400085449219,
//                 width: 43.826690673828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   507.2637634277344, 482.5400085449219, 551.0904541015625,
//                   488.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 116,
//               type: "text",
//               content:
//                 'DOES APPLICANT OWN / LEASE / OPERATE ANY DRONES?  (If "YES", describe use)',
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 584.1599731445312,
//                 width: 264.8092231750488,
//                 height: 7.539794921875,
//                 bbox: [
//                   36.29999923706055, 584.1599731445312, 301.1092224121094,
//                   591.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 117,
//               type: "text",
//               content: "14.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 584.1599731445312,
//                 width: 9.375749588012695,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 584.1599731445312, 31.27574920654297,
//                   591.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 118,
//               type: "text",
//               content:
//                 '15. DOES APPLICANT HIRE OTHERS TO OPERATE DRONES?  (If "YES", describe use)',
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 608.1599731445312,
//                 width: 273.4717044830322,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 608.1599731445312, 295.3717041015625,
//                   615.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 41.26749469857623,
//                 width: 577.4399999999999,
//                 height: 589.5013632232656,
//                 bbox: [
//                   17.52, 41.26749469857623, 594.9599999999999, 630.7688579218418
//                 ]
//               },
//               properties: {
//                 rows: 34,
//                 columns: 28,
//                 accuracy: 59.829
//               }
//             },
//             {
//               id: 1,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 683.3129354740988,
//                 width: 577.68,
//                 height: 73.41775219630404,
//                 bbox: [
//                   17.28, 683.3129354740988, 594.9599999999999, 756.7306876704029
//                 ]
//               },
//               properties: {
//                 rows: 6,
//                 columns: 6,
//                 accuracy: 100
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 119,
//           table_count: 2,
//           total_elements: 121
//         }
//       },
//       {
//         page_number: 4,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 415.20001220703125,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   415.20001220703125, 25.188751220703125, 447.44805908203125,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "2023",
//               coordinates: {
//                 x: 22.834999084472656,
//                 y: 79.18875122070312,
//                 width: 16.124004364013672,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.834999084472656, 79.18875122070312, 38.95900344848633,
//                   87.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "Grange",
//               coordinates: {
//                 x: 120,
//                 y: 55.188751220703125,
//                 width: 24.171524047851562,
//                 height: 8.098247528076172,
//                 bbox: [
//                   120, 55.188751220703125, 144.17152404785156, 63.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "CT275857106",
//               coordinates: {
//                 x: 120,
//                 y: 67.18875122070312,
//                 width: 45.93605041503906,
//                 height: 8.098251342773438,
//                 bbox: [
//                   120, 67.18875122070312, 165.93605041503906, 75.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "1,477.00",
//               coordinates: {
//                 x: 127.19999694824219,
//                 y: 79.18875122070312,
//                 width: 28.202545166015625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   127.19999694824219, 79.18875122070312, 155.4025421142578,
//                   87.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "05/18/2023",
//               coordinates: {
//                 x: 156.7550048828125,
//                 y: 91.18875122070312,
//                 width: 36.264556884765625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   156.7550048828125, 91.18875122070312, 193.01956176757812,
//                   99.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "05/18/2024",
//               coordinates: {
//                 x: 156.7550048828125,
//                 y: 103.18875122070312,
//                 width: 36.264556884765625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   156.7550048828125, 103.18875122070312, 193.01956176757812,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "Grange",
//               coordinates: {
//                 x: 238.8000030517578,
//                 y: 55.188751220703125,
//                 width: 24.171524047851562,
//                 height: 8.098247528076172,
//                 bbox: [
//                   238.8000030517578, 55.188751220703125, 262.9715270996094,
//                   63.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "CA2839697",
//               coordinates: {
//                 x: 238.8000030517578,
//                 y: 67.18875122070312,
//                 width: 38.28004455566406,
//                 height: 8.098251342773438,
//                 bbox: [
//                   238.8000030517578, 67.18875122070312, 277.0800476074219,
//                   75.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "4,420.00",
//               coordinates: {
//                 x: 246,
//                 y: 79.18875122070312,
//                 width: 28.2025146484375,
//                 height: 8.098251342773438,
//                 bbox: [
//                   246, 79.18875122070312, 274.2025146484375, 87.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "05/18/2023",
//               coordinates: {
//                 x: 275.55499267578125,
//                 y: 91.18875122070312,
//                 width: 36.2645263671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   275.55499267578125, 91.18875122070312, 311.81951904296875,
//                   99.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "05/18/2024",
//               coordinates: {
//                 x: 275.55499267578125,
//                 y: 103.18875122070312,
//                 width: 36.2645263671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   275.55499267578125, 103.18875122070312, 311.81951904296875,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "2022",
//               coordinates: {
//                 x: 22.834999084472656,
//                 y: 139.18875122070312,
//                 width: 16.124004364013672,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.834999084472656, 139.18875122070312, 38.95900344848633,
//                   147.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "Grange",
//               coordinates: {
//                 x: 120,
//                 y: 115.18875122070312,
//                 width: 24.171524047851562,
//                 height: 8.098251342773438,
//                 bbox: [
//                   120, 115.18875122070312, 144.17152404785156,
//                   123.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "CT275857106",
//               coordinates: {
//                 x: 120,
//                 y: 127.18875122070312,
//                 width: 45.93605041503906,
//                 height: 8.098251342773438,
//                 bbox: [
//                   120, 127.18875122070312, 165.93605041503906,
//                   135.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "1,003.00",
//               coordinates: {
//                 x: 127.19999694824219,
//                 y: 139.18875122070312,
//                 width: 28.202545166015625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   127.19999694824219, 139.18875122070312, 155.4025421142578,
//                   147.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "05/18/2022",
//               coordinates: {
//                 x: 156.7550048828125,
//                 y: 151.18875122070312,
//                 width: 36.264556884765625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   156.7550048828125, 151.18875122070312, 193.01956176757812,
//                   159.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "05/18/2023",
//               coordinates: {
//                 x: 156.7550048828125,
//                 y: 163.18875122070312,
//                 width: 36.264556884765625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   156.7550048828125, 163.18875122070312, 193.01956176757812,
//                   171.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "Grange",
//               coordinates: {
//                 x: 238.8000030517578,
//                 y: 115.18875122070312,
//                 width: 24.171524047851562,
//                 height: 8.098251342773438,
//                 bbox: [
//                   238.8000030517578, 115.18875122070312, 262.9715270996094,
//                   123.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "CA2839697",
//               coordinates: {
//                 x: 238.8000030517578,
//                 y: 127.18875122070312,
//                 width: 38.28004455566406,
//                 height: 8.098251342773438,
//                 bbox: [
//                   238.8000030517578, 127.18875122070312, 277.0800476074219,
//                   135.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "3,917.00",
//               coordinates: {
//                 x: 246,
//                 y: 139.18875122070312,
//                 width: 28.2025146484375,
//                 height: 8.098251342773438,
//                 bbox: [
//                   246, 139.18875122070312, 274.2025146484375, 147.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content: "05/18/2022",
//               coordinates: {
//                 x: 275.55499267578125,
//                 y: 151.18875122070312,
//                 width: 36.2645263671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   275.55499267578125, 151.18875122070312, 311.81951904296875,
//                   159.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "05/18/2023",
//               coordinates: {
//                 x: 275.55499267578125,
//                 y: 163.18875122070312,
//                 width: 36.2645263671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   275.55499267578125, 163.18875122070312, 311.81951904296875,
//                   171.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "Applicable in OR:",
//               coordinates: {
//                 x: 25.5,
//                 y: 602.6799926757812,
//                 width: 64.51101684570312,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 602.6799926757812, 90.01101684570312, 611.3367309570312
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content:
//                 " Any person who knowingly and with intent to defraud or solicit another to defraud the insurer by submitting an application containing a",
//               coordinates: {
//                 x: 90.01101684570312,
//                 y: 602.6799926757812,
//                 width: 460.9772033691406,
//                 height: 8.65673828125,
//                 bbox: [
//                   90.01101684570312, 602.6799926757812, 550.9882202148438,
//                   611.3367309570312
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content:
//                 "false statement as to any material fact may be violating state law.",
//               coordinates: {
//                 x: 25.5,
//                 y: 611.9800415039062,
//                 width: 222.9520263671875,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 611.9800415039062, 248.4520263671875, 620.6367797851562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: "Applicable in NJ:",
//               coordinates: {
//                 x: 25.5,
//                 y: 583.4800415039062,
//                 width: 62.79826354980469,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 583.4800415039062, 88.29826354980469, 592.1367797851562
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content:
//                 " Any person who includes any false or misleading information on an application for an insurance policy is subject to criminal and civil",
//               coordinates: {
//                 x: 88.29826354980469,
//                 y: 583.4800415039062,
//                 width: 454.09034729003906,
//                 height: 8.65673828125,
//                 bbox: [
//                   88.29826354980469, 583.4800415039062, 542.3886108398438,
//                   592.1367797851562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content: "penalties.",
//               coordinates: {
//                 x: 25.5,
//                 y: 592.780029296875,
//                 width: 33.154510498046875,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 592.780029296875, 58.654510498046875, 601.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content: "Applicable in KY, NY, OH and PA:",
//               coordinates: {
//                 x: 25.5,
//                 y: 522.8800048828125,
//                 width: 121.14801025390625,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 522.8800048828125, 146.64801025390625, 531.5367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content:
//                 " Any person who knowingly and with intent to defraud any insurance company or other person files an application for",
//               coordinates: {
//                 x: 146.64801025390625,
//                 y: 522.8800048828125,
//                 width: 400.36016845703125,
//                 height: 8.65673828125,
//                 bbox: [
//                   146.64801025390625, 522.8800048828125, 547.0081787109375,
//                   531.5367431640625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content:
//                 "insurance or statement of claim containing any materially false information or conceals for the purpose of misleading, information concerning any fact material",
//               coordinates: {
//                 x: 25.5,
//                 y: 532.1799926757812,
//                 width: 539.3998413085938,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 532.1799926757812, 564.8998413085938, 540.8367309570312
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content:
//                 "thereto commits a fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties (not to exceed five thousand dollars and",
//               coordinates: {
//                 x: 25.5,
//                 y: 541.780029296875,
//                 width: 535.9667358398438,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 541.780029296875, 561.4667358398438, 550.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content:
//                 "the stated value of the claim for each such violation)*. *Applies in NY Only.",
//               coordinates: {
//                 x: 25.5,
//                 y: 550.780029296875,
//                 width: 254.52560424804688,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 550.780029296875, 280.0256042480469, 559.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content:
//                 "(Not applicable in AZ, CA, DE, KS, MA, MN, ND, NY, OR, VA, or WV.  Specific ACORD 38s are available for applicants in these states.)",
//               coordinates: {
//                 x: 25.5,
//                 y: 366.3599853515625,
//                 width: 402.3876647949219,
//                 height: 7.539764404296875,
//                 bbox: [
//                   25.5, 366.3599853515625, 427.8876647949219, 373.8997497558594
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content: "(Applicant's Initials):",
//               coordinates: {
//                 x: 478.5849914550781,
//                 y: 368.5400085449219,
//                 width: 56.252349853515625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   478.5849914550781, 368.5400085449219, 534.8373413085938,
//                   374.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content:
//                 "PERSONAL INFORMATION ABOUT YOU, INCLUDING INFORMATION FROM A CREDIT OR OTHER INVESTIGATIVE REPORT, MAY BE COLLECTED FROM PERSONS",
//               coordinates: {
//                 x: 25.5,
//                 y: 292.55999755859375,
//                 width: 516.0242309570312,
//                 height: 7.539764404296875,
//                 bbox: [
//                   25.5, 292.55999755859375, 541.5242309570312, 300.0997619628906
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content:
//                 "OTHER THAN YOU IN CONNECTION WITH THIS APPLICATION FOR INSURANCE AND SUBSEQUENT AMENDMENTS AND RENEWALS.  SUCH INFORMATION AS WELL AS",
//               coordinates: {
//                 x: 25.5,
//                 y: 300.9599914550781,
//                 width: 538.265380859375,
//                 height: 7.539764404296875,
//                 bbox: [
//                   25.5, 300.9599914550781, 563.765380859375, 308.499755859375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content:
//                 "OTHER PERSONAL AND PRIVILEGED INFORMATION COLLECTED BY US OR OUR AGENTS MAY IN CERTAIN CIRCUMSTANCES BE DISCLOSED TO THIRD PARTIES",
//               coordinates: {
//                 x: 25.5,
//                 y: 308.7599792480469,
//                 width: 521.6671752929688,
//                 height: 7.539764404296875,
//                 bbox: [
//                   25.5, 308.7599792480469, 547.1671752929688, 316.29974365234375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content:
//                 "WITHOUT YOUR AUTHORIZATION.  CREDIT SCORING INFORMATION MAY BE USED TO HELP DETERMINE EITHER YOUR ELIGIBILITY FOR INSURANCE OR THE",
//               coordinates: {
//                 x: 25.5,
//                 y: 317.15997314453125,
//                 width: 512.7572631835938,
//                 height: 7.539764404296875,
//                 bbox: [
//                   25.5, 317.15997314453125, 538.2572631835938, 324.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content:
//                 "PREMIUM YOU WILL BE CHARGED.  WE MAY USE A THIRD PARTY IN CONNECTION WITH THE DEVELOPMENT OF YOUR SCORE.  YOU MAY HAVE THE RIGHT TO",
//               coordinates: {
//                 x: 25.5,
//                 y: 325.55999755859375,
//                 width: 517.5159301757812,
//                 height: 7.539764404296875,
//                 bbox: [
//                   25.5, 325.55999755859375, 543.0159301757812, 333.0997619628906
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content:
//                 "REVIEW YOUR PERSONAL INFORMATION IN OUR FILES AND REQUEST CORRECTION OF ANY INACCURACIES. YOU MAY ALSO HAVE THE RIGHT TO REQUEST IN",
//               coordinates: {
//                 x: 25.5,
//                 y: 333.3599853515625,
//                 width: 522.64599609375,
//                 height: 7.539764404296875,
//                 bbox: [
//                   25.5, 333.3599853515625, 548.14599609375, 340.8997497558594
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content:
//                 "WRITING THAT WE CONSIDER EXTRAORDINARY LIFE CIRCUMSTANCES IN CONNECTION WITH THE DEVELOPMENT OF YOUR CREDIT SCORE. THESE RIGHTS MAY",
//               coordinates: {
//                 x: 25.5,
//                 y: 341.7599792480469,
//                 width: 531.61669921875,
//                 height: 7.539764404296875,
//                 bbox: [
//                   25.5, 341.7599792480469, 557.11669921875, 349.29974365234375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content:
//                 "BE LIMITED IN SOME STATES. PLEASE CONTACT YOUR AGENT OR BROKER TO LEARN HOW THESE RIGHTS MAY APPLY IN YOUR STATE OR FOR INSTRUCTIONS ON",
//               coordinates: {
//                 x: 25.5,
//                 y: 349.55999755859375,
//                 width: 535.5991821289062,
//                 height: 7.539764404296875,
//                 bbox: [
//                   25.5, 349.55999755859375, 561.0991821289062, 357.0997619628906
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content:
//                 "HOW TO SUBMIT A REQUEST TO US FOR A MORE DETAILED DESCRIPTION OF YOUR RIGHTS AND OUR PRACTICES REGARDING PERSONAL INFORMATION.",
//               coordinates: {
//                 x: 25.5,
//                 y: 357.9599914550781,
//                 width: 507.39776611328125,
//                 height: 7.539764404296875,
//                 bbox: [
//                   25.5, 357.9599914550781, 532.8977661132812, 365.499755859375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content:
//                 "Copy of the Notice of Information Practices (Privacy) has been given to the applicant. (Not required in all states, contact your agent or broker for your state's requirements.)",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 278.15997314453125,
//                 width: 510.0162239074707,
//                 height: 7.539764404296875,
//                 bbox: [
//                   36.29999923706055, 278.15997314453125, 546.3162231445312,
//                   285.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content: "Applicable in PR:",
//               coordinates: {
//                 x: 25.5,
//                 y: 622.4800415039062,
//                 width: 63.65076446533203,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 622.4800415039062, 89.15076446533203, 631.1367797851562
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content:
//                 " Any person who knowingly and with the intention of defrauding presents false information in an insurance application, or presents, helps,",
//               coordinates: {
//                 x: 89.15076446533203,
//                 y: 622.4800415039062,
//                 width: 470.89208221435547,
//                 height: 8.65673828125,
//                 bbox: [
//                   89.15076446533203, 622.4800415039062, 560.0428466796875,
//                   631.1367797851562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content:
//                 "or causes the presentation of a fraudulent claim for the payment of a loss or any other benefit, or presents more than one claim for the same damage or loss,",
//               coordinates: {
//                 x: 25.5,
//                 y: 631.780029296875,
//                 width: 536.7882080078125,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 631.780029296875, 562.2882080078125, 640.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content:
//                 "shall incur a felony and, upon conviction, shall be sanctioned for each violation by a fine of not less than five thousand dollars ($5,000) and not more than ten",
//               coordinates: {
//                 x: 25.5,
//                 y: 640.780029296875,
//                 width: 536.8423461914062,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 640.780029296875, 562.3423461914062, 649.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content:
//                 "thousand dollars ($10,000), or a fixed term of imprisonment for three (3) years, or both penalties.  Should aggravating circumstances [be] present, the penalty",
//               coordinates: {
//                 x: 25.5,
//                 y: 650.3800048828125,
//                 width: 538.5241088867188,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 650.3800048828125, 564.0241088867188, 659.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content:
//                 "thus established may be increased to a maximum of five (5) years, if extenuating circumstances are present, it may be reduced to a minimum of two (2)",
//               coordinates: {
//                 x: 25.5,
//                 y: 659.3800048828125,
//                 width: 517.83154296875,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 659.3800048828125, 543.33154296875, 668.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 52,
//               type: "text",
//               content: "years.",
//               coordinates: {
//                 x: 25.5,
//                 y: 668.9800415039062,
//                 width: 21.095504760742188,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 668.9800415039062, 46.59550476074219, 677.6367797851562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 53,
//               type: "text",
//               content: "Applicable in ME, TN, VA and WA:",
//               coordinates: {
//                 x: 25.5,
//                 y: 562.4800415039062,
//                 width: 123.85275268554688,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 562.4800415039062, 149.35275268554688, 571.1367797851562
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 54,
//               type: "text",
//               content:
//                 " It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose",
//               coordinates: {
//                 x: 149.35275268554688,
//                 y: 562.4800415039062,
//                 width: 407.6553649902344,
//                 height: 8.65673828125,
//                 bbox: [
//                   149.35275268554688, 562.4800415039062, 557.0081176757812,
//                   571.1367797851562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 55,
//               type: "text",
//               content:
//                 "of defrauding the company.  Penalties (may)* include imprisonment, fines and denial of insurance benefits. *Applies in ME Only.",
//               coordinates: {
//                 x: 25.5,
//                 y: 571.780029296875,
//                 width: 436.2164306640625,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 571.780029296875, 461.7164306640625, 580.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 56,
//               type: "text",
//               content: "Applicable in KS:",
//               coordinates: {
//                 x: 25.5,
//                 y: 475.47998046875,
//                 width: 63.65076446533203,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 475.47998046875, 89.15076446533203, 484.1367492675781
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 57,
//               type: "text",
//               content:
//                 " Any person who, knowingly and with intent to defraud, presents, causes to be presented or prepares with knowledge or belief that it will be",
//               coordinates: {
//                 x: 89.15076446533203,
//                 y: 475.47998046875,
//                 width: 476.8828659057617,
//                 height: 8.656768798828125,
//                 bbox: [
//                   89.15076446533203, 475.47998046875, 566.0336303710938,
//                   484.1367492675781
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 58,
//               type: "text",
//               content:
//                 "presented to or by an insurer, purported insurer, broker or any agent thereof, any written statement as part of, or in support of, an application for the issuance",
//               coordinates: {
//                 x: 25.5,
//                 y: 484.7799987792969,
//                 width: 536.362060546875,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 484.7799987792969, 561.862060546875, 493.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 59,
//               type: "text",
//               content:
//                 "of, or the rating of an insurance policy for personal or commercial insurance, or a claim for payment or other benefit pursuant to an insurance policy for",
//               coordinates: {
//                 x: 25.5,
//                 y: 494.3799743652344,
//                 width: 514.4139404296875,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 494.3799743652344, 539.9139404296875, 503.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 60,
//               type: "text",
//               content:
//                 "commercial or personal insurance which such person knows to contain materially false information concerning any fact material thereto; or conceals, for the",
//               coordinates: {
//                 x: 25.5,
//                 y: 503.3799743652344,
//                 width: 532.0916137695312,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 503.3799743652344, 557.5916137695312, 512.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 61,
//               type: "text",
//               content:
//                 "purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act.",
//               coordinates: {
//                 x: 25.5,
//                 y: 512.9800415039062,
//                 width: 368.0707092285156,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 512.9800415039062, 393.5707092285156, 521.6367797851562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 62,
//               type: "text",
//               content: "Applicable in FL and OK:",
//               coordinates: {
//                 x: 25.5,
//                 y: 455.67999267578125,
//                 width: 91.88401794433594,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 455.67999267578125, 117.38401794433594,
//                   464.3367614746094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 63,
//               type: "text",
//               content:
//                 " Any person who knowingly and with intent to injure, defraud, or deceive any insurer files a statement of claim or an application",
//               coordinates: {
//                 x: 117.38401794433594,
//                 y: 455.67999267578125,
//                 width: 434.7312774658203,
//                 height: 8.656768798828125,
//                 bbox: [
//                   117.38401794433594, 455.67999267578125, 552.1152954101562,
//                   464.3367614746094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 64,
//               type: "text",
//               content:
//                 "containing any false, incomplete, or misleading information is guilty of a felony (of the third degree)*. *Applies in FL Only.",
//               coordinates: {
//                 x: 25.5,
//                 y: 464.97998046875,
//                 width: 411.501708984375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 464.97998046875, 437.001708984375, 473.6367492675781
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 65,
//               type: "text",
//               content: "Applicable in CO:",
//               coordinates: {
//                 x: 25.5,
//                 y: 408.2799987792969,
//                 width: 64.51101684570312,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 408.2799987792969, 90.01101684570312, 416.936767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 66,
//               type: "text",
//               content:
//                 " It is unlawful to knowingly provide false, incomplete, or misleading facts or information to an insurance company for the purpose of",
//               coordinates: {
//                 x: 90.01101684570312,
//                 y: 408.2799987792969,
//                 width: 448.8871765136719,
//                 height: 8.656768798828125,
//                 bbox: [
//                   90.01101684570312, 408.2799987792969, 538.898193359375,
//                   416.936767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 67,
//               type: "text",
//               content:
//                 "defrauding or attempting to defraud the company.  Penalties may include imprisonment, fines, denial of insurance and civil damages.  Any insurance",
//               coordinates: {
//                 x: 25.5,
//                 y: 417.5799865722656,
//                 width: 506.5631103515625,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 417.5799865722656, 532.0631103515625, 426.23675537109375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 68,
//               type: "text",
//               content:
//                 "company or agent of an insurance company who knowingly provides false, incomplete, or misleading facts or information to a policyholder or claimant for the",
//               coordinates: {
//                 x: 25.5,
//                 y: 426.5799865722656,
//                 width: 535.9744262695312,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 426.5799865722656, 561.4744262695312, 435.23675537109375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 69,
//               type: "text",
//               content:
//                 "purpose of defrauding or attempting to defraud the policyholder or claimant with regard to a settlement or award payable from insurance proceeds shall be",
//               coordinates: {
//                 x: 25.5,
//                 y: 436.17999267578125,
//                 width: 527.3796997070312,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 436.17999267578125, 552.8796997070312, 444.8367614746094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 70,
//               type: "text",
//               content:
//                 "reported to the Colorado Division of Insurance within the Department of Regulatory Agencies.",
//               coordinates: {
//                 x: 25.5,
//                 y: 445.17999267578125,
//                 width: 319.4239807128906,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 445.17999267578125, 344.9239807128906, 453.8367614746094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 71,
//               type: "text",
//               content: "Applicable in AL, AR, DC, LA, MD, NM, RI and WV:",
//               coordinates: {
//                 x: 25.5,
//                 y: 379.47998046875,
//                 width: 183.05494689941406,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 379.47998046875, 208.55494689941406, 388.1367492675781
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 72,
//               type: "text",
//               content:
//                 " Any person who knowingly (or willfully)* presents a false or fraudulent claim for payment of a loss or",
//               coordinates: {
//                 x: 208.55494689941406,
//                 y: 379.47998046875,
//                 width: 345.26853942871094,
//                 height: 8.656768798828125,
//                 bbox: [
//                   208.55494689941406, 379.47998046875, 553.823486328125,
//                   388.1367492675781
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 73,
//               type: "text",
//               content:
//                 "benefit or knowingly (or willfully)* presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in",
//               coordinates: {
//                 x: 25.5,
//                 y: 388.7799987792969,
//                 width: 536.3619384765625,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 388.7799987792969, 561.8619384765625, 397.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 74,
//               type: "text",
//               content: "prison. *Applies in MD Only.",
//               coordinates: {
//                 x: 25.5,
//                 y: 397.7799987792969,
//                 width: 95.83649444580078,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 397.7799987792969, 121.33649444580078, 406.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 75,
//               type: "text",
//               content: "SIGNATURE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 266.3799743652344,
//                 width: 45.02750587463379,
//                 height: 8.656768798828125,
//                 bbox: [
//                   21.899999618530273, 266.3799743652344, 66.92750549316406,
//                   275.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 76,
//               type: "text",
//               content: "NATIONAL PRODUCER NUMBER",
//               coordinates: {
//                 x: 498.646240234375,
//                 y: 733.3400268554688,
//                 width: 90.447509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   498.646240234375, 733.3400268554688, 589.09375,
//                   739.7627563476562
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 77,
//               type: "text",
//               content: "(Required in Florida)",
//               coordinates: {
//                 x: 497.1000061035156,
//                 y: 713.5400390625,
//                 width: 56.154693603515625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   497.1000061035156, 713.5400390625, 553.2546997070312,
//                   719.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 78,
//               type: "text",
//               content: "PRODUCER'S SIGNATURE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 710.5400390625,
//                 width: 73.07673835754395,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 710.5400390625, 94.97673797607422,
//                   716.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 79,
//               type: "text",
//               content: "DATE",
//               coordinates: {
//                 x: 425.1000061035156,
//                 y: 734.5400390625,
//                 width: 15.2144775390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   425.1000061035156, 734.5400390625, 440.3144836425781,
//                   740.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 80,
//               type: "text",
//               content: "APPLICANT'S SIGNATURE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 734.5400390625,
//                 width: 73.06524085998535,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 734.5400390625, 94.96524047851562,
//                   740.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 81,
//               type: "text",
//               content: "PRODUCER'S NAME (Please Print)",
//               coordinates: {
//                 x: 259.5,
//                 y: 711.1400146484375,
//                 width: 94.89791870117188,
//                 height: 6.4227294921875,
//                 bbox: [
//                   259.5, 711.1400146484375, 354.3979187011719, 717.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 82,
//               type: "text",
//               content: "STATE PRODUCER LICENSE NO",
//               coordinates: {
//                 x: 497.1000061035156,
//                 y: 708.1400146484375,
//                 width: 89.14822387695312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   497.1000061035156, 708.1400146484375, 586.2482299804688,
//                   714.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 83,
//               type: "text",
//               content:
//                 "THE UNDERSIGNED IS AN AUTHORIZED REPRESENTATIVE OF THE APPLICANT AND REPRESENTS THAT REASONABLE INQUIRY HAS BEEN MADE TO OBTAIN THE",
//               coordinates: {
//                 x: 25.5,
//                 y: 680.760009765625,
//                 width: 525.885986328125,
//                 height: 7.539794921875,
//                 bbox: [25.5, 680.760009765625, 551.385986328125, 688.2998046875]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 84,
//               type: "text",
//               content:
//                 "ANSWERS TO QUESTIONS ON THIS APPLICATION.  HE/SHE REPRESENTS THAT THE ANSWERS ARE TRUE, CORRECT AND COMPLETE TO THE BEST OF HIS/HER",
//               coordinates: {
//                 x: 25.5,
//                 y: 689.1599731445312,
//                 width: 522.3692626953125,
//                 height: 7.539794921875,
//                 bbox: [
//                   25.5, 689.1599731445312, 547.8692626953125, 696.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 85,
//               type: "text",
//               content: "KNOWLEDGE.",
//               coordinates: {
//                 x: 25.5,
//                 y: 696.9599609375,
//                 width: 45.71099853515625,
//                 height: 7.539794921875,
//                 bbox: [
//                   25.5, 696.9599609375, 71.21099853515625, 704.499755859375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 86,
//               type: "text",
//               content: "(Attach Loss Summary for Additional Loss Information)",
//               coordinates: {
//                 x: 209.10000610351562,
//                 y: 175.78001403808594,
//                 width: 204.04205322265625,
//                 height: 8.656753540039062,
//                 bbox: [
//                   209.10000610351562, 175.78001403808594, 413.1420593261719,
//                   184.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 87,
//               type: "text",
//               content: "Check if none",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 175.78001403808594,
//                 width: 50.762481689453125,
//                 height: 8.656753540039062,
//                 bbox: [
//                   144.3000030517578, 175.78001403808594, 195.06248474121094,
//                   184.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 88,
//               type: "text",
//               content: "YEARS",
//               coordinates: {
//                 x: 90.30000305175781,
//                 y: 194.8400115966797,
//                 width: 19.46949005126953,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   90.30000305175781, 194.8400115966797, 109.76949310302734,
//                   201.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 89,
//               type: "text",
//               content: "TOTAL LOSSES:  $",
//               coordinates: {
//                 x: 461.1000061035156,
//                 y: 194.54002380371094,
//                 width: 51.692535400390625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   461.1000061035156, 194.54002380371094, 512.7925415039062,
//                   200.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 90,
//               type: "text",
//               content: "DATE OF",
//               coordinates: {
//                 x: 34.696250915527344,
//                 y: 211.9399871826172,
//                 width: 24.782501220703125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   34.696250915527344, 211.9399871826172, 59.47875213623047,
//                   218.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 91,
//               type: "text",
//               content: "OCCURRENCE",
//               coordinates: {
//                 x: 26.4950008392334,
//                 y: 219.13999938964844,
//                 width: 41.1872501373291,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   26.4950008392334, 219.13999938964844, 67.6822509765625,
//                   225.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 92,
//               type: "text",
//               content: "DATE OF CLAIM",
//               coordinates: {
//                 x: 323.2950134277344,
//                 y: 215.54002380371094,
//                 width: 44.568206787109375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   323.2950134277344, 215.54002380371094, 367.86322021484375,
//                   221.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 93,
//               type: "text",
//               content: "AMOUNT PAID",
//               coordinates: {
//                 x: 395.7300109863281,
//                 y: 215.54002380371094,
//                 width: 40.1119384765625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   395.7300109863281, 215.54002380371094, 435.8419494628906,
//                   221.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 94,
//               type: "text",
//               content: "SUBRO-",
//               coordinates: {
//                 x: 539.760009765625,
//                 y: 205.9399871826172,
//                 width: 22.66650390625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   539.760009765625, 205.9399871826172, 562.426513671875,
//                   212.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 95,
//               type: "text",
//               content: "GATION",
//               coordinates: {
//                 x: 539.833740234375,
//                 y: 212.54002380371094,
//                 width: 21.913330078125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   539.833740234375, 212.54002380371094, 561.7470703125,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 96,
//               type: "text",
//               content: "Y / N",
//               coordinates: {
//                 x: 544.76123046875,
//                 y: 219.73997497558594,
//                 width: 12.65582275390625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   544.76123046875, 219.73997497558594, 557.4170532226562,
//                   226.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 97,
//               type: "text",
//               content: "AMOUNT RESERVED",
//               coordinates: {
//                 x: 467.6212463378906,
//                 y: 215.54002380371094,
//                 width: 58.310760498046875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   467.6212463378906, 215.54002380371094, 525.9320068359375,
//                   221.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 98,
//               type: "text",
//               content: "CLAIM",
//               coordinates: {
//                 x: 570.4974975585938,
//                 y: 205.9399871826172,
//                 width: 18.1929931640625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   570.4974975585938, 205.9399871826172, 588.6904907226562,
//                   212.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 99,
//               type: "text",
//               content: "OPEN",
//               coordinates: {
//                 x: 571.7525024414062,
//                 y: 212.54002380371094,
//                 width: 16.2783203125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   571.7525024414062, 212.54002380371094, 588.0308227539062,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 100,
//               type: "text",
//               content: "Y / N",
//               coordinates: {
//                 x: 573.561279296875,
//                 y: 219.73997497558594,
//                 width: 12.65582275390625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   573.561279296875, 219.73997497558594, 586.2171020507812,
//                   226.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 101,
//               type: "text",
//               content:
//                 "ENTER ALL CLAIMS OR LOSSES (REGARDLESS OF FAULT AND WHETHER OR NOT INSURED) OR OCCURRENCES THAT MAY GIVE RISE TO CLAIMS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 186.4851531982422,
//                 width: 405.9900760650635,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 186.4851531982422, 427.89007568359375,
//                   192.90789794921875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 102,
//               type: "text",
//               content: "FOR THE LAST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 195.4399871826172,
//                 width: 41.06074333190918,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 195.4399871826172, 62.96074295043945,
//                   201.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 103,
//               type: "text",
//               content: "LINE",
//               coordinates: {
//                 x: 92.75125122070312,
//                 y: 215.54002380371094,
//                 width: 13.081245422363281,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   92.75125122070312, 215.54002380371094, 105.8324966430664,
//                   221.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 104,
//               type: "text",
//               content: "TYPE / DESCRIPTION OF OCCURRENCE OR CLAIM",
//               coordinates: {
//                 x: 149.13999938964844,
//                 y: 217.3400115966797,
//                 width: 141.3751983642578,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   149.13999938964844, 217.3400115966797, 290.51519775390625,
//                   223.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 105,
//               type: "text",
//               content: "LOSS HISTORY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 176.37998962402344,
//                 width: 57.20274543762207,
//                 height: 8.656753540039062,
//                 bbox: [
//                   21.899999618530273, 176.37998962402344, 79.10274505615234,
//                   185.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 106,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 475.5,
//                 y: 140.54002380371094,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   475.5, 140.54002380371094, 478.6969909667969,
//                   146.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 107,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 356.70001220703125,
//                 y: 140.54002380371094,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   356.70001220703125, 140.54002380371094, 359.8970031738281,
//                   146.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 108,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 237.89999389648438,
//                 y: 140.54002380371094,
//                 width: 3.1970062255859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   237.89999389648438, 140.54002380371094, 241.0970001220703,
//                   146.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 109,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 119.0999984741211,
//                 y: 140.54002380371094,
//                 width: 3.1969985961914062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   119.0999984741211, 140.54002380371094, 122.2969970703125,
//                   146.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 110,
//               type: "text",
//               content: "EFFECTIVE DATE",
//               coordinates: {
//                 x: 47.099998474121094,
//                 y: 152.8400115966797,
//                 width: 48.069984436035156,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   47.099998474121094, 152.8400115966797, 95.16998291015625,
//                   159.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 111,
//               type: "text",
//               content: "EXPIRATION DATE",
//               coordinates: {
//                 x: 47.099998474121094,
//                 y: 164.8400115966797,
//                 width: 50.84148406982422,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   47.099998474121094, 164.8400115966797, 97.94148254394531,
//                   171.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 112,
//               type: "text",
//               content: "PREMIUM",
//               coordinates: {
//                 x: 47.099998474121094,
//                 y: 140.8400115966797,
//                 width: 27.134239196777344,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   47.099998474121094, 140.8400115966797, 74.23423767089844,
//                   147.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 113,
//               type: "text",
//               content: "POLICY NUMBER",
//               coordinates: {
//                 x: 47.099998474121094,
//                 y: 128.8400115966797,
//                 width: 47.460479736328125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   47.099998474121094, 128.8400115966797, 94.56047821044922,
//                   135.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 114,
//               type: "text",
//               content: "CARRIER",
//               coordinates: {
//                 x: 47.099998474121094,
//                 y: 116.84001159667969,
//                 width: 25.857742309570312,
//                 height: 6.422752380371094,
//                 bbox: [
//                   47.099998474121094, 116.84001159667969, 72.9577407836914,
//                   123.26276397705078
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 115,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 475.5,
//                 y: 80.54002380371094,
//                 width: 3.196990966796875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   475.5, 80.54002380371094, 478.6969909667969, 86.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 116,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 356.70001220703125,
//                 y: 80.54002380371094,
//                 width: 3.196990966796875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   356.70001220703125, 80.54002380371094, 359.8970031738281,
//                   86.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 117,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 237.89999389648438,
//                 y: 80.54002380371094,
//                 width: 3.1970062255859375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   237.89999389648438, 80.54002380371094, 241.0970001220703,
//                   86.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 118,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 119.0999984741211,
//                 y: 80.54002380371094,
//                 width: 3.1969985961914062,
//                 height: 6.422752380371094,
//                 bbox: [
//                   119.0999984741211, 80.54002380371094, 122.2969970703125,
//                   86.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 119,
//               type: "text",
//               content: "EFFECTIVE DATE",
//               coordinates: {
//                 x: 47.099998474121094,
//                 y: 92.84001159667969,
//                 width: 48.069984436035156,
//                 height: 6.422752380371094,
//                 bbox: [
//                   47.099998474121094, 92.84001159667969, 95.16998291015625,
//                   99.26276397705078
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 120,
//               type: "text",
//               content: "YEAR",
//               coordinates: {
//                 x: 22.612499237060547,
//                 y: 46.93998718261719,
//                 width: 15.96200180053711,
//                 height: 6.422752380371094,
//                 bbox: [
//                   22.612499237060547, 46.93998718261719, 38.574501037597656,
//                   53.36273956298828
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 121,
//               type: "text",
//               content: "EXPIRATION DATE",
//               coordinates: {
//                 x: 47.099998474121094,
//                 y: 104.84001159667969,
//                 width: 50.84148406982422,
//                 height: 6.422752380371094,
//                 bbox: [
//                   47.099998474121094, 104.84001159667969, 97.94148254394531,
//                   111.26276397705078
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 122,
//               type: "text",
//               content: "PREMIUM",
//               coordinates: {
//                 x: 47.099998474121094,
//                 y: 80.84001159667969,
//                 width: 27.134239196777344,
//                 height: 6.422752380371094,
//                 bbox: [
//                   47.099998474121094, 80.84001159667969, 74.23423767089844,
//                   87.26276397705078
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 123,
//               type: "text",
//               content: "POLICY NUMBER",
//               coordinates: {
//                 x: 47.099998474121094,
//                 y: 68.84001159667969,
//                 width: 47.460479736328125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   47.099998474121094, 68.84001159667969, 94.56047821044922,
//                   75.26276397705078
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 124,
//               type: "text",
//               content: "CARRIER",
//               coordinates: {
//                 x: 47.099998474121094,
//                 y: 56.84001159667969,
//                 width: 25.857742309570312,
//                 height: 6.422752380371094,
//                 bbox: [
//                   47.099998474121094, 56.84001159667969, 72.9577407836914,
//                   63.26276397705078
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 125,
//               type: "text",
//               content: "OTHER:",
//               coordinates: {
//                 x: 475.5,
//                 y: 46.93998718261719,
//                 width: 22.022491455078125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   475.5, 46.93998718261719, 497.5224914550781, 53.36273956298828
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 126,
//               type: "text",
//               content: "PROPERTY",
//               coordinates: {
//                 x: 396.68499755859375,
//                 y: 46.93998718261719,
//                 width: 31.596221923828125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   396.68499755859375, 46.93998718261719, 428.2812194824219,
//                   53.36273956298828
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 127,
//               type: "text",
//               content: "AUTOMOBILE",
//               coordinates: {
//                 x: 274.427490234375,
//                 y: 46.93998718261719,
//                 width: 38.51348876953125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   274.427490234375, 46.93998718261719, 312.94097900390625,
//                   53.36273956298828
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 128,
//               type: "text",
//               content: "GENERAL LIABILITY",
//               coordinates: {
//                 x: 146.3625030517578,
//                 y: 46.93998718261719,
//                 width: 57.011260986328125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   146.3625030517578, 46.93998718261719, 203.37376403808594,
//                   53.36273956298828
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 129,
//               type: "text",
//               content: "CATEGORY",
//               coordinates: {
//                 x: 47.099998474121094,
//                 y: 46.93998718261719,
//                 width: 31.918243408203125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   47.099998474121094, 46.93998718261719, 79.01824188232422,
//                   53.36273956298828
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 130,
//               type: "text",
//               content: "PRIOR CARRIER INFORMATION (continued)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 32.37998962402344,
//                 width: 162.4477024078369,
//                 height: 8.656749725341797,
//                 bbox: [
//                   21.899999618530273, 32.37998962402344, 184.3477020263672,
//                   41.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 131,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 317.0350036621094,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   317.0350036621094, 26.379987716674805, 408.8182373046875,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 132,
//               type: "text",
//               content: "ACORD 125 (2016/03)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 757.780029296875,
//                 width: 78.78650093078613,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 757.780029296875, 100.6865005493164,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 133,
//               type: "text",
//               content: "Page 4 of 4",
//               coordinates: {
//                 x: 285.84124755859375,
//                 y: 757.780029296875,
//                 width: 40.873504638671875,
//                 height: 8.65673828125,
//                 bbox: [
//                   285.84124755859375, 757.780029296875, 326.7147521972656,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 41.26749469857623,
//                 width: 577.68,
//                 height: 223.37231142078156,
//                 bbox: [
//                   17.28, 41.26749469857623, 594.9599999999999, 264.6398061193578
//                 ]
//               },
//               properties: {
//                 rows: 17,
//                 columns: 15,
//                 accuracy: 81.891
//               }
//             },
//             {
//               id: 1,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 275.4365343835202,
//                 width: 577.68,
//                 height: 481.29415328688265,
//                 bbox: [
//                   17.28, 275.4365343835202, 594.9599999999999, 756.7306876704029
//                 ]
//               },
//               properties: {
//                 rows: 6,
//                 columns: 5,
//                 accuracy: 48.845
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 134,
//           table_count: 2,
//           total_elements: 136
//         }
//       },
//       {
//         page_number: 5,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 415.20001220703125,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   415.20001220703125, 25.188751220703125, 447.44805908203125,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "04/04/2025",
//               coordinates: {
//                 x: 532.9550170898438,
//                 y: 55.188751220703125,
//                 width: 36.2645263671875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   532.9550170898438, 55.188751220703125, 569.2195434570312,
//                   63.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "UIS Insurance & Investments",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 79.18875122070312,
//                 width: 93.81499099731445,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 79.18875122070312, 116.614990234375,
//                   87.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "25-26",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 103.18875122070312,
//                 width: 18.538253784179688,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 103.18875122070312, 41.338253021240234,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "05/18/2025",
//               coordinates: {
//                 x: 259.3550109863281,
//                 y: 103.18875122070312,
//                 width: 36.2645263671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   259.3550109863281, 103.18875122070312, 295.6195373535156,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "Buckeye Premier Cleaning, LLC",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 79.18875122070312,
//                 width: 103.10223388671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 79.18875122070312, 413.9022216796875,
//                   87.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "Submissions",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 103.18875122070312,
//                 width: 41.08575439453125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 103.18875122070312, 351.8857421875,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "1,000,000",
//               coordinates: {
//                 x: 264,
//                 y: 139.18875122070312,
//                 width: 32.2335205078125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   264, 139.18875122070312, 296.2335205078125, 147.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "5,000",
//               coordinates: {
//                 x: 264,
//                 y: 241.18875122070312,
//                 width: 18.13226318359375,
//                 height: 8.098251342773438,
//                 bbox: [
//                   264, 241.18875122070312, 282.13226318359375,
//                   249.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "1,000,000",
//               coordinates: {
//                 x: 264,
//                 y: 259.1887512207031,
//                 width: 32.2335205078125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   264, 259.1887512207031, 296.2335205078125, 267.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "1,000,000",
//               coordinates: {
//                 x: 264,
//                 y: 307.1887512207031,
//                 width: 32.2335205078125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   264, 307.1887512207031, 296.2335205078125, 315.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 120,
//                 y: 355.1887512207031,
//                 width: 10.867752075195312,
//                 height: 8.098236083984375,
//                 bbox: [
//                   120, 355.1887512207031, 130.8677520751953, 363.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 120,
//                 y: 379.1887512207031,
//                 width: 10.867752075195312,
//                 height: 8.098236083984375,
//                 bbox: [
//                   120, 379.1887512207031, 130.8677520751953, 387.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "EFFECTIVE DATE",
//               coordinates: {
//                 x: 252.97500610351562,
//                 y: 92.54002380371094,
//                 width: 48.3919677734375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   252.97500610351562, 92.54002380371094, 301.3669738769531,
//                   98.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "NAMED INSURED(S)",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 68.54002380371094,
//                 width: 56.183197021484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   309.8999938964844, 68.54002380371094, 366.08319091796875,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "POLICY NUMBER",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 92.54002380371094,
//                 width: 48.09299659729004,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 92.54002380371094, 69.99299621582031,
//                   98.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "NAIC CODE",
//               coordinates: {
//                 x: 547.5,
//                 y: 92.54002380371094,
//                 width: 32.24029541015625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   547.5, 92.54002380371094, 579.7402954101562, 98.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "CARRIER",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 92.54002380371094,
//                 width: 26.1796875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   309.8999938964844, 92.54002380371094, 336.0796813964844,
//                   98.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "AGENCY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 68.54002380371094,
//                 width: 24.58125114440918,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 68.54002380371094, 46.48125076293945,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 317.0350036621094,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   317.0350036621094, 26.379987716674805, 408.8182373046875,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "DATE (MM/DD/YYYY)",
//               coordinates: {
//                 x: 522.563720703125,
//                 y: 45.13999938964844,
//                 width: 57.02288818359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   522.563720703125, 45.13999938964844, 579.5866088867188,
//                   51.56275177001953
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content: "OHIO COMMERCIAL AUTO",
//               coordinates: {
//                 x: 211.3800048828125,
//                 y: 36.701271057128906,
//                 width: 175.29867553710938,
//                 height: 15.358749389648438,
//                 bbox: [
//                   211.3800048828125, 36.701271057128906, 386.6786804199219,
//                   52.060020446777344
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 13.75,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "COVERAGES / LIMITS SECTION",
//               coordinates: {
//                 x: 224.5850067138672,
//                 y: 53.22001266479492,
//                 width: 148.2487030029297,
//                 height: 10.890750885009766,
//                 bbox: [
//                   224.5850067138672, 53.22001266479492, 372.8337097167969,
//                   64.11076354980469
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 9.75,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "The ACORD name and logo are registered marks of ACORD",
//               coordinates: {
//                 x: 196.4737548828125,
//                 y: 757.780029296875,
//                 width: 218.86770629882812,
//                 height: 8.65673828125,
//                 bbox: [
//                   196.4737548828125, 757.780029296875, 415.3414611816406,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "© 1996-2015 ACORD CORPORATION.  All rights reserved.",
//               coordinates: {
//                 x: 377.61749267578125,
//                 y: 733.780029296875,
//                 width: 211.10992431640625,
//                 height: 8.65673828125,
//                 bbox: [
//                   377.61749267578125, 733.780029296875, 588.7274169921875,
//                   742.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content: "Page 1 of 3",
//               coordinates: {
//                 x: 285.84124755859375,
//                 y: 733.780029296875,
//                 width: 40.873504638671875,
//                 height: 8.65673828125,
//                 bbox: [
//                   285.84124755859375, 733.780029296875, 326.7147521972656,
//                   742.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: "ACORD 137 OH (2015/12)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 733.780029296875,
//                 width: 92.55050086975098,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 733.780029296875, 114.45050048828125,
//                   742.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content:
//                 "ENDORSEMENTS / REMARKS  (ACORD 101, Additional Remarks Schedule, may be attached if more space is required)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 440.3799743652344,
//                 width: 435.999475479126,
//                 height: 8.656768798828125,
//                 bbox: [
//                   21.899999618530273, 440.3799743652344, 457.89947509765625,
//                   449.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content:
//                 "I UNDERSTAND THAT THE COVERAGE SELECTION AND LIMIT CHOICES INDICATED HERE WILL APPLY TO ALL FUTURE POLICY RENEWALS, CONTINUATIONS",
//               coordinates: {
//                 x: 25.5,
//                 y: 687.9599609375,
//                 width: 508.30902099609375,
//                 height: 7.539794921875,
//                 bbox: [
//                   25.5, 687.9599609375, 533.8090209960938, 695.499755859375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content: "AND CHANGES UNLESS I NOTIFY YOU OTHERWISE IN WRITING.",
//               coordinates: {
//                 x: 25.5,
//                 y: 696.3599853515625,
//                 width: 209.03399658203125,
//                 height: 7.539794921875,
//                 bbox: [
//                   25.5, 696.3599853515625, 234.53399658203125, 703.8997802734375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content:
//                 "ANY PERSON WHO KNOWINGLY AND WITH INTENT TO DEFRAUD ANY INSURANCE COMPANY OR OTHER PERSON FILES AN",
//               coordinates: {
//                 x: 25.5,
//                 y: 640.780029296875,
//                 width: 467.3094177246094,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 640.780029296875, 492.8094177246094, 649.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content:
//                 "APPLICATION FOR INSURANCE OR STATEMENT OF CLAIM CONTAINING ANY MATERIALLY FALSE INFORMATION OR CONCEALS FOR",
//               coordinates: {
//                 x: 25.5,
//                 y: 650.3800048828125,
//                 width: 500.68878173828125,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 650.3800048828125, 526.1887817382812, 659.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content:
//                 "THE PURPOSE OF MISLEADING, INFORMATION CONCERNING ANY FACT MATERIAL THERETO COMMITS A FRAUDULENT INSURANCE",
//               coordinates: {
//                 x: 25.5,
//                 y: 660.5800170898438,
//                 width: 502.572021484375,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 660.5800170898438, 528.072021484375, 669.2367553710938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content:
//                 "ACT, WHICH IS A CRIME AND SUBJECTS SUCH PERSON TO CRIMINAL AND CIVIL PENALTIES.",
//               coordinates: {
//                 x: 25.5,
//                 y: 670.780029296875,
//                 width: 350.5790100097656,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 670.780029296875, 376.0790100097656, 679.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content: "SIGNATURE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 626.3800048828125,
//                 width: 45.02750587463379,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 626.3800048828125, 66.92750549316406,
//                   635.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content: "2",
//               coordinates: {
//                 x: 421.5,
//                 y: 226.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   421.5, 226.63999938964844, 424.6969909667969, 233.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content: "3",
//               coordinates: {
//                 x: 421.5,
//                 y: 238.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   421.5, 238.63999938964844, 424.6969909667969, 245.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content: "4",
//               coordinates: {
//                 x: 450.29998779296875,
//                 y: 226.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   450.29998779296875, 226.63999938964844, 453.4969787597656,
//                   233.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content: "7",
//               coordinates: {
//                 x: 450.29998779296875,
//                 y: 238.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   450.29998779296875, 238.63999938964844, 453.4969787597656,
//                   245.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content: "8",
//               coordinates: {
//                 x: 479.1000061035156,
//                 y: 226.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   479.1000061035156, 226.63999938964844, 482.2969970703125,
//                   233.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content: "COMP / OTC",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 232.63999938964844,
//                 width: 34.03997802734375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   338.70001220703125, 232.63999938964844, 372.739990234375,
//                   239.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content: "& LABOR",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 212.23997497558594,
//                 width: 24.8974609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   338.70001220703125, 212.23997497558594, 363.59747314453125,
//                   218.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content: "TOWING",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 205.04002380371094,
//                 width: 23.5059814453125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   338.70001220703125, 205.04002380371094, 362.20599365234375,
//                   211.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content: "3",
//               coordinates: {
//                 x: 421.5,
//                 y: 202.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   421.5, 202.63999938964844, 424.6969909667969, 209.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content: "7",
//               coordinates: {
//                 x: 421.5,
//                 y: 214.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   421.5, 214.63999938964844, 424.6969909667969, 221.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 493.5,
//                 y: 208.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   493.5, 208.63999938964844, 496.6969909667969, 215.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content: "CAUSES OF LOSS",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 260.239990234375,
//                 width: 50.105438232421875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 260.239990234375, 388.8054504394531,
//                   266.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content: "SPECIFIED",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 253.04002380371094,
//                 width: 30.31396484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   338.70001220703125, 253.04002380371094, 369.01397705078125,
//                   259.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content: "2",
//               coordinates: {
//                 x: 421.5,
//                 y: 250.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   421.5, 250.63999938964844, 424.6969909667969, 257.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content: "3",
//               coordinates: {
//                 x: 421.5,
//                 y: 262.6400146484375,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   421.5, 262.6400146484375, 424.6969909667969, 269.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content: "4",
//               coordinates: {
//                 x: 450.29998779296875,
//                 y: 250.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   450.29998779296875, 250.63999938964844, 453.4969787597656,
//                   257.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content: "7",
//               coordinates: {
//                 x: 450.29998779296875,
//                 y: 262.6400146484375,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   450.29998779296875, 262.6400146484375, 453.4969787597656,
//                   269.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 52,
//               type: "text",
//               content: "8",
//               coordinates: {
//                 x: 479.1000061035156,
//                 y: 250.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   479.1000061035156, 250.63999938964844, 482.2969970703125,
//                   257.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 53,
//               type: "text",
//               content: "COLLISION",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 280.6400146484375,
//                 width: 30.647430419921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 280.6400146484375, 369.3474426269531,
//                   287.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 54,
//               type: "text",
//               content: "2",
//               coordinates: {
//                 x: 421.5,
//                 y: 274.6400146484375,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   421.5, 274.6400146484375, 424.6969909667969, 281.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 55,
//               type: "text",
//               content: "3",
//               coordinates: {
//                 x: 421.5,
//                 y: 286.6400146484375,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   421.5, 286.6400146484375, 424.6969909667969, 293.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 56,
//               type: "text",
//               content: "4",
//               coordinates: {
//                 x: 450.29998779296875,
//                 y: 274.6400146484375,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   450.29998779296875, 274.6400146484375, 453.4969787597656,
//                   281.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 57,
//               type: "text",
//               content: "7",
//               coordinates: {
//                 x: 450.29998779296875,
//                 y: 286.6400146484375,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   450.29998779296875, 286.6400146484375, 453.4969787597656,
//                   293.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 58,
//               type: "text",
//               content: "8",
//               coordinates: {
//                 x: 479.1000061035156,
//                 y: 274.6400146484375,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   479.1000061035156, 274.6400146484375, 482.2969970703125,
//                   281.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 59,
//               type: "text",
//               content: "HIRED",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 368.2400207519531,
//                 width: 17.876708984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 368.2400207519531, 356.57672119140625,
//                   374.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 60,
//               type: "text",
//               content: "PHYSICAL",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 374.84002685546875,
//                 width: 28.41070556640625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 374.84002685546875, 367.1107177734375,
//                   381.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 61,
//               type: "text",
//               content: "DAMAGE",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 382.0400085449219,
//                 width: 24.897491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 382.0400085449219, 363.5975036621094,
//                   388.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 62,
//               type: "text",
//               content: "SECONDARY",
//               coordinates: {
//                 x: 543.9000244140625,
//                 y: 406.6400146484375,
//                 width: 36.288330078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   543.9000244140625, 406.6400146484375, 580.1883544921875,
//                   413.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 63,
//               type: "text",
//               content: "PRIMARY",
//               coordinates: {
//                 x: 486.29998779296875,
//                 y: 406.6400146484375,
//                 width: 26.07049560546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   486.29998779296875, 406.6400146484375, 512.3704833984375,
//                   413.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 64,
//               type: "text",
//               content: "COVERAGE IS:",
//               coordinates: {
//                 x: 400.59124755859375,
//                 y: 406.6400146484375,
//                 width: 41.1641845703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   400.59124755859375, 406.6400146484375, 441.75543212890625,
//                   413.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 65,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 536.7000122070312,
//                 y: 382.6400146484375,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   536.7000122070312, 382.6400146484375, 539.8970336914062,
//                   389.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 66,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 536.7000122070312,
//                 y: 370.6400146484375,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   536.7000122070312, 370.6400146484375, 539.8970336914062,
//                   377.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 67,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 536.7000122070312,
//                 y: 358.6400146484375,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   536.7000122070312, 358.6400146484375, 539.8970336914062,
//                   365.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 68,
//               type: "text",
//               content: "COLL",
//               coordinates: {
//                 x: 507.8999938964844,
//                 y: 382.6400146484375,
//                 width: 15.013336181640625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   507.8999938964844, 382.6400146484375, 522.913330078125,
//                   389.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 69,
//               type: "text",
//               content: "C OF L",
//               coordinates: {
//                 x: 507.8999938964844,
//                 y: 372.44000244140625,
//                 width: 18.509368896484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   507.8999938964844, 372.44000244140625, 526.4093627929688,
//                   378.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 70,
//               type: "text",
//               content: "SPEC",
//               coordinates: {
//                 x: 507.8999938964844,
//                 y: 367.0400085449219,
//                 width: 15.640045166015625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   507.8999938964844, 367.0400085449219, 523.5400390625,
//                   373.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 71,
//               type: "text",
//               content: "COMP",
//               coordinates: {
//                 x: 507.8999938964844,
//                 y: 358.6400146484375,
//                 width: 17.238555908203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   507.8999938964844, 358.6400146484375, 525.1385498046875,
//                   365.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 72,
//               type: "text",
//               content: "COVERAGE / DEDUCTIBLE",
//               coordinates: {
//                 x: 493.5,
//                 y: 344.2400207519531,
//                 width: 73.72674560546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   493.5, 344.2400207519531, 567.2267456054688, 350.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 73,
//               type: "text",
//               content: "# VEH",
//               coordinates: {
//                 x: 459.6912536621094,
//                 y: 344.2400207519531,
//                 width: 16.6002197265625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   459.6912536621094, 344.2400207519531, 476.2914733886719,
//                   350.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 74,
//               type: "text",
//               content: "# DAYS",
//               coordinates: {
//                 x: 422.2875061035156,
//                 y: 344.2400207519531,
//                 width: 20.00421142578125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   422.2875061035156, 344.2400207519531, 442.2917175292969,
//                   350.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 75,
//               type: "text",
//               content: "STATES",
//               coordinates: {
//                 x: 385.2449951171875,
//                 y: 344.2400207519531,
//                 width: 21.48199462890625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   385.2449951171875, 344.2400207519531, 406.72698974609375,
//                   350.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 76,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 298.0400085449219,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   255.89999389648438, 298.0400085449219, 259.09698486328125,
//                   304.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 77,
//               type: "text",
//               content: "DED",
//               coordinates: {
//                 x: 236.55999755859375,
//                 y: 298.6400146484375,
//                 width: 12.13250732421875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   236.55999755859375, 298.6400146484375, 248.6925048828125,
//                   305.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 78,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 286.0400085449219,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   255.89999389648438, 286.0400085449219, 259.09698486328125,
//                   292.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 79,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 275.2400207519531,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   255.89999389648438, 275.2400207519531, 259.09698486328125,
//                   281.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 80,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 263.239990234375,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   255.89999389648438, 263.239990234375, 259.09698486328125,
//                   269.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 81,
//               type: "text",
//               content: "PROPERTY DAMAGE",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 286.6400146484375,
//                 width: 57.879486083984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 286.6400146484375, 248.9794921875,
//                   293.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 82,
//               type: "text",
//               content: "BI EACH ACCIDENT",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 275.2400207519531,
//                 width: 53.618743896484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   176.6999969482422, 275.2400207519531, 230.31874084472656,
//                   281.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 83,
//               type: "text",
//               content: "EA PER",
//               coordinates: {
//                 x: 227.10000610351562,
//                 y: 264.44000244140625,
//                 width: 20.745986938476562,
//                 height: 6.4227294921875,
//                 bbox: [
//                   227.10000610351562, 264.44000244140625, 247.8459930419922,
//                   270.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 84,
//               type: "text",
//               content: "BI",
//               coordinates: {
//                 x: 227.10000610351562,
//                 y: 259.0400390625,
//                 width: 5.4222412109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   227.10000610351562, 259.0400390625, 232.52224731445312,
//                   265.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 85,
//               type: "text",
//               content: "CSL",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 263.239990234375,
//                 width: 11.178009033203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 263.239990234375, 202.27801513671875,
//                   269.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 86,
//               type: "text",
//               content: "7",
//               coordinates: {
//                 x: 133.5,
//                 y: 263.239990234375,
//                 width: 3.1970062255859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   133.5, 263.239990234375, 136.69700622558594, 269.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 87,
//               type: "text",
//               content: "6",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 299.2400207519531,
//                 width: 3.1969985961914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 299.2400207519531, 107.8969955444336,
//                   305.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 88,
//               type: "text",
//               content: "4",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 286.6400146484375,
//                 width: 3.1969985961914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 286.6400146484375, 107.8969955444336,
//                   293.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 89,
//               type: "text",
//               content: "3",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 274.6400146484375,
//                 width: 3.1969985961914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 274.6400146484375, 107.8969955444336,
//                   281.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 90,
//               type: "text",
//               content: "2",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 262.6400146484375,
//                 width: 3.1969985961914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 262.6400146484375, 107.8969955444336,
//                   269.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 91,
//               type: "text",
//               content: "UNINSURED",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 275.84002685546875,
//                 width: 34.160749435424805,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 275.84002685546875, 56.06074905395508,
//                   282.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 92,
//               type: "text",
//               content: "MOTORIST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 283.0400085449219,
//                 width: 30.210500717163086,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 283.0400085449219, 52.11050033569336,
//                   289.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 93,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 323.2400207519531,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   255.89999389648438, 323.2400207519531, 259.09698486328125,
//                   329.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 94,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 311.2400207519531,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   255.89999389648438, 311.2400207519531, 259.09698486328125,
//                   317.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 95,
//               type: "text",
//               content: "BI EACH ACCIDENT",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 323.2400207519531,
//                 width: 53.618743896484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   176.6999969482422, 323.2400207519531, 230.31874084472656,
//                   329.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 96,
//               type: "text",
//               content: "EA PER",
//               coordinates: {
//                 x: 227.10000610351562,
//                 y: 312.44000244140625,
//                 width: 20.745986938476562,
//                 height: 6.4227294921875,
//                 bbox: [
//                   227.10000610351562, 312.44000244140625, 247.8459930419922,
//                   318.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 97,
//               type: "text",
//               content: "BI",
//               coordinates: {
//                 x: 227.10000610351562,
//                 y: 307.0400085449219,
//                 width: 5.4222412109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   227.10000610351562, 307.0400085449219, 232.52224731445312,
//                   313.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 98,
//               type: "text",
//               content: "CSL",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 311.2400207519531,
//                 width: 11.178009033203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 311.2400207519531, 202.27801513671875,
//                   317.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 99,
//               type: "text",
//               content: "UNDERINSURED",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 318.44000244140625,
//                 width: 46.29324531555176,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 318.44000244140625, 68.19324493408203,
//                   324.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 100,
//               type: "text",
//               content: "MOTORIST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 326.2400207519531,
//                 width: 30.210500717163086,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 326.2400207519531, 52.11050033569336,
//                   332.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 101,
//               type: "text",
//               content: "2",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 310.6400146484375,
//                 width: 3.1969985961914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 310.6400146484375, 107.8969955444336,
//                   317.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 102,
//               type: "text",
//               content: "3",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 322.6400146484375,
//                 width: 3.1969985961914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 322.6400146484375, 107.8969955444336,
//                   329.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 103,
//               type: "text",
//               content: "4",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 334.6400146484375,
//                 width: 3.1969985961914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 334.6400146484375, 107.8969955444336,
//                   341.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 104,
//               type: "text",
//               content: "6",
//               coordinates: {
//                 x: 133.5,
//                 y: 310.6400146484375,
//                 width: 3.1970062255859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   133.5, 310.6400146484375, 136.69700622558594, 317.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 105,
//               type: "text",
//               content: "7",
//               coordinates: {
//                 x: 133.5,
//                 y: 322.6400146484375,
//                 width: 3.1970062255859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   133.5, 322.6400146484375, 136.69700622558594, 329.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 106,
//               type: "text",
//               content: "LIABILITY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 392.2400207519531,
//                 width: 26.168249130249023,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 392.2400207519531, 48.0682487487793,
//                   398.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 107,
//               type: "text",
//               content: "NON-OWNED",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 385.0400085449219,
//                 width: 36.707998275756836,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 385.0400085449219, 58.60799789428711,
//                   391.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 108,
//               type: "text",
//               content: "NUMBER OF",
//               coordinates: {
//                 x: 281.8500061035156,
//                 y: 370.6400146484375,
//                 width: 34.471221923828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.8500061035156, 370.6400146484375, 316.32122802734375,
//                   377.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 109,
//               type: "text",
//               content: "PARTNERS",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 406.6400146484375,
//                 width: 30.751007080078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 406.6400146484375, 221.85101318359375,
//                   413.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 110,
//               type: "text",
//               content: "VOLUNTEERS",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 394.6400146484375,
//                 width: 38.94476318359375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 394.6400146484375, 230.04476928710938,
//                   401.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 111,
//               type: "text",
//               content: "EMPLOYEES",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 382.6400146484375,
//                 width: 35.431488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 382.6400146484375, 226.531494140625,
//                   389.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 112,
//               type: "text",
//               content: "GROUP TYPE",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 370.6400146484375,
//                 width: 37.449737548828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   176.6999969482422, 370.6400146484375, 214.1497344970703,
//                   377.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 113,
//               type: "text",
//               content: "NO",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 380.84002685546875,
//                 width: 8.619247436523438,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 380.84002685546875, 113.31924438476562,
//                   387.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 114,
//               type: "text",
//               content: "YES",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 368.84002685546875,
//                 width: 11.488494873046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 368.84002685546875, 116.18849182128906,
//                   375.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 115,
//               type: "text",
//               content: "STATES",
//               coordinates: {
//                 x: 136.84500122070312,
//                 y: 368.84002685546875,
//                 width: 21.48199462890625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   136.84500122070312, 368.84002685546875, 158.32699584960938,
//                   375.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 116,
//               type: "text",
//               content: "BUSINESS AUTO SECTION",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 116.98002624511719,
//                 width: 99.79673957824707,
//                 height: 8.656745910644531,
//                 bbox: [
//                   21.899999618530273, 116.98002624511719, 121.69673919677734,
//                   125.63677215576172
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 117,
//               type: "text",
//               content: "LIMITS",
//               coordinates: {
//                 x: 244.67750549316406,
//                 y: 130.3400115966797,
//                 width: 18.819747924804688,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   244.67750549316406, 130.3400115966797, 263.49725341796875,
//                   136.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 118,
//               type: "text",
//               content: "COVERED AUTO SYMBOLS",
//               coordinates: {
//                 x: 91.5824966430664,
//                 y: 130.3400115966797,
//                 width: 75.96321868896484,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   91.5824966430664, 130.3400115966797, 167.54571533203125,
//                   136.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 119,
//               type: "text",
//               content: "COVERAGES",
//               coordinates: {
//                 x: 34.12874984741211,
//                 y: 130.3400115966797,
//                 width: 36.7079963684082,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   34.12874984741211, 130.3400115966797, 70.83674621582031,
//                   136.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 120,
//               type: "text",
//               content: "CSL",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 142.63999938964844,
//                 width: 11.178009033203125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   191.10000610351562, 142.63999938964844, 202.27801513671875,
//                   149.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 121,
//               type: "text",
//               content: "BI",
//               coordinates: {
//                 x: 227.10000610351562,
//                 y: 139.04002380371094,
//                 width: 5.4222412109375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   227.10000610351562, 139.04002380371094, 232.52224731445312,
//                   145.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 122,
//               type: "text",
//               content: "EA PER",
//               coordinates: {
//                 x: 227.10000610351562,
//                 y: 144.4399871826172,
//                 width: 20.745986938476562,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   227.10000610351562, 144.4399871826172, 247.8459930419922,
//                   150.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 123,
//               type: "text",
//               content: "BI EACH ACCIDENT",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 154.63999938964844,
//                 width: 53.618743896484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   176.6999969482422, 154.63999938964844, 230.31874084472656,
//                   161.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 124,
//               type: "text",
//               content: "PROPERTY DAMAGE",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 166.63999938964844,
//                 width: 57.879486083984375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   176.6999969482422, 166.63999938964844, 234.57948303222656,
//                   173.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 125,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 142.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   255.89999389648438, 142.63999938964844, 259.09698486328125,
//                   149.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 126,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 154.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   255.89999389648438, 154.63999938964844, 259.09698486328125,
//                   161.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 127,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 166.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   255.89999389648438, 166.63999938964844, 259.09698486328125,
//                   173.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 128,
//               type: "text",
//               content: "9",
//               coordinates: {
//                 x: 162.3000030517578,
//                 y: 142.63999938964844,
//                 width: 3.1970062255859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   162.3000030517578, 142.63999938964844, 165.49700927734375,
//                   149.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 129,
//               type: "text",
//               content: "8",
//               coordinates: {
//                 x: 133.5,
//                 y: 166.63999938964844,
//                 width: 3.1970062255859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   133.5, 166.63999938964844, 136.69700622558594,
//                   173.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 130,
//               type: "text",
//               content: "7",
//               coordinates: {
//                 x: 133.5,
//                 y: 154.63999938964844,
//                 width: 3.1970062255859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   133.5, 154.63999938964844, 136.69700622558594,
//                   161.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 131,
//               type: "text",
//               content: "4",
//               coordinates: {
//                 x: 133.5,
//                 y: 142.63999938964844,
//                 width: 3.1970062255859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   133.5, 142.63999938964844, 136.69700622558594,
//                   149.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 132,
//               type: "text",
//               content: "3",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 166.63999938964844,
//                 width: 3.1969985961914062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 166.63999938964844, 107.8969955444336,
//                   173.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 133,
//               type: "text",
//               content: "2",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 154.63999938964844,
//                 width: 3.1969985961914062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 154.63999938964844, 107.8969955444336,
//                   161.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 134,
//               type: "text",
//               content: "1",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 142.63999938964844,
//                 width: 3.1969985961914062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 142.63999938964844, 107.8969955444336,
//                   149.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 135,
//               type: "text",
//               content: "LIABILITY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 154.63999938964844,
//                 width: 26.168249130249023,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 154.63999938964844, 48.0682487487793,
//                   161.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 136,
//               type: "text",
//               content: "EACH PERSON",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 244.63999938964844,
//                 width: 41.813995361328125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   176.6999969482422, 244.63999938964844, 218.5139923095703,
//                   251.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 137,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 244.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   255.89999389648438, 244.63999938964844, 259.09698486328125,
//                   251.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 138,
//               type: "text",
//               content: "8",
//               coordinates: {
//                 x: 162.3000030517578,
//                 y: 238.63999938964844,
//                 width: 3.1970062255859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   162.3000030517578, 238.63999938964844, 165.49700927734375,
//                   245.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 139,
//               type: "text",
//               content: "7",
//               coordinates: {
//                 x: 133.5,
//                 y: 250.63999938964844,
//                 width: 3.1970062255859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   133.5, 250.63999938964844, 136.69700622558594,
//                   257.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 140,
//               type: "text",
//               content: "4",
//               coordinates: {
//                 x: 133.5,
//                 y: 238.63999938964844,
//                 width: 3.1970062255859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   133.5, 238.63999938964844, 136.69700622558594,
//                   245.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 141,
//               type: "text",
//               content: "3",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 250.63999938964844,
//                 width: 3.1969985961914062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 250.63999938964844, 107.8969955444336,
//                   257.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 142,
//               type: "text",
//               content: "2",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 238.63999938964844,
//                 width: 3.1969985961914062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 238.63999938964844, 107.8969955444336,
//                   245.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 143,
//               type: "text",
//               content: "MEDICAL",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 241.04002380371094,
//                 width: 25.5414981842041,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 241.04002380371094, 47.441497802734375,
//                   247.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 144,
//               type: "text",
//               content: "PAYMENTS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 248.23997497558594,
//                 width: 30.7452449798584,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 248.23997497558594, 52.64524459838867,
//                   254.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 145,
//               type: "text",
//               content: "PHYSICAL DAMAGE",
//               coordinates: {
//                 x: 436.6400146484375,
//                 y: 190.3400115966797,
//                 width: 56.073944091796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   436.6400146484375, 190.3400115966797, 492.7139587402344,
//                   196.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 146,
//               type: "text",
//               content: "LIMITS",
//               coordinates: {
//                 x: 532.677490234375,
//                 y: 130.3400115966797,
//                 width: 18.81982421875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   532.677490234375, 130.3400115966797, 551.497314453125,
//                   136.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 147,
//               type: "text",
//               content: "COVERED AUTO SYMBOLS",
//               coordinates: {
//                 x: 408.38250732421875,
//                 y: 130.3400115966797,
//                 width: 75.96319580078125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   408.38250732421875, 130.3400115966797, 484.345703125,
//                   136.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 148,
//               type: "text",
//               content: "COVERAGES",
//               coordinates: {
//                 x: 350.9287414550781,
//                 y: 130.3400115966797,
//                 width: 36.70794677734375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   350.9287414550781, 130.3400115966797, 387.6366882324219,
//                   136.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 149,
//               type: "text",
//               content: "COST OF HIRE",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 346.6400146484375,
//                 width: 40.738739013671875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   176.6999969482422, 346.6400146484375, 217.43873596191406,
//                   353.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 150,
//               type: "text",
//               content: "IF ANY BASIS",
//               coordinates: {
//                 x: 263.1000061035156,
//                 y: 346.6400146484375,
//                 width: 36.58721923828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   263.1000061035156, 346.6400146484375, 299.6872253417969,
//                   353.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 151,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 358.6400146484375,
//                 width: 3.1970062255859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   176.6999969482422, 358.6400146484375, 179.89700317382812,
//                   365.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 152,
//               type: "text",
//               content: "HIRED / BORROWED",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 347.2400207519531,
//                 width: 57.12624549865723,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 347.2400207519531, 79.0262451171875,
//                   353.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 153,
//               type: "text",
//               content: "LIABILITY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 354.44000244140625,
//                 width: 26.168249130249023,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 354.44000244140625, 48.0682487487793,
//                   360.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 154,
//               type: "text",
//               content: "NO",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 356.84002685546875,
//                 width: 8.619247436523438,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 356.84002685546875, 113.31924438476562,
//                   363.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 155,
//               type: "text",
//               content: "YES",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 344.84002685546875,
//                 width: 11.488494873046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 344.84002685546875, 116.18849182128906,
//                   351.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 156,
//               type: "text",
//               content: "STATES",
//               coordinates: {
//                 x: 136.84500122070312,
//                 y: 344.84002685546875,
//                 width: 21.48199462890625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   136.84500122070312, 344.84002685546875, 158.32699584960938,
//                   351.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 157,
//               type: "text",
//               content: "APPLICANT'S SIGNATURE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 710.5400390625,
//                 width: 73.06524085998535,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 710.5400390625, 94.96524047851562,
//                   716.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 158,
//               type: "text",
//               content: "DATE",
//               coordinates: {
//                 x: 223.5,
//                 y: 710.5400390625,
//                 width: 15.214508056640625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   223.5, 710.5400390625, 238.71450805664062, 716.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 159,
//               type: "text",
//               content: "PRODUCER'S SIGNATURE",
//               coordinates: {
//                 x: 295.5,
//                 y: 710.5400390625,
//                 width: 73.07662963867188,
//                 height: 6.4227294921875,
//                 bbox: [
//                   295.5, 710.5400390625, 368.5766296386719, 716.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 160,
//               type: "text",
//               content: "NATIONAL PRODUCER NUMBER",
//               coordinates: {
//                 x: 498.646240234375,
//                 y: 710.5400390625,
//                 width: 90.447509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   498.646240234375, 710.5400390625, 589.09375, 716.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 161,
//               type: "text",
//               content: "Attach to ACORD 127 and/or 132",
//               coordinates: {
//                 x: 246.06875610351562,
//                 y: 745.780029296875,
//                 width: 119.76849365234375,
//                 height: 8.65673828125,
//                 bbox: [
//                   246.06875610351562, 745.780029296875, 365.8372497558594,
//                   754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 162,
//               type: "text",
//               content: "(9) NON-OWNED AUTOS ONLY",
//               coordinates: {
//                 x: 464.70001220703125,
//                 y: 430.6400146484375,
//                 width: 83.09912109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   464.70001220703125, 430.6400146484375, 547.7991333007812,
//                   437.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 163,
//               type: "text",
//               content: "(8) HIRED AUTOS ONLY",
//               coordinates: {
//                 x: 464.70001220703125,
//                 y: 422.84002685546875,
//                 width: 64.267822265625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   464.70001220703125, 422.84002685546875, 528.9678344726562,
//                   429.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 164,
//               type: "text",
//               content: "(7) SPECIFICALLY DESCRIBED AUTOS",
//               coordinates: {
//                 x: 464.70001220703125,
//                 y: 415.6400146484375,
//                 width: 104.6961669921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   464.70001220703125, 415.6400146484375, 569.3961791992188,
//                   422.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 165,
//               type: "text",
//               content:
//                 "(6) OWNED AUTOS SUBJECT TO A COMPULSORY UNINSURED MOTORISTS LAW",
//               coordinates: {
//                 x: 219.89999389648438,
//                 y: 430.6400146484375,
//                 width: 220.88037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   219.89999389648438, 430.6400146484375, 440.7803649902344,
//                   437.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 166,
//               type: "text",
//               content: "(5) OWNED AUTOS SUBJECT TO NO-FAULT",
//               coordinates: {
//                 x: 219.89999389648438,
//                 y: 422.84002685546875,
//                 width: 118.20272827148438,
//                 height: 6.4227294921875,
//                 bbox: [
//                   219.89999389648438, 422.84002685546875, 338.10272216796875,
//                   429.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 167,
//               type: "text",
//               content:
//                 "(4) OWNED AUTOS OTHER THAN PRIVATE PASSENGER AUTOS ONLY",
//               coordinates: {
//                 x: 219.89999389648438,
//                 y: 415.6400146484375,
//                 width: 190.42831420898438,
//                 height: 6.4227294921875,
//                 bbox: [
//                   219.89999389648438, 415.6400146484375, 410.32830810546875,
//                   422.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 168,
//               type: "text",
//               content: "(3) OWNED PRIVATE PASSENGER AUTOS ONLY",
//               coordinates: {
//                 x: 65.0999984741211,
//                 y: 430.6400146484375,
//                 width: 130.63996124267578,
//                 height: 6.4227294921875,
//                 bbox: [
//                   65.0999984741211, 430.6400146484375, 195.73995971679688,
//                   437.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 169,
//               type: "text",
//               content: "(2) OWNED AUTOS ONLY",
//               coordinates: {
//                 x: 65.0999984741211,
//                 y: 422.84002685546875,
//                 width: 68.4134750366211,
//                 height: 6.4227294921875,
//                 bbox: [
//                   65.0999984741211, 422.84002685546875, 133.5134735107422,
//                   429.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 170,
//               type: "text",
//               content: "(1) ANY AUTO",
//               coordinates: {
//                 x: 65.0999984741211,
//                 y: 415.6400146484375,
//                 width: 37.13922882080078,
//                 height: 6.4227294921875,
//                 bbox: [
//                   65.0999984741211, 415.6400146484375, 102.23922729492188,
//                   422.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 171,
//               type: "text",
//               content: "COVERED",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 415.94000244140625,
//                 width: 28.410749435424805,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 415.94000244140625, 50.31074905395508,
//                   422.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 172,
//               type: "text",
//               content: "AUTO",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 422.5400085449219,
//                 width: 16.174753189086914,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 422.5400085449219, 38.07475280761719,
//                   428.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 173,
//               type: "text",
//               content: "SYMBOLS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 429.7400207519531,
//                 width: 28.405000686645508,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 429.7400207519531, 50.30500030517578,
//                   436.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 41.26749469857623,
//                 width: 577.68,
//                 height: 73.41775219630415,
//                 bbox: [
//                   17.28, 41.26749469857623, 594.9599999999999,
//                   114.68524689488038
//                 ]
//               },
//               properties: {
//                 rows: 3,
//                 columns: 5,
//                 accuracy: 86.959
//               }
//             },
//             {
//               id: 1,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 125.24204786428356,
//                 width: 577.4399999999999,
//                 height: 313.34504695546804,
//                 bbox: [
//                   17.52, 125.24204786428356, 594.9599999999999,
//                   438.5870948197516
//                 ]
//               },
//               properties: {
//                 rows: 26,
//                 columns: 28,
//                 accuracy: 83.666
//               }
//             },
//             {
//               id: 2,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 635.327476522266,
//                 width: 577.68,
//                 height: 97.4104816722205,
//                 bbox: [
//                   17.28, 635.327476522266, 594.9599999999999, 732.7379581944865
//                 ]
//               },
//               properties: {
//                 rows: 3,
//                 columns: 4,
//                 accuracy: 57.179
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 174,
//           table_count: 3,
//           total_elements: 177
//         }
//       },
//       {
//         page_number: 6,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 415.20001220703125,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   415.20001220703125, 25.188751220703125, 447.44805908203125,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "Page 2 of 3",
//               coordinates: {
//                 x: 285.84124755859375,
//                 y: 757.780029296875,
//                 width: 40.873504638671875,
//                 height: 8.65673828125,
//                 bbox: [
//                   285.84124755859375, 757.780029296875, 326.7147521972656,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content:
//                 "ENDORSEMENTS / REMARKS  (ACORD 101, Additional Remarks Schedule, may be attached if more space is required)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 440.3799743652344,
//                 width: 435.999475479126,
//                 height: 8.656768798828125,
//                 bbox: [
//                   21.899999618530273, 440.3799743652344, 457.89947509765625,
//                   449.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content:
//                 "I UNDERSTAND THAT THE COVERAGE SELECTION AND LIMIT CHOICES INDICATED HERE WILL APPLY TO ALL FUTURE POLICY RENEWALS, CONTINUATIONS",
//               coordinates: {
//                 x: 25.5,
//                 y: 711.9599609375,
//                 width: 508.30902099609375,
//                 height: 7.539794921875,
//                 bbox: [
//                   25.5, 711.9599609375, 533.8090209960938, 719.499755859375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "AND CHANGES UNLESS I NOTIFY YOU OTHERWISE IN WRITING.",
//               coordinates: {
//                 x: 25.5,
//                 y: 720.3599853515625,
//                 width: 209.03399658203125,
//                 height: 7.539794921875,
//                 bbox: [
//                   25.5, 720.3599853515625, 234.53399658203125, 727.8997802734375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "SIGNATURE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 650.3800048828125,
//                 width: 45.02750587463379,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 650.3800048828125, 66.92750549316406,
//                   659.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "ZONE",
//               coordinates: {
//                 x: 470.8137512207031,
//                 y: 215.54002380371094,
//                 width: 15.95623779296875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   470.8137512207031, 215.54002380371094, 486.7699890136719,
//                   221.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "DEDUCTIBLE",
//               coordinates: {
//                 x: 552.3724975585938,
//                 y: 214.3400115966797,
//                 width: 37.0242919921875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   552.3724975585938, 214.3400115966797, 589.3967895507812,
//                   220.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "RADIUS",
//               coordinates: {
//                 x: 521.7787475585938,
//                 y: 214.3400115966797,
//                 width: 22.02825927734375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   521.7787475585938, 214.3400115966797, 543.8070068359375,
//                   220.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "# DAYS",
//               coordinates: {
//                 x: 494.1787414550781,
//                 y: 214.3400115966797,
//                 width: 20.228485107421875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   494.1787414550781, 214.3400115966797, 514.4072265625,
//                   220.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "FARTH",
//               coordinates: {
//                 x: 469.2174987792969,
//                 y: 210.13999938964844,
//                 width: 19.153228759765625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   469.2174987792969, 210.13999938964844, 488.3707275390625,
//                   216.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "# TRAILERS",
//               coordinates: {
//                 x: 433.2275085449219,
//                 y: 214.3400115966797,
//                 width: 33.510955810546875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   433.2275085449219, 214.3400115966797, 466.73846435546875,
//                   220.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "SYMBOL",
//               coordinates: {
//                 x: 401.7012634277344,
//                 y: 214.3400115966797,
//                 width: 24.57550048828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   401.7012634277344, 214.3400115966797, 426.2767639160156,
//                   220.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "COVERAGES",
//               coordinates: {
//                 x: 347.3287353515625,
//                 y: 214.3400115966797,
//                 width: 36.70794677734375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   347.3287353515625, 214.3400115966797, 384.03668212890625,
//                   220.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "TRAILER INTERCHANGE",
//               coordinates: {
//                 x: 430.3599853515625,
//                 y: 202.3400115966797,
//                 width: 68.62039184570312,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   430.3599853515625, 202.3400115966797, 498.9803771972656,
//                   208.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "TRUCKERS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 260.239990234375,
//                 width: 31.60199546813965,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 260.239990234375, 53.50199508666992,
//                   266.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "HIRED / BORROWED",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 266.84002685546875,
//                 width: 57.12624549865723,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 266.84002685546875, 79.0262451171875,
//                   273.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "LIABILITY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 274.0400390625,
//                 width: 26.168249130249023,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 274.0400390625, 48.0682487487793,
//                   280.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 274.6400146484375,
//                 width: 3.1970062255859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   176.6999969482422, 274.6400146484375, 179.89700317382812,
//                   281.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "IF ANY BASIS",
//               coordinates: {
//                 x: 263.1000061035156,
//                 y: 262.6400146484375,
//                 width: 36.58721923828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   263.1000061035156, 262.6400146484375, 299.6872253417969,
//                   269.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "COST OF HIRE",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 262.6400146484375,
//                 width: 40.738739013671875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   176.6999969482422, 262.6400146484375, 217.43873596191406,
//                   269.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content: "NO",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 272.84002685546875,
//                 width: 8.619247436523438,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 272.84002685546875, 113.31924438476562,
//                   279.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "YES",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 260.84002685546875,
//                 width: 11.488494873046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 260.84002685546875, 116.18849182128906,
//                   267.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "STATES",
//               coordinates: {
//                 x: 138.64500427246094,
//                 y: 260.84002685546875,
//                 width: 21.48199462890625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   138.64500427246094, 260.84002685546875, 160.1269989013672,
//                   267.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "NON-TRUCKERS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 239.23997497558594,
//                 width: 46.287492752075195,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 239.23997497558594, 68.18749237060547,
//                   245.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content: "HIRED / BORROWED",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 246.4399871826172,
//                 width: 57.12624549865723,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 246.4399871826172, 79.0262451171875,
//                   252.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 250.63999938964844,
//                 width: 3.1970062255859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   176.6999969482422, 250.63999938964844, 179.89700317382812,
//                   257.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content: "IF ANY BASIS",
//               coordinates: {
//                 x: 263.1000061035156,
//                 y: 238.63999938964844,
//                 width: 36.58721923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   263.1000061035156, 238.63999938964844, 299.6872253417969,
//                   245.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content: "COST OF HIRE",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 238.63999938964844,
//                 width: 40.738739013671875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   176.6999969482422, 238.63999938964844, 217.43873596191406,
//                   245.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content: "STATES",
//               coordinates: {
//                 x: 138.64500427246094,
//                 y: 236.8400115966797,
//                 width: 21.48199462890625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   138.64500427246094, 236.8400115966797, 160.1269989013672,
//                   243.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content: "YES",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 236.8400115966797,
//                 width: 11.488494873046875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 236.8400115966797, 116.18849182128906,
//                   243.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content: "NO",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 248.8400115966797,
//                 width: 8.619247436523438,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 248.8400115966797, 113.31924438476562,
//                   255.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 551.0999755859375,
//                 y: 154.63999938964844,
//                 width: 3.197021484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   551.0999755859375, 154.63999938964844, 554.2969970703125,
//                   161.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content: "47",
//               coordinates: {
//                 x: 450.29998779296875,
//                 y: 143.23997497558594,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   450.29998779296875, 143.23997497558594, 456.6939697265625,
//                   149.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content: "46",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 167.23997497558594,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   414.29998779296875, 167.23997497558594, 420.6939697265625,
//                   173.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content: "43",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 154.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   414.29998779296875, 154.63999938964844, 420.6939697265625,
//                   161.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content: "42",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 142.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   414.29998779296875, 142.63999938964844, 420.6939697265625,
//                   149.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content: "COLLISION",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 152.8400115966797,
//                 width: 30.647430419921875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   338.70001220703125, 152.8400115966797, 369.3474426269531,
//                   159.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content: "SPECIFIED",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 113.23997497558594,
//                 width: 30.31396484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   338.70001220703125, 113.23997497558594, 369.01397705078125,
//                   119.66272735595703
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content: "CAUSES OF LOSS",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 120.43998718261719,
//                 width: 50.105438232421875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   338.70001220703125, 120.43998718261719, 388.8054504394531,
//                   126.86273956298828
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content: "47",
//               coordinates: {
//                 x: 450.29998779296875,
//                 y: 107.23997497558594,
//                 width: 6.39398193359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   450.29998779296875, 107.23997497558594, 456.6939697265625,
//                   113.66272735595703
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content: "46",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 131.23997497558594,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   414.29998779296875, 131.23997497558594, 420.6939697265625,
//                   137.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content: "43",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 118.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   414.29998779296875, 118.63999938964844, 420.6939697265625,
//                   125.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content: "42",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 106.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   414.29998779296875, 106.63999938964844, 420.6939697265625,
//                   113.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 551.0999755859375,
//                 y: 118.63999938964844,
//                 width: 3.197021484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   551.0999755859375, 118.63999938964844, 554.2969970703125,
//                   125.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content: "SCL",
//               coordinates: {
//                 x: 476.8074951171875,
//                 y: 106.63999938964844,
//                 width: 11.177978515625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   476.8074951171875, 106.63999938964844, 487.9854736328125,
//                   113.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content: "F",
//               coordinates: {
//                 x: 479.1000061035156,
//                 y: 118.63999938964844,
//                 width: 3.50750732421875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   479.1000061035156, 118.63999938964844, 482.6075134277344,
//                   125.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content: "FT",
//               coordinates: {
//                 x: 507.98748779296875,
//                 y: 106.63999938964844,
//                 width: 7.0150146484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   507.98748779296875, 106.63999938964844, 515.0025024414062,
//                   113.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content: "FTW",
//               coordinates: {
//                 x: 507.8999938964844,
//                 y: 118.63999938964844,
//                 width: 12.437225341796875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   507.8999938964844, 118.63999938964844, 520.3372192382812,
//                   125.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content: "LSP",
//               coordinates: {
//                 x: 534.5662231445312,
//                 y: 106.63999938964844,
//                 width: 10.8560791015625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   534.5662231445312, 106.63999938964844, 545.4223022460938,
//                   113.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content: "47",
//               coordinates: {
//                 x: 450.29998779296875,
//                 y: 71.23997497558594,
//                 width: 6.39398193359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   450.29998779296875, 71.23997497558594, 456.6939697265625,
//                   77.66272735595703
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content: "46",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 95.23997497558594,
//                 width: 6.39398193359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   414.29998779296875, 95.23997497558594, 420.6939697265625,
//                   101.66272735595703
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 52,
//               type: "text",
//               content: "43",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 82.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   414.29998779296875, 82.63999938964844, 420.6939697265625,
//                   89.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 53,
//               type: "text",
//               content: "42",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 70.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   414.29998779296875, 70.63999938964844, 420.6939697265625,
//                   77.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 54,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 551.0999755859375,
//                 y: 82.63999938964844,
//                 width: 3.197021484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   551.0999755859375, 82.63999938964844, 554.2969970703125,
//                   89.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 55,
//               type: "text",
//               content: "COMP / OTC",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 80.84001159667969,
//                 width: 34.03997802734375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   338.70001220703125, 80.84001159667969, 372.739990234375,
//                   87.26276397705078
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 56,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 464.70001220703125,
//                 y: 184.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   464.70001220703125, 184.63999938964844, 467.8970031738281,
//                   191.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 57,
//               type: "text",
//               content: "46",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 178.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   414.29998779296875, 178.63999938964844, 420.6939697265625,
//                   185.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 58,
//               type: "text",
//               content: "& LABOR",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 188.23997497558594,
//                 width: 24.8974609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   338.70001220703125, 188.23997497558594, 363.59747314453125,
//                   194.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 59,
//               type: "text",
//               content: "TOWING",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 181.04002380371094,
//                 width: 23.5059814453125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   338.70001220703125, 181.04002380371094, 362.20599365234375,
//                   187.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 60,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 399.8999938964844,
//                 y: 296.84002685546875,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   399.8999938964844, 296.84002685546875, 403.09698486328125,
//                   303.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 61,
//               type: "text",
//               content: "TRAILER VALUE",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 296.84002685546875,
//                 width: 44.263427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 296.84002685546875, 382.96343994140625,
//                   303.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 62,
//               type: "text",
//               content: "UNINSURED",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 167.8400115966797,
//                 width: 34.160749435424805,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 167.8400115966797, 56.06074905395508,
//                   174.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 63,
//               type: "text",
//               content: "MOTORIST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 175.04002380371094,
//                 width: 30.210500717163086,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 175.04002380371094, 52.11050033569336,
//                   181.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 64,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 190.04002380371094,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   255.89999389648438, 190.04002380371094, 259.09698486328125,
//                   196.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 65,
//               type: "text",
//               content: "DED",
//               coordinates: {
//                 x: 236.55999755859375,
//                 y: 190.63999938964844,
//                 width: 12.13250732421875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   236.55999755859375, 190.63999938964844, 248.6925048828125,
//                   197.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 66,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 178.04002380371094,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   255.89999389648438, 178.04002380371094, 259.09698486328125,
//                   184.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 67,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 167.23997497558594,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   255.89999389648438, 167.23997497558594, 259.09698486328125,
//                   173.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 68,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 155.23997497558594,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   255.89999389648438, 155.23997497558594, 259.09698486328125,
//                   161.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 69,
//               type: "text",
//               content: "PROPERTY DAMAGE",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 178.63999938964844,
//                 width: 57.879486083984375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   191.10000610351562, 178.63999938964844, 248.9794921875,
//                   185.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 70,
//               type: "text",
//               content: "BI EACH ACCIDENT",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 167.23997497558594,
//                 width: 53.618743896484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   176.6999969482422, 167.23997497558594, 230.31874084472656,
//                   173.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 71,
//               type: "text",
//               content: "EA PER",
//               coordinates: {
//                 x: 227.10000610351562,
//                 y: 156.4399871826172,
//                 width: 20.745986938476562,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   227.10000610351562, 156.4399871826172, 247.8459930419922,
//                   162.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 72,
//               type: "text",
//               content: "BI",
//               coordinates: {
//                 x: 227.10000610351562,
//                 y: 151.04002380371094,
//                 width: 5.4222412109375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   227.10000610351562, 151.04002380371094, 232.52224731445312,
//                   157.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 73,
//               type: "text",
//               content: "CSL",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 155.23997497558594,
//                 width: 11.178009033203125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   191.10000610351562, 155.23997497558594, 202.27801513671875,
//                   161.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 74,
//               type: "text",
//               content: "42",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 154.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 154.63999938964844, 111.093994140625,
//                   161.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 75,
//               type: "text",
//               content: "43",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 166.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 166.63999938964844, 111.093994140625,
//                   173.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 76,
//               type: "text",
//               content: "45",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 178.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 178.63999938964844, 111.093994140625,
//                   185.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 77,
//               type: "text",
//               content: "46",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 190.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 190.63999938964844, 111.093994140625,
//                   197.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 78,
//               type: "text",
//               content: "42",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 202.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 202.63999938964844, 111.093994140625,
//                   209.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 79,
//               type: "text",
//               content: "43",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 214.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 214.63999938964844, 111.093994140625,
//                   221.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 80,
//               type: "text",
//               content: "45",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 226.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 226.63999938964844, 111.093994140625,
//                   233.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 81,
//               type: "text",
//               content: "46",
//               coordinates: {
//                 x: 133.5,
//                 y: 202.63999938964844,
//                 width: 6.394012451171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   133.5, 202.63999938964844, 139.89401245117188,
//                   209.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 82,
//               type: "text",
//               content: "UNDERINSURED",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 211.04002380371094,
//                 width: 46.29324531555176,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 211.04002380371094, 68.19324493408203,
//                   217.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 83,
//               type: "text",
//               content: "MOTORIST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 218.23997497558594,
//                 width: 30.210500717163086,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 218.23997497558594, 52.11050033569336,
//                   224.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 84,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 215.23997497558594,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   255.89999389648438, 215.23997497558594, 259.09698486328125,
//                   221.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 85,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 203.23997497558594,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   255.89999389648438, 203.23997497558594, 259.09698486328125,
//                   209.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 86,
//               type: "text",
//               content: "BI EACH ACCIDENT",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 215.23997497558594,
//                 width: 53.618743896484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   176.6999969482422, 215.23997497558594, 230.31874084472656,
//                   221.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 87,
//               type: "text",
//               content: "EA PER",
//               coordinates: {
//                 x: 227.10000610351562,
//                 y: 204.4399871826172,
//                 width: 20.745986938476562,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   227.10000610351562, 204.4399871826172, 247.8459930419922,
//                   210.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 88,
//               type: "text",
//               content: "BI",
//               coordinates: {
//                 x: 227.10000610351562,
//                 y: 199.04002380371094,
//                 width: 5.4222412109375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   227.10000610351562, 199.04002380371094, 232.52224731445312,
//                   205.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 89,
//               type: "text",
//               content: "CSL",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 203.23997497558594,
//                 width: 11.178009033203125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   191.10000610351562, 203.23997497558594, 202.27801513671875,
//                   209.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 90,
//               type: "text",
//               content: "HIRED",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 333.44000244140625,
//                 width: 17.876708984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 333.44000244140625, 356.57672119140625,
//                   339.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 91,
//               type: "text",
//               content: "PHYSICAL",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 340.6400146484375,
//                 width: 28.41070556640625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 340.6400146484375, 367.1107177734375,
//                   347.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 92,
//               type: "text",
//               content: "DAMAGE",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 347.84002685546875,
//                 width: 24.897491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 347.84002685546875, 363.5975036621094,
//                   354.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 93,
//               type: "text",
//               content: "STATES",
//               coordinates: {
//                 x: 385.2449951171875,
//                 y: 308.2400207519531,
//                 width: 21.48199462890625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   385.2449951171875, 308.2400207519531, 406.72698974609375,
//                   314.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 94,
//               type: "text",
//               content: "# DAYS",
//               coordinates: {
//                 x: 422.2875061035156,
//                 y: 308.2400207519531,
//                 width: 20.00421142578125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   422.2875061035156, 308.2400207519531, 442.2917175292969,
//                   314.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 95,
//               type: "text",
//               content: "# VEH",
//               coordinates: {
//                 x: 459.6912536621094,
//                 y: 308.2400207519531,
//                 width: 16.6002197265625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   459.6912536621094, 308.2400207519531, 476.2914733886719,
//                   314.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 96,
//               type: "text",
//               content: "COVERAGE IS:",
//               coordinates: {
//                 x: 400.59124755859375,
//                 y: 370.6400146484375,
//                 width: 41.1641845703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   400.59124755859375, 370.6400146484375, 441.75543212890625,
//                   377.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 97,
//               type: "text",
//               content: "PRIMARY",
//               coordinates: {
//                 x: 486.29998779296875,
//                 y: 370.6400146484375,
//                 width: 26.07049560546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   486.29998779296875, 370.6400146484375, 512.3704833984375,
//                   377.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 98,
//               type: "text",
//               content: "SECONDARY",
//               coordinates: {
//                 x: 543.9000244140625,
//                 y: 370.6400146484375,
//                 width: 36.288330078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   543.9000244140625, 370.6400146484375, 580.1883544921875,
//                   377.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 99,
//               type: "text",
//               content: "GROUP TYPE",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 286.6400146484375,
//                 width: 37.449737548828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   176.6999969482422, 286.6400146484375, 214.1497344970703,
//                   293.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 100,
//               type: "text",
//               content: "EMPLOYEES",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 298.6400146484375,
//                 width: 35.431488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 298.6400146484375, 226.531494140625,
//                   305.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 101,
//               type: "text",
//               content: "VOLUNTEERS",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 310.6400146484375,
//                 width: 38.94476318359375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 310.6400146484375, 230.04476928710938,
//                   317.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 102,
//               type: "text",
//               content: "PARTNERS",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 322.6400146484375,
//                 width: 30.751007080078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 322.6400146484375, 221.85101318359375,
//                   329.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 103,
//               type: "text",
//               content: "NUMBER OF",
//               coordinates: {
//                 x: 281.8500061035156,
//                 y: 286.6400146484375,
//                 width: 34.471221923828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.8500061035156, 286.6400146484375, 316.32122802734375,
//                   293.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 104,
//               type: "text",
//               content: "NON-OWNED",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 296.2400207519531,
//                 width: 36.707998275756836,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 296.2400207519531, 58.60799789428711,
//                   302.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 105,
//               type: "text",
//               content: "AUTO",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 302.84002685546875,
//                 width: 15.852750778198242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 302.84002685546875, 37.752750396728516,
//                   309.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 106,
//               type: "text",
//               content: "LIABILITY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 310.0400085449219,
//                 width: 26.168249130249023,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 310.0400085449219, 48.0682487487793,
//                   316.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 107,
//               type: "text",
//               content: "STATES",
//               coordinates: {
//                 x: 138.64500427246094,
//                 y: 284.84002685546875,
//                 width: 21.48199462890625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   138.64500427246094, 284.84002685546875, 160.1269989013672,
//                   291.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 108,
//               type: "text",
//               content: "YES",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 284.84002685546875,
//                 width: 11.488494873046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 284.84002685546875, 116.18849182128906,
//                   291.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 109,
//               type: "text",
//               content: "NO",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 296.84002685546875,
//                 width: 8.619247436523438,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 296.84002685546875, 113.31924438476562,
//                   303.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 110,
//               type: "text",
//               content: "TRUCKERS SECTION",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 32.98002624511719,
//                 width: 79.58474922180176,
//                 height: 8.656749725341797,
//                 bbox: [
//                   21.899999618530273, 32.98002624511719, 101.48474884033203,
//                   41.636775970458984
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 111,
//               type: "text",
//               content: "LIMITS",
//               coordinates: {
//                 x: 244.67750549316406,
//                 y: 46.34001159667969,
//                 width: 18.819747924804688,
//                 height: 6.422752380371094,
//                 bbox: [
//                   244.67750549316406, 46.34001159667969, 263.49725341796875,
//                   52.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 112,
//               type: "text",
//               content: "COVERED AUTO SYMBOLS",
//               coordinates: {
//                 x: 91.5824966430664,
//                 y: 46.34001159667969,
//                 width: 75.96321868896484,
//                 height: 6.422752380371094,
//                 bbox: [
//                   91.5824966430664, 46.34001159667969, 167.54571533203125,
//                   52.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 113,
//               type: "text",
//               content: "COVERAGES",
//               coordinates: {
//                 x: 34.12874984741211,
//                 y: 46.34001159667969,
//                 width: 36.7079963684082,
//                 height: 6.422752380371094,
//                 bbox: [
//                   34.12874984741211, 46.34001159667969, 70.83674621582031,
//                   52.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 114,
//               type: "text",
//               content: "LIABILITY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 70.63999938964844,
//                 width: 26.168249130249023,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 70.63999938964844, 48.0682487487793,
//                   77.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 115,
//               type: "text",
//               content: "50",
//               coordinates: {
//                 x: 133.5,
//                 y: 82.63999938964844,
//                 width: 6.394012451171875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   133.5, 82.63999938964844, 139.89401245117188,
//                   89.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 116,
//               type: "text",
//               content: "47",
//               coordinates: {
//                 x: 133.5,
//                 y: 70.63999938964844,
//                 width: 6.394012451171875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   133.5, 70.63999938964844, 139.89401245117188,
//                   77.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 117,
//               type: "text",
//               content: "46",
//               coordinates: {
//                 x: 133.5,
//                 y: 58.63999938964844,
//                 width: 6.394012451171875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   133.5, 58.63999938964844, 139.89401245117188,
//                   65.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 118,
//               type: "text",
//               content: "43",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 82.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   104.69999694824219, 82.63999938964844, 111.093994140625,
//                   89.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 119,
//               type: "text",
//               content: "42",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 70.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   104.69999694824219, 70.63999938964844, 111.093994140625,
//                   77.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 120,
//               type: "text",
//               content: "41",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 58.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   104.69999694824219, 58.63999938964844, 111.093994140625,
//                   65.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 121,
//               type: "text",
//               content: "CSL",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 58.63999938964844,
//                 width: 11.178009033203125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   191.10000610351562, 58.63999938964844, 202.27801513671875,
//                   65.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 122,
//               type: "text",
//               content: "BI",
//               coordinates: {
//                 x: 227.10000610351562,
//                 y: 55.04002380371094,
//                 width: 5.4222412109375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   227.10000610351562, 55.04002380371094, 232.52224731445312,
//                   61.46277618408203
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 123,
//               type: "text",
//               content: "EA PER",
//               coordinates: {
//                 x: 227.10000610351562,
//                 y: 60.43998718261719,
//                 width: 20.745986938476562,
//                 height: 6.422752380371094,
//                 bbox: [
//                   227.10000610351562, 60.43998718261719, 247.8459930419922,
//                   66.86273956298828
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 124,
//               type: "text",
//               content: "BI EACH ACCIDENT",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 70.63999938964844,
//                 width: 53.618743896484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   176.6999969482422, 70.63999938964844, 230.31874084472656,
//                   77.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 125,
//               type: "text",
//               content: "PROPERTY DAMAGE",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 82.63999938964844,
//                 width: 57.879486083984375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   176.6999969482422, 82.63999938964844, 234.57948303222656,
//                   89.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 126,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 58.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   255.89999389648438, 58.63999938964844, 259.09698486328125,
//                   65.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 127,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 70.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   255.89999389648438, 70.63999938964844, 259.09698486328125,
//                   77.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 128,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 82.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   255.89999389648438, 82.63999938964844, 259.09698486328125,
//                   89.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 129,
//               type: "text",
//               content: "MEDICAL",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 133.04002380371094,
//                 width: 25.5414981842041,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 133.04002380371094, 47.441497802734375,
//                   139.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 130,
//               type: "text",
//               content: "PAYMENTS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 140.23997497558594,
//                 width: 30.7452449798584,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 140.23997497558594, 52.64524459838867,
//                   146.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 131,
//               type: "text",
//               content: "42",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 130.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 130.63999938964844, 111.093994140625,
//                   137.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 132,
//               type: "text",
//               content: "43",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 142.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 142.63999938964844, 111.093994140625,
//                   149.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 133,
//               type: "text",
//               content: "46",
//               coordinates: {
//                 x: 133.5,
//                 y: 130.63999938964844,
//                 width: 6.394012451171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   133.5, 130.63999938964844, 139.89401245117188,
//                   137.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 134,
//               type: "text",
//               content: "EACH PERSON",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 136.63999938964844,
//                 width: 41.813995361328125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   176.6999969482422, 136.63999938964844, 218.5139923095703,
//                   143.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 135,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 136.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   255.89999389648438, 136.63999938964844, 259.09698486328125,
//                   143.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 136,
//               type: "text",
//               content: "OTHER",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 332.2400207519531,
//                 width: 20.10774803161621,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 332.2400207519531, 42.007747650146484,
//                   338.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 137,
//               type: "text",
//               content: "(50) NON-OWNED AUTOS ONLY",
//               coordinates: {
//                 x: 450.29998779296875,
//                 y: 429.44000244140625,
//                 width: 86.29608154296875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   450.29998779296875, 429.44000244140625, 536.5960693359375,
//                   435.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 138,
//               type: "text",
//               content: "INTERCHANGE AGREEMENT",
//               coordinates: {
//                 x: 462.8999938964844,
//                 y: 422.2400207519531,
//                 width: 79.47647094726562,
//                 height: 6.4227294921875,
//                 bbox: [
//                   462.8999938964844, 422.2400207519531, 542.37646484375,
//                   428.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 139,
//               type: "text",
//               content: "ANOTHER TRUCKER UNDER A TRAILER",
//               coordinates: {
//                 x: 462.8999938964844,
//                 y: 415.0400085449219,
//                 width: 109.91720581054688,
//                 height: 6.4227294921875,
//                 bbox: [
//                   462.8999938964844, 415.0400085449219, 572.8171997070312,
//                   421.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 140,
//               type: "text",
//               content: "(49) YOUR TRAILERS IN THE POSSESSION OF",
//               coordinates: {
//                 x: 450.29998779296875,
//                 y: 407.84002685546875,
//                 width: 127.0235595703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   450.29998779296875, 407.84002685546875, 577.3235473632812,
//                   414.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 141,
//               type: "text",
//               content: "A TRAILER INTERCHANGE AGREEMENT",
//               coordinates: {
//                 x: 318.8999938964844,
//                 y: 429.44000244140625,
//                 width: 110.33087158203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   318.8999938964844, 429.44000244140625, 429.2308654785156,
//                   435.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 142,
//               type: "text",
//               content: "(48) TRAILERS IN YOUR POSSESSION UNDER",
//               coordinates: {
//                 x: 306.29998779296875,
//                 y: 422.2400207519531,
//                 width: 126.50558471679688,
//                 height: 6.4227294921875,
//                 bbox: [
//                   306.29998779296875, 422.2400207519531, 432.8055725097656,
//                   428.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 143,
//               type: "text",
//               content: "(47) HIRED AUTOS ONLY",
//               coordinates: {
//                 x: 306.29998779296875,
//                 y: 415.0400085449219,
//                 width: 67.46466064453125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   306.29998779296875, 415.0400085449219, 373.7646484375,
//                   421.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 144,
//               type: "text",
//               content: "(46) SPECIFICALLY DESCRIBED AUTOS",
//               coordinates: {
//                 x: 306.29998779296875,
//                 y: 407.84002685546875,
//                 width: 107.89288330078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   306.29998779296875, 407.84002685546875, 414.19287109375,
//                   414.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 145,
//               type: "text",
//               content: "MOTORIST LAW",
//               coordinates: {
//                 x: 174.89999389648438,
//                 y: 429.44000244140625,
//                 width: 43.93574523925781,
//                 height: 6.4227294921875,
//                 bbox: [
//                   174.89999389648438, 429.44000244140625, 218.8357391357422,
//                   435.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 146,
//               type: "text",
//               content: "COMPULSORY UNINSURED",
//               coordinates: {
//                 x: 174.89999389648438,
//                 y: 422.2400207519531,
//                 width: 76.41175842285156,
//                 height: 6.4227294921875,
//                 bbox: [
//                   174.89999389648438, 422.2400207519531, 251.31175231933594,
//                   428.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 147,
//               type: "text",
//               content: "(45) OWNED AUTOS SUBJECT TO A",
//               coordinates: {
//                 x: 162.3000030517578,
//                 y: 415.0400085449219,
//                 width: 96.92774963378906,
//                 height: 6.4227294921875,
//                 bbox: [
//                   162.3000030517578, 415.0400085449219, 259.2277526855469,
//                   421.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 148,
//               type: "text",
//               content: "(44) OWNED AUTOS SUBJECT TO NO-FAULT",
//               coordinates: {
//                 x: 162.3000030517578,
//                 y: 407.84002685546875,
//                 width: 121.39973449707031,
//                 height: 6.4227294921875,
//                 bbox: [
//                   162.3000030517578, 407.84002685546875, 283.6997375488281,
//                   414.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 149,
//               type: "text",
//               content: "(43) OWNED COMMERCIAL AUTOS ONLY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 429.44000244140625,
//                 width: 111.94097328186035,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 429.44000244140625, 133.84097290039062,
//                   435.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 150,
//               type: "text",
//               content: "(42) OWNED AUTOS ONLY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 422.2400207519531,
//                 width: 71.6104907989502,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 422.2400207519531, 93.51049041748047,
//                   428.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 151,
//               type: "text",
//               content: "(41) ANY AUTO",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 415.0400085449219,
//                 width: 40.33624839782715,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 415.0400085449219, 62.23624801635742,
//                   421.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 152,
//               type: "text",
//               content: "COVERED AUTO SYMBOLS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 406.34002685546875,
//                 width: 75.96324348449707,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 406.34002685546875, 97.86324310302734,
//                   412.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 153,
//               type: "text",
//               content: "PHYSICAL DAMAGE",
//               coordinates: {
//                 x: 436.6400146484375,
//                 y: 46.34001159667969,
//                 width: 56.073944091796875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   436.6400146484375, 46.34001159667969, 492.7139587402344,
//                   52.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 154,
//               type: "text",
//               content: "DEDUCTIBLE",
//               coordinates: {
//                 x: 552.3724975585938,
//                 y: 58.34001159667969,
//                 width: 37.0242919921875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   552.3724975585938, 58.34001159667969, 589.3967895507812,
//                   64.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 155,
//               type: "text",
//               content: "LIMITS",
//               coordinates: {
//                 x: 494.87750244140625,
//                 y: 58.34001159667969,
//                 width: 18.81976318359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   494.87750244140625, 58.34001159667969, 513.697265625,
//                   64.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 156,
//               type: "text",
//               content: "AUTO SYMBOLS",
//               coordinates: {
//                 x: 405.5924987792969,
//                 y: 59.54002380371094,
//                 width: 46.1724853515625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   405.5924987792969, 59.54002380371094, 451.7649841308594,
//                   65.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 157,
//               type: "text",
//               content: "COVERED",
//               coordinates: {
//                 x: 414.1824951171875,
//                 y: 54.13999938964844,
//                 width: 28.41070556640625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   414.1824951171875, 54.13999938964844, 442.59320068359375,
//                   60.56275177001953
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 158,
//               type: "text",
//               content: "COVERAGES",
//               coordinates: {
//                 x: 347.3287353515625,
//                 y: 58.34001159667969,
//                 width: 36.70794677734375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   347.3287353515625, 58.34001159667969, 384.03668212890625,
//                   64.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 159,
//               type: "text",
//               content: "49",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 238.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   414.29998779296875, 238.63999938964844, 420.6939697265625,
//                   245.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 160,
//               type: "text",
//               content: "48",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 226.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   414.29998779296875, 226.63999938964844, 420.6939697265625,
//                   233.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 161,
//               type: "text",
//               content: "COMP / OTC",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 230.8400115966797,
//                 width: 34.03997802734375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   338.70001220703125, 230.8400115966797, 372.739990234375,
//                   237.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 162,
//               type: "text",
//               content: "49",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 262.6400146484375,
//                 width: 6.39398193359375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   414.29998779296875, 262.6400146484375, 420.6939697265625,
//                   269.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 163,
//               type: "text",
//               content: "48",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 250.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   414.29998779296875, 250.63999938964844, 420.6939697265625,
//                   257.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 164,
//               type: "text",
//               content: "CAUSES OF LOSS",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 260.239990234375,
//                 width: 50.105438232421875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 260.239990234375, 388.8054504394531,
//                   266.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 165,
//               type: "text",
//               content: "SPECIFIED",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 253.04002380371094,
//                 width: 30.31396484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   338.70001220703125, 253.04002380371094, 369.01397705078125,
//                   259.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 166,
//               type: "text",
//               content: "49",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 286.6400146484375,
//                 width: 6.39398193359375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   414.29998779296875, 286.6400146484375, 420.6939697265625,
//                   293.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 167,
//               type: "text",
//               content: "48",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 274.6400146484375,
//                 width: 6.39398193359375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   414.29998779296875, 274.6400146484375, 420.6939697265625,
//                   281.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 168,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 551.0999755859375,
//                 y: 280.6400146484375,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   551.0999755859375, 280.6400146484375, 554.2969970703125,
//                   287.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 169,
//               type: "text",
//               content: "COLLISION",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 280.6400146484375,
//                 width: 30.647430419921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 280.6400146484375, 369.3474426269531,
//                   287.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 170,
//               type: "text",
//               content: "OTHER",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 380.2400207519531,
//                 width: 20.10772705078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 380.2400207519531, 358.8077392578125,
//                   386.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 171,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 317.0350036621094,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   317.0350036621094, 26.379987716674805, 408.8182373046875,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 172,
//               type: "text",
//               content: "APPLICANT'S SIGNATURE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 734.5400390625,
//                 width: 73.06524085998535,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 734.5400390625, 94.96524047851562,
//                   740.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 173,
//               type: "text",
//               content: "DATE",
//               coordinates: {
//                 x: 223.5,
//                 y: 734.5400390625,
//                 width: 15.214508056640625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   223.5, 734.5400390625, 238.71450805664062, 740.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 174,
//               type: "text",
//               content: "PRODUCER'S SIGNATURE",
//               coordinates: {
//                 x: 295.5,
//                 y: 734.5400390625,
//                 width: 73.07662963867188,
//                 height: 6.4227294921875,
//                 bbox: [
//                   295.5, 734.5400390625, 368.5766296386719, 740.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 175,
//               type: "text",
//               content: "NATIONAL PRODUCER NUMBER",
//               coordinates: {
//                 x: 498.646240234375,
//                 y: 734.5400390625,
//                 width: 90.447509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   498.646240234375, 734.5400390625, 589.09375, 740.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 176,
//               type: "text",
//               content:
//                 "ANY PERSON WHO KNOWINGLY AND WITH INTENT TO DEFRAUD ANY INSURANCE COMPANY OR OTHER PERSON FILES AN",
//               coordinates: {
//                 x: 25.5,
//                 y: 664.780029296875,
//                 width: 467.3094177246094,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 664.780029296875, 492.8094177246094, 673.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 177,
//               type: "text",
//               content:
//                 "APPLICATION FOR INSURANCE OR STATEMENT OF CLAIM CONTAINING ANY MATERIALLY FALSE INFORMATION OR CONCEALS FOR",
//               coordinates: {
//                 x: 25.5,
//                 y: 674.3800048828125,
//                 width: 500.68878173828125,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 674.3800048828125, 526.1887817382812, 683.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 178,
//               type: "text",
//               content:
//                 "THE PURPOSE OF MISLEADING, INFORMATION CONCERNING ANY FACT MATERIAL THERETO COMMITS A FRAUDULENT INSURANCE",
//               coordinates: {
//                 x: 25.5,
//                 y: 684.5800170898438,
//                 width: 502.572021484375,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 684.5800170898438, 528.072021484375, 693.2367553710938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 179,
//               type: "text",
//               content:
//                 "ACT, WHICH IS A CRIME AND SUBJECTS SUCH PERSON TO CRIMINAL AND CIVIL PENALTIES.",
//               coordinates: {
//                 x: 25.5,
//                 y: 694.780029296875,
//                 width: 350.5790100097656,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 694.780029296875, 376.0790100097656, 703.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 180,
//               type: "text",
//               content: "ACORD 137 OH (2015/12)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 757.780029296875,
//                 width: 92.55050086975098,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 757.780029296875, 114.45050048828125,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 41.26749469857623,
//                 width: 577.4399999999999,
//                 height: 397.31960012117537,
//                 bbox: [
//                   17.52, 41.26749469857623, 594.9599999999999, 438.5870948197516
//                 ]
//               },
//               properties: {
//                 rows: 29,
//                 columns: 32,
//                 accuracy: 75.907
//               }
//             },
//             {
//               id: 1,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 659.3202059981824,
//                 width: 577.68,
//                 height: 97.4104816722205,
//                 bbox: [
//                   17.28, 659.3202059981824, 594.9599999999999, 756.7306876704029
//                 ]
//               },
//               properties: {
//                 rows: 3,
//                 columns: 4,
//                 accuracy: 57.179
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 181,
//           table_count: 2,
//           total_elements: 183
//         }
//       },
//       {
//         page_number: 7,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 415.20001220703125,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   415.20001220703125, 25.188751220703125, 447.44805908203125,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 317.0350036621094,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   317.0350036621094, 26.379987716674805, 408.8182373046875,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "Page 3 of 3",
//               coordinates: {
//                 x: 285.84124755859375,
//                 y: 757.780029296875,
//                 width: 40.873504638671875,
//                 height: 8.65673828125,
//                 bbox: [
//                   285.84124755859375, 757.780029296875, 326.7147521972656,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content:
//                 "I UNDERSTAND THAT THE COVERAGE SELECTION AND LIMIT CHOICES INDICATED HERE WILL APPLY TO ALL FUTURE POLICY RENEWALS, CONTINUATIONS",
//               coordinates: {
//                 x: 25.5,
//                 y: 711.9599609375,
//                 width: 508.30902099609375,
//                 height: 7.539794921875,
//                 bbox: [
//                   25.5, 711.9599609375, 533.8090209960938, 719.499755859375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "AND CHANGES UNLESS I NOTIFY YOU OTHERWISE IN WRITING.",
//               coordinates: {
//                 x: 25.5,
//                 y: 720.3599853515625,
//                 width: 209.03399658203125,
//                 height: 7.539794921875,
//                 bbox: [
//                   25.5, 720.3599853515625, 234.53399658203125, 727.8997802734375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "SIGNATURE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 650.3800048828125,
//                 width: 45.02750587463379,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 650.3800048828125, 66.92750549316406,
//                   659.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content:
//                 "ENDORSEMENTS / REMARKS  (ACORD 101, Additional Remarks Schedule, may be attached if more space is required)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 440.3799743652344,
//                 width: 435.999475479126,
//                 height: 8.656768798828125,
//                 bbox: [
//                   21.899999618530273, 440.3799743652344, 457.89947509765625,
//                   449.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 399.8999938964844,
//                 y: 296.84002685546875,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   399.8999938964844, 296.84002685546875, 403.09698486328125,
//                   303.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "TRAILER VALUE",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 296.84002685546875,
//                 width: 44.263427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 296.84002685546875, 382.96343994140625,
//                   303.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "69",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 226.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   414.29998779296875, 226.63999938964844, 420.6939697265625,
//                   233.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "70",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 238.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   414.29998779296875, 238.63999938964844, 420.6939697265625,
//                   245.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "COMP / OTC",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 230.8400115966797,
//                 width: 34.03997802734375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   338.70001220703125, 230.8400115966797, 372.739990234375,
//                   237.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "TRAILER INTERCHANGE",
//               coordinates: {
//                 x: 430.3599853515625,
//                 y: 202.3400115966797,
//                 width: 68.62039184570312,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   430.3599853515625, 202.3400115966797, 498.9803771972656,
//                   208.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "COVERAGES",
//               coordinates: {
//                 x: 347.3287353515625,
//                 y: 214.3400115966797,
//                 width: 36.70794677734375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   347.3287353515625, 214.3400115966797, 384.03668212890625,
//                   220.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "SYMBOL",
//               coordinates: {
//                 x: 401.7012634277344,
//                 y: 214.3400115966797,
//                 width: 24.57550048828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   401.7012634277344, 214.3400115966797, 426.2767639160156,
//                   220.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "# TRAILERS ",
//               coordinates: {
//                 x: 433.2275085449219,
//                 y: 210.13999938964844,
//                 width: 35.989990234375,
//                 height: 10.622756958007812,
//                 bbox: [
//                   433.2275085449219, 210.13999938964844, 469.2174987792969,
//                   220.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "FARTH",
//               coordinates: {
//                 x: 469.2174987792969,
//                 y: 210.13999938964844,
//                 width: 19.153228759765625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   469.2174987792969, 210.13999938964844, 488.3707275390625,
//                   216.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "# DAYS",
//               coordinates: {
//                 x: 494.1787414550781,
//                 y: 214.3400115966797,
//                 width: 20.228485107421875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   494.1787414550781, 214.3400115966797, 514.4072265625,
//                   220.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "RADIUS",
//               coordinates: {
//                 x: 521.7787475585938,
//                 y: 214.3400115966797,
//                 width: 22.02825927734375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   521.7787475585938, 214.3400115966797, 543.8070068359375,
//                   220.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "DEDUCTIBLE",
//               coordinates: {
//                 x: 552.3724975585938,
//                 y: 214.3400115966797,
//                 width: 37.0242919921875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   552.3724975585938, 214.3400115966797, 589.3967895507812,
//                   220.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "ZONE",
//               coordinates: {
//                 x: 470.8137512207031,
//                 y: 215.54002380371094,
//                 width: 15.95623779296875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   470.8137512207031, 215.54002380371094, 486.7699890136719,
//                   221.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content: "CAUSES OF LOSS",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 122.23997497558594,
//                 width: 50.105438232421875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   338.70001220703125, 122.23997497558594, 388.8054504394531,
//                   128.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "SPECIFIED",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 115.04002380371094,
//                 width: 30.31396484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   338.70001220703125, 115.04002380371094, 369.01397705078125,
//                   121.46277618408203
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "68",
//               coordinates: {
//                 x: 450.29998779296875,
//                 y: 118.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   450.29998779296875, 118.63999938964844, 456.6939697265625,
//                   125.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "67",
//               coordinates: {
//                 x: 450.29998779296875,
//                 y: 106.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   450.29998779296875, 106.63999938964844, 456.6939697265625,
//                   113.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content: "64",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 130.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   414.29998779296875, 130.63999938964844, 420.6939697265625,
//                   137.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: "63",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 118.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   414.29998779296875, 118.63999938964844, 420.6939697265625,
//                   125.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content: "62",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 106.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   414.29998779296875, 106.63999938964844, 420.6939697265625,
//                   113.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 551.0999755859375,
//                 y: 118.63999938964844,
//                 width: 3.197021484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   551.0999755859375, 118.63999938964844, 554.2969970703125,
//                   125.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content: "SCL",
//               coordinates: {
//                 x: 476.8074951171875,
//                 y: 106.63999938964844,
//                 width: 11.177978515625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   476.8074951171875, 106.63999938964844, 487.9854736328125,
//                   113.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content: "F",
//               coordinates: {
//                 x: 479.1000061035156,
//                 y: 118.63999938964844,
//                 width: 3.50750732421875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   479.1000061035156, 118.63999938964844, 482.6075134277344,
//                   125.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content: "FT",
//               coordinates: {
//                 x: 507.8999938964844,
//                 y: 106.63999938964844,
//                 width: 7.014984130859375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   507.8999938964844, 106.63999938964844, 514.9149780273438,
//                   113.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content: "FTW",
//               coordinates: {
//                 x: 507.8999938964844,
//                 y: 118.63999938964844,
//                 width: 12.437225341796875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   507.8999938964844, 118.63999938964844, 520.3372192382812,
//                   125.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content: "LSP",
//               coordinates: {
//                 x: 534.5662231445312,
//                 y: 106.63999938964844,
//                 width: 10.8560791015625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   534.5662231445312, 106.63999938964844, 545.4223022460938,
//                   113.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content: "68",
//               coordinates: {
//                 x: 450.29998779296875,
//                 y: 82.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   450.29998779296875, 82.63999938964844, 456.6939697265625,
//                   89.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content: "67",
//               coordinates: {
//                 x: 450.29998779296875,
//                 y: 70.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   450.29998779296875, 70.63999938964844, 456.6939697265625,
//                   77.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content: "64",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 94.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   414.29998779296875, 94.63999938964844, 420.6939697265625,
//                   101.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content: "63",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 82.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   414.29998779296875, 82.63999938964844, 420.6939697265625,
//                   89.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content: "62",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 70.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   414.29998779296875, 70.63999938964844, 420.6939697265625,
//                   77.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 551.0999755859375,
//                 y: 82.63999938964844,
//                 width: 3.197021484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   551.0999755859375, 82.63999938964844, 554.2969970703125,
//                   89.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content: "COMP / OTC",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 80.84001159667969,
//                 width: 34.03997802734375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   338.70001220703125, 80.84001159667969, 372.739990234375,
//                   87.26276397705078
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 464.70001220703125,
//                 y: 184.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   464.70001220703125, 184.63999938964844, 467.8970031738281,
//                   191.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content: "63",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 178.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   414.29998779296875, 178.63999938964844, 420.6939697265625,
//                   185.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content: "67",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 190.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   414.29998779296875, 190.63999938964844, 420.6939697265625,
//                   197.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content: "& LABOR",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 188.23997497558594,
//                 width: 24.8974609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   338.70001220703125, 188.23997497558594, 363.59747314453125,
//                   194.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content: "TOWING",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 181.04002380371094,
//                 width: 23.5059814453125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   338.70001220703125, 181.04002380371094, 362.20599365234375,
//                   187.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 551.0999755859375,
//                 y: 154.63999938964844,
//                 width: 3.197021484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   551.0999755859375, 154.63999938964844, 554.2969970703125,
//                   161.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content: "68",
//               coordinates: {
//                 x: 450.29998779296875,
//                 y: 154.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   450.29998779296875, 154.63999938964844, 456.6939697265625,
//                   161.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content: "67",
//               coordinates: {
//                 x: 450.29998779296875,
//                 y: 142.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   450.29998779296875, 142.63999938964844, 456.6939697265625,
//                   149.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content: "64",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 166.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   414.29998779296875, 166.63999938964844, 420.6939697265625,
//                   173.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content: "63",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 154.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   414.29998779296875, 154.63999938964844, 420.6939697265625,
//                   161.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content: "62",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 142.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   414.29998779296875, 142.63999938964844, 420.6939697265625,
//                   149.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 52,
//               type: "text",
//               content: "COLLISION",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 154.63999938964844,
//                 width: 30.647430419921875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   338.70001220703125, 154.63999938964844, 369.3474426269531,
//                   161.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 53,
//               type: "text",
//               content: "69",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 274.6400146484375,
//                 width: 6.39398193359375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   414.29998779296875, 274.6400146484375, 420.6939697265625,
//                   281.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 54,
//               type: "text",
//               content: "70",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 286.6400146484375,
//                 width: 6.39398193359375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   414.29998779296875, 286.6400146484375, 420.6939697265625,
//                   293.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 55,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 551.0999755859375,
//                 y: 280.6400146484375,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   551.0999755859375, 280.6400146484375, 554.2969970703125,
//                   287.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 56,
//               type: "text",
//               content: "COLLISION",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 280.6400146484375,
//                 width: 30.647430419921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 280.6400146484375, 369.3474426269531,
//                   287.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 57,
//               type: "text",
//               content: "69",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 250.63999938964844,
//                 width: 6.39398193359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   414.29998779296875, 250.63999938964844, 420.6939697265625,
//                   257.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 58,
//               type: "text",
//               content: "70",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 262.6400146484375,
//                 width: 6.39398193359375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   414.29998779296875, 262.6400146484375, 420.6939697265625,
//                   269.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 59,
//               type: "text",
//               content: "CAUSES OF LOSS",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 260.239990234375,
//                 width: 50.105438232421875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 260.239990234375, 388.8054504394531,
//                   266.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 60,
//               type: "text",
//               content: "SPECIFIED",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 253.04002380371094,
//                 width: 30.31396484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   338.70001220703125, 253.04002380371094, 369.01397705078125,
//                   259.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 61,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 310.6400146484375,
//                 width: 3.1970062255859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   176.6999969482422, 310.6400146484375, 179.89700317382812,
//                   317.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 62,
//               type: "text",
//               content: "IF ANY BASIS",
//               coordinates: {
//                 x: 263.1000061035156,
//                 y: 298.6400146484375,
//                 width: 36.58721923828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   263.1000061035156, 298.6400146484375, 299.6872253417969,
//                   305.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 63,
//               type: "text",
//               content: "COST OF HIRE",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 298.6400146484375,
//                 width: 40.738739013671875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   176.6999969482422, 298.6400146484375, 217.43873596191406,
//                   305.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 64,
//               type: "text",
//               content: "TRUCKERS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 296.2400207519531,
//                 width: 31.60199546813965,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 296.2400207519531, 53.50199508666992,
//                   302.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 65,
//               type: "text",
//               content: "HIRED / BORROWED",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 302.84002685546875,
//                 width: 57.12624549865723,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 302.84002685546875, 79.0262451171875,
//                   309.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 66,
//               type: "text",
//               content: "LIABILITY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 310.0400085449219,
//                 width: 26.168249130249023,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 310.0400085449219, 48.0682487487793,
//                   316.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 67,
//               type: "text",
//               content: "NO",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 308.84002685546875,
//                 width: 8.619247436523438,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 308.84002685546875, 113.31924438476562,
//                   315.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 68,
//               type: "text",
//               content: "YES",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 296.84002685546875,
//                 width: 11.488494873046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 296.84002685546875, 116.18849182128906,
//                   303.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 69,
//               type: "text",
//               content: "STATES",
//               coordinates: {
//                 x: 136.84500122070312,
//                 y: 296.84002685546875,
//                 width: 21.48199462890625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   136.84500122070312, 296.84002685546875, 158.32699584960938,
//                   303.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 70,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 286.6400146484375,
//                 width: 3.1970062255859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   176.6999969482422, 286.6400146484375, 179.89700317382812,
//                   293.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 71,
//               type: "text",
//               content: "IF ANY BASIS",
//               coordinates: {
//                 x: 263.1000061035156,
//                 y: 274.6400146484375,
//                 width: 36.58721923828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   263.1000061035156, 274.6400146484375, 299.6872253417969,
//                   281.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 72,
//               type: "text",
//               content: "COST OF HIRE",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 274.6400146484375,
//                 width: 40.738739013671875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   176.6999969482422, 274.6400146484375, 217.43873596191406,
//                   281.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 73,
//               type: "text",
//               content: "NON-TRUCKERS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 275.2400207519531,
//                 width: 46.287492752075195,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 275.2400207519531, 68.18749237060547,
//                   281.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 74,
//               type: "text",
//               content: "HIRED / BORROWED",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 282.44000244140625,
//                 width: 57.12624549865723,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 282.44000244140625, 79.0262451171875,
//                   288.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 75,
//               type: "text",
//               content: "NO",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 284.84002685546875,
//                 width: 8.619247436523438,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 284.84002685546875, 113.31924438476562,
//                   291.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 76,
//               type: "text",
//               content: "YES",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 272.84002685546875,
//                 width: 11.488494873046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 272.84002685546875, 116.18849182128906,
//                   279.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 77,
//               type: "text",
//               content: "STATES",
//               coordinates: {
//                 x: 136.84500122070312,
//                 y: 272.84002685546875,
//                 width: 21.48199462890625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   136.84500122070312, 272.84002685546875, 158.32699584960938,
//                   279.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 78,
//               type: "text",
//               content: "UNINSURED",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 203.8400115966797,
//                 width: 34.160749435424805,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 203.8400115966797, 56.06074905395508,
//                   210.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 79,
//               type: "text",
//               content: "MOTORIST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 211.04002380371094,
//                 width: 30.210500717163086,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 211.04002380371094, 52.11050033569336,
//                   217.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 80,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 226.04002380371094,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   255.89999389648438, 226.04002380371094, 259.09698486328125,
//                   232.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 81,
//               type: "text",
//               content: "DED",
//               coordinates: {
//                 x: 236.55999755859375,
//                 y: 226.63999938964844,
//                 width: 12.13250732421875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   236.55999755859375, 226.63999938964844, 248.6925048828125,
//                   233.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 82,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 214.04002380371094,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   255.89999389648438, 214.04002380371094, 259.09698486328125,
//                   220.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 83,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 203.23997497558594,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   255.89999389648438, 203.23997497558594, 259.09698486328125,
//                   209.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 84,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 191.23997497558594,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   255.89999389648438, 191.23997497558594, 259.09698486328125,
//                   197.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 85,
//               type: "text",
//               content: "PROPERTY DAMAGE",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 214.63999938964844,
//                 width: 57.879486083984375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   191.10000610351562, 214.63999938964844, 248.9794921875,
//                   221.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 86,
//               type: "text",
//               content: "BI EACH ACCIDENT",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 203.23997497558594,
//                 width: 53.618743896484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   176.6999969482422, 203.23997497558594, 230.31874084472656,
//                   209.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 87,
//               type: "text",
//               content: "EA PER",
//               coordinates: {
//                 x: 227.10000610351562,
//                 y: 192.4399871826172,
//                 width: 20.745986938476562,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   227.10000610351562, 192.4399871826172, 247.8459930419922,
//                   198.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 88,
//               type: "text",
//               content: "BI",
//               coordinates: {
//                 x: 227.10000610351562,
//                 y: 187.04002380371094,
//                 width: 5.4222412109375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   227.10000610351562, 187.04002380371094, 232.52224731445312,
//                   193.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 89,
//               type: "text",
//               content: "CSL",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 191.23997497558594,
//                 width: 11.178009033203125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   191.10000610351562, 191.23997497558594, 202.27801513671875,
//                   197.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 90,
//               type: "text",
//               content: "62",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 190.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 190.63999938964844, 111.093994140625,
//                   197.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 91,
//               type: "text",
//               content: "63",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 202.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 202.63999938964844, 111.093994140625,
//                   209.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 92,
//               type: "text",
//               content: "64",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 214.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 214.63999938964844, 111.093994140625,
//                   221.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 93,
//               type: "text",
//               content: "66",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 226.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 226.63999938964844, 111.093994140625,
//                   233.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 94,
//               type: "text",
//               content: "67",
//               coordinates: {
//                 x: 133.5,
//                 y: 190.63999938964844,
//                 width: 6.394012451171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   133.5, 190.63999938964844, 139.89401245117188,
//                   197.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 95,
//               type: "text",
//               content: "62",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 238.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 238.63999938964844, 111.093994140625,
//                   245.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 96,
//               type: "text",
//               content: "63",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 250.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 250.63999938964844, 111.093994140625,
//                   257.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 97,
//               type: "text",
//               content: "64",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 262.6400146484375,
//                 width: 6.3939971923828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 262.6400146484375, 111.093994140625,
//                   269.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 98,
//               type: "text",
//               content: "66",
//               coordinates: {
//                 x: 133.5,
//                 y: 238.63999938964844,
//                 width: 6.394012451171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   133.5, 238.63999938964844, 139.89401245117188,
//                   245.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 99,
//               type: "text",
//               content: "67",
//               coordinates: {
//                 x: 133.5,
//                 y: 250.63999938964844,
//                 width: 6.394012451171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   133.5, 250.63999938964844, 139.89401245117188,
//                   257.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 100,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 251.23997497558594,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   255.89999389648438, 251.23997497558594, 259.09698486328125,
//                   257.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 101,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 239.23997497558594,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   255.89999389648438, 239.23997497558594, 259.09698486328125,
//                   245.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 102,
//               type: "text",
//               content: "BI EACH ACCIDENT",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 251.23997497558594,
//                 width: 53.618743896484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   176.6999969482422, 251.23997497558594, 230.31874084472656,
//                   257.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 103,
//               type: "text",
//               content: "EA PER",
//               coordinates: {
//                 x: 227.10000610351562,
//                 y: 240.4399871826172,
//                 width: 20.745986938476562,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   227.10000610351562, 240.4399871826172, 247.8459930419922,
//                   246.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 104,
//               type: "text",
//               content: "BI",
//               coordinates: {
//                 x: 227.10000610351562,
//                 y: 235.04002380371094,
//                 width: 5.4222412109375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   227.10000610351562, 235.04002380371094, 232.52224731445312,
//                   241.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 105,
//               type: "text",
//               content: "CSL",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 239.23997497558594,
//                 width: 11.178009033203125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   191.10000610351562, 239.23997497558594, 202.27801513671875,
//                   245.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 106,
//               type: "text",
//               content: "UNDERINSURED",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 247.04002380371094,
//                 width: 46.29324531555176,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 247.04002380371094, 68.19324493408203,
//                   253.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 107,
//               type: "text",
//               content: "MOTORIST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 254.23997497558594,
//                 width: 30.210500717163086,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 254.23997497558594, 52.11050033569336,
//                   260.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 108,
//               type: "text",
//               content: "HIRED",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 333.44000244140625,
//                 width: 17.876708984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 333.44000244140625, 356.57672119140625,
//                   339.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 109,
//               type: "text",
//               content: "PHYSICAL",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 340.6400146484375,
//                 width: 28.41070556640625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 340.6400146484375, 367.1107177734375,
//                   347.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 110,
//               type: "text",
//               content: "DAMAGE",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 347.84002685546875,
//                 width: 24.897491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 347.84002685546875, 363.5975036621094,
//                   354.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 111,
//               type: "text",
//               content: "STATES",
//               coordinates: {
//                 x: 385.2449951171875,
//                 y: 308.2400207519531,
//                 width: 21.48199462890625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   385.2449951171875, 308.2400207519531, 406.72698974609375,
//                   314.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 112,
//               type: "text",
//               content: "# DAYS",
//               coordinates: {
//                 x: 422.2875061035156,
//                 y: 308.2400207519531,
//                 width: 20.00421142578125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   422.2875061035156, 308.2400207519531, 442.2917175292969,
//                   314.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 113,
//               type: "text",
//               content: "# VEH",
//               coordinates: {
//                 x: 459.6912536621094,
//                 y: 308.2400207519531,
//                 width: 16.6002197265625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   459.6912536621094, 308.2400207519531, 476.2914733886719,
//                   314.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 114,
//               type: "text",
//               content: "COVERAGE IS:",
//               coordinates: {
//                 x: 400.59124755859375,
//                 y: 370.6400146484375,
//                 width: 41.1641845703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   400.59124755859375, 370.6400146484375, 441.75543212890625,
//                   377.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 115,
//               type: "text",
//               content: "PRIMARY",
//               coordinates: {
//                 x: 486.29998779296875,
//                 y: 370.6400146484375,
//                 width: 26.07049560546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   486.29998779296875, 370.6400146484375, 512.3704833984375,
//                   377.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 116,
//               type: "text",
//               content: "SECONDARY",
//               coordinates: {
//                 x: 543.9000244140625,
//                 y: 370.6400146484375,
//                 width: 36.288330078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   543.9000244140625, 370.6400146484375, 580.1883544921875,
//                   377.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 117,
//               type: "text",
//               content: "GROUP TYPE",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 322.6400146484375,
//                 width: 37.449737548828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   176.6999969482422, 322.6400146484375, 214.1497344970703,
//                   329.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 118,
//               type: "text",
//               content: "EMPLOYEES",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 334.6400146484375,
//                 width: 35.431488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 334.6400146484375, 226.531494140625,
//                   341.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 119,
//               type: "text",
//               content: "VOLUNTEERS",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 346.6400146484375,
//                 width: 38.94476318359375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 346.6400146484375, 230.04476928710938,
//                   353.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 120,
//               type: "text",
//               content: "PARTNERS",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 358.6400146484375,
//                 width: 30.751007080078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 358.6400146484375, 221.85101318359375,
//                   365.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 121,
//               type: "text",
//               content: "NUMBER OF",
//               coordinates: {
//                 x: 281.8500061035156,
//                 y: 322.6400146484375,
//                 width: 34.471221923828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.8500061035156, 322.6400146484375, 316.32122802734375,
//                   329.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 122,
//               type: "text",
//               content: "LIABILITY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 347.84002685546875,
//                 width: 26.168249130249023,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 347.84002685546875, 48.0682487487793,
//                   354.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 123,
//               type: "text",
//               content: "AUTO",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 340.6400146484375,
//                 width: 15.852750778198242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 340.6400146484375, 37.752750396728516,
//                   347.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 124,
//               type: "text",
//               content: "NON-OWNED",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 333.44000244140625,
//                 width: 36.707998275756836,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 333.44000244140625, 58.60799789428711,
//                   339.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 125,
//               type: "text",
//               content: "STATES",
//               coordinates: {
//                 x: 136.84500122070312,
//                 y: 320.84002685546875,
//                 width: 21.48199462890625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   136.84500122070312, 320.84002685546875, 158.32699584960938,
//                   327.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 126,
//               type: "text",
//               content: "YES",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 320.84002685546875,
//                 width: 11.488494873046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 320.84002685546875, 116.18849182128906,
//                   327.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 127,
//               type: "text",
//               content: "NO",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 332.84002685546875,
//                 width: 8.619247436523438,
//                 height: 6.4227294921875,
//                 bbox: [
//                   104.69999694824219, 332.84002685546875, 113.31924438476562,
//                   339.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 128,
//               type: "text",
//               content: "MOTOR CARRIER SECTION",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 32.98002624511719,
//                 width: 102.67199897766113,
//                 height: 8.656749725341797,
//                 bbox: [
//                   21.899999618530273, 32.98002624511719, 124.5719985961914,
//                   41.636775970458984
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 129,
//               type: "text",
//               content: "LIMITS",
//               coordinates: {
//                 x: 244.67750549316406,
//                 y: 46.34001159667969,
//                 width: 18.819747924804688,
//                 height: 6.422752380371094,
//                 bbox: [
//                   244.67750549316406, 46.34001159667969, 263.49725341796875,
//                   52.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 130,
//               type: "text",
//               content: "COVERED AUTO SYMBOLS",
//               coordinates: {
//                 x: 91.5824966430664,
//                 y: 46.34001159667969,
//                 width: 75.96321868896484,
//                 height: 6.422752380371094,
//                 bbox: [
//                   91.5824966430664, 46.34001159667969, 167.54571533203125,
//                   52.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 131,
//               type: "text",
//               content: "COVERAGES",
//               coordinates: {
//                 x: 34.12874984741211,
//                 y: 46.34001159667969,
//                 width: 36.7079963684082,
//                 height: 6.422752380371094,
//                 bbox: [
//                   34.12874984741211, 46.34001159667969, 70.83674621582031,
//                   52.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 132,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 82.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   255.89999389648438, 82.63999938964844, 259.09698486328125,
//                   89.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 133,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 70.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   255.89999389648438, 70.63999938964844, 259.09698486328125,
//                   77.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 134,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 58.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   255.89999389648438, 58.63999938964844, 259.09698486328125,
//                   65.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 135,
//               type: "text",
//               content: "PROPERTY DAMAGE",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 82.63999938964844,
//                 width: 57.879486083984375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   176.6999969482422, 82.63999938964844, 234.57948303222656,
//                   89.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 136,
//               type: "text",
//               content: "BI EACH ACCIDENT",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 70.63999938964844,
//                 width: 53.618743896484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   176.6999969482422, 70.63999938964844, 230.31874084472656,
//                   77.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 137,
//               type: "text",
//               content: "EA PER",
//               coordinates: {
//                 x: 227.10000610351562,
//                 y: 60.43998718261719,
//                 width: 20.745986938476562,
//                 height: 6.422752380371094,
//                 bbox: [
//                   227.10000610351562, 60.43998718261719, 247.8459930419922,
//                   66.86273956298828
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 138,
//               type: "text",
//               content: "BI",
//               coordinates: {
//                 x: 227.10000610351562,
//                 y: 55.04002380371094,
//                 width: 5.4222412109375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   227.10000610351562, 55.04002380371094, 232.52224731445312,
//                   61.46277618408203
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 139,
//               type: "text",
//               content: "CSL",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 58.63999938964844,
//                 width: 11.178009033203125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   191.10000610351562, 58.63999938964844, 202.27801513671875,
//                   65.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 140,
//               type: "text",
//               content: "71",
//               coordinates: {
//                 x: 133.5,
//                 y: 82.63999938964844,
//                 width: 6.394012451171875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   133.5, 82.63999938964844, 139.89401245117188,
//                   89.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 141,
//               type: "text",
//               content: "68",
//               coordinates: {
//                 x: 133.5,
//                 y: 70.63999938964844,
//                 width: 6.394012451171875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   133.5, 70.63999938964844, 139.89401245117188,
//                   77.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 142,
//               type: "text",
//               content: "67",
//               coordinates: {
//                 x: 133.5,
//                 y: 58.63999938964844,
//                 width: 6.394012451171875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   133.5, 58.63999938964844, 139.89401245117188,
//                   65.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 143,
//               type: "text",
//               content: "64",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 94.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   104.69999694824219, 94.63999938964844, 111.093994140625,
//                   101.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 144,
//               type: "text",
//               content: "63",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 82.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   104.69999694824219, 82.63999938964844, 111.093994140625,
//                   89.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 145,
//               type: "text",
//               content: "62",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 70.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   104.69999694824219, 70.63999938964844, 111.093994140625,
//                   77.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 146,
//               type: "text",
//               content: "61",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 58.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   104.69999694824219, 58.63999938964844, 111.093994140625,
//                   65.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 147,
//               type: "text",
//               content: "LIABILITY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 76.63999938964844,
//                 width: 26.168249130249023,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 76.63999938964844, 48.0682487487793,
//                   83.06275177001953
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 148,
//               type: "text",
//               content: "PHYSICAL DAMAGE",
//               coordinates: {
//                 x: 436.6400146484375,
//                 y: 46.34001159667969,
//                 width: 56.073944091796875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   436.6400146484375, 46.34001159667969, 492.7139587402344,
//                   52.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 149,
//               type: "text",
//               content: "DEDUCTIBLE",
//               coordinates: {
//                 x: 552.3724975585938,
//                 y: 58.34001159667969,
//                 width: 37.0242919921875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   552.3724975585938, 58.34001159667969, 589.3967895507812,
//                   64.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 150,
//               type: "text",
//               content: "LIMITS",
//               coordinates: {
//                 x: 494.87750244140625,
//                 y: 58.34001159667969,
//                 width: 18.81976318359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   494.87750244140625, 58.34001159667969, 513.697265625,
//                   64.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 151,
//               type: "text",
//               content: "AUTO SYMBOLS",
//               coordinates: {
//                 x: 405.5924987792969,
//                 y: 59.54002380371094,
//                 width: 46.1724853515625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   405.5924987792969, 59.54002380371094, 451.7649841308594,
//                   65.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 152,
//               type: "text",
//               content: "COVERED",
//               coordinates: {
//                 x: 414.1824951171875,
//                 y: 54.13999938964844,
//                 width: 28.41070556640625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   414.1824951171875, 54.13999938964844, 442.59320068359375,
//                   60.56275177001953
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 153,
//               type: "text",
//               content: "COVERAGES",
//               coordinates: {
//                 x: 347.3287353515625,
//                 y: 58.34001159667969,
//                 width: 36.70794677734375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   347.3287353515625, 58.34001159667969, 384.03668212890625,
//                   64.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 154,
//               type: "text",
//               content: "MEDICAL",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 169.04002380371094,
//                 width: 25.5414981842041,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 169.04002380371094, 47.441497802734375,
//                   175.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 155,
//               type: "text",
//               content: "PAYMENTS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 176.23997497558594,
//                 width: 30.7452449798584,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 176.23997497558594, 52.64524459838867,
//                   182.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 156,
//               type: "text",
//               content: "62",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 166.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 166.63999938964844, 111.093994140625,
//                   173.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 157,
//               type: "text",
//               content: "63",
//               coordinates: {
//                 x: 104.69999694824219,
//                 y: 178.63999938964844,
//                 width: 6.3939971923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   104.69999694824219, 178.63999938964844, 111.093994140625,
//                   185.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 158,
//               type: "text",
//               content: "64",
//               coordinates: {
//                 x: 133.5,
//                 y: 166.63999938964844,
//                 width: 6.394012451171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   133.5, 166.63999938964844, 139.89401245117188,
//                   173.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 159,
//               type: "text",
//               content: "67",
//               coordinates: {
//                 x: 133.5,
//                 y: 178.63999938964844,
//                 width: 6.394012451171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   133.5, 178.63999938964844, 139.89401245117188,
//                   185.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 160,
//               type: "text",
//               content: "EACH PERSON",
//               coordinates: {
//                 x: 176.6999969482422,
//                 y: 172.63999938964844,
//                 width: 41.813995361328125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   176.6999969482422, 172.63999938964844, 218.5139923095703,
//                   179.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 161,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 255.89999389648438,
//                 y: 172.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   255.89999389648438, 172.63999938964844, 259.09698486328125,
//                   179.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 162,
//               type: "text",
//               content: "OTHER",
//               coordinates: {
//                 x: 338.70001220703125,
//                 y: 380.2400207519531,
//                 width: 20.10772705078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   338.70001220703125, 380.2400207519531, 358.8077392578125,
//                   386.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 163,
//               type: "text",
//               content: "OTHER",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 368.2400207519531,
//                 width: 20.10774803161621,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 368.2400207519531, 42.007747650146484,
//                   374.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 164,
//               type: "text",
//               content: "(65) OWNED AUTOS SUBJECT TO NO-FAULT",
//               coordinates: {
//                 x: 165.89999389648438,
//                 y: 415.0400085449219,
//                 width: 121.39971923828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   165.89999389648438, 415.0400085449219, 287.2997131347656,
//                   421.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 165,
//               type: "text",
//               content: "(71) NON-OWNED AUTOS ONLY",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 429.44000244140625,
//                 width: 86.29605102539062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 429.44000244140625, 540.196044921875,
//                   435.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 166,
//               type: "text",
//               content: "INTERCHANGE AGREEMENT",
//               coordinates: {
//                 x: 466.5,
//                 y: 422.2400207519531,
//                 width: 79.47650146484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   466.5, 422.2400207519531, 545.9765014648438, 428.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 167,
//               type: "text",
//               content: "ANOTHER TRUCKER UNDER A TRAILER",
//               coordinates: {
//                 x: 466.5,
//                 y: 415.0400085449219,
//                 width: 109.917236328125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   466.5, 415.0400085449219, 576.417236328125, 421.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 168,
//               type: "text",
//               content: "(70) YOUR TRAILERS IN THE POSSESSION OF",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 407.84002685546875,
//                 width: 127.02359008789062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 407.84002685546875, 580.923583984375,
//                   414.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 169,
//               type: "text",
//               content: "A TRAILER INTERCHANGE AGREEMENT",
//               coordinates: {
//                 x: 322.5,
//                 y: 429.44000244140625,
//                 width: 110.33087158203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   322.5, 429.44000244140625, 432.83087158203125,
//                   435.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 170,
//               type: "text",
//               content: "(69) TRAILERS IN YOUR POSSESSION UNDER",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 422.2400207519531,
//                 width: 126.50558471679688,
//                 height: 6.4227294921875,
//                 bbox: [
//                   309.8999938964844, 422.2400207519531, 436.40557861328125,
//                   428.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 171,
//               type: "text",
//               content: "(68) HIRED AUTOS ONLY",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 415.0400085449219,
//                 width: 67.46466064453125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   309.8999938964844, 415.0400085449219, 377.3646545410156,
//                   421.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 172,
//               type: "text",
//               content: "(67) SPECIFICALLY DESCRIBED AUTOS",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 407.84002685546875,
//                 width: 107.89288330078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   309.8999938964844, 407.84002685546875, 417.7928771972656,
//                   414.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 173,
//               type: "text",
//               content: "SORY UNINSURED MOTORIST LAW",
//               coordinates: {
//                 x: 178.5,
//                 y: 429.44000244140625,
//                 width: 97.35324096679688,
//                 height: 6.4227294921875,
//                 bbox: [
//                   178.5, 429.44000244140625, 275.8532409667969,
//                   435.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 174,
//               type: "text",
//               content: "(66) OWNED AUTOS SUBJECT TO A COMPUL-",
//               coordinates: {
//                 x: 165.89999389648438,
//                 y: 422.2400207519531,
//                 width: 124.70596313476562,
//                 height: 6.4227294921875,
//                 bbox: [
//                   165.89999389648438, 422.2400207519531, 290.60595703125,
//                   428.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 175,
//               type: "text",
//               content: "(64) OWNED COMMERCIAL AUTOS ONLY",
//               coordinates: {
//                 x: 165.89999389648438,
//                 y: 407.84002685546875,
//                 width: 111.94094848632812,
//                 height: 6.4227294921875,
//                 bbox: [
//                   165.89999389648438, 407.84002685546875, 277.8409423828125,
//                   414.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 176,
//               type: "text",
//               content: "(63) OWNED PRIVATE PASS AUTOS ONLY",
//               coordinates: {
//                 x: 25.5,
//                 y: 429.44000244140625,
//                 width: 113.4072265625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   25.5, 429.44000244140625, 138.9072265625, 435.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 177,
//               type: "text",
//               content: "(62) OWNED AUTOS ONLY",
//               coordinates: {
//                 x: 25.5,
//                 y: 422.2400207519531,
//                 width: 71.61048889160156,
//                 height: 6.4227294921875,
//                 bbox: [
//                   25.5, 422.2400207519531, 97.11048889160156, 428.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 178,
//               type: "text",
//               content: "(61) ANY AUTO",
//               coordinates: {
//                 x: 25.5,
//                 y: 415.0400085449219,
//                 width: 40.33624267578125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   25.5, 415.0400085449219, 65.83624267578125, 421.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 179,
//               type: "text",
//               content: "COVERED AUTO SYMBOLS",
//               coordinates: {
//                 x: 25.5,
//                 y: 406.34002685546875,
//                 width: 75.96324157714844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   25.5, 406.34002685546875, 101.46324157714844,
//                   412.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 180,
//               type: "text",
//               content: "APPLICANT'S SIGNATURE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 734.5400390625,
//                 width: 73.06524085998535,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 734.5400390625, 94.96524047851562,
//                   740.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 181,
//               type: "text",
//               content: "DATE",
//               coordinates: {
//                 x: 223.5,
//                 y: 734.5400390625,
//                 width: 15.214508056640625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   223.5, 734.5400390625, 238.71450805664062, 740.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 182,
//               type: "text",
//               content: "PRODUCER'S SIGNATURE",
//               coordinates: {
//                 x: 295.5,
//                 y: 734.5400390625,
//                 width: 73.07662963867188,
//                 height: 6.4227294921875,
//                 bbox: [
//                   295.5, 734.5400390625, 368.5766296386719, 740.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 183,
//               type: "text",
//               content: "NATIONAL PRODUCER NUMBER",
//               coordinates: {
//                 x: 498.646240234375,
//                 y: 734.5400390625,
//                 width: 90.447509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   498.646240234375, 734.5400390625, 589.09375, 740.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 184,
//               type: "text",
//               content:
//                 "ANY PERSON WHO KNOWINGLY AND WITH INTENT TO DEFRAUD ANY INSURANCE COMPANY OR OTHER PERSON FILES AN",
//               coordinates: {
//                 x: 25.5,
//                 y: 664.780029296875,
//                 width: 467.3094177246094,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 664.780029296875, 492.8094177246094, 673.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 185,
//               type: "text",
//               content:
//                 "APPLICATION FOR INSURANCE OR STATEMENT OF CLAIM CONTAINING ANY MATERIALLY FALSE INFORMATION OR CONCEALS FOR",
//               coordinates: {
//                 x: 25.5,
//                 y: 674.3800048828125,
//                 width: 500.68878173828125,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 674.3800048828125, 526.1887817382812, 683.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 186,
//               type: "text",
//               content:
//                 "THE PURPOSE OF MISLEADING, INFORMATION CONCERNING ANY FACT MATERIAL THERETO COMMITS A FRAUDULENT INSURANCE",
//               coordinates: {
//                 x: 25.5,
//                 y: 684.5800170898438,
//                 width: 502.572021484375,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 684.5800170898438, 528.072021484375, 693.2367553710938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 187,
//               type: "text",
//               content:
//                 "ACT, WHICH IS A CRIME AND SUBJECTS SUCH PERSON TO CRIMINAL AND CIVIL PENALTIES.",
//               coordinates: {
//                 x: 25.5,
//                 y: 694.780029296875,
//                 width: 350.5790100097656,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 694.780029296875, 376.0790100097656, 703.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 188,
//               type: "text",
//               content: "ACORD 137 OH (2015/12)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 757.780029296875,
//                 width: 92.55050086975098,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 757.780029296875, 114.45050048828125,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 41.26749469857623,
//                 width: 577.4399999999999,
//                 height: 397.31960012117537,
//                 bbox: [
//                   17.52, 41.26749469857623, 594.9599999999999, 438.5870948197516
//                 ]
//               },
//               properties: {
//                 rows: 31,
//                 columns: 32,
//                 accuracy: 76.065
//               }
//             },
//             {
//               id: 1,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 659.3202059981824,
//                 width: 577.68,
//                 height: 97.4104816722205,
//                 bbox: [
//                   17.28, 659.3202059981824, 594.9599999999999, 756.7306876704029
//                 ]
//               },
//               properties: {
//                 rows: 3,
//                 columns: 4,
//                 accuracy: 57.179
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 189,
//           table_count: 2,
//           total_elements: 191
//         }
//       },
//       {
//         page_number: 8,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 415.20001220703125,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   415.20001220703125, 25.188751220703125, 447.44805908203125,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "04/04/2025",
//               coordinates: {
//                 x: 532.9550170898438,
//                 y: 55.188751220703125,
//                 width: 36.2645263671875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   532.9550170898438, 55.188751220703125, 569.2195434570312,
//                   63.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "UIS Insurance & Investments",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 79.18875122070312,
//                 width: 93.81499099731445,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 79.18875122070312, 116.614990234375,
//                   87.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "25-26",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 103.18875122070312,
//                 width: 18.538253784179688,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 103.18875122070312, 41.338253021240234,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "05/18/2025",
//               coordinates: {
//                 x: 259.3550109863281,
//                 y: 103.18875122070312,
//                 width: 36.2645263671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   259.3550109863281, 103.18875122070312, 295.6195373535156,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "Submissions",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 79.18875122070312,
//                 width: 41.08575439453125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 79.18875122070312, 351.8857421875,
//                   87.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "Buckeye Premier Cleaning, LLC",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 103.18875122070312,
//                 width: 103.10223388671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 103.18875122070312, 413.9022216796875,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "1",
//               coordinates: {
//                 x: 29.103099822998047,
//                 y: 181.18875122070312,
//                 width: 4.031002044677734,
//                 height: 8.098251342773438,
//                 bbox: [
//                   29.103099822998047, 181.18875122070312, 33.13410186767578,
//                   189.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "Patti",
//               coordinates: {
//                 x: 48,
//                 y: 175.18875122070312,
//                 width: 14.485504150390625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   48, 175.18875122070312, 62.485504150390625, 183.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "Smith",
//               coordinates: {
//                 x: 134.39999389648438,
//                 y: 175.18875122070312,
//                 width: 18.516510009765625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   134.39999389648438, 175.18875122070312, 152.91650390625,
//                   183.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 140.66250610351562,
//                 y: 187.18875122070312,
//                 width: 10.867752075195312,
//                 height: 8.098251342773438,
//                 bbox: [
//                   140.66250610351562, 187.18875122070312, 151.53025817871094,
//                   195.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "01/22/1978",
//               coordinates: {
//                 x: 250.35499572753906,
//                 y: 181.18875122070312,
//                 width: 36.26451110839844,
//                 height: 8.098251342773438,
//                 bbox: [
//                   250.35499572753906, 181.18875122070312, 286.6195068359375,
//                   189.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "RF057057",
//               coordinates: {
//                 x: 345,
//                 y: 175.18875122070312,
//                 width: 33.843017578125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   345, 175.18875122070312, 378.843017578125, 183.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 441.26251220703125,
//                 y: 181.18875122070312,
//                 width: 10.86773681640625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   441.26251220703125, 181.18875122070312, 452.1302490234375,
//                   189.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "2",
//               coordinates: {
//                 x: 28.664400100708008,
//                 y: 205.18875122070312,
//                 width: 4.031000137329102,
//                 height: 8.098251342773438,
//                 bbox: [
//                   28.664400100708008, 205.18875122070312, 32.69540023803711,
//                   213.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "Brittany",
//               coordinates: {
//                 x: 48,
//                 y: 199.18875122070312,
//                 width: 24.555747985839844,
//                 height: 8.098251342773438,
//                 bbox: [
//                   48, 199.18875122070312, 72.55574798583984, 207.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "McCarty",
//               coordinates: {
//                 x: 134.39999389648438,
//                 y: 199.18875122070312,
//                 width: 26.977249145507812,
//                 height: 8.098251342773438,
//                 bbox: [
//                   134.39999389648438, 199.18875122070312, 161.3772430419922,
//                   207.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 140.66250610351562,
//                 y: 211.18875122070312,
//                 width: 10.867752075195312,
//                 height: 8.098251342773438,
//                 bbox: [
//                   140.66250610351562, 211.18875122070312, 151.53025817871094,
//                   219.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "10/20/1988",
//               coordinates: {
//                 x: 250.35499572753906,
//                 y: 205.18875122070312,
//                 width: 36.26451110839844,
//                 height: 8.098251342773438,
//                 bbox: [
//                   250.35499572753906, 205.18875122070312, 286.6195068359375,
//                   213.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "TG363620",
//               coordinates: {
//                 x: 345,
//                 y: 199.18875122070312,
//                 width: 34.24176025390625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   345, 199.18875122070312, 379.24176025390625,
//                   207.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 441.26251220703125,
//                 y: 205.18875122070312,
//                 width: 10.86773681640625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   441.26251220703125, 205.18875122070312, 452.1302490234375,
//                   213.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content: "3",
//               coordinates: {
//                 x: 28.664400100708008,
//                 y: 229.18875122070312,
//                 width: 4.031000137329102,
//                 height: 8.098251342773438,
//                 bbox: [
//                   28.664400100708008, 229.18875122070312, 32.69540023803711,
//                   237.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "Dylan",
//               coordinates: {
//                 x: 48,
//                 y: 223.18875122070312,
//                 width: 18.531005859375,
//                 height: 8.098251342773438,
//                 bbox: [
//                   48, 223.18875122070312, 66.531005859375, 231.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "Smith",
//               coordinates: {
//                 x: 134.39999389648438,
//                 y: 223.18875122070312,
//                 width: 18.516510009765625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   134.39999389648438, 223.18875122070312, 152.91650390625,
//                   231.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 140.66250610351562,
//                 y: 235.18875122070312,
//                 width: 10.867752075195312,
//                 height: 8.098251342773438,
//                 bbox: [
//                   140.66250610351562, 235.18875122070312, 151.53025817871094,
//                   243.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content: "08/02/2007",
//               coordinates: {
//                 x: 251.2550048828125,
//                 y: 229.18875122070312,
//                 width: 36.2645263671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   251.2550048828125, 229.18875122070312, 287.51953125,
//                   237.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: "VQ997357",
//               coordinates: {
//                 x: 345,
//                 y: 223.18875122070312,
//                 width: 34.64776611328125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   345, 223.18875122070312, 379.64776611328125,
//                   231.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 441.26251220703125,
//                 y: 229.18875122070312,
//                 width: 10.86773681640625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   441.26251220703125, 229.18875122070312, 452.1302490234375,
//                   237.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content: "4",
//               coordinates: {
//                 x: 28.883750915527344,
//                 y: 253.18875122070312,
//                 width: 4.031002044677734,
//                 height: 8.098236083984375,
//                 bbox: [
//                   28.883750915527344, 253.18875122070312, 32.91475296020508,
//                   261.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content: "Dannielle",
//               coordinates: {
//                 x: 48,
//                 y: 247.18875122070312,
//                 width: 30.217994689941406,
//                 height: 8.098251342773438,
//                 bbox: [
//                   48, 247.18875122070312, 78.2179946899414, 255.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content: "Asztalos",
//               coordinates: {
//                 x: 134.39999389648438,
//                 y: 247.18875122070312,
//                 width: 27.383270263671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   134.39999389648438, 247.18875122070312, 161.78326416015625,
//                   255.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 140.66250610351562,
//                 y: 259.1887512207031,
//                 width: 10.867752075195312,
//                 height: 8.098236083984375,
//                 bbox: [
//                   140.66250610351562, 259.1887512207031, 151.53025817871094,
//                   267.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content: "03/31/1999",
//               coordinates: {
//                 x: 251.2550048828125,
//                 y: 253.18875122070312,
//                 width: 36.2645263671875,
//                 height: 8.098236083984375,
//                 bbox: [
//                   251.2550048828125, 253.18875122070312, 287.51953125,
//                   261.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content: "UM243175",
//               coordinates: {
//                 x: 345,
//                 y: 247.18875122070312,
//                 width: 35.45977783203125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   345, 247.18875122070312, 380.45977783203125,
//                   255.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 441.26251220703125,
//                 y: 253.18875122070312,
//                 width: 10.86773681640625,
//                 height: 8.098236083984375,
//                 bbox: [
//                   441.26251220703125, 253.18875122070312, 452.1302490234375,
//                   261.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content: "5",
//               coordinates: {
//                 x: 28.883750915527344,
//                 y: 277.1887512207031,
//                 width: 4.031002044677734,
//                 height: 8.098236083984375,
//                 bbox: [
//                   28.883750915527344, 277.1887512207031, 32.91475296020508,
//                   285.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content: "Morgan",
//               coordinates: {
//                 x: 48,
//                 y: 271.1887512207031,
//                 width: 24.577499389648438,
//                 height: 8.098236083984375,
//                 bbox: [
//                   48, 271.1887512207031, 72.57749938964844, 279.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content: "McBride",
//               coordinates: {
//                 x: 134.39999389648438,
//                 y: 271.1887512207031,
//                 width: 26.578506469726562,
//                 height: 8.098236083984375,
//                 bbox: [
//                   134.39999389648438, 271.1887512207031, 160.97850036621094,
//                   279.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 140.66250610351562,
//                 y: 283.1887512207031,
//                 width: 10.867752075195312,
//                 height: 8.098236083984375,
//                 bbox: [
//                   140.66250610351562, 283.1887512207031, 151.53025817871094,
//                   291.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content: "04/17/1994",
//               coordinates: {
//                 x: 251.2550048828125,
//                 y: 277.1887512207031,
//                 width: 36.2645263671875,
//                 height: 8.098236083984375,
//                 bbox: [
//                   251.2550048828125, 277.1887512207031, 287.51953125,
//                   285.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content: "UG924518",
//               coordinates: {
//                 x: 345,
//                 y: 271.1887512207031,
//                 width: 35.05377197265625,
//                 height: 8.098236083984375,
//                 bbox: [
//                   345, 271.1887512207031, 380.05377197265625, 279.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 441.26251220703125,
//                 y: 277.1887512207031,
//                 width: 10.86773681640625,
//                 height: 8.098236083984375,
//                 bbox: [
//                   441.26251220703125, 277.1887512207031, 452.1302490234375,
//                   285.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 529.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 529.188720703125, 586.1170043945312,
//                   537.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 568.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 568.188720703125, 586.1170043945312,
//                   576.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 589.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 589.188720703125, 586.1170043945312,
//                   597.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 625.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 625.188720703125, 586.1170043945312,
//                   633.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 661.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 661.188720703125, 586.1170043945312,
//                   669.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 694.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 694.188720703125, 586.1170043945312,
//                   702.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 715.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 715.188720703125, 586.1170043945312,
//                   723.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content: "7.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 710.1599731445312,
//                 width: 5.622751235961914,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 710.1599731445312, 27.522750854492188,
//                   717.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content: "DO OPERATIONS INVOLVE TRANSPORTING HAZARDOUS MATERIAL?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 710.1599731445312,
//                 width: 224.55229568481445,
//                 height: 7.539794921875,
//                 bbox: [
//                   36.29999923706055, 710.1599731445312, 260.852294921875,
//                   717.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content: "* MARITAL STATUS / CIVIL UNION (if applicable)",
//               coordinates: {
//                 x: 224.55999755859375,
//                 y: 488.5400085449219,
//                 width: 130.93890380859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   224.55999755859375, 488.5400085449219, 355.4989013671875,
//                   494.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 52,
//               type: "text",
//               content: "EFFECTIVE DATE",
//               coordinates: {
//                 x: 252.97500610351562,
//                 y: 92.54002380371094,
//                 width: 48.3919677734375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   252.97500610351562, 92.54002380371094, 301.3669738769531,
//                   98.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 53,
//               type: "text",
//               content: "NAMED INSURED(S)",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 92.54002380371094,
//                 width: 56.183197021484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   309.8999938964844, 92.54002380371094, 366.08319091796875,
//                   98.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 54,
//               type: "text",
//               content: "POLICY NUMBER",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 92.54002380371094,
//                 width: 48.09299659729004,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 92.54002380371094, 69.99299621582031,
//                   98.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 55,
//               type: "text",
//               content: "NAIC CODE",
//               coordinates: {
//                 x: 547.5,
//                 y: 68.54002380371094,
//                 width: 32.24029541015625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   547.5, 68.54002380371094, 579.7402954101562, 74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 56,
//               type: "text",
//               content: "CARRIER",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 67.17997741699219,
//                 width: 35.28570556640625,
//                 height: 8.656745910644531,
//                 bbox: [
//                   309.8999938964844, 67.17997741699219, 345.1856994628906,
//                   75.83672332763672
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 57,
//               type: "text",
//               content: "AGENCY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 68.54002380371094,
//                 width: 24.58125114440918,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 68.54002380371094, 46.48125076293945,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 58,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 317.0350036621094,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   317.0350036621094, 26.379987716674805, 408.8182373046875,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 59,
//               type: "text",
//               content: "The ACORD name and logo are registered marks of ACORD",
//               coordinates: {
//                 x: 196.4737548828125,
//                 y: 757.780029296875,
//                 width: 218.86770629882812,
//                 height: 8.65673828125,
//                 bbox: [
//                   196.4737548828125, 757.780029296875, 415.3414611816406,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 60,
//               type: "text",
//               content: "NAME OF OTHER OWNER",
//               coordinates: {
//                 x: 324.29998779296875,
//                 y: 542.5400390625,
//                 width: 71.805908203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   324.29998779296875, 542.5400390625, 396.10589599609375,
//                   548.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 61,
//               type: "text",
//               content: "VEH #",
//               coordinates: {
//                 x: 301.291259765625,
//                 y: 542.5400390625,
//                 width: 16.6002197265625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   301.291259765625, 542.5400390625, 317.8914794921875,
//                   548.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 62,
//               type: "text",
//               content: "NAME OF OTHER OWNER",
//               coordinates: {
//                 x: 61.5,
//                 y: 542.5400390625,
//                 width: 71.80598449707031,
//                 height: 6.4227294921875,
//                 bbox: [
//                   61.5, 542.5400390625, 133.3059844970703, 548.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 63,
//               type: "text",
//               content: "VEH #",
//               coordinates: {
//                 x: 38.491249084472656,
//                 y: 542.5400390625,
//                 width: 16.60024642944336,
//                 height: 6.4227294921875,
//                 bbox: [
//                   38.491249084472656, 542.5400390625, 55.091495513916016,
//                   548.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 64,
//               type: "text",
//               content:
//                 "WITH THE EXCEPTION OF ANY ENCUMBRANCES, ARE ANY VEHICLES FOR WHICH INSURANCE IS REQUESTED NOT SOLELY OWNED BY AND",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 522.9599609375,
//                 width: 458.8383674621582,
//                 height: 7.539794921875,
//                 bbox: [
//                   36.29999923706055, 522.9599609375, 495.13836669921875,
//                   530.499755859375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 65,
//               type: "text",
//               content: "REGISTERED TO THE APPLICANT?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 531.3599853515625,
//                 width: 112.77899551391602,
//                 height: 7.539794921875,
//                 bbox: [
//                   36.29999923706055, 531.3599853515625, 149.07899475097656,
//                   538.8997802734375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 66,
//               type: "text",
//               content: "1.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 522.9599609375,
//                 width: 5.622751235961914,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 522.9599609375, 27.522750854492188,
//                   530.499755859375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 67,
//               type: "text",
//               content: "Y / N",
//               coordinates: {
//                 x: 577.1612548828125,
//                 y: 512.5400390625,
//                 width: 12.65582275390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   577.1612548828125, 512.5400390625, 589.8170776367188,
//                   518.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 68,
//               type: "text",
//               content: 'EXPLAIN ALL "YES" RESPONSES',
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 514.9400024414062,
//                 width: 93.20748329162598,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 514.9400024414062, 115.10748291015625,
//                   521.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 69,
//               type: "text",
//               content: "GENERAL INFORMATION",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 500.97998046875,
//                 width: 93.92225074768066,
//                 height: 8.656768798828125,
//                 bbox: [
//                   21.899999618530273, 500.97998046875, 115.82225036621094,
//                   509.6367492675781
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 70,
//               type: "text",
//               content: "2.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 569.1599731445312,
//                 width: 5.622751235961914,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 569.1599731445312, 27.522750854492188,
//                   576.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 71,
//               type: "text",
//               content:
//                 "DO OVER 50% OF THE EMPLOYEES USE THEIR AUTOS IN THE BUSINESS?  (no explanation needed)",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 569.1599731445312,
//                 width: 318.7956428527832,
//                 height: 7.539794921875,
//                 bbox: [
//                   36.29999923706055, 569.1599731445312, 355.09564208984375,
//                   576.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 72,
//               type: "text",
//               content: "3.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 584.1599731445312,
//                 width: 5.622751235961914,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 584.1599731445312, 27.522750854492188,
//                   591.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 73,
//               type: "text",
//               content: "IS THERE A VEHICLE MAINTENANCE PROGRAM IN OPERATION?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 584.1599731445312,
//                 width: 208.44006729125977,
//                 height: 7.539794921875,
//                 bbox: [
//                   36.29999923706055, 584.1599731445312, 244.7400665283203,
//                   591.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 74,
//               type: "text",
//               content: "4.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 620.1599731445312,
//                 width: 5.622751235961914,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 620.1599731445312, 27.522750854492188,
//                   627.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 75,
//               type: "text",
//               content: "ARE ANY VEHICLES LEASED TO OTHERS?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 620.1599731445312,
//                 width: 137.5177345275879,
//                 height: 7.539794921875,
//                 bbox: [
//                   36.29999923706055, 620.1599731445312, 173.81773376464844,
//                   627.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 76,
//               type: "text",
//               content: "VEH #",
//               coordinates: {
//                 x: 301.291259765625,
//                 y: 668.5400390625,
//                 width: 16.6002197265625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   301.291259765625, 668.5400390625, 317.8914794921875,
//                   674.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 77,
//               type: "text",
//               content: "VEH #",
//               coordinates: {
//                 x: 38.491249084472656,
//                 y: 668.5400390625,
//                 width: 16.60024642944336,
//                 height: 6.4227294921875,
//                 bbox: [
//                   38.491249084472656, 668.5400390625, 55.091495513916016,
//                   674.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 78,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 515.0999755859375,
//                 y: 680.5400390625,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   515.0999755859375, 680.5400390625, 518.2969970703125,
//                   686.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 79,
//               type: "text",
//               content: "COST",
//               coordinates: {
//                 x: 515.0999755859375,
//                 y: 668.5400390625,
//                 width: 15.956298828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   515.0999755859375, 668.5400390625, 531.0562744140625,
//                   674.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 80,
//               type: "text",
//               content: "DESCRIPTION",
//               coordinates: {
//                 x: 324.29998779296875,
//                 y: 668.5400390625,
//                 width: 39.25518798828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   324.29998779296875, 668.5400390625, 363.55517578125,
//                   674.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 81,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 252.3000030517578,
//                 y: 680.5400390625,
//                 width: 3.1970062255859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   252.3000030517578, 680.5400390625, 255.49700927734375,
//                   686.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 82,
//               type: "text",
//               content: "COST",
//               coordinates: {
//                 x: 252.3000030517578,
//                 y: 668.5400390625,
//                 width: 15.956253051757812,
//                 height: 6.4227294921875,
//                 bbox: [
//                   252.3000030517578, 668.5400390625, 268.2562561035156,
//                   674.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 83,
//               type: "text",
//               content: "DESCRIPTION",
//               coordinates: {
//                 x: 61.5,
//                 y: 668.5400390625,
//                 width: 39.25523376464844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   61.5, 668.5400390625, 100.75523376464844, 674.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 84,
//               type: "text",
//               content: "5.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 656.1599731445312,
//                 width: 5.622751235961914,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 656.1599731445312, 27.522750854492188,
//                   663.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 85,
//               type: "text",
//               content:
//                 "ANY CAR MODIFIED / SPECIAL EQUIPMENT? (Include customized vans / pickups)",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 656.1599731445312,
//                 width: 252.97658157348633,
//                 height: 7.539794921875,
//                 bbox: [
//                   36.29999923706055, 656.1599731445312, 289.2765808105469,
//                   663.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 86,
//               type: "text",
//               content: "6.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 695.1599731445312,
//                 width: 5.622751235961914,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 695.1599731445312, 27.522750854492188,
//                   702.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 87,
//               type: "text",
//               content:
//                 "ARE ICC (Interstate Commerce Commission), PUC (Public Utility Commission) OR OTHER FILINGS REQUIRED?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 695.1599731445312,
//                 width: 342.5424385070801,
//                 height: 7.539794921875,
//                 bbox: [
//                   36.29999923706055, 695.1599731445312, 378.8424377441406,
//                   702.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 88,
//               type: "text",
//               content: "© 1993-2015 ACORD CORPORATION.  All rights reserved.",
//               coordinates: {
//                 x: 377.61749267578125,
//                 y: 745.780029296875,
//                 width: 211.10992431640625,
//                 height: 8.65673828125,
//                 bbox: [
//                   377.61749267578125, 745.780029296875, 588.7274169921875,
//                   754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 89,
//               type: "text",
//               content: "Attach to ACORD 125",
//               coordinates: {
//                 x: 266.8275146484375,
//                 y: 745.780029296875,
//                 width: 78.89495849609375,
//                 height: 8.65673828125,
//                 bbox: [
//                   266.8275146484375, 745.780029296875, 345.72247314453125,
//                   754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 90,
//               type: "text",
//               content: "ACORD 127 (2015/12)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 745.780029296875,
//                 width: 78.78650093078613,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 745.780029296875, 100.6865005493164,
//                   754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 91,
//               type: "text",
//               content: "COVERAGES / LIMITS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 116.98002624511719,
//                 width: 81.28200721740723,
//                 height: 8.656745910644531,
//                 bbox: [
//                   21.899999618530273, 116.98002624511719, 103.1820068359375,
//                   125.63677215576172
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 92,
//               type: "text",
//               content:
//                 "USE ACORD 137 FOR YOUR STATE TO PROVIDE COVERAGES / LIMITS INFORMATION",
//               coordinates: {
//                 x: 125.5374984741211,
//                 y: 127.09999084472656,
//                 width: 361.15625762939453,
//                 height: 9.77374267578125,
//                 bbox: [
//                   125.5374984741211, 127.09999084472656, 486.6937561035156,
//                   136.8737335205078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 8.75,
//                 color: 0
//               }
//             },
//             {
//               id: 93,
//               type: "text",
//               content: "ACORD 163 attached for additional drivers",
//               coordinates: {
//                 x: 162.3000030517578,
//                 y: 140.9800262451172,
//                 width: 156.6197967529297,
//                 height: 8.656753540039062,
//                 bbox: [
//                   162.3000030517578, 140.9800262451172, 318.9197998046875,
//                   149.63677978515625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 94,
//               type: "text",
//               content: "DRIVER INFORMATION",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 140.9800262451172,
//                 width: 85.4592456817627,
//                 height: 8.656753540039062,
//                 bbox: [
//                   21.899999618530273, 140.9800262451172, 107.35924530029297,
//                   149.63677978515625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 95,
//               type: "text",
//               content: "CITY, STATE AND ZIP CODE",
//               coordinates: {
//                 x: 86.12999725341797,
//                 y: 167.54002380371094,
//                 width: 76.05522918701172,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   86.12999725341797, 167.54002380371094, 162.1852264404297,
//                   173.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 96,
//               type: "text",
//               content: "DOC",
//               coordinates: {
//                 x: 524.6112670898438,
//                 y: 166.9399871826172,
//                 width: 12.770751953125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   524.6112670898438, 166.9399871826172, 537.3820190429688,
//                   173.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 97,
//               type: "text",
//               content: "USE",
//               coordinates: {
//                 x: 575.7887573242188,
//                 y: 167.54002380371094,
//                 width: 11.810546875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   575.7887573242188, 167.54002380371094, 587.5993041992188,
//                   173.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 98,
//               type: "text",
//               content: "%",
//               coordinates: {
//                 x: 579.1437377929688,
//                 y: 162.13999938964844,
//                 width: 5.11175537109375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   579.1437377929688, 162.13999938964844, 584.2554931640625,
//                   168.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 99,
//               type: "text",
//               content: "VEH #",
//               coordinates: {
//                 x: 547.8912353515625,
//                 y: 167.54002380371094,
//                 width: 16.600341796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   547.8912353515625, 167.54002380371094, 564.4915771484375,
//                   173.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 100,
//               type: "text",
//               content: "USE",
//               coordinates: {
//                 x: 548.7887573242188,
//                 y: 162.13999938964844,
//                 width: 11.810546875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   548.7887573242188, 162.13999938964844, 560.5993041992188,
//                   168.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 101,
//               type: "text",
//               content: "HIRE",
//               coordinates: {
//                 x: 471.9312438964844,
//                 y: 168.13999938964844,
//                 width: 13.7252197265625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   471.9312438964844, 168.13999938964844, 485.6564636230469,
//                   174.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 102,
//               type: "text",
//               content: "DATE",
//               coordinates: {
//                 x: 471.1875,
//                 y: 162.13999938964844,
//                 width: 15.2144775390625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   471.1875, 162.13999938964844, 486.4019775390625,
//                   168.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 103,
//               type: "text",
//               content: "LIC",
//               coordinates: {
//                 x: 441.76873779296875,
//                 y: 167.54002380371094,
//                 width: 9.251739501953125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   441.76873779296875, 167.54002380371094, 451.0204772949219,
//                   173.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 104,
//               type: "text",
//               content: "STATE",
//               coordinates: {
//                 x: 437.7037353515625,
//                 y: 162.13999938964844,
//                 width: 17.9744873046875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   437.7037353515625, 162.13999938964844, 455.67822265625,
//                   168.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 105,
//               type: "text",
//               content: "SOCIAL SECURITY NUMBER",
//               coordinates: {
//                 x: 349.291259765625,
//                 y: 167.54002380371094,
//                 width: 78.94741821289062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   349.291259765625, 167.54002380371094, 428.2386779785156,
//                   173.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 106,
//               type: "text",
//               content: "DRIVERS LICENSE NUMBER/",
//               coordinates: {
//                 x: 348.5462646484375,
//                 y: 162.13999938964844,
//                 width: 80.43087768554688,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   348.5462646484375, 162.13999938964844, 428.9771423339844,
//                   168.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 107,
//               type: "text",
//               content: "LIC",
//               coordinates: {
//                 x: 326.5687561035156,
//                 y: 167.54002380371094,
//                 width: 9.251739501953125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   326.5687561035156, 167.54002380371094, 335.82049560546875,
//                   173.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 108,
//               type: "text",
//               content: "YEAR",
//               coordinates: {
//                 x: 323.2124938964844,
//                 y: 162.13999938964844,
//                 width: 15.96197509765625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   323.2124938964844, 162.13999938964844, 339.1744689941406,
//                   168.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 109,
//               type: "text",
//               content: "EXP",
//               coordinates: {
//                 x: 304.1474914550781,
//                 y: 168.13999938964844,
//                 width: 11.488494873046875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   304.1474914550781, 168.13999938964844, 315.635986328125,
//                   174.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 110,
//               type: "text",
//               content: "YRS",
//               coordinates: {
//                 x: 303.9887390136719,
//                 y: 162.13999938964844,
//                 width: 11.81048583984375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   303.9887390136719, 162.13999938964844, 315.7992248535156,
//                   168.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 111,
//               type: "text",
//               content: "DATE OF BIRTH",
//               coordinates: {
//                 x: 246.5137481689453,
//                 y: 166.9399871826172,
//                 width: 43.92994689941406,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   246.5137481689453, 166.9399871826172, 290.4436950683594,
//                   173.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 112,
//               type: "text",
//               content: "STAT",
//               coordinates: {
//                 x: 221.52125549316406,
//                 y: 168.13999938964844,
//                 width: 14.145004272460938,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   221.52125549316406, 168.13999938964844, 235.666259765625,
//                   174.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 113,
//               type: "text",
//               content: "* MAR",
//               coordinates: {
//                 x: 220.13499450683594,
//                 y: 162.13999938964844,
//                 width: 16.922256469726562,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   220.13499450683594, 162.13999938964844, 237.0572509765625,
//                   168.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 114,
//               type: "text",
//               content: "SEX",
//               coordinates: {
//                 x: 206.94749450683594,
//                 y: 166.9399871826172,
//                 width: 11.488494873046875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   206.94749450683594, 166.9399871826172, 218.4359893798828,
//                   173.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 115,
//               type: "text",
//               content: "NAME",
//               coordinates: {
//                 x: 115.73500061035156,
//                 y: 162.13999938964844,
//                 width: 16.9222412109375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   115.73500061035156, 162.13999938964844, 132.65724182128906,
//                   168.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 116,
//               type: "text",
//               content: "#",
//               coordinates: {
//                 x: 29.001249313354492,
//                 y: 167.54002380371094,
//                 width: 3.197000503540039,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   29.001249313354492, 167.54002380371094, 32.19824981689453,
//                   173.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 117,
//               type: "text",
//               content: "DRIVER",
//               coordinates: {
//                 x: 19.737499237060547,
//                 y: 162.13999938964844,
//                 width: 21.706249237060547,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   19.737499237060547, 162.13999938964844, 41.443748474121094,
//                   168.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 118,
//               type: "text",
//               content:
//                 "LIST ALL DRIVERS, INCLUDING FAMILY MEMBERS THAT DRIVE COMPANY VEHICLES, AND EMPLOYEES WHO DRIVE OWN VEHICLES ON COMPANY BUSINESS.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 154.3400115966797,
//                 width: 443.1751651763916,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 154.3400115966797, 465.0751647949219,
//                   160.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 119,
//               type: "text",
//               content: "BROADEN",
//               coordinates: {
//                 x: 502.2300109863281,
//                 y: 164.40000915527344,
//                 width: 18.528778076171875,
//                 height: 4.188751220703125,
//                 bbox: [
//                   502.2300109863281, 164.40000915527344, 520.7587890625,
//                   168.58876037597656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 3.75,
//                 color: 0
//               }
//             },
//             {
//               id: 120,
//               type: "text",
//               content: "NO-FAULT",
//               coordinates: {
//                 x: 502.3687438964844,
//                 y: 169.1999969482422,
//                 width: 18.251251220703125,
//                 height: 4.188751220703125,
//                 bbox: [
//                   502.3687438964844, 169.1999969482422, 520.6199951171875,
//                   173.3887481689453
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 3.75,
//                 color: 0
//               }
//             },
//             {
//               id: 121,
//               type: "text",
//               content: "BUSINESS AUTO SECTION",
//               coordinates: {
//                 x: 210.47999572753906,
//                 y: 45.701271057128906,
//                 width: 177.05873107910156,
//                 height: 15.358749389648438,
//                 bbox: [
//                   210.47999572753906, 45.701271057128906, 387.5387268066406,
//                   61.060020446777344
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 13.75,
//                 color: 0
//               }
//             },
//             {
//               id: 122,
//               type: "text",
//               content: "DATE (MM/DD/YYYY)",
//               coordinates: {
//                 x: 522.563720703125,
//                 y: 44.54002380371094,
//                 width: 57.02288818359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   522.563720703125, 44.54002380371094, 579.5866088867188,
//                   50.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 123,
//               type: "text",
//               content: '(If "YES", attach ACORD 194) (no explanation needed)',
//               coordinates: {
//                 x: 427.38751220703125,
//                 y: 696.4400024414062,
//                 width: 139.7999267578125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   427.38751220703125, 696.4400024414062, 567.1874389648438,
//                   702.8627319335938
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 41.26749469857623,
//                 width: 577.68,
//                 height: 73.41775219630415,
//                 bbox: [
//                   17.28, 41.26749469857623, 594.9599999999999,
//                   114.68524689488038
//                 ]
//               },
//               properties: {
//                 rows: 3,
//                 columns: 5,
//                 accuracy: 90.372
//               }
//             },
//             {
//               id: 1,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 125.24204786428356,
//                 width: 577.68,
//                 height: 373.326870645259,
//                 bbox: [
//                   17.28, 125.24204786428356, 594.9599999999999,
//                   498.5689185095426
//                 ]
//               },
//               properties: {
//                 rows: 18,
//                 columns: 16,
//                 accuracy: 86.401
//               }
//             },
//             {
//               id: 2,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 509.36564677370495,
//                 width: 577.4399999999999,
//                 height: 235.36867615873973,
//                 bbox: [
//                   17.52, 509.36564677370495, 594.9599999999999,
//                   744.7343229324447
//                 ]
//               },
//               properties: {
//                 rows: 10,
//                 columns: 10,
//                 accuracy: 76.605
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 124,
//           table_count: 3,
//           total_elements: 127
//         }
//       },
//       {
//         page_number: 9,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 415.20001220703125,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   415.20001220703125, 25.188751220703125, 447.44805908203125,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 61.188751220703125,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 61.188751220703125, 586.1170043945312,
//                   69.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 97.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 97.18875122070312, 586.1170043945312,
//                   105.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 133.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 133.18875122070312, 586.1170043945312,
//                   141.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 169.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 169.18875122070312, 586.1170043945312,
//                   177.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 205.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 205.18875122070312, 586.1170043945312,
//                   213.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 241.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 241.18875122070312, 586.1170043945312,
//                   249.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 277.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 277.1887512207031, 586.1170043945312,
//                   285.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 337.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 337.1887512207031, 586.1170043945312,
//                   345.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "DESCRIPTION OF GARAGE / STORAGE LOCATIONS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 433.94000244140625,
//                 width: 143.70972633361816,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 433.94000244140625, 165.60972595214844,
//                   440.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 445.17999267578125,
//                 width: 4.308990478515625,
//                 height: 8.656768798828125,
//                 bbox: [
//                   453.8999938964844, 445.17999267578125, 458.208984375,
//                   453.8367614746094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "MAXIMUM DOLLAR VALUE SUBJECT TO LOSS",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 433.94000244140625,
//                 width: 129.36373901367188,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 433.94000244140625, 583.2637329101562,
//                   440.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "Describe:",
//               coordinates: {
//                 x: 252.3000030517578,
//                 y: 422.84002685546875,
//                 width: 24.276473999023438,
//                 height: 6.4227294921875,
//                 bbox: [
//                   252.3000030517578, 422.84002685546875, 276.57647705078125,
//                   429.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "LOCATION TRACKING",
//               coordinates: {
//                 x: 486.29998779296875,
//                 y: 410.84002685546875,
//                 width: 60.11053466796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   486.29998779296875, 410.84002685546875, 546.4105224609375,
//                   417.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "MILEAGE TRACKING",
//               coordinates: {
//                 x: 399.8999938964844,
//                 y: 410.84002685546875,
//                 width: 56.706451416015625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   399.8999938964844, 410.84002685546875, 456.6064453125,
//                   417.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "MONITOR VEHICLE MAINTENANCE",
//               coordinates: {
//                 x: 270.29998779296875,
//                 y: 410.84002685546875,
//                 width: 96.60565185546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   270.29998779296875, 410.84002685546875, 366.9056396484375,
//                   417.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "TRACK FUEL CONSUMPTION",
//               coordinates: {
//                 x: 155.10000610351562,
//                 y: 410.84002685546875,
//                 width: 80.21826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   155.10000610351562, 410.84002685546875, 235.31826782226562,
//                   417.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "NAVIGATION",
//               coordinates: {
//                 x: 54.29999923706055,
//                 y: 422.84002685546875,
//                 width: 34.56899642944336,
//                 height: 6.4227294921875,
//                 bbox: [
//                   54.29999923706055, 422.84002685546875, 88.8689956665039,
//                   429.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "MONITOR DRIVER SAFETY",
//               coordinates: {
//                 x: 54.29999923706055,
//                 y: 410.84002685546875,
//                 width: 74.24972915649414,
//                 height: 6.4227294921875,
//                 bbox: [
//                   54.29999923706055, 410.84002685546875, 128.5497283935547,
//                   417.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content:
//                 "Please indicate how you utilize the devices (check all that apply):",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 398.84002685546875,
//                 width: 164.80606079101562,
//                 height: 6.4227294921875,
//                 bbox: [
//                   309.8999938964844, 398.84002685546875, 474.7060546875,
//                   405.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "%",
//               coordinates: {
//                 x: 295.5,
//                 y: 401.2400207519531,
//                 width: 5.11175537109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   295.5, 401.2400207519531, 300.61175537109375,
//                   407.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content:
//                 'If "YES", what percentage of vehicles in your overall fleet are monitored (1 - 100%)',
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 398.84002685546875,
//                 width: 210.05328750610352,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 398.84002685546875, 246.35328674316406,
//                   405.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content:
//                 "17. DO YOU HAVE ELECTRONIC MONITORING DEVICES THAT RECORD AND TRANSMIT DATA IN ANY OF YOUR VEHICLES?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 386.15997314453125,
//                 width: 398.448205947876,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 386.15997314453125, 420.34820556640625,
//                   393.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "Page 2 of 4",
//               coordinates: {
//                 x: 285.84124755859375,
//                 y: 757.780029296875,
//                 width: 40.873504638671875,
//                 height: 8.65673828125,
//                 bbox: [
//                   285.84124755859375, 757.780029296875, 326.7147521972656,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content:
//                 "16. ARE ALL VEHICLES TO BE INCLUDED IN THIS POLICY PART OF A FLEET?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 371.15997314453125,
//                 width: 249.7050724029541,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 371.15997314453125, 271.6050720214844,
//                   378.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content:
//                 "13. ANY VEHICLES OWNED BUT NOT SCHEDULED ON THIS APPLICATION?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 236.1599884033203,
//                 width: 244.21053504943848,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 236.1599884033203, 266.11053466796875,
//                   243.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content:
//                 "12. ARE ANY DRIVERS NOT COVERED BY WORKERS COMPENSATION?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 200.1599884033203,
//                 width: 233.8357639312744,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 200.1599884033203, 255.7357635498047,
//                   207.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content: "11.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 164.1599884033203,
//                 width: 8.876249313354492,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 164.1599884033203, 30.776248931884766,
//                   171.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content:
//                 "DOES THE APPLICANT HAVE A SPECIFIC DRIVER RECRUITING METHOD?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 164.1599884033203,
//                 width: 237.5392951965332,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   36.29999923706055, 164.1599884033203, 273.83929443359375,
//                   171.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content:
//                 "10. DOES THE APPLICANT OBTAIN MVR (Motor Vehicle Record) VERIFICATIONS?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 128.1599884033203,
//                 width: 258.5948734283447,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 128.1599884033203, 280.494873046875,
//                   135.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content: "9.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 92.15998840332031,
//                 width: 5.622751235961914,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 92.15998840332031, 27.522750854492188,
//                   99.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content: "ANY VEHICLES USED BY FAMILY MEMBERS?  IF SO, IDENTIFY.",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 92.15998840332031,
//                 width: 202.0612678527832,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   36.29999923706055, 92.15998840332031, 238.36126708984375,
//                   99.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content: "8.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 56.15998840332031,
//                 width: 5.622751235961914,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 56.15998840332031, 27.522750854492188,
//                   63.699737548828125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content: "ANY HOLD HARMLESS AGREEMENTS?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 56.15998840332031,
//                 width: 125.79301834106445,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   36.29999923706055, 56.15998840332031, 162.093017578125,
//                   63.699737548828125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content: "15. HAS AGENT INSPECTED VEHICLES?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 332.15997314453125,
//                 width: 132.30225563049316,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 332.15997314453125, 154.20225524902344,
//                   339.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content: "# YRS REV",
//               coordinates: {
//                 x: 519.6337280273438,
//                 y: 308.5400085449219,
//                 width: 29.900146484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   519.6337280273438, 308.5400085449219, 549.5338745117188,
//                   314.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content: "PLACE (CITY, STATE)",
//               coordinates: {
//                 x: 345.8999938964844,
//                 y: 308.5400085449219,
//                 width: 58.500457763671875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   345.8999938964844, 308.5400085449219, 404.40045166015625,
//                   314.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content: "TYPE",
//               coordinates: {
//                 x: 126.30000305175781,
//                 y: 308.5400085449219,
//                 width: 14.996002197265625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   126.30000305175781, 308.5400085449219, 141.29600524902344,
//                   314.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content: "DATE (MM/DD/YYYY)",
//               coordinates: {
//                 x: 61.76374816894531,
//                 y: 308.5400085449219,
//                 width: 57.022727966308594,
//                 height: 6.4227294921875,
//                 bbox: [
//                   61.76374816894531, 308.5400085449219, 118.7864761352539,
//                   314.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content: "DRV #",
//               coordinates: {
//                 x: 38.3849983215332,
//                 y: 308.5400085449219,
//                 width: 16.818748474121094,
//                 height: 6.4227294921875,
//                 bbox: [
//                   38.3849983215332, 308.5400085449219, 55.2037467956543,
//                   314.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content:
//                 "1.  A speeding violation of up to six (6) miles per hour (mph) that occurs in an area with a maximum posted speed limit from 30 mph through 54 mph, or",
//               coordinates: {
//                 x: 39.900001525878906,
//                 y: 289.94000244140625,
//                 width: 412.53380584716797,
//                 height: 6.4227294921875,
//                 bbox: [
//                   39.900001525878906, 289.94000244140625, 452.4338073730469,
//                   296.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content:
//                 "2.  A speeding violation of up to ten (10) miles per hour (mph) that occurs in an area with a maximum posted speed limit from 55 mph through 75 mph.",
//               coordinates: {
//                 x: 39.900001525878906,
//                 y: 297.1400146484375,
//                 width: 409.02632904052734,
//                 height: 6.4227294921875,
//                 bbox: [
//                   39.900001525878906, 297.1400146484375, 448.92633056640625,
//                   303.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content:
//                 "APPLICABLE ONLY IN KANSAS:  UNDER KANSAS LAW, THE FOLLOWING TRAFFIC VIOLATIONS ARE NOT REQUIRED TO BE REPORTED TO INSURERS:",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 282.1400146484375,
//                 width: 420.3994941711426,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 282.1400146484375, 456.6994934082031,
//                   288.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content:
//                 "14. ANY DRIVERS WITH CONVICTIONS FOR MOVING TRAFFIC VIOLATIONS?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 272.15997314453125,
//                 width: 248.9085636138916,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 272.15997314453125, 270.8085632324219,
//                   279.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content: "Y / N",
//               coordinates: {
//                 x: 577.1612548828125,
//                 y: 44.54002380371094,
//                 width: 12.65582275390625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   577.1612548828125, 44.54002380371094, 589.8170776367188,
//                   50.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content: 'EXPLAIN ALL "YES" RESPONSES',
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 46.34001159667969,
//                 width: 93.20748329162598,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 46.34001159667969, 115.10748291015625,
//                   52.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content: "GENERAL INFORMATION (continued)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 32.98002624511719,
//                 width: 138.21346473693848,
//                 height: 8.656749725341797,
//                 bbox: [
//                   21.899999618530273, 32.98002624511719, 160.11346435546875,
//                   41.636775970458984
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 317.0350036621094,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   317.0350036621094, 26.379987716674805, 408.8182373046875,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 324.29998779296875,
//                 y: 555.739990234375,
//                 width: 37.547454833984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   324.29998779296875, 555.739990234375, 361.8474426269531,
//                   562.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content: "AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 582.1400146484375,
//                 width: 33.18899154663086,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 582.1400146484375, 69.4889907836914,
//                   588.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content: "INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 570.1400146484375,
//                 width: 25.857749938964844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 570.1400146484375, 62.15774917602539,
//                   576.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 270.29998779296875,
//                 y: 555.739990234375,
//                 width: 31.27996826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   270.29998779296875, 555.739990234375, 301.5799560546875,
//                   562.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 52,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 555.739990234375,
//                 width: 18.520767211914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   212.6999969482422, 555.739990234375, 231.22076416015625,
//                   562.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 53,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 555.739990234375,
//                 width: 60.23126220703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 555.739990234375, 204.53126525878906,
//                   562.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 54,
//               type: "text",
//               content: "REGISTRANT",
//               coordinates: {
//                 x: 97.5,
//                 y: 590.5400390625,
//                 width: 37.34049987792969,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 590.5400390625, 134.8404998779297, 596.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 55,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 97.5,
//                 y: 578.5400390625,
//                 width: 22.022491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 578.5400390625, 119.52249145507812, 584.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 56,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 554.5400390625,
//                 width: 28.399248123168945,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 554.5400390625, 50.29924774169922,
//                   560.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 57,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 556.3400268554688,
//                 width: 77.8665771484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   483.3275146484375, 556.3400268554688, 561.194091796875,
//                   562.7627563476562
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 58,
//               type: "text",
//               content: "ADDITIONAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 564.1400146484375,
//                 width: 35.42574691772461,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 564.1400146484375, 71.72574615478516,
//                   570.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 59,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 566.5400390625,
//                 width: 35.74774169921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 566.5400390625, 133.24774169921875, 572.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 60,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 602.5400390625,
//                 width: 37.34049606323242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 602.5400390625, 73.64049530029297,
//                   608.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 61,
//               type: "text",
//               content: "EMPLOYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 576.1400146484375,
//                 width: 31.912494659423828,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 576.1400146484375, 68.21249389648438,
//                   582.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 62,
//               type: "text",
//               content: "VEHICLE:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 568.9400024414062,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 568.9400024414062, 480.70648193359375,
//                   575.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 63,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 568.9400024414062,
//                 width: 31.487060546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 568.9400024414062, 557.3870849609375,
//                   575.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 64,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 628.9400024414062,
//                 width: 63.1925048828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 628.9400024414062, 207.4925079345703,
//                   635.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 65,
//               type: "text",
//               content: "ADDITIONAL INTEREST / CERTIFICATE RECIPIENT",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 458.97998046875,
//                 width: 188.5187168121338,
//                 height: 8.656768798828125,
//                 bbox: [
//                   21.899999618530273, 458.97998046875, 210.41871643066406,
//                   467.6367492675781
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 66,
//               type: "text",
//               content: "ACORD 45 attached for additional names",
//               coordinates: {
//                 x: 263.1000061035156,
//                 y: 458.97998046875,
//                 width: 151.02423095703125,
//                 height: 8.656768798828125,
//                 bbox: [
//                   263.1000061035156, 458.97998046875, 414.1242370605469,
//                   467.6367492675781
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 67,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 324.29998779296875,
//                 y: 471.7400207519531,
//                 width: 37.547454833984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   324.29998779296875, 471.7400207519531, 361.8474426269531,
//                   478.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 68,
//               type: "text",
//               content: "AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 498.1400146484375,
//                 width: 33.18899154663086,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 498.1400146484375, 69.4889907836914,
//                   504.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 69,
//               type: "text",
//               content: "INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 486.1400146484375,
//                 width: 25.857749938964844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 486.1400146484375, 62.15774917602539,
//                   492.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 70,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 270.29998779296875,
//                 y: 471.7400207519531,
//                 width: 31.27996826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   270.29998779296875, 471.7400207519531, 301.5799560546875,
//                   478.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 71,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 471.7400207519531,
//                 width: 18.520767211914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   212.6999969482422, 471.7400207519531, 231.22076416015625,
//                   478.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 72,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 471.7400207519531,
//                 width: 60.23126220703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 471.7400207519531, 204.53126525878906,
//                   478.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 73,
//               type: "text",
//               content: "REGISTRANT",
//               coordinates: {
//                 x: 97.5,
//                 y: 506.5400085449219,
//                 width: 37.34049987792969,
//                 height: 6.422760009765625,
//                 bbox: [
//                   97.5, 506.5400085449219, 134.8404998779297, 512.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 74,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 97.5,
//                 y: 494.5400085449219,
//                 width: 22.022491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 494.5400085449219, 119.52249145507812, 500.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 75,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 470.5400085449219,
//                 width: 28.399248123168945,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 470.5400085449219, 50.29924774169922,
//                   476.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 76,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 472.34002685546875,
//                 width: 77.8665771484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   483.3275146484375, 472.34002685546875, 561.194091796875,
//                   478.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 77,
//               type: "text",
//               content: "ADDITIONAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 480.1400146484375,
//                 width: 35.42574691772461,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 480.1400146484375, 71.72574615478516,
//                   486.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 78,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 482.5400085449219,
//                 width: 35.74774169921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 482.5400085449219, 133.24774169921875, 488.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 79,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 518.5400390625,
//                 width: 37.34049606323242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 518.5400390625, 73.64049530029297,
//                   524.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 80,
//               type: "text",
//               content: "EMPLOYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 492.1400146484375,
//                 width: 31.912494659423828,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 492.1400146484375, 68.21249389648438,
//                   498.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 81,
//               type: "text",
//               content: "VEHICLE:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 484.94000244140625,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 484.94000244140625, 480.70648193359375,
//                   491.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 82,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 484.94000244140625,
//                 width: 31.487060546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 484.94000244140625, 557.3870849609375,
//                   491.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 83,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 544.9400024414062,
//                 width: 63.1925048828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 544.9400024414062, 207.4925079345703,
//                   551.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 84,
//               type: "text",
//               content:
//                 "REMARKS (ACORD 101, Additional Remarks Schedule, may be attached if more space is required)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 638.3800048828125,
//                 width: 362.0179386138916,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 638.3800048828125, 383.9179382324219,
//                   647.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 85,
//               type: "text",
//               content: "ACORD 127 (2015/12)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 757.780029296875,
//                 width: 78.78650093078613,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 757.780029296875, 100.6865005493164,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 86,
//               type: "text",
//               content: "LENDER'S LOSS",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 504.82000732421875,
//                 width: 38.03325271606445,
//                 height: 5.30572509765625,
//                 bbox: [
//                   36.29999923706055, 504.82000732421875, 74.333251953125,
//                   510.125732421875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 4.75,
//                 color: 0
//               }
//             },
//             {
//               id: 87,
//               type: "text",
//               content: "PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 510.8200378417969,
//                 width: 21.46050262451172,
//                 height: 5.305755615234375,
//                 bbox: [
//                   36.29999923706055, 510.8200378417969, 57.760501861572266,
//                   516.1257934570312
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 4.75,
//                 color: 0
//               }
//             },
//             {
//               id: 88,
//               type: "text",
//               content: "LENDER'S LOSS",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 588.8200073242188,
//                 width: 38.03325271606445,
//                 height: 5.3057861328125,
//                 bbox: [
//                   36.29999923706055, 588.8200073242188, 74.333251953125,
//                   594.1257934570312
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 4.75,
//                 color: 0
//               }
//             },
//             {
//               id: 89,
//               type: "text",
//               content: "PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 594.8200073242188,
//                 width: 21.46050262451172,
//                 height: 5.3057861328125,
//                 bbox: [
//                   36.29999923706055, 594.8200073242188, 57.760501861572266,
//                   600.1257934570312
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 4.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 41.26749469857623,
//                 width: 577.68,
//                 height: 595.4995455922448,
//                 bbox: [
//                   17.28, 41.26749469857623, 594.9599999999999, 636.767040290821
//                 ]
//               },
//               properties: {
//                 rows: 30,
//                 columns: 29,
//                 accuracy: 52.221
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 90,
//           table_count: 1,
//           total_elements: 91
//         }
//       },
//       {
//         page_number: 10,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 415.20001220703125,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   415.20001220703125, 25.188751220703125, 447.44805908203125,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "1",
//               coordinates: {
//                 x: 32.48374938964844,
//                 y: 61.188751220703125,
//                 width: 4.031002044677734,
//                 height: 8.098251342773438,
//                 bbox: [
//                   32.48374938964844, 61.188751220703125, 36.51475143432617,
//                   69.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "2019",
//               coordinates: {
//                 x: 57.03499984741211,
//                 y: 61.188751220703125,
//                 width: 16.12399673461914,
//                 height: 8.098251342773438,
//                 bbox: [
//                   57.03499984741211, 61.188751220703125, 73.15899658203125,
//                   69.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "Ram",
//               coordinates: {
//                 x: 109.19999694824219,
//                 y: 49.188751220703125,
//                 width: 15.30474853515625,
//                 height: 8.098247528076172,
//                 bbox: [
//                   109.19999694824219, 49.188751220703125, 124.50474548339844,
//                   57.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "Promaster",
//               coordinates: {
//                 x: 109.19999694824219,
//                 y: 61.188751220703125,
//                 width: 33.422515869140625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   109.19999694824219, 61.188751220703125, 142.6225128173828,
//                   69.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "3C6TRVBG2KE547511",
//               coordinates: {
//                 x: 264,
//                 y: 61.188751220703125,
//                 width: 75.45074462890625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   264, 61.188751220703125, 339.45074462890625, 69.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "8484 Huffman  Rd",
//               coordinates: {
//                 x: 62.400001525878906,
//                 y: 85.18875122070312,
//                 width: 58.666969299316406,
//                 height: 8.098251342773438,
//                 bbox: [
//                   62.400001525878906, 85.18875122070312, 121.06697082519531,
//                   93.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "Cygnet",
//               coordinates: {
//                 x: 213.60000610351562,
//                 y: 85.18875122070312,
//                 width: 22.960769653320312,
//                 height: 8.098251342773438,
//                 bbox: [
//                   213.60000610351562, 85.18875122070312, 236.56077575683594,
//                   93.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 520.4625244140625,
//                 y: 85.18875122070312,
//                 width: 10.86773681640625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   520.4625244140625, 85.18875122070312, 531.3302612304688,
//                   93.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "43413",
//               coordinates: {
//                 x: 544.7999877929688,
//                 y: 85.18875122070312,
//                 width: 20.155029296875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   544.7999877929688, 85.18875122070312, 564.9550170898438,
//                   93.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 25.462499618530273,
//                 y: 109.18875122070312,
//                 width: 10.86775016784668,
//                 height: 8.098251342773438,
//                 bbox: [
//                   25.462499618530273, 109.18875122070312, 36.33024978637695,
//                   117.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "152",
//               coordinates: {
//                 x: 66.25125122070312,
//                 y: 109.18875122070312,
//                 width: 12.092994689941406,
//                 height: 8.098251342773438,
//                 bbox: [
//                   66.25125122070312, 109.18875122070312, 78.34424591064453,
//                   117.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "01199",
//               coordinates: {
//                 x: 195.6875,
//                 y: 109.18875122070312,
//                 width: 19.6185302734375,
//                 height: 8.098251342773438,
//                 bbox: [
//                   195.6875, 109.18875122070312, 215.3060302734375,
//                   117.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "local",
//               coordinates: {
//                 x: 363.6449890136719,
//                 y: 109.18875122070312,
//                 width: 14.906005859375,
//                 height: 8.098251342773438,
//                 bbox: [
//                   363.6449890136719, 109.18875122070312, 378.5509948730469,
//                   117.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "33595",
//               coordinates: {
//                 x: 526.7999877929688,
//                 y: 109.18875122070312,
//                 width: 20.155029296875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   526.7999877929688, 109.18875122070312, 546.9550170898438,
//                   117.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "1,000",
//               coordinates: {
//                 x: 534,
//                 y: 133.18875122070312,
//                 width: 18.13226318359375,
//                 height: 8.098251342773438,
//                 bbox: [
//                   534, 133.18875122070312, 552.1322631835938, 141.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "1,000",
//               coordinates: {
//                 x: 534,
//                 y: 145.18875122070312,
//                 width: 18.13226318359375,
//                 height: 8.098251342773438,
//                 bbox: [
//                   534, 145.18875122070312, 552.1322631835938, 153.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "2",
//               coordinates: {
//                 x: 32.48374938964844,
//                 y: 181.18875122070312,
//                 width: 4.031002044677734,
//                 height: 8.098251342773438,
//                 bbox: [
//                   32.48374938964844, 181.18875122070312, 36.51475143432617,
//                   189.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "2015",
//               coordinates: {
//                 x: 57.03499984741211,
//                 y: 181.18875122070312,
//                 width: 16.12399673461914,
//                 height: 8.098251342773438,
//                 bbox: [
//                   57.03499984741211, 181.18875122070312, 73.15899658203125,
//                   189.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "Ram",
//               coordinates: {
//                 x: 109.19999694824219,
//                 y: 169.18875122070312,
//                 width: 15.30474853515625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   109.19999694824219, 169.18875122070312, 124.50474548339844,
//                   177.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "Tradesman",
//               coordinates: {
//                 x: 109.19999694824219,
//                 y: 181.18875122070312,
//                 width: 36.38775634765625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   109.19999694824219, 181.18875122070312, 145.58775329589844,
//                   189.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content: "2C4JRGAG1FR682271",
//               coordinates: {
//                 x: 264,
//                 y: 181.18875122070312,
//                 width: 76.125,
//                 height: 8.098251342773438,
//                 bbox: [264, 181.18875122070312, 340.125, 189.28700256347656]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "8484 Huffman  Rd",
//               coordinates: {
//                 x: 62.400001525878906,
//                 y: 205.18875122070312,
//                 width: 58.666969299316406,
//                 height: 8.098251342773438,
//                 bbox: [
//                   62.400001525878906, 205.18875122070312, 121.06697082519531,
//                   213.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "Cygnet",
//               coordinates: {
//                 x: 213.60000610351562,
//                 y: 205.18875122070312,
//                 width: 22.960769653320312,
//                 height: 8.098251342773438,
//                 bbox: [
//                   213.60000610351562, 205.18875122070312, 236.56077575683594,
//                   213.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 520.4625244140625,
//                 y: 205.18875122070312,
//                 width: 10.86773681640625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   520.4625244140625, 205.18875122070312, 531.3302612304688,
//                   213.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content: "43413",
//               coordinates: {
//                 x: 544.7999877929688,
//                 y: 205.18875122070312,
//                 width: 20.155029296875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   544.7999877929688, 205.18875122070312, 564.9550170898438,
//                   213.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 25.462499618530273,
//                 y: 229.18875122070312,
//                 width: 10.86775016784668,
//                 height: 8.098251342773438,
//                 bbox: [
//                   25.462499618530273, 229.18875122070312, 36.33024978637695,
//                   237.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content: "152",
//               coordinates: {
//                 x: 66.25125122070312,
//                 y: 229.18875122070312,
//                 width: 12.092994689941406,
//                 height: 8.098251342773438,
//                 bbox: [
//                   66.25125122070312, 229.18875122070312, 78.34424591064453,
//                   237.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content: "01199",
//               coordinates: {
//                 x: 195.6875,
//                 y: 229.18875122070312,
//                 width: 19.6185302734375,
//                 height: 8.098251342773438,
//                 bbox: [
//                   195.6875, 229.18875122070312, 215.3060302734375,
//                   237.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content: "local",
//               coordinates: {
//                 x: 363.6449890136719,
//                 y: 229.18875122070312,
//                 width: 14.906005859375,
//                 height: 8.098251342773438,
//                 bbox: [
//                   363.6449890136719, 229.18875122070312, 378.5509948730469,
//                   237.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content: "22000",
//               coordinates: {
//                 x: 526.7999877929688,
//                 y: 229.18875122070312,
//                 width: 20.155029296875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   526.7999877929688, 229.18875122070312, 546.9550170898438,
//                   237.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content: "1,000",
//               coordinates: {
//                 x: 534,
//                 y: 253.18875122070312,
//                 width: 18.13226318359375,
//                 height: 8.098236083984375,
//                 bbox: [
//                   534, 253.18875122070312, 552.1322631835938, 261.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content: "1,000",
//               coordinates: {
//                 x: 534,
//                 y: 265.1887512207031,
//                 width: 18.13226318359375,
//                 height: 8.098236083984375,
//                 bbox: [
//                   534, 265.1887512207031, 552.1322631835938, 273.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content: "3",
//               coordinates: {
//                 x: 32.48374938964844,
//                 y: 301.1887512207031,
//                 width: 4.031002044677734,
//                 height: 8.098236083984375,
//                 bbox: [
//                   32.48374938964844, 301.1887512207031, 36.51475143432617,
//                   309.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content: "2022",
//               coordinates: {
//                 x: 57.03499984741211,
//                 y: 301.1887512207031,
//                 width: 16.12399673461914,
//                 height: 8.098236083984375,
//                 bbox: [
//                   57.03499984741211, 301.1887512207031, 73.15899658203125,
//                   309.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content: "Dodge",
//               coordinates: {
//                 x: 109.19999694824219,
//                 y: 289.1887512207031,
//                 width: 21.358489990234375,
//                 height: 8.098236083984375,
//                 bbox: [
//                   109.19999694824219, 289.1887512207031, 130.55848693847656,
//                   297.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content: "Charger",
//               coordinates: {
//                 x: 109.19999694824219,
//                 y: 301.1887512207031,
//                 width: 26.186996459960938,
//                 height: 8.098236083984375,
//                 bbox: [
//                   109.19999694824219, 301.1887512207031, 135.38699340820312,
//                   309.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content: "2C3CDXGJ6NH262203",
//               coordinates: {
//                 x: 264,
//                 y: 301.1887512207031,
//                 width: 76.53826904296875,
//                 height: 8.098236083984375,
//                 bbox: [
//                   264, 301.1887512207031, 340.53826904296875, 309.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content: "8484 Huffman  Rd",
//               coordinates: {
//                 x: 62.400001525878906,
//                 y: 325.1887512207031,
//                 width: 58.666969299316406,
//                 height: 8.098236083984375,
//                 bbox: [
//                   62.400001525878906, 325.1887512207031, 121.06697082519531,
//                   333.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content: "Cygnet",
//               coordinates: {
//                 x: 213.60000610351562,
//                 y: 325.1887512207031,
//                 width: 22.960769653320312,
//                 height: 8.098236083984375,
//                 bbox: [
//                   213.60000610351562, 325.1887512207031, 236.56077575683594,
//                   333.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 520.4625244140625,
//                 y: 325.1887512207031,
//                 width: 10.86773681640625,
//                 height: 8.098236083984375,
//                 bbox: [
//                   520.4625244140625, 325.1887512207031, 531.3302612304688,
//                   333.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content: "43413",
//               coordinates: {
//                 x: 544.7999877929688,
//                 y: 325.1887512207031,
//                 width: 20.155029296875,
//                 height: 8.098236083984375,
//                 bbox: [
//                   544.7999877929688, 325.1887512207031, 564.9550170898438,
//                   333.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 25.462499618530273,
//                 y: 349.1887512207031,
//                 width: 10.86775016784668,
//                 height: 8.098236083984375,
//                 bbox: [
//                   25.462499618530273, 349.1887512207031, 36.33024978637695,
//                   357.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content: "152",
//               coordinates: {
//                 x: 66.25125122070312,
//                 y: 349.1887512207031,
//                 width: 12.092994689941406,
//                 height: 8.098236083984375,
//                 bbox: [
//                   66.25125122070312, 349.1887512207031, 78.34424591064453,
//                   357.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content: "01199",
//               coordinates: {
//                 x: 195.6875,
//                 y: 349.1887512207031,
//                 width: 19.6185302734375,
//                 height: 8.098236083984375,
//                 bbox: [
//                   195.6875, 349.1887512207031, 215.3060302734375,
//                   357.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content: "local",
//               coordinates: {
//                 x: 363.6449890136719,
//                 y: 349.1887512207031,
//                 width: 14.906005859375,
//                 height: 8.098236083984375,
//                 bbox: [
//                   363.6449890136719, 349.1887512207031, 378.5509948730469,
//                   357.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content: "58210",
//               coordinates: {
//                 x: 526.7999877929688,
//                 y: 349.1887512207031,
//                 width: 20.155029296875,
//                 height: 8.098236083984375,
//                 bbox: [
//                   526.7999877929688, 349.1887512207031, 546.9550170898438,
//                   357.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content: "1,000",
//               coordinates: {
//                 x: 534,
//                 y: 373.1887512207031,
//                 width: 18.13226318359375,
//                 height: 8.098236083984375,
//                 bbox: [
//                   534, 373.1887512207031, 552.1322631835938, 381.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content: "1,000",
//               coordinates: {
//                 x: 534,
//                 y: 385.1887512207031,
//                 width: 18.13226318359375,
//                 height: 8.098236083984375,
//                 bbox: [
//                   534, 385.1887512207031, 552.1322631835938, 393.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content: "4",
//               coordinates: {
//                 x: 32.48374938964844,
//                 y: 421.1887512207031,
//                 width: 4.031002044677734,
//                 height: 8.098236083984375,
//                 bbox: [
//                   32.48374938964844, 421.1887512207031, 36.51475143432617,
//                   429.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content: "2012",
//               coordinates: {
//                 x: 57.03499984741211,
//                 y: 421.1887512207031,
//                 width: 16.12399673461914,
//                 height: 8.098236083984375,
//                 bbox: [
//                   57.03499984741211, 421.1887512207031, 73.15899658203125,
//                   429.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content: "Ford",
//               coordinates: {
//                 x: 109.19999694824219,
//                 y: 409.1887512207031,
//                 width: 14.898750305175781,
//                 height: 8.098236083984375,
//                 bbox: [
//                   109.19999694824219, 409.1887512207031, 124.09874725341797,
//                   417.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 52,
//               type: "text",
//               content: "Edge",
//               coordinates: {
//                 x: 109.19999694824219,
//                 y: 421.1887512207031,
//                 width: 16.921493530273438,
//                 height: 8.098236083984375,
//                 bbox: [
//                   109.19999694824219, 421.1887512207031, 126.12149047851562,
//                   429.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 53,
//               type: "text",
//               content: "2FMDK3GC5CBA42109",
//               coordinates: {
//                 x: 264,
//                 y: 421.1887512207031,
//                 width: 78.531982421875,
//                 height: 8.098236083984375,
//                 bbox: [
//                   264, 421.1887512207031, 342.531982421875, 429.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 54,
//               type: "text",
//               content: "8484 Huffman  Rd",
//               coordinates: {
//                 x: 62.400001525878906,
//                 y: 445.1887512207031,
//                 width: 58.666969299316406,
//                 height: 8.098236083984375,
//                 bbox: [
//                   62.400001525878906, 445.1887512207031, 121.06697082519531,
//                   453.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 55,
//               type: "text",
//               content: "Cygnet",
//               coordinates: {
//                 x: 213.60000610351562,
//                 y: 445.1887512207031,
//                 width: 22.960769653320312,
//                 height: 8.098236083984375,
//                 bbox: [
//                   213.60000610351562, 445.1887512207031, 236.56077575683594,
//                   453.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 56,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 520.4625244140625,
//                 y: 445.1887512207031,
//                 width: 10.86773681640625,
//                 height: 8.098236083984375,
//                 bbox: [
//                   520.4625244140625, 445.1887512207031, 531.3302612304688,
//                   453.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 57,
//               type: "text",
//               content: "43413",
//               coordinates: {
//                 x: 557.21875,
//                 y: 445.1887512207031,
//                 width: 20.155029296875,
//                 height: 8.098236083984375,
//                 bbox: [
//                   557.21875, 445.1887512207031, 577.373779296875,
//                   453.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 58,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 25.462499618530273,
//                 y: 469.1887512207031,
//                 width: 10.86775016784668,
//                 height: 8.098236083984375,
//                 bbox: [
//                   25.462499618530273, 469.1887512207031, 36.33024978637695,
//                   477.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 59,
//               type: "text",
//               content: "152",
//               coordinates: {
//                 x: 66.25125122070312,
//                 y: 469.1887512207031,
//                 width: 12.092994689941406,
//                 height: 8.098236083984375,
//                 bbox: [
//                   66.25125122070312, 469.1887512207031, 78.34424591064453,
//                   477.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 60,
//               type: "text",
//               content: "01199",
//               coordinates: {
//                 x: 195.6875,
//                 y: 469.1887512207031,
//                 width: 19.6185302734375,
//                 height: 8.098236083984375,
//                 bbox: [
//                   195.6875, 469.1887512207031, 215.3060302734375,
//                   477.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 61,
//               type: "text",
//               content: "local",
//               coordinates: {
//                 x: 363.6449890136719,
//                 y: 469.1887512207031,
//                 width: 14.906005859375,
//                 height: 8.098236083984375,
//                 bbox: [
//                   363.6449890136719, 469.1887512207031, 378.5509948730469,
//                   477.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 62,
//               type: "text",
//               content: "300",
//               coordinates: {
//                 x: 526.7999877929688,
//                 y: 469.1887512207031,
//                 width: 12.093017578125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   526.7999877929688, 469.1887512207031, 538.8930053710938,
//                   477.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 63,
//               type: "text",
//               content:
//                 "REMARKS (ACORD 101, Additional Remarks Schedule, may be attached if more space is required)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 530.3800048828125,
//                 width: 362.0179386138916,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 530.3800048828125, 383.9179382324219,
//                   539.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 64,
//               type: "text",
//               content: "ACORD 129 attached for additional vehicles",
//               coordinates: {
//                 x: 147.89999389648438,
//                 y: 38.37998962402344,
//                 width: 161.35501098632812,
//                 height: 8.656749725341797,
//                 bbox: [
//                   147.89999389648438, 38.37998962402344, 309.2550048828125,
//                   47.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 65,
//               type: "text",
//               content: "Page 3 of 4",
//               coordinates: {
//                 x: 285.84124755859375,
//                 y: 757.780029296875,
//                 width: 40.873504638671875,
//                 height: 8.65673828125,
//                 bbox: [
//                   285.84124755859375, 757.780029296875, 326.7147521972656,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 66,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 317.0350036621094,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   317.0350036621094, 26.379987716674805, 408.8182373046875,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 67,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 518.7000122070312,
//                 y: 471.44000244140625,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   518.7000122070312, 471.44000244140625, 521.8970336914062,
//                   477.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 68,
//               type: "text",
//               content: "COST NEW",
//               coordinates: {
//                 x: 537.407470703125,
//                 y: 458.5400085449219,
//                 width: 30.95233154296875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   537.407470703125, 458.5400085449219, 568.3598022460938,
//                   464.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 69,
//               type: "text",
//               content: "SYM",
//               coordinates: {
//                 x: 573.6699829101562,
//                 y: 413.5400085449219,
//                 width: 12.44879150390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   573.6699829101562, 413.5400085449219, 586.1187744140625,
//                   419.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 70,
//               type: "text",
//               content: "COLL",
//               coordinates: {
//                 x: 572.0750122070312,
//                 y: 408.1400146484375,
//                 width: 15.63427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   572.0750122070312, 408.1400146484375, 587.7092895507812,
//                   414.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 71,
//               type: "text",
//               content: "OTC SYM",
//               coordinates: {
//                 x: 537.7025146484375,
//                 y: 413.5400085449219,
//                 width: 26.1683349609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   537.7025146484375, 413.5400085449219, 563.870849609375,
//                   419.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 72,
//               type: "text",
//               content: "COMP /",
//               coordinates: {
//                 x: 540.9287719726562,
//                 y: 408.1400146484375,
//                 width: 20.320556640625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   540.9287719726562, 408.1400146484375, 561.2493286132812,
//                   414.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 73,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 486.29998779296875,
//                 y: 521.239990234375,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   486.29998779296875, 521.239990234375, 489.4969787597656,
//                   527.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 74,
//               type: "text",
//               content: "TOTAL PREM:",
//               coordinates: {
//                 x: 443.1000061035156,
//                 y: 520.9400024414062,
//                 width: 38.617034912109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   443.1000061035156, 520.9400024414062, 481.717041015625,
//                   527.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 75,
//               type: "text",
//               content: "OTC",
//               coordinates: {
//                 x: 367.5,
//                 y: 497.84002685546875,
//                 width: 12.126739501953125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   367.5, 497.84002685546875, 379.6267395019531,
//                   504.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 76,
//               type: "text",
//               content: "FG",
//               coordinates: {
//                 x: 407.1000061035156,
//                 y: 494.84002685546875,
//                 width: 7.975250244140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   407.1000061035156, 494.84002685546875, 415.07525634765625,
//                   501.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 77,
//               type: "text",
//               content: "REIMB",
//               coordinates: {
//                 x: 407.1000061035156,
//                 y: 486.44000244140625,
//                 width: 18.1929931640625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   407.1000061035156, 486.44000244140625, 425.2929992675781,
//                   492.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 78,
//               type: "text",
//               content: "RENT",
//               coordinates: {
//                 x: 407.1000061035156,
//                 y: 480.44000244140625,
//                 width: 15.639984130859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   407.1000061035156, 480.44000244140625, 422.739990234375,
//                   486.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 79,
//               type: "text",
//               content: "COLL",
//               coordinates: {
//                 x: 367.5,
//                 y: 506.84002685546875,
//                 width: 15.013214111328125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   367.5, 506.84002685546875, 382.5132141113281,
//                   513.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 80,
//               type: "text",
//               content: "COMP/",
//               coordinates: {
//                 x: 367.5,
//                 y: 492.44000244140625,
//                 width: 18.83123779296875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   367.5, 492.44000244140625, 386.33123779296875,
//                   498.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 81,
//               type: "text",
//               content: "LSP",
//               coordinates: {
//                 x: 367.5,
//                 y: 482.84002685546875,
//                 width: 10.855987548828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   367.5, 482.84002685546875, 378.3559875488281,
//                   489.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 82,
//               type: "text",
//               content: "FTW",
//               coordinates: {
//                 x: 331.5,
//                 y: 506.84002685546875,
//                 width: 12.437255859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   331.5, 506.84002685546875, 343.937255859375, 513.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 83,
//               type: "text",
//               content: "FT",
//               coordinates: {
//                 x: 331.5,
//                 y: 494.84002685546875,
//                 width: 7.0150146484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   331.5, 494.84002685546875, 338.5150146484375,
//                   501.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 84,
//               type: "text",
//               content: "F",
//               coordinates: {
//                 x: 331.5,
//                 y: 482.84002685546875,
//                 width: 3.50750732421875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   331.5, 482.84002685546875, 335.00750732421875,
//                   489.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 85,
//               type: "text",
//               content: "C OF L",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 510.44000244140625,
//                 width: 18.50921630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 510.44000244140625, 299.6092224121094,
//                   516.8627319335938
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 86,
//               type: "text",
//               content: "SPEC",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 505.0400085449219,
//                 width: 15.639984130859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 505.0400085449219, 296.739990234375,
//                   511.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 87,
//               type: "text",
//               content: "& LABOR",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 498.44000244140625,
//                 width: 24.8974609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 498.44000244140625, 305.9974670410156,
//                   504.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 88,
//               type: "text",
//               content: "TOWING",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 493.0400085449219,
//                 width: 23.5059814453125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 493.0400085449219, 304.6059875488281,
//                   499.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 89,
//               type: "text",
//               content: "MOTOR",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 486.44000244140625,
//                 width: 21.28076171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 486.44000244140625, 302.3807678222656,
//                   492.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 90,
//               type: "text",
//               content: "UNDRINS",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 481.0400085449219,
//                 width: 26.1796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 481.0400085449219, 307.2796936035156,
//                   487.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 91,
//               type: "text",
//               content: "MOTOR",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 510.44000244140625,
//                 width: 21.280746459960938,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 510.44000244140625, 251.98074340820312,
//                   516.8627319335938
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 92,
//               type: "text",
//               content: "UNINS",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 505.0400085449219,
//                 width: 17.876754760742188,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 505.0400085449219, 248.57675170898438,
//                   511.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 93,
//               type: "text",
//               content: "MED PAY",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 496.6400146484375,
//                 width: 25.0009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 496.6400146484375, 255.7009735107422,
//                   503.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 94,
//               type: "text",
//               content: "FAULT",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 486.44000244140625,
//                 width: 17.451263427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 486.44000244140625, 248.15126037597656,
//                   492.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 95,
//               type: "text",
//               content: "ADD'L NO-",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 481.0400085449219,
//                 width: 28.336013793945312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 481.0400085449219, 259.0360107421875,
//                   487.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 96,
//               type: "text",
//               content: "FAULT",
//               coordinates: {
//                 x: 187.5,
//                 y: 510.44000244140625,
//                 width: 17.451263427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   187.5, 510.44000244140625, 204.95126342773438,
//                   516.8627319335938
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 97,
//               type: "text",
//               content: "NO-",
//               coordinates: {
//                 x: 187.5,
//                 y: 505.0400085449219,
//                 width: 10.53399658203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   187.5, 505.0400085449219, 198.03399658203125,
//                   511.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 98,
//               type: "text",
//               content: "LIAB",
//               coordinates: {
//                 x: 187.5,
//                 y: 496.6400146484375,
//                 width: 12.448745727539062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   187.5, 496.6400146484375, 199.94874572753906, 503.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 99,
//               type: "text",
//               content: "COVERAGES",
//               coordinates: {
//                 x: 173.10000610351562,
//                 y: 485.5400085449219,
//                 width: 36.70799255371094,
//                 height: 6.4227294921875,
//                 bbox: [
//                   173.10000610351562, 485.5400085449219, 209.80799865722656,
//                   491.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 100,
//               type: "text",
//               content: "CHECK",
//               coordinates: {
//                 x: 173.10000610351562,
//                 y: 480.1400146484375,
//                 width: 20.435516357421875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   173.10000610351562, 480.1400146484375, 193.5355224609375,
//                   486.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 101,
//               type: "text",
//               content: "FOR HIRE",
//               coordinates: {
//                 x: 137.10000610351562,
//                 y: 482.84002685546875,
//                 width: 27.444747924804688,
//                 height: 6.4227294921875,
//                 bbox: [
//                   137.10000610351562, 482.84002685546875, 164.5447540283203,
//                   489.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 102,
//               type: "text",
//               content: "SERVICE",
//               coordinates: {
//                 x: 90.30000305175781,
//                 y: 506.84002685546875,
//                 width: 25.11023712158203,
//                 height: 6.4227294921875,
//                 bbox: [
//                   90.30000305175781, 506.84002685546875, 115.41024017333984,
//                   513.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 103,
//               type: "text",
//               content: "RETAIL",
//               coordinates: {
//                 x: 90.30000305175781,
//                 y: 494.84002685546875,
//                 width: 19.68224334716797,
//                 height: 6.4227294921875,
//                 bbox: [
//                   90.30000305175781, 494.84002685546875, 109.98224639892578,
//                   501.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 104,
//               type: "text",
//               content: "COMM'L",
//               coordinates: {
//                 x: 90.30000305175781,
//                 y: 482.84002685546875,
//                 width: 22.488243103027344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   90.30000305175781, 482.84002685546875, 112.78824615478516,
//                   489.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 105,
//               type: "text",
//               content: "FARM",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 506.84002685546875,
//                 width: 15.961997985839844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 506.84002685546875, 52.26199722290039,
//                   513.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 106,
//               type: "text",
//               content: "PLEASURE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 494.84002685546875,
//                 width: 30.64749526977539,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 494.84002685546875, 66.94749450683594,
//                   501.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 107,
//               type: "text",
//               content: "USE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 482.5400085449219,
//                 width: 11.81049919128418,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 482.5400085449219, 33.71049880981445,
//                   488.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 108,
//               type: "text",
//               content: "15 MILES +",
//               coordinates: {
//                 x: 147.89999389648438,
//                 y: 518.8400268554688,
//                 width: 30.170242309570312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   147.89999389648438, 518.8400268554688, 178.0702362060547,
//                   525.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 109,
//               type: "text",
//               content: "< 15 MILES",
//               coordinates: {
//                 x: 93.9000015258789,
//                 y: 518.8400268554688,
//                 width: 30.170242309570312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   93.9000015258789, 518.8400268554688, 124.07024383544922,
//                   525.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 110,
//               type: "text",
//               content: "WORK / SCHOOL",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 521.5400390625,
//                 width: 47.54675483703613,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 521.5400390625, 69.4467544555664,
//                   527.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 111,
//               type: "text",
//               content: "DRIVE TO",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 516.1400146484375,
//                 width: 27.019250869750977,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 516.1400146484375, 48.91925048828125,
//                   522.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 112,
//               type: "text",
//               content: "ZIP",
//               coordinates: {
//                 x: 543.9000244140625,
//                 y: 434.5400085449219,
//                 width: 8.9298095703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   543.9000244140625, 434.5400085449219, 552.829833984375,
//                   440.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 113,
//               type: "text",
//               content: "STATE",
//               coordinates: {
//                 x: 515.0999755859375,
//                 y: 434.5400085449219,
//                 width: 17.974609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   515.0999755859375, 434.5400085449219, 533.0745849609375,
//                   440.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 114,
//               type: "text",
//               content: "COUNTY",
//               coordinates: {
//                 x: 363.8999938964844,
//                 y: 434.5400085449219,
//                 width: 24.25921630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   363.8999938964844, 434.5400085449219, 388.1592102050781,
//                   440.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 115,
//               type: "text",
//               content: "CITY",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 434.5400085449219,
//                 width: 13.081253051757812,
//                 height: 6.4227294921875,
//                 bbox: [
//                   212.6999969482422, 434.5400085449219, 225.78125,
//                   440.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 116,
//               type: "text",
//               content: "STREET (Required in KY)",
//               coordinates: {
//                 x: 61.5,
//                 y: 434.5400085449219,
//                 width: 69.24148559570312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   61.5, 434.5400085449219, 130.74148559570312, 440.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 117,
//               type: "text",
//               content: "GARAGING",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 436.94000244140625,
//                 width: 31.60200309753418,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 436.94000244140625, 53.50200271606445,
//                   443.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 118,
//               type: "text",
//               content: "ADDRESS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 444.1400146484375,
//                 width: 28.09449577331543,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 444.1400146484375, 49.9944953918457,
//                   450.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 119,
//               type: "text",
//               content: "STATE",
//               coordinates: {
//                 x: 21.903749465942383,
//                 y: 461.5400085449219,
//                 width: 17.974496841430664,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.903749465942383, 461.5400085449219, 39.87824630737305,
//                   467.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 120,
//               type: "text",
//               content: "LIC",
//               coordinates: {
//                 x: 25.96875,
//                 y: 456.1400146484375,
//                 width: 9.251750946044922,
//                 height: 6.4227294921875,
//                 bbox: [
//                   25.96875, 456.1400146484375, 35.22050094604492,
//                   462.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 121,
//               type: "text",
//               content: "TERR",
//               coordinates: {
//                 x: 64.17375183105469,
//                 y: 458.5400085449219,
//                 width: 15.639991760253906,
//                 height: 6.4227294921875,
//                 bbox: [
//                   64.17375183105469, 458.5400085449219, 79.8137435913086,
//                   464.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 122,
//               type: "text",
//               content: "GVW / GCW",
//               coordinates: {
//                 x: 122.61000061035156,
//                 y: 458.5400085449219,
//                 width: 32.53924560546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   122.61000061035156, 458.5400085449219, 155.1492462158203,
//                   464.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 123,
//               type: "text",
//               content: "CLASS",
//               coordinates: {
//                 x: 195.4562530517578,
//                 y: 458.5400085449219,
//                 width: 19.469512939453125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   195.4562530517578, 458.5400085449219, 214.92576599121094,
//                   464.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 124,
//               type: "text",
//               content: "SIC",
//               coordinates: {
//                 x: 251.1074981689453,
//                 y: 458.5400085449219,
//                 width: 9.573745727539062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   251.1074981689453, 458.5400085449219, 260.6812438964844,
//                   464.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 125,
//               type: "text",
//               content: "FACTOR",
//               coordinates: {
//                 x: 290.6337585449219,
//                 y: 458.5400085449219,
//                 width: 23.517486572265625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   290.6337585449219, 458.5400085449219, 314.1512451171875,
//                   464.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 126,
//               type: "text",
//               content: "SEAT CP",
//               coordinates: {
//                 x: 326.4537353515625,
//                 y: 458.5400085449219,
//                 width: 24.466217041015625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   326.4537353515625, 458.5400085449219, 350.9199523925781,
//                   464.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 127,
//               type: "text",
//               content: "RADIUS",
//               coordinates: {
//                 x: 359.77874755859375,
//                 y: 458.5400085449219,
//                 width: 22.0281982421875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   359.77874755859375, 458.5400085449219, 381.80694580078125,
//                   464.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 128,
//               type: "text",
//               content: "FARTHEST TERMINAL",
//               coordinates: {
//                 x: 419.4750061035156,
//                 y: 458.5400085449219,
//                 width: 61.593963623046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   419.4750061035156, 458.5400085449219, 481.0689697265625,
//                   464.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 129,
//               type: "text",
//               content: "NET VEH",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 516.1400146484375,
//                 width: 24.891754150390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 516.1400146484375, 215.99176025390625,
//                   522.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 130,
//               type: "text",
//               content: "DR/CR:",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 521.5400390625,
//                 width: 20.113510131835938,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 521.5400390625, 211.21351623535156,
//                   527.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 131,
//               type: "text",
//               content: "OTC",
//               coordinates: {
//                 x: 540.53125,
//                 y: 486.44000244140625,
//                 width: 12.12677001953125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   540.53125, 486.44000244140625, 552.6580200195312,
//                   492.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 132,
//               type: "text",
//               content: "COLL",
//               coordinates: {
//                 x: 576.9000244140625,
//                 y: 508.6400146484375,
//                 width: 15.0133056640625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   576.9000244140625, 508.6400146484375, 591.913330078125,
//                   515.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 133,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 525.2999877929688,
//                 y: 508.6400146484375,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.2999877929688, 508.6400146484375, 528.4970092773438,
//                   515.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 134,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 525.2999877929688,
//                 y: 496.6400146484375,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.2999877929688, 496.6400146484375, 528.4970092773438,
//                   503.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 135,
//               type: "text",
//               content: "C OF L",
//               coordinates: {
//                 x: 573.2999877929688,
//                 y: 486.44000244140625,
//                 width: 18.50933837890625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   573.2999877929688, 486.44000244140625, 591.809326171875,
//                   492.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 136,
//               type: "text",
//               content: "SPEC",
//               coordinates: {
//                 x: 573.2999877929688,
//                 y: 481.0400085449219,
//                 width: 15.64007568359375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   573.2999877929688, 481.0400085449219, 588.9400634765625,
//                   487.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 137,
//               type: "text",
//               content: "COMP/",
//               coordinates: {
//                 x: 537.17626953125,
//                 y: 480.44000244140625,
//                 width: 18.831298828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   537.17626953125, 480.44000244140625, 556.007568359375,
//                   486.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 138,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 443.1000061035156,
//                 y: 508.6400146484375,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   443.1000061035156, 508.6400146484375, 446.2969970703125,
//                   515.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 139,
//               type: "text",
//               content: "ST AMT",
//               coordinates: {
//                 x: 493.5,
//                 y: 496.6400146484375,
//                 width: 20.63677978515625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   493.5, 496.6400146484375, 514.1367797851562, 503.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 140,
//               type: "text",
//               content: "AA",
//               coordinates: {
//                 x: 457.5,
//                 y: 496.6400146484375,
//                 width: 7.65899658203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   457.5, 496.6400146484375, 465.15899658203125, 503.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 141,
//               type: "text",
//               content: "ACV",
//               coordinates: {
//                 x: 507.8999938964844,
//                 y: 484.6400146484375,
//                 width: 11.810516357421875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   507.8999938964844, 484.6400146484375, 519.7105102539062,
//                   491.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 142,
//               type: "text",
//               content: "DEDUCTIBLES",
//               coordinates: {
//                 x: 443.1000061035156,
//                 y: 481.94000244140625,
//                 width: 40.85369873046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   443.1000061035156, 481.94000244140625, 483.9537048339844,
//                   488.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 143,
//               type: "text",
//               content: "SYM / AGE",
//               coordinates: {
//                 x: 503.6499938964844,
//                 y: 410.5400085449219,
//                 width: 29.463104248046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   503.6499938964844, 410.5400085449219, 533.1130981445312,
//                   416.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 144,
//               type: "text",
//               content: "V.I.N.:",
//               coordinates: {
//                 x: 241.5,
//                 y: 424.34002685546875,
//                 width: 15.74346923828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   241.5, 424.34002685546875, 257.24346923828125,
//                   430.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 145,
//               type: "text",
//               content: "TYPE:",
//               coordinates: {
//                 x: 241.5,
//                 y: 413.5400085449219,
//                 width: 16.9107666015625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   241.5, 413.5400085449219, 258.4107666015625, 419.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 146,
//               type: "text",
//               content: "BODY",
//               coordinates: {
//                 x: 241.5,
//                 y: 408.1400146484375,
//                 width: 16.600250244140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   241.5, 408.1400146484375, 258.1002502441406, 414.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 147,
//               type: "text",
//               content: "MODEL:",
//               coordinates: {
//                 x: 83.0999984741211,
//                 y: 424.34002685546875,
//                 width: 22.660743713378906,
//                 height: 6.4227294921875,
//                 bbox: [
//                   83.0999984741211, 424.34002685546875, 105.7607421875,
//                   430.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 148,
//               type: "text",
//               content: "MAKE:",
//               coordinates: {
//                 x: 83.0999984741211,
//                 y: 412.34002685546875,
//                 width: 18.836990356445312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   83.0999984741211, 412.34002685546875, 101.9369888305664,
//                   418.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 149,
//               type: "text",
//               content: "YEAR",
//               coordinates: {
//                 x: 56.8125,
//                 y: 409.94000244140625,
//                 width: 15.961990356445312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   56.8125, 409.94000244140625, 72.77449035644531,
//                   416.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 150,
//               type: "text",
//               content: "VEH #",
//               coordinates: {
//                 x: 25.891250610351562,
//                 y: 409.94000244140625,
//                 width: 16.600250244140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   25.891250610351562, 409.94000244140625, 42.49150085449219,
//                   416.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 151,
//               type: "text",
//               content: "PP",
//               coordinates: {
//                 x: 403.5,
//                 y: 422.84002685546875,
//                 width: 7.65899658203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   403.5, 422.84002685546875, 411.15899658203125,
//                   429.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 152,
//               type: "text",
//               content: "SPEC",
//               coordinates: {
//                 x: 435.8999938964844,
//                 y: 422.84002685546875,
//                 width: 15.639984130859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   435.8999938964844, 422.84002685546875, 451.53997802734375,
//                   429.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 153,
//               type: "text",
//               content: "COML",
//               coordinates: {
//                 x: 475.5,
//                 y: 422.84002685546875,
//                 width: 16.605987548828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   475.5, 422.84002685546875, 492.1059875488281,
//                   429.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 154,
//               type: "text",
//               content: "VEHICLE TYPE",
//               coordinates: {
//                 x: 422.3324890136719,
//                 y: 410.5400085449219,
//                 width: 41.48046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   422.3324890136719, 410.5400085449219, 463.8129577636719,
//                   416.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 155,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 518.7000122070312,
//                 y: 351.44000244140625,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   518.7000122070312, 351.44000244140625, 521.8970336914062,
//                   357.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 156,
//               type: "text",
//               content: "COST NEW",
//               coordinates: {
//                 x: 537.407470703125,
//                 y: 338.5400085449219,
//                 width: 30.95233154296875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   537.407470703125, 338.5400085449219, 568.3598022460938,
//                   344.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 157,
//               type: "text",
//               content: "SYM",
//               coordinates: {
//                 x: 573.6699829101562,
//                 y: 293.5400085449219,
//                 width: 12.44879150390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   573.6699829101562, 293.5400085449219, 586.1187744140625,
//                   299.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 158,
//               type: "text",
//               content: "COLL",
//               coordinates: {
//                 x: 572.0750122070312,
//                 y: 288.1400146484375,
//                 width: 15.63427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   572.0750122070312, 288.1400146484375, 587.7092895507812,
//                   294.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 159,
//               type: "text",
//               content: "OTC SYM",
//               coordinates: {
//                 x: 537.7025146484375,
//                 y: 293.5400085449219,
//                 width: 26.1683349609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   537.7025146484375, 293.5400085449219, 563.870849609375,
//                   299.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 160,
//               type: "text",
//               content: "COMP /",
//               coordinates: {
//                 x: 540.9287719726562,
//                 y: 288.1400146484375,
//                 width: 20.320556640625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   540.9287719726562, 288.1400146484375, 561.2493286132812,
//                   294.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 161,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 486.29998779296875,
//                 y: 401.2400207519531,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   486.29998779296875, 401.2400207519531, 489.4969787597656,
//                   407.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 162,
//               type: "text",
//               content: "TOTAL PREM:",
//               coordinates: {
//                 x: 443.1000061035156,
//                 y: 400.94000244140625,
//                 width: 38.617034912109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   443.1000061035156, 400.94000244140625, 481.717041015625,
//                   407.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 163,
//               type: "text",
//               content: "OTC",
//               coordinates: {
//                 x: 367.5,
//                 y: 377.84002685546875,
//                 width: 12.126739501953125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   367.5, 377.84002685546875, 379.6267395019531,
//                   384.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 164,
//               type: "text",
//               content: "FG",
//               coordinates: {
//                 x: 407.1000061035156,
//                 y: 374.84002685546875,
//                 width: 7.975250244140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   407.1000061035156, 374.84002685546875, 415.07525634765625,
//                   381.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 165,
//               type: "text",
//               content: "REIMB",
//               coordinates: {
//                 x: 407.1000061035156,
//                 y: 366.44000244140625,
//                 width: 18.1929931640625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   407.1000061035156, 366.44000244140625, 425.2929992675781,
//                   372.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 166,
//               type: "text",
//               content: "RENT",
//               coordinates: {
//                 x: 407.1000061035156,
//                 y: 360.44000244140625,
//                 width: 15.639984130859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   407.1000061035156, 360.44000244140625, 422.739990234375,
//                   366.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 167,
//               type: "text",
//               content: "COLL",
//               coordinates: {
//                 x: 367.5,
//                 y: 386.84002685546875,
//                 width: 15.013214111328125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   367.5, 386.84002685546875, 382.5132141113281,
//                   393.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 168,
//               type: "text",
//               content: "COMP/",
//               coordinates: {
//                 x: 367.5,
//                 y: 372.44000244140625,
//                 width: 18.83123779296875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   367.5, 372.44000244140625, 386.33123779296875,
//                   378.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 169,
//               type: "text",
//               content: "LSP",
//               coordinates: {
//                 x: 367.5,
//                 y: 362.84002685546875,
//                 width: 10.855987548828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   367.5, 362.84002685546875, 378.3559875488281,
//                   369.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 170,
//               type: "text",
//               content: "FTW",
//               coordinates: {
//                 x: 331.5,
//                 y: 386.84002685546875,
//                 width: 12.437255859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   331.5, 386.84002685546875, 343.937255859375,
//                   393.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 171,
//               type: "text",
//               content: "FT",
//               coordinates: {
//                 x: 331.5,
//                 y: 374.84002685546875,
//                 width: 7.0150146484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   331.5, 374.84002685546875, 338.5150146484375,
//                   381.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 172,
//               type: "text",
//               content: "F",
//               coordinates: {
//                 x: 331.5,
//                 y: 362.84002685546875,
//                 width: 3.50750732421875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   331.5, 362.84002685546875, 335.00750732421875,
//                   369.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 173,
//               type: "text",
//               content: "C OF L",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 390.44000244140625,
//                 width: 18.50921630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 390.44000244140625, 299.6092224121094,
//                   396.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 174,
//               type: "text",
//               content: "SPEC",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 385.0400085449219,
//                 width: 15.639984130859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 385.0400085449219, 296.739990234375,
//                   391.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 175,
//               type: "text",
//               content: "& LABOR",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 378.44000244140625,
//                 width: 24.8974609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 378.44000244140625, 305.9974670410156,
//                   384.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 176,
//               type: "text",
//               content: "TOWING",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 373.0400085449219,
//                 width: 23.5059814453125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 373.0400085449219, 304.6059875488281,
//                   379.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 177,
//               type: "text",
//               content: "MOTOR",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 366.44000244140625,
//                 width: 21.28076171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 366.44000244140625, 302.3807678222656,
//                   372.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 178,
//               type: "text",
//               content: "UNDRINS",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 361.0400085449219,
//                 width: 26.1796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 361.0400085449219, 307.2796936035156,
//                   367.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 179,
//               type: "text",
//               content: "MOTOR",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 390.44000244140625,
//                 width: 21.280746459960938,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 390.44000244140625, 251.98074340820312,
//                   396.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 180,
//               type: "text",
//               content: "UNINS",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 385.0400085449219,
//                 width: 17.876754760742188,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 385.0400085449219, 248.57675170898438,
//                   391.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 181,
//               type: "text",
//               content: "MED PAY",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 376.6400146484375,
//                 width: 25.0009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 376.6400146484375, 255.7009735107422,
//                   383.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 182,
//               type: "text",
//               content: "FAULT",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 366.44000244140625,
//                 width: 17.451263427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 366.44000244140625, 248.15126037597656,
//                   372.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 183,
//               type: "text",
//               content: "ADD'L NO-",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 361.0400085449219,
//                 width: 28.336013793945312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 361.0400085449219, 259.0360107421875,
//                   367.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 184,
//               type: "text",
//               content: "FAULT",
//               coordinates: {
//                 x: 187.5,
//                 y: 390.44000244140625,
//                 width: 17.451263427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   187.5, 390.44000244140625, 204.95126342773438,
//                   396.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 185,
//               type: "text",
//               content: "NO-",
//               coordinates: {
//                 x: 187.5,
//                 y: 385.0400085449219,
//                 width: 10.53399658203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   187.5, 385.0400085449219, 198.03399658203125,
//                   391.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 186,
//               type: "text",
//               content: "LIAB",
//               coordinates: {
//                 x: 187.5,
//                 y: 376.6400146484375,
//                 width: 12.448745727539062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   187.5, 376.6400146484375, 199.94874572753906, 383.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 187,
//               type: "text",
//               content: "COVERAGES",
//               coordinates: {
//                 x: 173.10000610351562,
//                 y: 365.5400085449219,
//                 width: 36.70799255371094,
//                 height: 6.4227294921875,
//                 bbox: [
//                   173.10000610351562, 365.5400085449219, 209.80799865722656,
//                   371.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 188,
//               type: "text",
//               content: "CHECK",
//               coordinates: {
//                 x: 173.10000610351562,
//                 y: 360.1400146484375,
//                 width: 20.435516357421875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   173.10000610351562, 360.1400146484375, 193.5355224609375,
//                   366.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 189,
//               type: "text",
//               content: "FOR HIRE",
//               coordinates: {
//                 x: 137.10000610351562,
//                 y: 362.84002685546875,
//                 width: 27.444747924804688,
//                 height: 6.4227294921875,
//                 bbox: [
//                   137.10000610351562, 362.84002685546875, 164.5447540283203,
//                   369.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 190,
//               type: "text",
//               content: "SERVICE",
//               coordinates: {
//                 x: 90.30000305175781,
//                 y: 386.84002685546875,
//                 width: 25.11023712158203,
//                 height: 6.4227294921875,
//                 bbox: [
//                   90.30000305175781, 386.84002685546875, 115.41024017333984,
//                   393.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 191,
//               type: "text",
//               content: "RETAIL",
//               coordinates: {
//                 x: 90.30000305175781,
//                 y: 374.84002685546875,
//                 width: 19.68224334716797,
//                 height: 6.4227294921875,
//                 bbox: [
//                   90.30000305175781, 374.84002685546875, 109.98224639892578,
//                   381.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 192,
//               type: "text",
//               content: "COMM'L",
//               coordinates: {
//                 x: 90.30000305175781,
//                 y: 362.84002685546875,
//                 width: 22.488243103027344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   90.30000305175781, 362.84002685546875, 112.78824615478516,
//                   369.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 193,
//               type: "text",
//               content: "FARM",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 386.84002685546875,
//                 width: 15.961997985839844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 386.84002685546875, 52.26199722290039,
//                   393.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 194,
//               type: "text",
//               content: "PLEASURE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 374.84002685546875,
//                 width: 30.64749526977539,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 374.84002685546875, 66.94749450683594,
//                   381.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 195,
//               type: "text",
//               content: "USE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 362.5400085449219,
//                 width: 11.81049919128418,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 362.5400085449219, 33.71049880981445,
//                   368.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 196,
//               type: "text",
//               content: "15 MILES +",
//               coordinates: {
//                 x: 147.89999389648438,
//                 y: 398.84002685546875,
//                 width: 30.170242309570312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   147.89999389648438, 398.84002685546875, 178.0702362060547,
//                   405.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 197,
//               type: "text",
//               content: "< 15 MILES",
//               coordinates: {
//                 x: 93.9000015258789,
//                 y: 398.84002685546875,
//                 width: 30.170242309570312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   93.9000015258789, 398.84002685546875, 124.07024383544922,
//                   405.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 198,
//               type: "text",
//               content: "WORK / SCHOOL",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 401.5400085449219,
//                 width: 47.54675483703613,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 401.5400085449219, 69.4467544555664,
//                   407.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 199,
//               type: "text",
//               content: "DRIVE TO",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 396.1400146484375,
//                 width: 27.019250869750977,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 396.1400146484375, 48.91925048828125,
//                   402.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 200,
//               type: "text",
//               content: "ZIP",
//               coordinates: {
//                 x: 543.9000244140625,
//                 y: 314.5400085449219,
//                 width: 8.9298095703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   543.9000244140625, 314.5400085449219, 552.829833984375,
//                   320.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 201,
//               type: "text",
//               content: "STATE",
//               coordinates: {
//                 x: 515.0999755859375,
//                 y: 314.5400085449219,
//                 width: 17.974609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   515.0999755859375, 314.5400085449219, 533.0745849609375,
//                   320.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 202,
//               type: "text",
//               content: "COUNTY",
//               coordinates: {
//                 x: 363.8999938964844,
//                 y: 314.5400085449219,
//                 width: 24.25921630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   363.8999938964844, 314.5400085449219, 388.1592102050781,
//                   320.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 203,
//               type: "text",
//               content: "CITY",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 314.5400085449219,
//                 width: 13.081253051757812,
//                 height: 6.4227294921875,
//                 bbox: [
//                   212.6999969482422, 314.5400085449219, 225.78125,
//                   320.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 204,
//               type: "text",
//               content: "STREET (Required in KY)",
//               coordinates: {
//                 x: 61.5,
//                 y: 314.5400085449219,
//                 width: 69.24148559570312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   61.5, 314.5400085449219, 130.74148559570312, 320.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 205,
//               type: "text",
//               content: "GARAGING",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 316.94000244140625,
//                 width: 31.60200309753418,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 316.94000244140625, 53.50200271606445,
//                   323.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 206,
//               type: "text",
//               content: "ADDRESS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 324.1400146484375,
//                 width: 28.09449577331543,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 324.1400146484375, 49.9944953918457,
//                   330.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 207,
//               type: "text",
//               content: "STATE",
//               coordinates: {
//                 x: 21.903749465942383,
//                 y: 341.5400085449219,
//                 width: 17.974496841430664,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.903749465942383, 341.5400085449219, 39.87824630737305,
//                   347.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 208,
//               type: "text",
//               content: "LIC",
//               coordinates: {
//                 x: 25.96875,
//                 y: 336.1400146484375,
//                 width: 9.251750946044922,
//                 height: 6.4227294921875,
//                 bbox: [
//                   25.96875, 336.1400146484375, 35.22050094604492,
//                   342.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 209,
//               type: "text",
//               content: "TERR",
//               coordinates: {
//                 x: 64.17375183105469,
//                 y: 338.5400085449219,
//                 width: 15.639991760253906,
//                 height: 6.4227294921875,
//                 bbox: [
//                   64.17375183105469, 338.5400085449219, 79.8137435913086,
//                   344.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 210,
//               type: "text",
//               content: "GVW / GCW",
//               coordinates: {
//                 x: 122.61000061035156,
//                 y: 338.5400085449219,
//                 width: 32.53924560546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   122.61000061035156, 338.5400085449219, 155.1492462158203,
//                   344.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 211,
//               type: "text",
//               content: "CLASS",
//               coordinates: {
//                 x: 195.4562530517578,
//                 y: 338.5400085449219,
//                 width: 19.469512939453125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   195.4562530517578, 338.5400085449219, 214.92576599121094,
//                   344.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 212,
//               type: "text",
//               content: "SIC",
//               coordinates: {
//                 x: 251.1074981689453,
//                 y: 338.5400085449219,
//                 width: 9.573745727539062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   251.1074981689453, 338.5400085449219, 260.6812438964844,
//                   344.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 213,
//               type: "text",
//               content: "FACTOR",
//               coordinates: {
//                 x: 290.6337585449219,
//                 y: 338.5400085449219,
//                 width: 23.517486572265625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   290.6337585449219, 338.5400085449219, 314.1512451171875,
//                   344.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 214,
//               type: "text",
//               content: "SEAT CP",
//               coordinates: {
//                 x: 326.4537353515625,
//                 y: 338.5400085449219,
//                 width: 24.466217041015625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   326.4537353515625, 338.5400085449219, 350.9199523925781,
//                   344.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 215,
//               type: "text",
//               content: "RADIUS",
//               coordinates: {
//                 x: 359.77874755859375,
//                 y: 338.5400085449219,
//                 width: 22.0281982421875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   359.77874755859375, 338.5400085449219, 381.80694580078125,
//                   344.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 216,
//               type: "text",
//               content: "FARTHEST TERMINAL",
//               coordinates: {
//                 x: 419.4750061035156,
//                 y: 338.5400085449219,
//                 width: 61.593963623046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   419.4750061035156, 338.5400085449219, 481.0689697265625,
//                   344.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 217,
//               type: "text",
//               content: "NET VEH",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 396.1400146484375,
//                 width: 24.891754150390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 396.1400146484375, 215.99176025390625,
//                   402.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 218,
//               type: "text",
//               content: "DR/CR:",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 401.5400085449219,
//                 width: 20.113510131835938,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 401.5400085449219, 211.21351623535156,
//                   407.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 219,
//               type: "text",
//               content: "OTC",
//               coordinates: {
//                 x: 540.53125,
//                 y: 366.44000244140625,
//                 width: 12.12677001953125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   540.53125, 366.44000244140625, 552.6580200195312,
//                   372.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 220,
//               type: "text",
//               content: "COLL",
//               coordinates: {
//                 x: 576.9000244140625,
//                 y: 388.6400146484375,
//                 width: 15.0133056640625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   576.9000244140625, 388.6400146484375, 591.913330078125,
//                   395.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 221,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 525.2999877929688,
//                 y: 388.6400146484375,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.2999877929688, 388.6400146484375, 528.4970092773438,
//                   395.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 222,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 525.2999877929688,
//                 y: 376.6400146484375,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.2999877929688, 376.6400146484375, 528.4970092773438,
//                   383.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 223,
//               type: "text",
//               content: "C OF L",
//               coordinates: {
//                 x: 573.2999877929688,
//                 y: 366.44000244140625,
//                 width: 18.50933837890625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   573.2999877929688, 366.44000244140625, 591.809326171875,
//                   372.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 224,
//               type: "text",
//               content: "SPEC",
//               coordinates: {
//                 x: 573.2999877929688,
//                 y: 361.0400085449219,
//                 width: 15.64007568359375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   573.2999877929688, 361.0400085449219, 588.9400634765625,
//                   367.4627380371094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 225,
//               type: "text",
//               content: "COMP/",
//               coordinates: {
//                 x: 537.17626953125,
//                 y: 360.44000244140625,
//                 width: 18.831298828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   537.17626953125, 360.44000244140625, 556.007568359375,
//                   366.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 226,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 443.1000061035156,
//                 y: 388.6400146484375,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   443.1000061035156, 388.6400146484375, 446.2969970703125,
//                   395.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 227,
//               type: "text",
//               content: "ST AMT",
//               coordinates: {
//                 x: 493.5,
//                 y: 376.6400146484375,
//                 width: 20.63677978515625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   493.5, 376.6400146484375, 514.1367797851562, 383.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 228,
//               type: "text",
//               content: "AA",
//               coordinates: {
//                 x: 457.5,
//                 y: 376.6400146484375,
//                 width: 7.65899658203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   457.5, 376.6400146484375, 465.15899658203125, 383.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 229,
//               type: "text",
//               content: "ACV",
//               coordinates: {
//                 x: 507.8999938964844,
//                 y: 364.6400146484375,
//                 width: 11.810516357421875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   507.8999938964844, 364.6400146484375, 519.7105102539062,
//                   371.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 230,
//               type: "text",
//               content: "DEDUCTIBLES",
//               coordinates: {
//                 x: 443.1000061035156,
//                 y: 361.94000244140625,
//                 width: 40.85369873046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   443.1000061035156, 361.94000244140625, 483.9537048339844,
//                   368.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 231,
//               type: "text",
//               content: "SYM / AGE",
//               coordinates: {
//                 x: 503.6499938964844,
//                 y: 290.5400085449219,
//                 width: 29.463104248046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   503.6499938964844, 290.5400085449219, 533.1130981445312,
//                   296.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 232,
//               type: "text",
//               content: "V.I.N.:",
//               coordinates: {
//                 x: 241.5,
//                 y: 304.34002685546875,
//                 width: 15.74346923828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   241.5, 304.34002685546875, 257.24346923828125,
//                   310.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 233,
//               type: "text",
//               content: "TYPE:",
//               coordinates: {
//                 x: 241.5,
//                 y: 293.5400085449219,
//                 width: 16.9107666015625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   241.5, 293.5400085449219, 258.4107666015625, 299.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 234,
//               type: "text",
//               content: "BODY",
//               coordinates: {
//                 x: 241.5,
//                 y: 288.1400146484375,
//                 width: 16.600250244140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   241.5, 288.1400146484375, 258.1002502441406, 294.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 235,
//               type: "text",
//               content: "MODEL:",
//               coordinates: {
//                 x: 83.0999984741211,
//                 y: 304.34002685546875,
//                 width: 22.660743713378906,
//                 height: 6.4227294921875,
//                 bbox: [
//                   83.0999984741211, 304.34002685546875, 105.7607421875,
//                   310.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 236,
//               type: "text",
//               content: "MAKE:",
//               coordinates: {
//                 x: 83.0999984741211,
//                 y: 292.34002685546875,
//                 width: 18.836990356445312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   83.0999984741211, 292.34002685546875, 101.9369888305664,
//                   298.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 237,
//               type: "text",
//               content: "YEAR",
//               coordinates: {
//                 x: 56.8125,
//                 y: 289.94000244140625,
//                 width: 15.961990356445312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   56.8125, 289.94000244140625, 72.77449035644531,
//                   296.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 238,
//               type: "text",
//               content: "VEH #",
//               coordinates: {
//                 x: 25.891250610351562,
//                 y: 289.94000244140625,
//                 width: 16.600250244140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   25.891250610351562, 289.94000244140625, 42.49150085449219,
//                   296.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 239,
//               type: "text",
//               content: "PP",
//               coordinates: {
//                 x: 403.5,
//                 y: 302.84002685546875,
//                 width: 7.65899658203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   403.5, 302.84002685546875, 411.15899658203125,
//                   309.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 240,
//               type: "text",
//               content: "SPEC",
//               coordinates: {
//                 x: 435.8999938964844,
//                 y: 302.84002685546875,
//                 width: 15.639984130859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   435.8999938964844, 302.84002685546875, 451.53997802734375,
//                   309.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 241,
//               type: "text",
//               content: "COML",
//               coordinates: {
//                 x: 475.5,
//                 y: 302.84002685546875,
//                 width: 16.605987548828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   475.5, 302.84002685546875, 492.1059875488281,
//                   309.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 242,
//               type: "text",
//               content: "VEHICLE TYPE",
//               coordinates: {
//                 x: 422.3324890136719,
//                 y: 290.5400085449219,
//                 width: 41.48046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   422.3324890136719, 290.5400085449219, 463.8129577636719,
//                   296.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 243,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 518.7000122070312,
//                 y: 231.4399871826172,
//                 width: 3.197021484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   518.7000122070312, 231.4399871826172, 521.8970336914062,
//                   237.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 244,
//               type: "text",
//               content: "COST NEW",
//               coordinates: {
//                 x: 537.407470703125,
//                 y: 218.54002380371094,
//                 width: 30.95233154296875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   537.407470703125, 218.54002380371094, 568.3598022460938,
//                   224.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 245,
//               type: "text",
//               content: "SYM",
//               coordinates: {
//                 x: 573.6699829101562,
//                 y: 173.54002380371094,
//                 width: 12.44879150390625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   573.6699829101562, 173.54002380371094, 586.1187744140625,
//                   179.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 246,
//               type: "text",
//               content: "COLL",
//               coordinates: {
//                 x: 572.0750122070312,
//                 y: 168.13999938964844,
//                 width: 15.63427734375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   572.0750122070312, 168.13999938964844, 587.7092895507812,
//                   174.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 247,
//               type: "text",
//               content: "OTC SYM",
//               coordinates: {
//                 x: 537.7025146484375,
//                 y: 173.54002380371094,
//                 width: 26.1683349609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   537.7025146484375, 173.54002380371094, 563.870849609375,
//                   179.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 248,
//               type: "text",
//               content: "COMP /",
//               coordinates: {
//                 x: 540.9287719726562,
//                 y: 168.13999938964844,
//                 width: 20.320556640625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   540.9287719726562, 168.13999938964844, 561.2493286132812,
//                   174.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 249,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 486.29998779296875,
//                 y: 281.2400207519531,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   486.29998779296875, 281.2400207519531, 489.4969787597656,
//                   287.6627502441406
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 250,
//               type: "text",
//               content: "TOTAL PREM:",
//               coordinates: {
//                 x: 443.1000061035156,
//                 y: 280.94000244140625,
//                 width: 38.617034912109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   443.1000061035156, 280.94000244140625, 481.717041015625,
//                   287.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 251,
//               type: "text",
//               content: "OTC",
//               coordinates: {
//                 x: 367.5,
//                 y: 257.84002685546875,
//                 width: 12.126739501953125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   367.5, 257.84002685546875, 379.6267395019531,
//                   264.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 252,
//               type: "text",
//               content: "FG",
//               coordinates: {
//                 x: 407.1000061035156,
//                 y: 254.8400115966797,
//                 width: 7.975250244140625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   407.1000061035156, 254.8400115966797, 415.07525634765625,
//                   261.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 253,
//               type: "text",
//               content: "REIMB",
//               coordinates: {
//                 x: 407.1000061035156,
//                 y: 246.4399871826172,
//                 width: 18.1929931640625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   407.1000061035156, 246.4399871826172, 425.2929992675781,
//                   252.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 254,
//               type: "text",
//               content: "RENT",
//               coordinates: {
//                 x: 407.1000061035156,
//                 y: 240.4399871826172,
//                 width: 15.639984130859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   407.1000061035156, 240.4399871826172, 422.739990234375,
//                   246.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 255,
//               type: "text",
//               content: "COLL",
//               coordinates: {
//                 x: 367.5,
//                 y: 266.84002685546875,
//                 width: 15.013214111328125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   367.5, 266.84002685546875, 382.5132141113281,
//                   273.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 256,
//               type: "text",
//               content: "COMP/",
//               coordinates: {
//                 x: 367.5,
//                 y: 252.4399871826172,
//                 width: 18.83123779296875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   367.5, 252.4399871826172, 386.33123779296875,
//                   258.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 257,
//               type: "text",
//               content: "LSP",
//               coordinates: {
//                 x: 367.5,
//                 y: 242.8400115966797,
//                 width: 10.855987548828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   367.5, 242.8400115966797, 378.3559875488281,
//                   249.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 258,
//               type: "text",
//               content: "FTW",
//               coordinates: {
//                 x: 331.5,
//                 y: 266.84002685546875,
//                 width: 12.437255859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   331.5, 266.84002685546875, 343.937255859375,
//                   273.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 259,
//               type: "text",
//               content: "FT",
//               coordinates: {
//                 x: 331.5,
//                 y: 254.8400115966797,
//                 width: 7.0150146484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   331.5, 254.8400115966797, 338.5150146484375,
//                   261.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 260,
//               type: "text",
//               content: "F",
//               coordinates: {
//                 x: 331.5,
//                 y: 242.8400115966797,
//                 width: 3.50750732421875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   331.5, 242.8400115966797, 335.00750732421875,
//                   249.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 261,
//               type: "text",
//               content: "C OF L",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 270.44000244140625,
//                 width: 18.50921630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 270.44000244140625, 299.6092224121094,
//                   276.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 262,
//               type: "text",
//               content: "SPEC",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 265.0400390625,
//                 width: 15.639984130859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 265.0400390625, 296.739990234375,
//                   271.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 263,
//               type: "text",
//               content: "& LABOR",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 258.44000244140625,
//                 width: 24.8974609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   281.1000061035156, 258.44000244140625, 305.9974670410156,
//                   264.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 264,
//               type: "text",
//               content: "TOWING",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 253.04002380371094,
//                 width: 23.5059814453125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   281.1000061035156, 253.04002380371094, 304.6059875488281,
//                   259.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 265,
//               type: "text",
//               content: "MOTOR",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 246.4399871826172,
//                 width: 21.28076171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   281.1000061035156, 246.4399871826172, 302.3807678222656,
//                   252.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 266,
//               type: "text",
//               content: "UNDRINS",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 241.04002380371094,
//                 width: 26.1796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   281.1000061035156, 241.04002380371094, 307.2796936035156,
//                   247.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 267,
//               type: "text",
//               content: "MOTOR",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 270.44000244140625,
//                 width: 21.280746459960938,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 270.44000244140625, 251.98074340820312,
//                   276.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 268,
//               type: "text",
//               content: "UNINS",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 265.0400390625,
//                 width: 17.876754760742188,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 265.0400390625, 248.57675170898438,
//                   271.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 269,
//               type: "text",
//               content: "MED PAY",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 256.6400146484375,
//                 width: 25.0009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   230.6999969482422, 256.6400146484375, 255.7009735107422,
//                   263.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 270,
//               type: "text",
//               content: "FAULT",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 246.4399871826172,
//                 width: 17.451263427734375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   230.6999969482422, 246.4399871826172, 248.15126037597656,
//                   252.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 271,
//               type: "text",
//               content: "ADD'L NO-",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 241.04002380371094,
//                 width: 28.336013793945312,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   230.6999969482422, 241.04002380371094, 259.0360107421875,
//                   247.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 272,
//               type: "text",
//               content: "FAULT",
//               coordinates: {
//                 x: 187.5,
//                 y: 270.44000244140625,
//                 width: 17.451263427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   187.5, 270.44000244140625, 204.95126342773438,
//                   276.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 273,
//               type: "text",
//               content: "NO-",
//               coordinates: {
//                 x: 187.5,
//                 y: 265.0400390625,
//                 width: 10.53399658203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   187.5, 265.0400390625, 198.03399658203125, 271.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 274,
//               type: "text",
//               content: "LIAB",
//               coordinates: {
//                 x: 187.5,
//                 y: 256.6400146484375,
//                 width: 12.448745727539062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   187.5, 256.6400146484375, 199.94874572753906, 263.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 275,
//               type: "text",
//               content: "COVERAGES",
//               coordinates: {
//                 x: 173.10000610351562,
//                 y: 245.54002380371094,
//                 width: 36.70799255371094,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   173.10000610351562, 245.54002380371094, 209.80799865722656,
//                   251.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 276,
//               type: "text",
//               content: "CHECK",
//               coordinates: {
//                 x: 173.10000610351562,
//                 y: 240.13999938964844,
//                 width: 20.435516357421875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   173.10000610351562, 240.13999938964844, 193.5355224609375,
//                   246.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 277,
//               type: "text",
//               content: "FOR HIRE",
//               coordinates: {
//                 x: 137.10000610351562,
//                 y: 242.8400115966797,
//                 width: 27.444747924804688,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   137.10000610351562, 242.8400115966797, 164.5447540283203,
//                   249.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 278,
//               type: "text",
//               content: "SERVICE",
//               coordinates: {
//                 x: 90.30000305175781,
//                 y: 266.84002685546875,
//                 width: 25.11023712158203,
//                 height: 6.4227294921875,
//                 bbox: [
//                   90.30000305175781, 266.84002685546875, 115.41024017333984,
//                   273.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 279,
//               type: "text",
//               content: "RETAIL",
//               coordinates: {
//                 x: 90.30000305175781,
//                 y: 254.8400115966797,
//                 width: 19.68224334716797,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   90.30000305175781, 254.8400115966797, 109.98224639892578,
//                   261.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 280,
//               type: "text",
//               content: "COMM'L",
//               coordinates: {
//                 x: 90.30000305175781,
//                 y: 242.8400115966797,
//                 width: 22.488243103027344,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   90.30000305175781, 242.8400115966797, 112.78824615478516,
//                   249.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 281,
//               type: "text",
//               content: "FARM",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 266.84002685546875,
//                 width: 15.961997985839844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 266.84002685546875, 52.26199722290039,
//                   273.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 282,
//               type: "text",
//               content: "PLEASURE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 254.8400115966797,
//                 width: 30.64749526977539,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 254.8400115966797, 66.94749450683594,
//                   261.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 283,
//               type: "text",
//               content: "USE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 242.54002380371094,
//                 width: 11.81049919128418,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 242.54002380371094, 33.71049880981445,
//                   248.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 284,
//               type: "text",
//               content: "15 MILES +",
//               coordinates: {
//                 x: 147.89999389648438,
//                 y: 278.84002685546875,
//                 width: 30.170242309570312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   147.89999389648438, 278.84002685546875, 178.0702362060547,
//                   285.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 285,
//               type: "text",
//               content: "< 15 MILES",
//               coordinates: {
//                 x: 93.9000015258789,
//                 y: 278.84002685546875,
//                 width: 30.170242309570312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   93.9000015258789, 278.84002685546875, 124.07024383544922,
//                   285.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 286,
//               type: "text",
//               content: "WORK / SCHOOL",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 281.5400085449219,
//                 width: 47.54675483703613,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 281.5400085449219, 69.4467544555664,
//                   287.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 287,
//               type: "text",
//               content: "DRIVE TO",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 276.1400146484375,
//                 width: 27.019250869750977,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 276.1400146484375, 48.91925048828125,
//                   282.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 288,
//               type: "text",
//               content: "ZIP",
//               coordinates: {
//                 x: 543.9000244140625,
//                 y: 194.54002380371094,
//                 width: 8.9298095703125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   543.9000244140625, 194.54002380371094, 552.829833984375,
//                   200.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 289,
//               type: "text",
//               content: "STATE",
//               coordinates: {
//                 x: 515.0999755859375,
//                 y: 194.54002380371094,
//                 width: 17.974609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   515.0999755859375, 194.54002380371094, 533.0745849609375,
//                   200.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 290,
//               type: "text",
//               content: "COUNTY",
//               coordinates: {
//                 x: 363.8999938964844,
//                 y: 194.54002380371094,
//                 width: 24.25921630859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   363.8999938964844, 194.54002380371094, 388.1592102050781,
//                   200.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 291,
//               type: "text",
//               content: "CITY",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 194.54002380371094,
//                 width: 13.081253051757812,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   212.6999969482422, 194.54002380371094, 225.78125,
//                   200.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 292,
//               type: "text",
//               content: "STREET (Required in KY)",
//               coordinates: {
//                 x: 61.5,
//                 y: 194.54002380371094,
//                 width: 69.24148559570312,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   61.5, 194.54002380371094, 130.74148559570312,
//                   200.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 293,
//               type: "text",
//               content: "GARAGING",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 196.9399871826172,
//                 width: 31.60200309753418,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 196.9399871826172, 53.50200271606445,
//                   203.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 294,
//               type: "text",
//               content: "ADDRESS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 204.13999938964844,
//                 width: 28.09449577331543,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 204.13999938964844, 49.9944953918457,
//                   210.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 295,
//               type: "text",
//               content: "STATE",
//               coordinates: {
//                 x: 21.903749465942383,
//                 y: 221.54002380371094,
//                 width: 17.974496841430664,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.903749465942383, 221.54002380371094, 39.87824630737305,
//                   227.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 296,
//               type: "text",
//               content: "LIC",
//               coordinates: {
//                 x: 25.96875,
//                 y: 216.13999938964844,
//                 width: 9.251750946044922,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   25.96875, 216.13999938964844, 35.22050094604492,
//                   222.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 297,
//               type: "text",
//               content: "TERR",
//               coordinates: {
//                 x: 64.17375183105469,
//                 y: 218.54002380371094,
//                 width: 15.639991760253906,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   64.17375183105469, 218.54002380371094, 79.8137435913086,
//                   224.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 298,
//               type: "text",
//               content: "GVW / GCW",
//               coordinates: {
//                 x: 122.61000061035156,
//                 y: 218.54002380371094,
//                 width: 32.53924560546875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   122.61000061035156, 218.54002380371094, 155.1492462158203,
//                   224.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 299,
//               type: "text",
//               content: "CLASS",
//               coordinates: {
//                 x: 195.4562530517578,
//                 y: 218.54002380371094,
//                 width: 19.469512939453125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   195.4562530517578, 218.54002380371094, 214.92576599121094,
//                   224.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 300,
//               type: "text",
//               content: "SIC",
//               coordinates: {
//                 x: 251.1074981689453,
//                 y: 218.54002380371094,
//                 width: 9.573745727539062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   251.1074981689453, 218.54002380371094, 260.6812438964844,
//                   224.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 301,
//               type: "text",
//               content: "FACTOR",
//               coordinates: {
//                 x: 290.6337585449219,
//                 y: 218.54002380371094,
//                 width: 23.517486572265625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   290.6337585449219, 218.54002380371094, 314.1512451171875,
//                   224.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 302,
//               type: "text",
//               content: "SEAT CP",
//               coordinates: {
//                 x: 326.4537353515625,
//                 y: 218.54002380371094,
//                 width: 24.466217041015625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   326.4537353515625, 218.54002380371094, 350.9199523925781,
//                   224.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 303,
//               type: "text",
//               content: "RADIUS",
//               coordinates: {
//                 x: 359.77874755859375,
//                 y: 218.54002380371094,
//                 width: 22.0281982421875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   359.77874755859375, 218.54002380371094, 381.80694580078125,
//                   224.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 304,
//               type: "text",
//               content: "FARTHEST TERMINAL",
//               coordinates: {
//                 x: 419.4750061035156,
//                 y: 218.54002380371094,
//                 width: 61.593963623046875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   419.4750061035156, 218.54002380371094, 481.0689697265625,
//                   224.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 305,
//               type: "text",
//               content: "NET VEH",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 276.1400146484375,
//                 width: 24.891754150390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 276.1400146484375, 215.99176025390625,
//                   282.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 306,
//               type: "text",
//               content: "DR/CR:",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 281.5400085449219,
//                 width: 20.113510131835938,
//                 height: 6.4227294921875,
//                 bbox: [
//                   191.10000610351562, 281.5400085449219, 211.21351623535156,
//                   287.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 307,
//               type: "text",
//               content: "OTC",
//               coordinates: {
//                 x: 540.53125,
//                 y: 246.4399871826172,
//                 width: 12.12677001953125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   540.53125, 246.4399871826172, 552.6580200195312,
//                   252.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 308,
//               type: "text",
//               content: "COLL",
//               coordinates: {
//                 x: 576.9000244140625,
//                 y: 268.6400146484375,
//                 width: 15.0133056640625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   576.9000244140625, 268.6400146484375, 591.913330078125,
//                   275.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 309,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 525.2999877929688,
//                 y: 268.6400146484375,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.2999877929688, 268.6400146484375, 528.4970092773438,
//                   275.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 310,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 525.2999877929688,
//                 y: 256.6400146484375,
//                 width: 3.197021484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.2999877929688, 256.6400146484375, 528.4970092773438,
//                   263.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 311,
//               type: "text",
//               content: "C OF L",
//               coordinates: {
//                 x: 573.2999877929688,
//                 y: 246.4399871826172,
//                 width: 18.50933837890625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   573.2999877929688, 246.4399871826172, 591.809326171875,
//                   252.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 312,
//               type: "text",
//               content: "SPEC",
//               coordinates: {
//                 x: 573.2999877929688,
//                 y: 241.04002380371094,
//                 width: 15.64007568359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   573.2999877929688, 241.04002380371094, 588.9400634765625,
//                   247.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 313,
//               type: "text",
//               content: "COMP/",
//               coordinates: {
//                 x: 537.17626953125,
//                 y: 240.4399871826172,
//                 width: 18.831298828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   537.17626953125, 240.4399871826172, 556.007568359375,
//                   246.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 314,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 443.1000061035156,
//                 y: 268.6400146484375,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   443.1000061035156, 268.6400146484375, 446.2969970703125,
//                   275.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 315,
//               type: "text",
//               content: "ST AMT",
//               coordinates: {
//                 x: 493.5,
//                 y: 256.6400146484375,
//                 width: 20.63677978515625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   493.5, 256.6400146484375, 514.1367797851562, 263.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 316,
//               type: "text",
//               content: "AA",
//               coordinates: {
//                 x: 457.5,
//                 y: 256.6400146484375,
//                 width: 7.65899658203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   457.5, 256.6400146484375, 465.15899658203125, 263.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 317,
//               type: "text",
//               content: "ACV",
//               coordinates: {
//                 x: 507.8999938964844,
//                 y: 244.63999938964844,
//                 width: 11.810516357421875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   507.8999938964844, 244.63999938964844, 519.7105102539062,
//                   251.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 318,
//               type: "text",
//               content: "DEDUCTIBLES",
//               coordinates: {
//                 x: 443.1000061035156,
//                 y: 241.9399871826172,
//                 width: 40.85369873046875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   443.1000061035156, 241.9399871826172, 483.9537048339844,
//                   248.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 319,
//               type: "text",
//               content: "SYM / AGE",
//               coordinates: {
//                 x: 503.6499938964844,
//                 y: 170.54002380371094,
//                 width: 29.463104248046875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   503.6499938964844, 170.54002380371094, 533.1130981445312,
//                   176.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 320,
//               type: "text",
//               content: "V.I.N.:",
//               coordinates: {
//                 x: 241.5,
//                 y: 184.3400115966797,
//                 width: 15.74346923828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   241.5, 184.3400115966797, 257.24346923828125,
//                   190.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 321,
//               type: "text",
//               content: "TYPE:",
//               coordinates: {
//                 x: 241.5,
//                 y: 173.54002380371094,
//                 width: 16.9107666015625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   241.5, 173.54002380371094, 258.4107666015625,
//                   179.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 322,
//               type: "text",
//               content: "BODY",
//               coordinates: {
//                 x: 241.5,
//                 y: 168.13999938964844,
//                 width: 16.600250244140625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   241.5, 168.13999938964844, 258.1002502441406, 174.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 323,
//               type: "text",
//               content: "MODEL:",
//               coordinates: {
//                 x: 83.0999984741211,
//                 y: 184.3400115966797,
//                 width: 22.660743713378906,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   83.0999984741211, 184.3400115966797, 105.7607421875,
//                   190.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 324,
//               type: "text",
//               content: "MAKE:",
//               coordinates: {
//                 x: 83.0999984741211,
//                 y: 172.3400115966797,
//                 width: 18.836990356445312,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   83.0999984741211, 172.3400115966797, 101.9369888305664,
//                   178.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 325,
//               type: "text",
//               content: "YEAR",
//               coordinates: {
//                 x: 56.8125,
//                 y: 169.9399871826172,
//                 width: 15.961990356445312,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   56.8125, 169.9399871826172, 72.77449035644531,
//                   176.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 326,
//               type: "text",
//               content: "VEH #",
//               coordinates: {
//                 x: 25.891250610351562,
//                 y: 169.9399871826172,
//                 width: 16.600250244140625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   25.891250610351562, 169.9399871826172, 42.49150085449219,
//                   176.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 327,
//               type: "text",
//               content: "PP",
//               coordinates: {
//                 x: 403.5,
//                 y: 182.8400115966797,
//                 width: 7.65899658203125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   403.5, 182.8400115966797, 411.15899658203125,
//                   189.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 328,
//               type: "text",
//               content: "SPEC",
//               coordinates: {
//                 x: 435.8999938964844,
//                 y: 182.8400115966797,
//                 width: 15.639984130859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   435.8999938964844, 182.8400115966797, 451.53997802734375,
//                   189.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 329,
//               type: "text",
//               content: "COML",
//               coordinates: {
//                 x: 475.5,
//                 y: 182.8400115966797,
//                 width: 16.605987548828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   475.5, 182.8400115966797, 492.1059875488281,
//                   189.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 330,
//               type: "text",
//               content: "VEHICLE TYPE",
//               coordinates: {
//                 x: 422.3324890136719,
//                 y: 170.54002380371094,
//                 width: 41.48046875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   422.3324890136719, 170.54002380371094, 463.8129577636719,
//                   176.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 331,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 518.7000122070312,
//                 y: 111.43998718261719,
//                 width: 3.197021484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   518.7000122070312, 111.43998718261719, 521.8970336914062,
//                   117.86273956298828
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 332,
//               type: "text",
//               content: "COST NEW",
//               coordinates: {
//                 x: 537.407470703125,
//                 y: 98.54002380371094,
//                 width: 30.95233154296875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   537.407470703125, 98.54002380371094, 568.3598022460938,
//                   104.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 333,
//               type: "text",
//               content: "SYM",
//               coordinates: {
//                 x: 573.6699829101562,
//                 y: 53.54002380371094,
//                 width: 12.44879150390625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   573.6699829101562, 53.54002380371094, 586.1187744140625,
//                   59.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 334,
//               type: "text",
//               content: "COLL",
//               coordinates: {
//                 x: 572.0750122070312,
//                 y: 48.13999938964844,
//                 width: 15.63427734375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   572.0750122070312, 48.13999938964844, 587.7092895507812,
//                   54.56275177001953
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 335,
//               type: "text",
//               content: "OTC SYM",
//               coordinates: {
//                 x: 537.7025146484375,
//                 y: 53.54002380371094,
//                 width: 26.1683349609375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   537.7025146484375, 53.54002380371094, 563.870849609375,
//                   59.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 336,
//               type: "text",
//               content: "COMP /",
//               coordinates: {
//                 x: 540.9287719726562,
//                 y: 48.13999938964844,
//                 width: 20.320556640625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   540.9287719726562, 48.13999938964844, 561.2493286132812,
//                   54.56275177001953
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 337,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 486.29998779296875,
//                 y: 161.23997497558594,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   486.29998779296875, 161.23997497558594, 489.4969787597656,
//                   167.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 338,
//               type: "text",
//               content: "TOTAL PREM:",
//               coordinates: {
//                 x: 443.1000061035156,
//                 y: 160.9399871826172,
//                 width: 38.617034912109375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   443.1000061035156, 160.9399871826172, 481.717041015625,
//                   167.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 339,
//               type: "text",
//               content: "OTC",
//               coordinates: {
//                 x: 367.5,
//                 y: 137.8400115966797,
//                 width: 12.126739501953125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   367.5, 137.8400115966797, 379.6267395019531,
//                   144.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 340,
//               type: "text",
//               content: "FG",
//               coordinates: {
//                 x: 407.1000061035156,
//                 y: 134.8400115966797,
//                 width: 7.975250244140625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   407.1000061035156, 134.8400115966797, 415.07525634765625,
//                   141.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 341,
//               type: "text",
//               content: "REIMB",
//               coordinates: {
//                 x: 407.1000061035156,
//                 y: 126.43998718261719,
//                 width: 18.1929931640625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   407.1000061035156, 126.43998718261719, 425.2929992675781,
//                   132.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 342,
//               type: "text",
//               content: "RENT",
//               coordinates: {
//                 x: 407.1000061035156,
//                 y: 120.43998718261719,
//                 width: 15.639984130859375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   407.1000061035156, 120.43998718261719, 422.739990234375,
//                   126.86273956298828
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 343,
//               type: "text",
//               content: "COLL",
//               coordinates: {
//                 x: 367.5,
//                 y: 146.8400115966797,
//                 width: 15.013214111328125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   367.5, 146.8400115966797, 382.5132141113281,
//                   153.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 344,
//               type: "text",
//               content: "COMP/",
//               coordinates: {
//                 x: 367.5,
//                 y: 132.4399871826172,
//                 width: 18.83123779296875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   367.5, 132.4399871826172, 386.33123779296875,
//                   138.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 345,
//               type: "text",
//               content: "LSP",
//               coordinates: {
//                 x: 367.5,
//                 y: 122.84001159667969,
//                 width: 10.855987548828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   367.5, 122.84001159667969, 378.3559875488281,
//                   129.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 346,
//               type: "text",
//               content: "FTW",
//               coordinates: {
//                 x: 331.5,
//                 y: 146.8400115966797,
//                 width: 12.437255859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   331.5, 146.8400115966797, 343.937255859375, 153.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 347,
//               type: "text",
//               content: "FT",
//               coordinates: {
//                 x: 331.5,
//                 y: 134.8400115966797,
//                 width: 7.0150146484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   331.5, 134.8400115966797, 338.5150146484375,
//                   141.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 348,
//               type: "text",
//               content: "F",
//               coordinates: {
//                 x: 331.5,
//                 y: 122.84001159667969,
//                 width: 3.50750732421875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   331.5, 122.84001159667969, 335.00750732421875,
//                   129.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 349,
//               type: "text",
//               content: "C OF L",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 150.4399871826172,
//                 width: 18.50921630859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   281.1000061035156, 150.4399871826172, 299.6092224121094,
//                   156.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 350,
//               type: "text",
//               content: "SPEC",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 145.04002380371094,
//                 width: 15.639984130859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   281.1000061035156, 145.04002380371094, 296.739990234375,
//                   151.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 351,
//               type: "text",
//               content: "& LABOR",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 138.4399871826172,
//                 width: 24.8974609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   281.1000061035156, 138.4399871826172, 305.9974670410156,
//                   144.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 352,
//               type: "text",
//               content: "TOWING",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 133.04002380371094,
//                 width: 23.5059814453125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   281.1000061035156, 133.04002380371094, 304.6059875488281,
//                   139.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 353,
//               type: "text",
//               content: "MOTOR",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 126.43998718261719,
//                 width: 21.28076171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   281.1000061035156, 126.43998718261719, 302.3807678222656,
//                   132.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 354,
//               type: "text",
//               content: "UNDRINS",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 121.04002380371094,
//                 width: 26.1796875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   281.1000061035156, 121.04002380371094, 307.2796936035156,
//                   127.46277618408203
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 355,
//               type: "text",
//               content: "MOTOR",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 150.4399871826172,
//                 width: 21.280746459960938,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   230.6999969482422, 150.4399871826172, 251.98074340820312,
//                   156.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 356,
//               type: "text",
//               content: "UNINS",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 145.04002380371094,
//                 width: 17.876754760742188,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   230.6999969482422, 145.04002380371094, 248.57675170898438,
//                   151.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 357,
//               type: "text",
//               content: "MED PAY",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 136.63999938964844,
//                 width: 25.0009765625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   230.6999969482422, 136.63999938964844, 255.7009735107422,
//                   143.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 358,
//               type: "text",
//               content: "FAULT",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 126.43998718261719,
//                 width: 17.451263427734375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   230.6999969482422, 126.43998718261719, 248.15126037597656,
//                   132.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 359,
//               type: "text",
//               content: "ADD'L NO-",
//               coordinates: {
//                 x: 230.6999969482422,
//                 y: 121.04002380371094,
//                 width: 28.336013793945312,
//                 height: 6.422752380371094,
//                 bbox: [
//                   230.6999969482422, 121.04002380371094, 259.0360107421875,
//                   127.46277618408203
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 360,
//               type: "text",
//               content: "FAULT",
//               coordinates: {
//                 x: 187.5,
//                 y: 150.4399871826172,
//                 width: 17.451263427734375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   187.5, 150.4399871826172, 204.95126342773438,
//                   156.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 361,
//               type: "text",
//               content: "NO-",
//               coordinates: {
//                 x: 187.5,
//                 y: 145.04002380371094,
//                 width: 10.53399658203125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   187.5, 145.04002380371094, 198.03399658203125,
//                   151.4627685546875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 362,
//               type: "text",
//               content: "LIAB",
//               coordinates: {
//                 x: 187.5,
//                 y: 136.63999938964844,
//                 width: 12.448745727539062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   187.5, 136.63999938964844, 199.94874572753906,
//                   143.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 363,
//               type: "text",
//               content: "COVERAGES",
//               coordinates: {
//                 x: 173.10000610351562,
//                 y: 125.54002380371094,
//                 width: 36.70799255371094,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   173.10000610351562, 125.54002380371094, 209.80799865722656,
//                   131.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 364,
//               type: "text",
//               content: "CHECK",
//               coordinates: {
//                 x: 173.10000610351562,
//                 y: 120.13999938964844,
//                 width: 20.435516357421875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   173.10000610351562, 120.13999938964844, 193.5355224609375,
//                   126.56275177001953
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 365,
//               type: "text",
//               content: "FOR HIRE",
//               coordinates: {
//                 x: 137.10000610351562,
//                 y: 122.84001159667969,
//                 width: 27.444747924804688,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   137.10000610351562, 122.84001159667969, 164.5447540283203,
//                   129.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 366,
//               type: "text",
//               content: "SERVICE",
//               coordinates: {
//                 x: 90.30000305175781,
//                 y: 146.8400115966797,
//                 width: 25.11023712158203,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   90.30000305175781, 146.8400115966797, 115.41024017333984,
//                   153.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 367,
//               type: "text",
//               content: "RETAIL",
//               coordinates: {
//                 x: 90.30000305175781,
//                 y: 134.8400115966797,
//                 width: 19.68224334716797,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   90.30000305175781, 134.8400115966797, 109.98224639892578,
//                   141.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 368,
//               type: "text",
//               content: "COMM'L",
//               coordinates: {
//                 x: 90.30000305175781,
//                 y: 122.84001159667969,
//                 width: 22.488243103027344,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   90.30000305175781, 122.84001159667969, 112.78824615478516,
//                   129.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 369,
//               type: "text",
//               content: "FARM",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 146.8400115966797,
//                 width: 15.961997985839844,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 146.8400115966797, 52.26199722290039,
//                   153.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 370,
//               type: "text",
//               content: "PLEASURE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 134.8400115966797,
//                 width: 30.64749526977539,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 134.8400115966797, 66.94749450683594,
//                   141.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 371,
//               type: "text",
//               content: "USE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 122.54002380371094,
//                 width: 11.81049919128418,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 122.54002380371094, 33.71049880981445,
//                   128.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 372,
//               type: "text",
//               content: "15 MILES +",
//               coordinates: {
//                 x: 147.89999389648438,
//                 y: 158.8400115966797,
//                 width: 30.170242309570312,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   147.89999389648438, 158.8400115966797, 178.0702362060547,
//                   165.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 373,
//               type: "text",
//               content: "< 15 MILES",
//               coordinates: {
//                 x: 93.9000015258789,
//                 y: 158.8400115966797,
//                 width: 30.170242309570312,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   93.9000015258789, 158.8400115966797, 124.07024383544922,
//                   165.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 374,
//               type: "text",
//               content: "WORK / SCHOOL",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 161.54002380371094,
//                 width: 47.54675483703613,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 161.54002380371094, 69.4467544555664,
//                   167.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 375,
//               type: "text",
//               content: "DRIVE TO",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 156.13999938964844,
//                 width: 27.019250869750977,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 156.13999938964844, 48.91925048828125,
//                   162.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 376,
//               type: "text",
//               content: "ZIP",
//               coordinates: {
//                 x: 543.9000244140625,
//                 y: 74.54002380371094,
//                 width: 8.9298095703125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   543.9000244140625, 74.54002380371094, 552.829833984375,
//                   80.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 377,
//               type: "text",
//               content: "STATE",
//               coordinates: {
//                 x: 515.0999755859375,
//                 y: 74.54002380371094,
//                 width: 17.974609375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   515.0999755859375, 74.54002380371094, 533.0745849609375,
//                   80.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 378,
//               type: "text",
//               content: "COUNTY",
//               coordinates: {
//                 x: 363.8999938964844,
//                 y: 74.54002380371094,
//                 width: 24.25921630859375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   363.8999938964844, 74.54002380371094, 388.1592102050781,
//                   80.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 379,
//               type: "text",
//               content: "CITY",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 74.54002380371094,
//                 width: 13.081253051757812,
//                 height: 6.422752380371094,
//                 bbox: [
//                   212.6999969482422, 74.54002380371094, 225.78125,
//                   80.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 380,
//               type: "text",
//               content: "STREET (Required in KY)",
//               coordinates: {
//                 x: 61.5,
//                 y: 74.54002380371094,
//                 width: 69.24148559570312,
//                 height: 6.422752380371094,
//                 bbox: [
//                   61.5, 74.54002380371094, 130.74148559570312, 80.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 381,
//               type: "text",
//               content: "GARAGING",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 76.93998718261719,
//                 width: 31.60200309753418,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 76.93998718261719, 53.50200271606445,
//                   83.36273956298828
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 382,
//               type: "text",
//               content: "ADDRESS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 84.13999938964844,
//                 width: 28.09449577331543,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 84.13999938964844, 49.9944953918457,
//                   90.56275177001953
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 383,
//               type: "text",
//               content: "STATE",
//               coordinates: {
//                 x: 21.903749465942383,
//                 y: 101.54002380371094,
//                 width: 17.974496841430664,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.903749465942383, 101.54002380371094, 39.87824630737305,
//                   107.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 384,
//               type: "text",
//               content: "LIC",
//               coordinates: {
//                 x: 25.96875,
//                 y: 96.13999938964844,
//                 width: 9.251750946044922,
//                 height: 6.422752380371094,
//                 bbox: [
//                   25.96875, 96.13999938964844, 35.22050094604492,
//                   102.56275177001953
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 385,
//               type: "text",
//               content: "TERR",
//               coordinates: {
//                 x: 64.17375183105469,
//                 y: 98.54002380371094,
//                 width: 15.639991760253906,
//                 height: 6.422752380371094,
//                 bbox: [
//                   64.17375183105469, 98.54002380371094, 79.8137435913086,
//                   104.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 386,
//               type: "text",
//               content: "GVW / GCW",
//               coordinates: {
//                 x: 122.61000061035156,
//                 y: 98.54002380371094,
//                 width: 32.53924560546875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   122.61000061035156, 98.54002380371094, 155.1492462158203,
//                   104.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 387,
//               type: "text",
//               content: "CLASS",
//               coordinates: {
//                 x: 195.4562530517578,
//                 y: 98.54002380371094,
//                 width: 19.469512939453125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   195.4562530517578, 98.54002380371094, 214.92576599121094,
//                   104.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 388,
//               type: "text",
//               content: "SIC",
//               coordinates: {
//                 x: 251.1074981689453,
//                 y: 98.54002380371094,
//                 width: 9.573745727539062,
//                 height: 6.422752380371094,
//                 bbox: [
//                   251.1074981689453, 98.54002380371094, 260.6812438964844,
//                   104.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 389,
//               type: "text",
//               content: "FACTOR",
//               coordinates: {
//                 x: 290.6337585449219,
//                 y: 98.54002380371094,
//                 width: 23.517486572265625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   290.6337585449219, 98.54002380371094, 314.1512451171875,
//                   104.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 390,
//               type: "text",
//               content: "SEAT CP",
//               coordinates: {
//                 x: 326.4537353515625,
//                 y: 98.54002380371094,
//                 width: 24.466217041015625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   326.4537353515625, 98.54002380371094, 350.9199523925781,
//                   104.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 391,
//               type: "text",
//               content: "RADIUS",
//               coordinates: {
//                 x: 359.77874755859375,
//                 y: 98.54002380371094,
//                 width: 22.0281982421875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   359.77874755859375, 98.54002380371094, 381.80694580078125,
//                   104.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 392,
//               type: "text",
//               content: "FARTHEST TERMINAL",
//               coordinates: {
//                 x: 419.4750061035156,
//                 y: 98.54002380371094,
//                 width: 61.593963623046875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   419.4750061035156, 98.54002380371094, 481.0689697265625,
//                   104.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 393,
//               type: "text",
//               content: "NET VEH",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 156.13999938964844,
//                 width: 24.891754150390625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   191.10000610351562, 156.13999938964844, 215.99176025390625,
//                   162.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 394,
//               type: "text",
//               content: "DR/CR:",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 161.54002380371094,
//                 width: 20.113510131835938,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   191.10000610351562, 161.54002380371094, 211.21351623535156,
//                   167.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 395,
//               type: "text",
//               content: "OTC",
//               coordinates: {
//                 x: 540.53125,
//                 y: 126.43998718261719,
//                 width: 12.12677001953125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   540.53125, 126.43998718261719, 552.6580200195312,
//                   132.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 396,
//               type: "text",
//               content: "COLL",
//               coordinates: {
//                 x: 576.9000244140625,
//                 y: 148.63999938964844,
//                 width: 15.0133056640625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   576.9000244140625, 148.63999938964844, 591.913330078125,
//                   155.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 397,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 525.2999877929688,
//                 y: 148.63999938964844,
//                 width: 3.197021484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   525.2999877929688, 148.63999938964844, 528.4970092773438,
//                   155.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 398,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 525.2999877929688,
//                 y: 136.63999938964844,
//                 width: 3.197021484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   525.2999877929688, 136.63999938964844, 528.4970092773438,
//                   143.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 399,
//               type: "text",
//               content: "C OF L",
//               coordinates: {
//                 x: 573.2999877929688,
//                 y: 126.43998718261719,
//                 width: 18.50933837890625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   573.2999877929688, 126.43998718261719, 591.809326171875,
//                   132.86273193359375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 400,
//               type: "text",
//               content: "SPEC",
//               coordinates: {
//                 x: 573.2999877929688,
//                 y: 121.04002380371094,
//                 width: 15.64007568359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   573.2999877929688, 121.04002380371094, 588.9400634765625,
//                   127.46277618408203
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 401,
//               type: "text",
//               content: "COMP/",
//               coordinates: {
//                 x: 537.17626953125,
//                 y: 120.43998718261719,
//                 width: 18.831298828125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   537.17626953125, 120.43998718261719, 556.007568359375,
//                   126.86273956298828
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 402,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 443.1000061035156,
//                 y: 148.63999938964844,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   443.1000061035156, 148.63999938964844, 446.2969970703125,
//                   155.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 403,
//               type: "text",
//               content: "ST AMT",
//               coordinates: {
//                 x: 493.5,
//                 y: 136.63999938964844,
//                 width: 20.63677978515625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   493.5, 136.63999938964844, 514.1367797851562, 143.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 404,
//               type: "text",
//               content: "AA",
//               coordinates: {
//                 x: 457.5,
//                 y: 136.63999938964844,
//                 width: 7.65899658203125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   457.5, 136.63999938964844, 465.15899658203125,
//                   143.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 405,
//               type: "text",
//               content: "ACV",
//               coordinates: {
//                 x: 507.8999938964844,
//                 y: 124.63999938964844,
//                 width: 11.810516357421875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   507.8999938964844, 124.63999938964844, 519.7105102539062,
//                   131.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 406,
//               type: "text",
//               content: "DEDUCTIBLES",
//               coordinates: {
//                 x: 443.1000061035156,
//                 y: 121.93998718261719,
//                 width: 40.85369873046875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   443.1000061035156, 121.93998718261719, 483.9537048339844,
//                   128.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 407,
//               type: "text",
//               content: "SYM / AGE",
//               coordinates: {
//                 x: 503.6499938964844,
//                 y: 50.54002380371094,
//                 width: 29.463104248046875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   503.6499938964844, 50.54002380371094, 533.1130981445312,
//                   56.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 408,
//               type: "text",
//               content: "V.I.N.:",
//               coordinates: {
//                 x: 241.5,
//                 y: 64.34001159667969,
//                 width: 15.74346923828125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   241.5, 64.34001159667969, 257.24346923828125,
//                   70.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 409,
//               type: "text",
//               content: "TYPE:",
//               coordinates: {
//                 x: 241.5,
//                 y: 53.54002380371094,
//                 width: 16.9107666015625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   241.5, 53.54002380371094, 258.4107666015625, 59.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 410,
//               type: "text",
//               content: "BODY",
//               coordinates: {
//                 x: 241.5,
//                 y: 48.13999938964844,
//                 width: 16.600250244140625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   241.5, 48.13999938964844, 258.1002502441406, 54.56275177001953
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 411,
//               type: "text",
//               content: "MODEL:",
//               coordinates: {
//                 x: 83.0999984741211,
//                 y: 64.34001159667969,
//                 width: 22.660743713378906,
//                 height: 6.422752380371094,
//                 bbox: [
//                   83.0999984741211, 64.34001159667969, 105.7607421875,
//                   70.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 412,
//               type: "text",
//               content: "MAKE:",
//               coordinates: {
//                 x: 83.0999984741211,
//                 y: 52.34001159667969,
//                 width: 18.836990356445312,
//                 height: 6.422752380371094,
//                 bbox: [
//                   83.0999984741211, 52.34001159667969, 101.9369888305664,
//                   58.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 413,
//               type: "text",
//               content: "YEAR",
//               coordinates: {
//                 x: 56.8125,
//                 y: 49.93998718261719,
//                 width: 15.961990356445312,
//                 height: 6.422752380371094,
//                 bbox: [
//                   56.8125, 49.93998718261719, 72.77449035644531,
//                   56.36273956298828
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 414,
//               type: "text",
//               content: "VEH #",
//               coordinates: {
//                 x: 25.891250610351562,
//                 y: 49.93998718261719,
//                 width: 16.600250244140625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   25.891250610351562, 49.93998718261719, 42.49150085449219,
//                   56.36273956298828
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 415,
//               type: "text",
//               content: "PP",
//               coordinates: {
//                 x: 403.5,
//                 y: 62.84001159667969,
//                 width: 7.65899658203125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   403.5, 62.84001159667969, 411.15899658203125,
//                   69.26276397705078
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 416,
//               type: "text",
//               content: "SPEC",
//               coordinates: {
//                 x: 435.8999938964844,
//                 y: 62.84001159667969,
//                 width: 15.639984130859375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   435.8999938964844, 62.84001159667969, 451.53997802734375,
//                   69.26276397705078
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 417,
//               type: "text",
//               content: "COML",
//               coordinates: {
//                 x: 475.5,
//                 y: 62.84001159667969,
//                 width: 16.605987548828125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   475.5, 62.84001159667969, 492.1059875488281, 69.26276397705078
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 418,
//               type: "text",
//               content: "VEHICLE TYPE",
//               coordinates: {
//                 x: 422.3324890136719,
//                 y: 50.54002380371094,
//                 width: 41.48046875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   422.3324890136719, 50.54002380371094, 463.8129577636719,
//                   56.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 419,
//               type: "text",
//               content: "VEHICLE DESCRIPTION",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 38.98002624511719,
//                 width: 88.60575294494629,
//                 height: 8.656749725341797,
//                 bbox: [
//                   21.899999618530273, 38.98002624511719, 110.50575256347656,
//                   47.636775970458984
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 420,
//               type: "text",
//               content: "ACORD 127 (2015/12)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 757.780029296875,
//                 width: 78.78650093078613,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 757.780029296875, 100.6865005493164,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 35.98909421387464,
//                 width: 577.4399999999999,
//                 height: 492.81066343532257,
//                 bbox: [
//                   17.52, 35.98909421387464, 594.9599999999999, 528.7997576491972
//                 ]
//               },
//               properties: {
//                 rows: 33,
//                 columns: 55,
//                 accuracy: 64.64
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 421,
//           table_count: 1,
//           total_elements: 422
//         }
//       },
//       {
//         page_number: 11,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 382.79998779296875,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   382.79998779296875, 25.188751220703125, 415.04803466796875,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content:
//                 "THE UNDERSIGNED IS AN AUTHORIZED REPRESENTATIVE OF THE APPLICANT AND REPRESENTS THAT REASONABLE INQUIRY HAS BEEN MADE TO OBTAIN THE",
//               coordinates: {
//                 x: 25.5,
//                 y: 680.760009765625,
//                 width: 525.885986328125,
//                 height: 7.539794921875,
//                 bbox: [25.5, 680.760009765625, 551.385986328125, 688.2998046875]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content:
//                 "ANSWERS TO QUESTIONS ON THIS APPLICATION.  HE/SHE REPRESENTS THAT THE ANSWERS ARE TRUE, CORRECT AND COMPLETE TO THE BEST OF HIS/HER",
//               coordinates: {
//                 x: 25.5,
//                 y: 689.1599731445312,
//                 width: 522.3692626953125,
//                 height: 7.539794921875,
//                 bbox: [
//                   25.5, 689.1599731445312, 547.8692626953125, 696.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "KNOWLEDGE.",
//               coordinates: {
//                 x: 25.5,
//                 y: 696.9599609375,
//                 width: 45.71099853515625,
//                 height: 7.539794921875,
//                 bbox: [
//                   25.5, 696.9599609375, 71.21099853515625, 704.499755859375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "Page 4 of 4",
//               coordinates: {
//                 x: 285.84124755859375,
//                 y: 757.780029296875,
//                 width: 40.873504638671875,
//                 height: 8.65673828125,
//                 bbox: [
//                   285.84124755859375, 757.780029296875, 326.7147521972656,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "NATIONAL PRODUCER NUMBER",
//               coordinates: {
//                 x: 498.646240234375,
//                 y: 734.5400390625,
//                 width: 90.447509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   498.646240234375, 734.5400390625, 589.09375, 740.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "(Required in Florida)",
//               coordinates: {
//                 x: 497.1000061035156,
//                 y: 713.5400390625,
//                 width: 56.154693603515625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   497.1000061035156, 713.5400390625, 553.2546997070312,
//                   719.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "PRODUCER'S SIGNATURE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 710.5400390625,
//                 width: 73.07673835754395,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 710.5400390625, 94.97673797607422,
//                   716.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "DATE",
//               coordinates: {
//                 x: 425.1000061035156,
//                 y: 734.5400390625,
//                 width: 15.2144775390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   425.1000061035156, 734.5400390625, 440.3144836425781,
//                   740.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "APPLICANT'S SIGNATURE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 734.5400390625,
//                 width: 73.06524085998535,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 734.5400390625, 94.96524047851562,
//                   740.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "PRODUCER'S NAME (Please Print)",
//               coordinates: {
//                 x: 259.5,
//                 y: 711.1400146484375,
//                 width: 94.89791870117188,
//                 height: 6.4227294921875,
//                 bbox: [
//                   259.5, 711.1400146484375, 354.3979187011719, 717.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "STATE PRODUCER LICENSE NO",
//               coordinates: {
//                 x: 497.1000061035156,
//                 y: 708.1400146484375,
//                 width: 89.14822387695312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   497.1000061035156, 708.1400146484375, 586.2482299804688,
//                   714.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "SIGNATURE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 32.37998962402344,
//                 width: 45.02750587463379,
//                 height: 8.656749725341797,
//                 bbox: [
//                   21.899999618530273, 32.37998962402344, 66.92750549316406,
//                   41.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 281.1000061035156,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   281.1000061035156, 26.379987716674805, 372.88323974609375,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "Applicable in NJ",
//               coordinates: {
//                 x: 25.5,
//                 y: 385.17999267578125,
//                 width: 60.21751403808594,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 385.17999267578125, 85.71751403808594, 393.8367614746094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content:
//                 "Any person who includes any false or misleading information on an application for an insurance policy is subject to criminal and civil penalties.",
//               coordinates: {
//                 x: 25.5,
//                 y: 397.17999267578125,
//                 width: 485.61474609375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 397.17999267578125, 511.11474609375, 405.8367614746094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "Applicable in PR",
//               coordinates: {
//                 x: 25.5,
//                 y: 460.17999267578125,
//                 width: 61.07001495361328,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 460.17999267578125, 86.57001495361328, 468.8367614746094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content:
//                 "Any person who knowingly and with the intention of defrauding presents false information in an insurance application, or presents, helps, or causes the",
//               coordinates: {
//                 x: 25.5,
//                 y: 472.17999267578125,
//                 width: 515.7545776367188,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 472.17999267578125, 541.2545776367188, 480.8367614746094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content:
//                 "presentation of a fraudulent claim for the payment of a loss or any other benefit, or presents more than one claim for the same damage or loss, shall incur a",
//               coordinates: {
//                 x: 25.5,
//                 y: 481.17999267578125,
//                 width: 531.6189575195312,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 481.17999267578125, 557.1189575195312, 489.8367614746094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content:
//                 "felony and, upon conviction, shall be sanctioned for each violation by a fine of not less than five thousand dollars ($5,000) and not more than ten thousand",
//               coordinates: {
//                 x: 25.5,
//                 y: 490.17999267578125,
//                 width: 527.3875122070312,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 490.17999267578125, 552.8875122070312, 498.8367614746094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content:
//                 "dollars ($10,000), or a fixed term of imprisonment for three (3) years, or both penalties.  Should aggravating circumstances [be] present, the penalty thus",
//               coordinates: {
//                 x: 25.5,
//                 y: 499.7799987792969,
//                 width: 521.2881469726562,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 499.7799987792969, 546.7881469726562, 508.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content:
//                 "established may be increased to a maximum of five (5) years, if extenuating circumstances are present, it may be reduced to a minimum of two (2) years.",
//               coordinates: {
//                 x: 25.5,
//                 y: 508.7799987792969,
//                 width: 524.2872924804688,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 508.7799987792969, 549.7872924804688, 517.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "Applicable in OR",
//               coordinates: {
//                 x: 25.5,
//                 y: 418.17999267578125,
//                 width: 61.930267333984375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 418.17999267578125, 87.43026733398438, 426.8367614746094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content:
//                 "Any person who knowingly and with intent to defraud or solicit another to defraud the insurer by submitting an application containing a false statement as to",
//               coordinates: {
//                 x: 25.5,
//                 y: 431.97998046875,
//                 width: 530.78955078125,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 431.97998046875, 556.28955078125, 440.6367492675781
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "any material fact may be violating state law.",
//               coordinates: {
//                 x: 25.5,
//                 y: 440.97998046875,
//                 width: 149.35800170898438,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 440.97998046875, 174.85800170898438, 449.6367492675781
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content: "Applicable in ME, TN, VA and WA",
//               coordinates: {
//                 x: 25.5,
//                 y: 343.17999267578125,
//                 width: 121.27200317382812,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 343.17999267578125, 146.77200317382812,
//                   351.8367614746094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content:
//                 "It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of defrauding the company.  Penalties",
//               coordinates: {
//                 x: 25.5,
//                 y: 356.97998046875,
//                 width: 535.3854370117188,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 356.97998046875, 560.8854370117188, 365.6367492675781
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content:
//                 "(may)* include imprisonment, fines and denial of insurance benefits.  *Applies in ME Only.",
//               coordinates: {
//                 x: 25.5,
//                 y: 365.97998046875,
//                 width: 306.77606201171875,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 365.97998046875, 332.27606201171875, 374.6367492675781
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content: "Applicable in KY, NY, OH and PA",
//               coordinates: {
//                 x: 25.5,
//                 y: 283.17999267578125,
//                 width: 118.5672607421875,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 283.17999267578125, 144.0672607421875, 291.8367614746094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content:
//                 "Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim",
//               coordinates: {
//                 x: 25.5,
//                 y: 296.3799743652344,
//                 width: 506.2763671875,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 296.3799743652344, 531.7763671875, 305.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content:
//                 "containing any materially false information or conceals for the purpose of misleading, information concerning any fact material thereto commits a fraudulent",
//               coordinates: {
//                 x: 25.5,
//                 y: 305.97998046875,
//                 width: 529.9293823242188,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 305.97998046875, 555.4293823242188, 314.6367492675781
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content:
//                 "insurance act, which is a crime and subjects such person to criminal and civil penalties* (not to exceed five thousand dollars and the stated value of the claim",
//               coordinates: {
//                 x: 25.5,
//                 y: 314.97998046875,
//                 width: 537.2531127929688,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 314.97998046875, 562.7531127929688, 323.6367492675781
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content: "for each such violation)*. *Applies in NY Only.",
//               coordinates: {
//                 x: 25.5,
//                 y: 323.97998046875,
//                 width: 155.96099853515625,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 323.97998046875, 181.46099853515625, 332.6367492675781
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content: "Applicable in KS",
//               coordinates: {
//                 x: 25.5,
//                 y: 211.1799774169922,
//                 width: 61.07001495361328,
//                 height: 8.656753540039062,
//                 bbox: [
//                   25.5, 211.1799774169922, 86.57001495361328, 219.83673095703125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content:
//                 "Any person who, knowingly and with intent to defraud, presents, causes to be presented or prepares with knowledge or belief that it will be presented to or by",
//               coordinates: {
//                 x: 25.5,
//                 y: 226.1799774169922,
//                 width: 537.6715087890625,
//                 height: 8.656753540039062,
//                 bbox: [
//                   25.5, 226.1799774169922, 563.1715087890625, 234.83673095703125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content:
//                 "an insurer, purported insurer, broker or any agent thereof, any written statement as part of, or in support of, an application for the issuance of, or the rating of",
//               coordinates: {
//                 x: 25.5,
//                 y: 235.1799774169922,
//                 width: 534.6104125976562,
//                 height: 8.656753540039062,
//                 bbox: [
//                   25.5, 235.1799774169922, 560.1104125976562, 243.83673095703125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content:
//                 "an insurance policy for personal or commercial insurance, or a claim for payment or other benefit pursuant to an insurance policy for commercial or personal",
//               coordinates: {
//                 x: 25.5,
//                 y: 244.1799774169922,
//                 width: 534.2540283203125,
//                 height: 8.656753540039062,
//                 bbox: [
//                   25.5, 244.1799774169922, 559.7540283203125, 252.83673095703125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content:
//                 "insurance which such person knows to contain materially false information concerning any fact material thereto; or conceals, for the purpose of misleading,",
//               coordinates: {
//                 x: 25.5,
//                 y: 253.78001403808594,
//                 width: 529.510986328125,
//                 height: 8.656753540039062,
//                 bbox: [
//                   25.5, 253.78001403808594, 555.010986328125, 262.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content:
//                 "information concerning any fact material thereto commits a fraudulent insurance act.",
//               coordinates: {
//                 x: 25.5,
//                 y: 262.7799987792969,
//                 width: 287.989990234375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 262.7799987792969, 313.489990234375, 271.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content: "Applicable in FL and OK",
//               coordinates: {
//                 x: 25.5,
//                 y: 169.1799774169922,
//                 width: 89.30326843261719,
//                 height: 8.656753540039062,
//                 bbox: [
//                   25.5, 169.1799774169922, 114.80326843261719,
//                   177.83673095703125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content:
//                 "Any person who knowingly and with intent to injure, defraud, or deceive any insurer files a statement of claim or an application containing any false,",
//               coordinates: {
//                 x: 25.5,
//                 y: 179.9800262451172,
//                 width: 503.66455078125,
//                 height: 8.656753540039062,
//                 bbox: [
//                   25.5, 179.9800262451172, 529.16455078125, 188.63677978515625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content:
//                 "incomplete, or misleading information is guilty of a felony (of the third degree)*.  *Applies in FL Only.",
//               coordinates: {
//                 x: 25.5,
//                 y: 188.9800262451172,
//                 width: 340.8914489746094,
//                 height: 8.656753540039062,
//                 bbox: [
//                   25.5, 188.9800262451172, 366.3914489746094, 197.63677978515625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content: "Applicable in CO",
//               coordinates: {
//                 x: 25.5,
//                 y: 97.17997741699219,
//                 width: 61.930267333984375,
//                 height: 8.656745910644531,
//                 bbox: [
//                   25.5, 97.17997741699219, 87.43026733398438, 105.83672332763672
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content:
//                 "Any person who knowingly (or willfully)* presents a false or fraudulent claim for payment of a loss or benefit or knowingly (or willfully)* presents false",
//               coordinates: {
//                 x: 25.5,
//                 y: 65.98002624511719,
//                 width: 506.20660400390625,
//                 height: 8.656745910644531,
//                 bbox: [
//                   25.5, 65.98002624511719, 531.7066040039062, 74.63677215576172
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content:
//                 "information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison.  *Applies in MD Only.",
//               coordinates: {
//                 x: 25.5,
//                 y: 74.98002624511719,
//                 width: 471.63385009765625,
//                 height: 8.656745910644531,
//                 bbox: [
//                   25.5, 74.98002624511719, 497.13385009765625, 83.63677215576172
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content:
//                 "It is unlawful to knowingly provide false, incomplete, or misleading facts or information to an insurance company for the purpose of defrauding or attempting to",
//               coordinates: {
//                 x: 25.5,
//                 y: 109.17997741699219,
//                 width: 539.8106079101562,
//                 height: 8.656745910644531,
//                 bbox: [
//                   25.5, 109.17997741699219, 565.3106079101562,
//                   117.83672332763672
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content:
//                 "defraud the company.  Penalties may include imprisonment, fines, denial of insurance and civil damages.  Any insurance company or agent of an insurance",
//               coordinates: {
//                 x: 25.5,
//                 y: 118.17997741699219,
//                 width: 531.1229248046875,
//                 height: 8.656745910644531,
//                 bbox: [
//                   25.5, 118.17997741699219, 556.6229248046875,
//                   126.83672332763672
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content:
//                 "company who knowingly provides false, incomplete, or misleading facts or information to a policyholder or claimant for the purpose of defrauding or",
//               coordinates: {
//                 x: 25.5,
//                 y: 127.17997741699219,
//                 width: 503.25384521484375,
//                 height: 8.656753540039062,
//                 bbox: [
//                   25.5, 127.17997741699219, 528.7538452148438,
//                   135.83673095703125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content:
//                 "attempting to defraud the policyholder or claimant with regard to a settlement or award payable from insurance proceeds shall be reported to the Colorado",
//               coordinates: {
//                 x: 25.5,
//                 y: 136.78001403808594,
//                 width: 526.93798828125,
//                 height: 8.656753540039062,
//                 bbox: [
//                   25.5, 136.78001403808594, 552.43798828125, 145.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content:
//                 "Division of Insurance within the Department of Regulatory Agencies.",
//               coordinates: {
//                 x: 25.5,
//                 y: 145.78001403808594,
//                 width: 233.32156372070312,
//                 height: 8.656753540039062,
//                 bbox: [
//                   25.5, 145.78001403808594, 258.8215637207031, 154.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content: "Applicable in AL, AR, DC, LA, MD, NM, RI and WV",
//               coordinates: {
//                 x: 25.5,
//                 y: 55.17997741699219,
//                 width: 180.90045166015625,
//                 height: 8.656749725341797,
//                 bbox: [
//                   25.5, 55.17997741699219, 206.40045166015625,
//                   63.836727142333984
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content: "ACORD 127 (2015/12)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 757.780029296875,
//                 width: 78.78650093078613,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 757.780029296875, 100.6865005493164,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 41.26749469857623,
//                 width: 577.4399999999999,
//                 height: 715.4631929718266,
//                 bbox: [
//                   17.52, 41.26749469857623, 594.9599999999999, 756.7306876704029
//                 ]
//               },
//               properties: {
//                 rows: 4,
//                 columns: 4,
//                 accuracy: 63.5
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 52,
//           table_count: 1,
//           total_elements: 53
//         }
//       },
//       {
//         page_number: 12,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 415.20001220703125,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   415.20001220703125, 25.188751220703125, 447.44805908203125,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "UIS Insurance & Investments",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 73.18875122070312,
//                 width: 93.81499099731445,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 73.18875122070312, 116.614990234375,
//                   81.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "25-26",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 97.18875122070312,
//                 width: 18.538253784179688,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 97.18875122070312, 41.338253021240234,
//                   105.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "05/18/2025",
//               coordinates: {
//                 x: 259.3550109863281,
//                 y: 97.18875122070312,
//                 width: 36.2645263671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   259.3550109863281, 97.18875122070312, 295.6195373535156,
//                   105.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "Submissions",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 73.18875122070312,
//                 width: 41.08575439453125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 73.18875122070312, 351.8857421875,
//                   81.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "Buckeye Premier Cleaning, LLC",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 97.18875122070312,
//                 width: 103.10223388671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 97.18875122070312, 413.9022216796875,
//                   105.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "Business Auto ENDT",
//               coordinates: {
//                 x: 199.1999969482422,
//                 y: 133.18875122070312,
//                 width: 67.64256286621094,
//                 height: 8.098251342773438,
//                 bbox: [
//                   199.1999969482422, 133.18875122070312, 266.8425598144531,
//                   141.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "EFFECTIVE DATE",
//               coordinates: {
//                 x: 252.97500610351562,
//                 y: 86.54002380371094,
//                 width: 48.3919677734375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   252.97500610351562, 86.54002380371094, 301.3669738769531,
//                   92.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "NAMED INSURED(S)",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 86.54002380371094,
//                 width: 56.183197021484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   309.8999938964844, 86.54002380371094, 366.08319091796875,
//                   92.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "POLICY NUMBER",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 86.54002380371094,
//                 width: 48.09299659729004,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 86.54002380371094, 69.99299621582031,
//                   92.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "NAIC CODE",
//               coordinates: {
//                 x: 547.5,
//                 y: 62.54002380371094,
//                 width: 32.24029541015625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   547.5, 62.54002380371094, 579.7402954101562, 68.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "CARRIER",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 61.17997741699219,
//                 width: 35.28570556640625,
//                 height: 8.656745910644531,
//                 bbox: [
//                   309.8999938964844, 61.17997741699219, 345.1856994628906,
//                   69.83672332763672
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "AGENCY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 62.54002380371094,
//                 width: 24.58125114440918,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 62.54002380371094, 46.48125076293945,
//                   68.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "FORM NAME",
//               coordinates: {
//                 x: 299.37249755859375,
//                 y: 124.93998718261719,
//                 width: 35.431488037109375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   299.37249755859375, 124.93998718261719, 334.8039855957031,
//                   131.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "ITEM #",
//               coordinates: {
//                 x: 100.83499908447266,
//                 y: 124.93998718261719,
//                 width: 18.509246826171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   100.83499908447266, 124.93998718261719, 119.34424591064453,
//                   131.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "BOAT #",
//               coordinates: {
//                 x: 74.27124786376953,
//                 y: 124.93998718261719,
//                 width: 20.642494201660156,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   74.27124786376953, 124.93998718261719, 94.91374206542969,
//                   131.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "VEH #",
//               coordinates: {
//                 x: 51.091251373291016,
//                 y: 124.93998718261719,
//                 width: 16.60024642944336,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   51.091251373291016, 124.93998718261719, 67.69149780273438,
//                   131.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "FORMS AND ENDORSEMENTS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 110.37998962402344,
//                 width: 114.14972877502441,
//                 height: 8.656745910644531,
//                 bbox: [
//                   21.899999618530273, 110.37998962402344, 136.0497283935547,
//                   119.03673553466797
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "LOC #",
//               coordinates: {
//                 x: 23.93375015258789,
//                 y: 124.93998718261719,
//                 width: 16.916500091552734,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   23.93375015258789, 124.93998718261719, 40.850250244140625,
//                   131.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "FORM NUMBER",
//               coordinates: {
//                 x: 136.82000732421875,
//                 y: 124.93998718261719,
//                 width: 43.73451232910156,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   136.82000732421875, 124.93998718261719, 180.5545196533203,
//                   131.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "EDITION DATE",
//               coordinates: {
//                 x: 442.8287353515625,
//                 y: 124.93998718261719,
//                 width: 40.100433349609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   442.8287353515625, 124.93998718261719, 482.9291687011719,
//                   131.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content: "COPYRIGHT OWNER CODE",
//               coordinates: {
//                 x: 501.9849853515625,
//                 y: 124.93998718261719,
//                 width: 75.9576416015625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   501.9849853515625, 124.93998718261719, 577.942626953125,
//                   131.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "ACORD 829 (2009/05)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 745.780029296875,
//                 width: 78.78650093078613,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 745.780029296875, 100.6865005493164,
//                   754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "The ACORD name and logo are registered marks of ACORD",
//               coordinates: {
//                 x: 196.4737548828125,
//                 y: 757.780029296875,
//                 width: 218.86770629882812,
//                 height: 8.65673828125,
//                 bbox: [
//                   196.4737548828125, 757.780029296875, 415.3414611816406,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "© 2009 ACORD CORPORATION.  All rights reserved.",
//               coordinates: {
//                 x: 397.4375,
//                 y: 745.780029296875,
//                 width: 191.293212890625,
//                 height: 8.65673828125,
//                 bbox: [
//                   397.4375, 745.780029296875, 588.730712890625, 754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content: "of",
//               coordinates: {
//                 x: 560.0999755859375,
//                 y: 42.5000114440918,
//                 width: 8.25128173828125,
//                 height: 9.773750305175781,
//                 bbox: [
//                   560.0999755859375, 42.5000114440918, 568.3512573242188,
//                   52.27376174926758
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 8.75,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: "Page",
//               coordinates: {
//                 x: 511.5,
//                 y: 42.5000114440918,
//                 width: 20.89501953125,
//                 height: 9.773750305175781,
//                 bbox: [
//                   511.5, 42.5000114440918, 532.39501953125, 52.27376174926758
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 8.75,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content: "FORMS AND ENDORSEMENTS SCHEDULE",
//               coordinates: {
//                 x: 157.72999572753906,
//                 y: 39.701271057128906,
//                 width: 281.90245056152344,
//                 height: 15.358749389648438,
//                 bbox: [
//                   157.72999572753906, 39.701271057128906, 439.6324462890625,
//                   55.060020446777344
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 13.75,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 317.1000061035156,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   317.1000061035156, 26.379987716674805, 408.88323974609375,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 59.26204180551349,
//                 width: 577.68,
//                 height: 49.4250227203878,
//                 bbox: [
//                   17.28, 59.26204180551349, 594.9599999999999,
//                   108.68706452590129
//                 ]
//               },
//               properties: {
//                 rows: 2,
//                 columns: 4,
//                 accuracy: 100
//               }
//             },
//             {
//               id: 1,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 119.24386549530448,
//                 width: 577.4399999999999,
//                 height: 625.4904574371402,
//                 bbox: [
//                   17.52, 119.24386549530448, 594.9599999999999,
//                   744.7343229324447
//                 ]
//               },
//               properties: {
//                 rows: 52,
//                 columns: 8,
//                 accuracy: 100
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 29,
//           table_count: 2,
//           total_elements: 31
//         }
//       },
//       {
//         page_number: 13,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 49.4640007019043,
//                 y: 67.45272827148438,
//                 width: 10.867752075195312,
//                 height: 8.098251342773438,
//                 bbox: [
//                   49.4640007019043, 67.45272827148438, 60.33175277709961,
//                   75.55097961425781
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "HRDBD",
//               coordinates: {
//                 x: 70.14450073242188,
//                 y: 67.45272827148438,
//                 width: 26.1724853515625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   70.14450073242188, 67.45272827148438, 96.31698608398438,
//                   75.55097961425781
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "Hired/borrowed",
//               coordinates: {
//                 x: 108,
//                 y: 67.45272827148438,
//                 width: 53.51951599121094,
//                 height: 8.098251342773438,
//                 bbox: [
//                   108, 67.45272827148438, 161.51951599121094, 75.55097961425781
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "Hired/Borrowed",
//               coordinates: {
//                 x: 220.46400451660156,
//                 y: 67.45272827148438,
//                 width: 54.33146667480469,
//                 height: 8.098251342773438,
//                 bbox: [
//                   220.46400451660156, 67.45272827148438, 274.79547119140625,
//                   75.55097961425781
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "1,000,000",
//               coordinates: {
//                 x: 27,
//                 y: 89.98873901367188,
//                 width: 32.23351287841797,
//                 height: 8.098251342773438,
//                 bbox: [
//                   27, 89.98873901367188, 59.23351287841797, 98.08699035644531
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 49.4640007019043,
//                 y: 121.45272827148438,
//                 width: 10.867752075195312,
//                 height: 8.098251342773438,
//                 bbox: [
//                   49.4640007019043, 121.45272827148438, 60.33175277709961,
//                   129.5509796142578
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "NOWND",
//               coordinates: {
//                 x: 69.13825225830078,
//                 y: 121.45272827148438,
//                 width: 28.173484802246094,
//                 height: 8.098251342773438,
//                 bbox: [
//                   69.13825225830078, 121.45272827148438, 97.31173706054688,
//                   129.5509796142578
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "Non-owned",
//               coordinates: {
//                 x: 108,
//                 y: 121.45272827148438,
//                 width: 39.425506591796875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   108, 121.45272827148438, 147.42550659179688, 129.5509796142578
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "Non-Owned",
//               coordinates: {
//                 x: 220.46400451660156,
//                 y: 121.45272827148438,
//                 width: 40.63624572753906,
//                 height: 8.098251342773438,
//                 bbox: [
//                   220.46400451660156, 121.45272827148438, 261.1002502441406,
//                   129.5509796142578
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "1,000,000",
//               coordinates: {
//                 x: 27,
//                 y: 143.98873901367188,
//                 width: 32.23351287841797,
//                 height: 8.098251342773438,
//                 bbox: [
//                   27, 143.98873901367188, 59.23351287841797, 152.0869903564453
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "ADDITIONAL COVERAGES AND ENDORSEMENTS",
//               coordinates: {
//                 x: 157.5240020751953,
//                 y: 30.991981506347656,
//                 width: 281.1186981201172,
//                 height: 13.124752044677734,
//                 bbox: [
//                   157.5240020751953, 30.991981506347656, 438.6427001953125,
//                   44.11673355102539
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 11.75,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "Loc #",
//               coordinates: {
//                 x: 23.964000701904297,
//                 y: 161.9440155029297,
//                 width: 18.948753356933594,
//                 height: 8.656753540039062,
//                 bbox: [
//                   23.964000701904297, 161.9440155029297, 42.91275405883789,
//                   170.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "Cov Code",
//               coordinates: {
//                 x: 65.50800323486328,
//                 y: 161.9440155029297,
//                 width: 34.44873809814453,
//                 height: 8.656753540039062,
//                 bbox: [
//                   65.50800323486328, 161.9440155029297, 99.95674133300781,
//                   170.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "Description",
//               coordinates: {
//                 x: 108.05999755859375,
//                 y: 161.9440155029297,
//                 width: 38.75001525878906,
//                 height: 8.656753540039062,
//                 bbox: [
//                   108.05999755859375, 161.9440155029297, 146.8100128173828,
//                   170.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "Type of Coverage",
//               coordinates: {
//                 x: 220.5240020751953,
//                 y: 161.9440155029297,
//                 width: 61.13969421386719,
//                 height: 8.656753540039062,
//                 bbox: [
//                   220.5240020751953, 161.9440155029297, 281.6636962890625,
//                   170.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "Form No.",
//               coordinates: {
//                 x: 360.05999755859375,
//                 y: 161.9440155029297,
//                 width: 32.27099609375,
//                 height: 8.656753540039062,
//                 bbox: [
//                   360.05999755859375, 161.9440155029297, 392.33099365234375,
//                   170.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "Edition Date",
//               coordinates: {
//                 x: 407.94000244140625,
//                 y: 161.9440155029297,
//                 width: 42.183197021484375,
//                 height: 8.656753540039062,
//                 bbox: [
//                   407.94000244140625, 161.9440155029297, 450.1231994628906,
//                   170.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "ST",
//               coordinates: {
//                 x: 48.948001861572266,
//                 y: 161.9440155029297,
//                 width: 9.888999938964844,
//                 height: 8.656753540039062,
//                 bbox: [
//                   48.948001861572266, 161.9440155029297, 58.83700180053711,
//                   170.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "Limit 1",
//               coordinates: {
//                 x: 27.059999465942383,
//                 y: 184.4080047607422,
//                 width: 22.808256149291992,
//                 height: 8.656753540039062,
//                 bbox: [
//                   27.059999465942383, 184.4080047607422, 49.868255615234375,
//                   193.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "Limit 2",
//               coordinates: {
//                 x: 90.05999755859375,
//                 y: 184.4080047607422,
//                 width: 22.808242797851562,
//                 height: 8.656753540039062,
//                 bbox: [
//                   90.05999755859375, 184.4080047607422, 112.86824035644531,
//                   193.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "Limit 3",
//               coordinates: {
//                 x: 153.05999755859375,
//                 y: 184.4080047607422,
//                 width: 22.808258056640625,
//                 height: 8.656753540039062,
//                 bbox: [
//                   153.05999755859375, 184.4080047607422, 175.86825561523438,
//                   193.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content: "Ded 1",
//               coordinates: {
//                 x: 216.05999755859375,
//                 y: 184.4080047607422,
//                 width: 20.669265747070312,
//                 height: 8.656753540039062,
//                 bbox: [
//                   216.05999755859375, 184.4080047607422, 236.72926330566406,
//                   193.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "Deductible Type 1",
//               coordinates: {
//                 x: 265.59600830078125,
//                 y: 184.4080047607422,
//                 width: 61.860443115234375,
//                 height: 8.656753540039062,
//                 bbox: [
//                   265.59600830078125, 184.4080047607422, 327.4564514160156,
//                   193.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "Ded 2",
//               coordinates: {
//                 x: 373.6679992675781,
//                 y: 184.4080047607422,
//                 width: 20.669219970703125,
//                 height: 8.656753540039062,
//                 bbox: [
//                   373.6679992675781, 184.4080047607422, 394.33721923828125,
//                   193.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "Deductible Type 2",
//               coordinates: {
//                 x: 423.05999755859375,
//                 y: 184.4080047607422,
//                 width: 61.860443115234375,
//                 height: 8.656753540039062,
//                 bbox: [
//                   423.05999755859375, 184.4080047607422, 484.9204406738281,
//                   193.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content: "Rate",
//               coordinates: {
//                 x: 459.05999755859375,
//                 y: 161.9440155029297,
//                 width: 16.3602294921875,
//                 height: 8.656753540039062,
//                 bbox: [
//                   459.05999755859375, 161.9440155029297, 475.42022705078125,
//                   170.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: "Premium",
//               coordinates: {
//                 x: 530.9879760742188,
//                 y: 184.4080047607422,
//                 width: 30.9923095703125,
//                 height: 8.656753540039062,
//                 bbox: [
//                   530.9879760742188, 184.4080047607422, 561.9802856445312,
//                   193.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content: "Option Codes",
//               coordinates: {
//                 x: 508.59600830078125,
//                 y: 162.01597595214844,
//                 width: 47.3603515625,
//                 height: 8.656753540039062,
//                 bbox: [
//                   508.59600830078125, 162.01597595214844, 555.9563598632812,
//                   170.6727294921875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content: "Loc # ST",
//               coordinates: {
//                 x: 23.964000701904297,
//                 y: 53.94401550292969,
//                 width: 34.87300109863281,
//                 height: 8.656749725341797,
//                 bbox: [
//                   23.964000701904297, 53.94401550292969, 58.83700180053711,
//                   62.600765228271484
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content: "Cov Code",
//               coordinates: {
//                 x: 65.50800323486328,
//                 y: 53.94401550292969,
//                 width: 34.44873809814453,
//                 height: 8.656749725341797,
//                 bbox: [
//                   65.50800323486328, 53.94401550292969, 99.95674133300781,
//                   62.600765228271484
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content: "Description",
//               coordinates: {
//                 x: 108.05999755859375,
//                 y: 53.94401550292969,
//                 width: 38.75001525878906,
//                 height: 8.656749725341797,
//                 bbox: [
//                   108.05999755859375, 53.94401550292969, 146.8100128173828,
//                   62.600765228271484
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content: "Type of Coverage",
//               coordinates: {
//                 x: 220.5240020751953,
//                 y: 53.94401550292969,
//                 width: 61.13969421386719,
//                 height: 8.656749725341797,
//                 bbox: [
//                   220.5240020751953, 53.94401550292969, 281.6636962890625,
//                   62.600765228271484
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content: "Form No.",
//               coordinates: {
//                 x: 360.05999755859375,
//                 y: 53.94401550292969,
//                 width: 32.27099609375,
//                 height: 8.656749725341797,
//                 bbox: [
//                   360.05999755859375, 53.94401550292969, 392.33099365234375,
//                   62.600765228271484
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content: "Edition Date",
//               coordinates: {
//                 x: 407.94000244140625,
//                 y: 53.94401550292969,
//                 width: 42.183197021484375,
//                 height: 8.656749725341797,
//                 bbox: [
//                   407.94000244140625, 53.94401550292969, 450.1231994628906,
//                   62.600765228271484
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content: "Rate",
//               coordinates: {
//                 x: 459.05999755859375,
//                 y: 53.94401550292969,
//                 width: 16.3602294921875,
//                 height: 8.656749725341797,
//                 bbox: [
//                   459.05999755859375, 53.94401550292969, 475.42022705078125,
//                   62.600765228271484
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content: "Option Codes",
//               coordinates: {
//                 x: 508.59600830078125,
//                 y: 54.01597595214844,
//                 width: 47.3603515625,
//                 height: 8.656749725341797,
//                 bbox: [
//                   508.59600830078125, 54.01597595214844, 555.9563598632812,
//                   62.672725677490234
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content: "Limit 1",
//               coordinates: {
//                 x: 27.059999465942383,
//                 y: 76.40800476074219,
//                 width: 22.808256149291992,
//                 height: 8.656745910644531,
//                 bbox: [
//                   27.059999465942383, 76.40800476074219, 49.868255615234375,
//                   85.06475067138672
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content: "Limit 2",
//               coordinates: {
//                 x: 90.05999755859375,
//                 y: 76.40800476074219,
//                 width: 22.808242797851562,
//                 height: 8.656745910644531,
//                 bbox: [
//                   90.05999755859375, 76.40800476074219, 112.86824035644531,
//                   85.06475067138672
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content: "Limit 3",
//               coordinates: {
//                 x: 153.05999755859375,
//                 y: 76.40800476074219,
//                 width: 22.808258056640625,
//                 height: 8.656745910644531,
//                 bbox: [
//                   153.05999755859375, 76.40800476074219, 175.86825561523438,
//                   85.06475067138672
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content: "Ded 1",
//               coordinates: {
//                 x: 216.05999755859375,
//                 y: 76.40800476074219,
//                 width: 20.669265747070312,
//                 height: 8.656745910644531,
//                 bbox: [
//                   216.05999755859375, 76.40800476074219, 236.72926330566406,
//                   85.06475067138672
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content: "Deductible Type 1",
//               coordinates: {
//                 x: 265.59600830078125,
//                 y: 76.40800476074219,
//                 width: 61.860443115234375,
//                 height: 8.656745910644531,
//                 bbox: [
//                   265.59600830078125, 76.40800476074219, 327.4564514160156,
//                   85.06475067138672
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content: "Ded 2",
//               coordinates: {
//                 x: 373.6679992675781,
//                 y: 76.40800476074219,
//                 width: 20.669219970703125,
//                 height: 8.656745910644531,
//                 bbox: [
//                   373.6679992675781, 76.40800476074219, 394.33721923828125,
//                   85.06475067138672
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content: "Deductible Type 2",
//               coordinates: {
//                 x: 423.05999755859375,
//                 y: 76.40800476074219,
//                 width: 61.860443115234375,
//                 height: 8.656745910644531,
//                 bbox: [
//                   423.05999755859375, 76.40800476074219, 484.9204406738281,
//                   85.06475067138672
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content: "Premium",
//               coordinates: {
//                 x: 531.0599975585938,
//                 y: 76.40800476074219,
//                 width: 30.9923095703125,
//                 height: 8.656745910644531,
//                 bbox: [
//                   531.0599975585938, 76.40800476074219, 562.0523071289062,
//                   85.06475067138672
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content: "Loc # ST",
//               coordinates: {
//                 x: 23.964000701904297,
//                 y: 107.94401550292969,
//                 width: 34.87300109863281,
//                 height: 8.656745910644531,
//                 bbox: [
//                   23.964000701904297, 107.94401550292969, 58.83700180053711,
//                   116.60076141357422
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content: "Cov Code",
//               coordinates: {
//                 x: 65.50800323486328,
//                 y: 107.94401550292969,
//                 width: 34.44873809814453,
//                 height: 8.656745910644531,
//                 bbox: [
//                   65.50800323486328, 107.94401550292969, 99.95674133300781,
//                   116.60076141357422
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content: "Description",
//               coordinates: {
//                 x: 108.05999755859375,
//                 y: 107.94401550292969,
//                 width: 38.75001525878906,
//                 height: 8.656745910644531,
//                 bbox: [
//                   108.05999755859375, 107.94401550292969, 146.8100128173828,
//                   116.60076141357422
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content: "Type of Coverage",
//               coordinates: {
//                 x: 220.5240020751953,
//                 y: 107.94401550292969,
//                 width: 61.13969421386719,
//                 height: 8.656745910644531,
//                 bbox: [
//                   220.5240020751953, 107.94401550292969, 281.6636962890625,
//                   116.60076141357422
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content: "Form No.",
//               coordinates: {
//                 x: 360.05999755859375,
//                 y: 107.94401550292969,
//                 width: 32.27099609375,
//                 height: 8.656745910644531,
//                 bbox: [
//                   360.05999755859375, 107.94401550292969, 392.33099365234375,
//                   116.60076141357422
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content: "Edition Date",
//               coordinates: {
//                 x: 407.94000244140625,
//                 y: 107.94401550292969,
//                 width: 42.183197021484375,
//                 height: 8.656745910644531,
//                 bbox: [
//                   407.94000244140625, 107.94401550292969, 450.1231994628906,
//                   116.60076141357422
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content: "Rate",
//               coordinates: {
//                 x: 459.05999755859375,
//                 y: 107.94401550292969,
//                 width: 16.3602294921875,
//                 height: 8.656745910644531,
//                 bbox: [
//                   459.05999755859375, 107.94401550292969, 475.42022705078125,
//                   116.60076141357422
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content: "Option Codes",
//               coordinates: {
//                 x: 508.59600830078125,
//                 y: 108.01597595214844,
//                 width: 47.3603515625,
//                 height: 8.656745910644531,
//                 bbox: [
//                   508.59600830078125, 108.01597595214844, 555.9563598632812,
//                   116.67272186279297
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 52,
//               type: "text",
//               content: "Limit 1",
//               coordinates: {
//                 x: 27.059999465942383,
//                 y: 130.4080047607422,
//                 width: 22.808256149291992,
//                 height: 8.656753540039062,
//                 bbox: [
//                   27.059999465942383, 130.4080047607422, 49.868255615234375,
//                   139.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 53,
//               type: "text",
//               content: "Limit 2",
//               coordinates: {
//                 x: 90.05999755859375,
//                 y: 130.4080047607422,
//                 width: 22.808242797851562,
//                 height: 8.656753540039062,
//                 bbox: [
//                   90.05999755859375, 130.4080047607422, 112.86824035644531,
//                   139.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 54,
//               type: "text",
//               content: "Limit 3",
//               coordinates: {
//                 x: 153.05999755859375,
//                 y: 130.4080047607422,
//                 width: 22.808258056640625,
//                 height: 8.656753540039062,
//                 bbox: [
//                   153.05999755859375, 130.4080047607422, 175.86825561523438,
//                   139.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 55,
//               type: "text",
//               content: "Ded 1",
//               coordinates: {
//                 x: 216.05999755859375,
//                 y: 130.4080047607422,
//                 width: 20.669265747070312,
//                 height: 8.656753540039062,
//                 bbox: [
//                   216.05999755859375, 130.4080047607422, 236.72926330566406,
//                   139.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 56,
//               type: "text",
//               content: "Deductible Type 1",
//               coordinates: {
//                 x: 265.59600830078125,
//                 y: 130.4080047607422,
//                 width: 61.860443115234375,
//                 height: 8.656753540039062,
//                 bbox: [
//                   265.59600830078125, 130.4080047607422, 327.4564514160156,
//                   139.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 57,
//               type: "text",
//               content: "Ded 2",
//               coordinates: {
//                 x: 373.6679992675781,
//                 y: 130.4080047607422,
//                 width: 20.669219970703125,
//                 height: 8.656753540039062,
//                 bbox: [
//                   373.6679992675781, 130.4080047607422, 394.33721923828125,
//                   139.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 58,
//               type: "text",
//               content: "Deductible Type 2",
//               coordinates: {
//                 x: 423.05999755859375,
//                 y: 130.4080047607422,
//                 width: 61.860443115234375,
//                 height: 8.656753540039062,
//                 bbox: [
//                   423.05999755859375, 130.4080047607422, 484.9204406738281,
//                   139.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 59,
//               type: "text",
//               content: "Premium",
//               coordinates: {
//                 x: 530.9879760742188,
//                 y: 130.4080047607422,
//                 width: 30.9923095703125,
//                 height: 8.656753540039062,
//                 bbox: [
//                   530.9879760742188, 130.4080047607422, 561.9802856445312,
//                   139.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 60,
//               type: "text",
//               content: "Loc # ST",
//               coordinates: {
//                 x: 23.964000701904297,
//                 y: 215.9440155029297,
//                 width: 34.87300109863281,
//                 height: 8.656753540039062,
//                 bbox: [
//                   23.964000701904297, 215.9440155029297, 58.83700180053711,
//                   224.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 61,
//               type: "text",
//               content: "Cov Code",
//               coordinates: {
//                 x: 65.50800323486328,
//                 y: 215.9440155029297,
//                 width: 34.44873809814453,
//                 height: 8.656753540039062,
//                 bbox: [
//                   65.50800323486328, 215.9440155029297, 99.95674133300781,
//                   224.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 62,
//               type: "text",
//               content: "Description",
//               coordinates: {
//                 x: 108.05999755859375,
//                 y: 215.9440155029297,
//                 width: 38.75001525878906,
//                 height: 8.656753540039062,
//                 bbox: [
//                   108.05999755859375, 215.9440155029297, 146.8100128173828,
//                   224.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 63,
//               type: "text",
//               content: "Type of Coverage",
//               coordinates: {
//                 x: 220.5240020751953,
//                 y: 215.9440155029297,
//                 width: 61.13969421386719,
//                 height: 8.656753540039062,
//                 bbox: [
//                   220.5240020751953, 215.9440155029297, 281.6636962890625,
//                   224.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 64,
//               type: "text",
//               content: "Form No.",
//               coordinates: {
//                 x: 360.05999755859375,
//                 y: 215.9440155029297,
//                 width: 32.27099609375,
//                 height: 8.656753540039062,
//                 bbox: [
//                   360.05999755859375, 215.9440155029297, 392.33099365234375,
//                   224.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 65,
//               type: "text",
//               content: "Edition Date",
//               coordinates: {
//                 x: 407.94000244140625,
//                 y: 215.9440155029297,
//                 width: 42.183197021484375,
//                 height: 8.656753540039062,
//                 bbox: [
//                   407.94000244140625, 215.9440155029297, 450.1231994628906,
//                   224.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 66,
//               type: "text",
//               content: "Rate",
//               coordinates: {
//                 x: 459.05999755859375,
//                 y: 215.9440155029297,
//                 width: 16.3602294921875,
//                 height: 8.656753540039062,
//                 bbox: [
//                   459.05999755859375, 215.9440155029297, 475.42022705078125,
//                   224.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 67,
//               type: "text",
//               content: "Option Codes",
//               coordinates: {
//                 x: 508.59600830078125,
//                 y: 216.01597595214844,
//                 width: 47.3603515625,
//                 height: 8.656753540039062,
//                 bbox: [
//                   508.59600830078125, 216.01597595214844, 555.9563598632812,
//                   224.6727294921875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 68,
//               type: "text",
//               content: "Limit 1",
//               coordinates: {
//                 x: 27.059999465942383,
//                 y: 238.4080047607422,
//                 width: 22.808256149291992,
//                 height: 8.656753540039062,
//                 bbox: [
//                   27.059999465942383, 238.4080047607422, 49.868255615234375,
//                   247.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 69,
//               type: "text",
//               content: "Limit 2",
//               coordinates: {
//                 x: 90.05999755859375,
//                 y: 238.4080047607422,
//                 width: 22.808242797851562,
//                 height: 8.656753540039062,
//                 bbox: [
//                   90.05999755859375, 238.4080047607422, 112.86824035644531,
//                   247.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 70,
//               type: "text",
//               content: "Limit 3",
//               coordinates: {
//                 x: 153.05999755859375,
//                 y: 238.4080047607422,
//                 width: 22.808258056640625,
//                 height: 8.656753540039062,
//                 bbox: [
//                   153.05999755859375, 238.4080047607422, 175.86825561523438,
//                   247.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 71,
//               type: "text",
//               content: "Ded 1",
//               coordinates: {
//                 x: 216.05999755859375,
//                 y: 238.4080047607422,
//                 width: 20.669265747070312,
//                 height: 8.656753540039062,
//                 bbox: [
//                   216.05999755859375, 238.4080047607422, 236.72926330566406,
//                   247.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 72,
//               type: "text",
//               content: "Deductible Type 1",
//               coordinates: {
//                 x: 265.59600830078125,
//                 y: 238.4080047607422,
//                 width: 61.860443115234375,
//                 height: 8.656753540039062,
//                 bbox: [
//                   265.59600830078125, 238.4080047607422, 327.4564514160156,
//                   247.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 73,
//               type: "text",
//               content: "Ded 2",
//               coordinates: {
//                 x: 373.6679992675781,
//                 y: 238.4080047607422,
//                 width: 20.669219970703125,
//                 height: 8.656753540039062,
//                 bbox: [
//                   373.6679992675781, 238.4080047607422, 394.33721923828125,
//                   247.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 74,
//               type: "text",
//               content: "Deductible Type 2",
//               coordinates: {
//                 x: 423.05999755859375,
//                 y: 238.4080047607422,
//                 width: 61.860443115234375,
//                 height: 8.656753540039062,
//                 bbox: [
//                   423.05999755859375, 238.4080047607422, 484.9204406738281,
//                   247.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 75,
//               type: "text",
//               content: "Premium",
//               coordinates: {
//                 x: 530.9879760742188,
//                 y: 238.4080047607422,
//                 width: 30.9923095703125,
//                 height: 8.656753540039062,
//                 bbox: [
//                   530.9879760742188, 238.4080047607422, 561.9802856445312,
//                   247.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 76,
//               type: "text",
//               content: "Loc # ST",
//               coordinates: {
//                 x: 23.964000701904297,
//                 y: 269.9440002441406,
//                 width: 34.87300109863281,
//                 height: 8.656768798828125,
//                 bbox: [
//                   23.964000701904297, 269.9440002441406, 58.83700180053711,
//                   278.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 77,
//               type: "text",
//               content: "Cov Code",
//               coordinates: {
//                 x: 65.50800323486328,
//                 y: 269.9440002441406,
//                 width: 34.44873809814453,
//                 height: 8.656768798828125,
//                 bbox: [
//                   65.50800323486328, 269.9440002441406, 99.95674133300781,
//                   278.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 78,
//               type: "text",
//               content: "Description",
//               coordinates: {
//                 x: 108.05999755859375,
//                 y: 269.9440002441406,
//                 width: 38.75001525878906,
//                 height: 8.656768798828125,
//                 bbox: [
//                   108.05999755859375, 269.9440002441406, 146.8100128173828,
//                   278.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 79,
//               type: "text",
//               content: "Type of Coverage",
//               coordinates: {
//                 x: 220.5240020751953,
//                 y: 269.9440002441406,
//                 width: 61.13969421386719,
//                 height: 8.656768798828125,
//                 bbox: [
//                   220.5240020751953, 269.9440002441406, 281.6636962890625,
//                   278.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 80,
//               type: "text",
//               content: "Form No.",
//               coordinates: {
//                 x: 360.05999755859375,
//                 y: 269.9440002441406,
//                 width: 32.27099609375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   360.05999755859375, 269.9440002441406, 392.33099365234375,
//                   278.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 81,
//               type: "text",
//               content: "Edition Date",
//               coordinates: {
//                 x: 407.94000244140625,
//                 y: 269.9440002441406,
//                 width: 42.183197021484375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   407.94000244140625, 269.9440002441406, 450.1231994628906,
//                   278.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 82,
//               type: "text",
//               content: "Rate",
//               coordinates: {
//                 x: 459.05999755859375,
//                 y: 269.9440002441406,
//                 width: 16.3602294921875,
//                 height: 8.656768798828125,
//                 bbox: [
//                   459.05999755859375, 269.9440002441406, 475.42022705078125,
//                   278.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 83,
//               type: "text",
//               content: "Option Codes",
//               coordinates: {
//                 x: 508.59600830078125,
//                 y: 270.0159606933594,
//                 width: 47.3603515625,
//                 height: 8.656768798828125,
//                 bbox: [
//                   508.59600830078125, 270.0159606933594, 555.9563598632812,
//                   278.6727294921875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 84,
//               type: "text",
//               content: "Limit 1",
//               coordinates: {
//                 x: 27.059999465942383,
//                 y: 292.4079895019531,
//                 width: 22.808256149291992,
//                 height: 8.656768798828125,
//                 bbox: [
//                   27.059999465942383, 292.4079895019531, 49.868255615234375,
//                   301.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 85,
//               type: "text",
//               content: "Limit 2",
//               coordinates: {
//                 x: 90.05999755859375,
//                 y: 292.4079895019531,
//                 width: 22.808242797851562,
//                 height: 8.656768798828125,
//                 bbox: [
//                   90.05999755859375, 292.4079895019531, 112.86824035644531,
//                   301.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 86,
//               type: "text",
//               content: "Limit 3",
//               coordinates: {
//                 x: 153.05999755859375,
//                 y: 292.4079895019531,
//                 width: 22.808258056640625,
//                 height: 8.656768798828125,
//                 bbox: [
//                   153.05999755859375, 292.4079895019531, 175.86825561523438,
//                   301.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 87,
//               type: "text",
//               content: "Ded 1",
//               coordinates: {
//                 x: 216.05999755859375,
//                 y: 292.4079895019531,
//                 width: 20.669265747070312,
//                 height: 8.656768798828125,
//                 bbox: [
//                   216.05999755859375, 292.4079895019531, 236.72926330566406,
//                   301.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 88,
//               type: "text",
//               content: "Deductible Type 1",
//               coordinates: {
//                 x: 265.59600830078125,
//                 y: 292.4079895019531,
//                 width: 61.860443115234375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   265.59600830078125, 292.4079895019531, 327.4564514160156,
//                   301.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 89,
//               type: "text",
//               content: "Ded 2",
//               coordinates: {
//                 x: 373.6679992675781,
//                 y: 292.4079895019531,
//                 width: 20.669219970703125,
//                 height: 8.656768798828125,
//                 bbox: [
//                   373.6679992675781, 292.4079895019531, 394.33721923828125,
//                   301.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 90,
//               type: "text",
//               content: "Deductible Type 2",
//               coordinates: {
//                 x: 423.05999755859375,
//                 y: 292.4079895019531,
//                 width: 61.860443115234375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   423.05999755859375, 292.4079895019531, 484.9204406738281,
//                   301.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 91,
//               type: "text",
//               content: "Premium",
//               coordinates: {
//                 x: 530.9879760742188,
//                 y: 292.4079895019531,
//                 width: 30.9923095703125,
//                 height: 8.656768798828125,
//                 bbox: [
//                   530.9879760742188, 292.4079895019531, 561.9802856445312,
//                   301.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 92,
//               type: "text",
//               content: "Loc # ST",
//               coordinates: {
//                 x: 23.964000701904297,
//                 y: 323.9440002441406,
//                 width: 34.87300109863281,
//                 height: 8.656768798828125,
//                 bbox: [
//                   23.964000701904297, 323.9440002441406, 58.83700180053711,
//                   332.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 93,
//               type: "text",
//               content: "Cov Code",
//               coordinates: {
//                 x: 65.50800323486328,
//                 y: 323.9440002441406,
//                 width: 34.44873809814453,
//                 height: 8.656768798828125,
//                 bbox: [
//                   65.50800323486328, 323.9440002441406, 99.95674133300781,
//                   332.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 94,
//               type: "text",
//               content: "Description",
//               coordinates: {
//                 x: 108.05999755859375,
//                 y: 323.9440002441406,
//                 width: 38.75001525878906,
//                 height: 8.656768798828125,
//                 bbox: [
//                   108.05999755859375, 323.9440002441406, 146.8100128173828,
//                   332.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 95,
//               type: "text",
//               content: "Type of Coverage",
//               coordinates: {
//                 x: 220.5240020751953,
//                 y: 323.9440002441406,
//                 width: 61.13969421386719,
//                 height: 8.656768798828125,
//                 bbox: [
//                   220.5240020751953, 323.9440002441406, 281.6636962890625,
//                   332.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 96,
//               type: "text",
//               content: "Form No.",
//               coordinates: {
//                 x: 360.05999755859375,
//                 y: 323.9440002441406,
//                 width: 32.27099609375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   360.05999755859375, 323.9440002441406, 392.33099365234375,
//                   332.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 97,
//               type: "text",
//               content: "Edition Date",
//               coordinates: {
//                 x: 407.94000244140625,
//                 y: 323.9440002441406,
//                 width: 42.183197021484375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   407.94000244140625, 323.9440002441406, 450.1231994628906,
//                   332.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 98,
//               type: "text",
//               content: "Rate",
//               coordinates: {
//                 x: 459.05999755859375,
//                 y: 323.9440002441406,
//                 width: 16.3602294921875,
//                 height: 8.656768798828125,
//                 bbox: [
//                   459.05999755859375, 323.9440002441406, 475.42022705078125,
//                   332.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 99,
//               type: "text",
//               content: "Option Codes",
//               coordinates: {
//                 x: 508.59600830078125,
//                 y: 324.0159912109375,
//                 width: 47.3603515625,
//                 height: 8.656768798828125,
//                 bbox: [
//                   508.59600830078125, 324.0159912109375, 555.9563598632812,
//                   332.6727600097656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 100,
//               type: "text",
//               content: "Limit 1",
//               coordinates: {
//                 x: 27.059999465942383,
//                 y: 346.4079895019531,
//                 width: 22.808256149291992,
//                 height: 8.656768798828125,
//                 bbox: [
//                   27.059999465942383, 346.4079895019531, 49.868255615234375,
//                   355.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 101,
//               type: "text",
//               content: "Limit 2",
//               coordinates: {
//                 x: 90.05999755859375,
//                 y: 346.4079895019531,
//                 width: 22.808242797851562,
//                 height: 8.656768798828125,
//                 bbox: [
//                   90.05999755859375, 346.4079895019531, 112.86824035644531,
//                   355.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 102,
//               type: "text",
//               content: "Limit 3",
//               coordinates: {
//                 x: 153.05999755859375,
//                 y: 346.4079895019531,
//                 width: 22.808258056640625,
//                 height: 8.656768798828125,
//                 bbox: [
//                   153.05999755859375, 346.4079895019531, 175.86825561523438,
//                   355.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 103,
//               type: "text",
//               content: "Ded 1",
//               coordinates: {
//                 x: 216.05999755859375,
//                 y: 346.4079895019531,
//                 width: 20.669265747070312,
//                 height: 8.656768798828125,
//                 bbox: [
//                   216.05999755859375, 346.4079895019531, 236.72926330566406,
//                   355.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 104,
//               type: "text",
//               content: "Deductible Type 1",
//               coordinates: {
//                 x: 265.59600830078125,
//                 y: 346.4079895019531,
//                 width: 61.860443115234375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   265.59600830078125, 346.4079895019531, 327.4564514160156,
//                   355.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 105,
//               type: "text",
//               content: "Ded 2",
//               coordinates: {
//                 x: 373.6679992675781,
//                 y: 346.4079895019531,
//                 width: 20.669219970703125,
//                 height: 8.656768798828125,
//                 bbox: [
//                   373.6679992675781, 346.4079895019531, 394.33721923828125,
//                   355.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 106,
//               type: "text",
//               content: "Deductible Type 2",
//               coordinates: {
//                 x: 423.05999755859375,
//                 y: 346.4079895019531,
//                 width: 61.860443115234375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   423.05999755859375, 346.4079895019531, 484.9204406738281,
//                   355.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 107,
//               type: "text",
//               content: "Premium",
//               coordinates: {
//                 x: 530.9879760742188,
//                 y: 346.4079895019531,
//                 width: 30.9923095703125,
//                 height: 8.656768798828125,
//                 bbox: [
//                   530.9879760742188, 346.4079895019531, 561.9802856445312,
//                   355.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 108,
//               type: "text",
//               content: "Loc # ST",
//               coordinates: {
//                 x: 23.964000701904297,
//                 y: 377.9440002441406,
//                 width: 34.87300109863281,
//                 height: 8.656768798828125,
//                 bbox: [
//                   23.964000701904297, 377.9440002441406, 58.83700180053711,
//                   386.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 109,
//               type: "text",
//               content: "Cov Code",
//               coordinates: {
//                 x: 65.50800323486328,
//                 y: 377.9440002441406,
//                 width: 34.44873809814453,
//                 height: 8.656768798828125,
//                 bbox: [
//                   65.50800323486328, 377.9440002441406, 99.95674133300781,
//                   386.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 110,
//               type: "text",
//               content: "Description",
//               coordinates: {
//                 x: 108.05999755859375,
//                 y: 377.9440002441406,
//                 width: 38.75001525878906,
//                 height: 8.656768798828125,
//                 bbox: [
//                   108.05999755859375, 377.9440002441406, 146.8100128173828,
//                   386.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 111,
//               type: "text",
//               content: "Type of Coverage",
//               coordinates: {
//                 x: 220.5240020751953,
//                 y: 377.9440002441406,
//                 width: 61.13969421386719,
//                 height: 8.656768798828125,
//                 bbox: [
//                   220.5240020751953, 377.9440002441406, 281.6636962890625,
//                   386.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 112,
//               type: "text",
//               content: "Form No.",
//               coordinates: {
//                 x: 360.05999755859375,
//                 y: 377.9440002441406,
//                 width: 32.27099609375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   360.05999755859375, 377.9440002441406, 392.33099365234375,
//                   386.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 113,
//               type: "text",
//               content: "Edition Date",
//               coordinates: {
//                 x: 407.94000244140625,
//                 y: 377.9440002441406,
//                 width: 42.183197021484375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   407.94000244140625, 377.9440002441406, 450.1231994628906,
//                   386.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 114,
//               type: "text",
//               content: "Rate",
//               coordinates: {
//                 x: 459.05999755859375,
//                 y: 377.9440002441406,
//                 width: 16.3602294921875,
//                 height: 8.656768798828125,
//                 bbox: [
//                   459.05999755859375, 377.9440002441406, 475.42022705078125,
//                   386.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 115,
//               type: "text",
//               content: "Option Codes",
//               coordinates: {
//                 x: 508.59600830078125,
//                 y: 378.0159912109375,
//                 width: 47.3603515625,
//                 height: 8.656768798828125,
//                 bbox: [
//                   508.59600830078125, 378.0159912109375, 555.9563598632812,
//                   386.6727600097656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 116,
//               type: "text",
//               content: "Limit 1",
//               coordinates: {
//                 x: 27.059999465942383,
//                 y: 400.4079895019531,
//                 width: 22.808256149291992,
//                 height: 8.656768798828125,
//                 bbox: [
//                   27.059999465942383, 400.4079895019531, 49.868255615234375,
//                   409.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 117,
//               type: "text",
//               content: "Limit 2",
//               coordinates: {
//                 x: 90.05999755859375,
//                 y: 400.4079895019531,
//                 width: 22.808242797851562,
//                 height: 8.656768798828125,
//                 bbox: [
//                   90.05999755859375, 400.4079895019531, 112.86824035644531,
//                   409.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 118,
//               type: "text",
//               content: "Limit 3",
//               coordinates: {
//                 x: 153.05999755859375,
//                 y: 400.4079895019531,
//                 width: 22.808258056640625,
//                 height: 8.656768798828125,
//                 bbox: [
//                   153.05999755859375, 400.4079895019531, 175.86825561523438,
//                   409.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 119,
//               type: "text",
//               content: "Ded 1",
//               coordinates: {
//                 x: 216.05999755859375,
//                 y: 400.4079895019531,
//                 width: 20.669265747070312,
//                 height: 8.656768798828125,
//                 bbox: [
//                   216.05999755859375, 400.4079895019531, 236.72926330566406,
//                   409.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 120,
//               type: "text",
//               content: "Deductible Type 1",
//               coordinates: {
//                 x: 265.59600830078125,
//                 y: 400.4079895019531,
//                 width: 61.860443115234375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   265.59600830078125, 400.4079895019531, 327.4564514160156,
//                   409.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 121,
//               type: "text",
//               content: "Ded 2",
//               coordinates: {
//                 x: 373.6679992675781,
//                 y: 400.4079895019531,
//                 width: 20.669219970703125,
//                 height: 8.656768798828125,
//                 bbox: [
//                   373.6679992675781, 400.4079895019531, 394.33721923828125,
//                   409.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 122,
//               type: "text",
//               content: "Deductible Type 2",
//               coordinates: {
//                 x: 423.05999755859375,
//                 y: 400.4079895019531,
//                 width: 61.860443115234375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   423.05999755859375, 400.4079895019531, 484.9204406738281,
//                   409.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 123,
//               type: "text",
//               content: "Premium",
//               coordinates: {
//                 x: 530.9879760742188,
//                 y: 400.4079895019531,
//                 width: 30.9923095703125,
//                 height: 8.656768798828125,
//                 bbox: [
//                   530.9879760742188, 400.4079895019531, 561.9802856445312,
//                   409.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 124,
//               type: "text",
//               content: "Loc # ST",
//               coordinates: {
//                 x: 23.964000701904297,
//                 y: 431.9440002441406,
//                 width: 34.87300109863281,
//                 height: 8.656768798828125,
//                 bbox: [
//                   23.964000701904297, 431.9440002441406, 58.83700180053711,
//                   440.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 125,
//               type: "text",
//               content: "Cov Code",
//               coordinates: {
//                 x: 65.50800323486328,
//                 y: 431.9440002441406,
//                 width: 34.44873809814453,
//                 height: 8.656768798828125,
//                 bbox: [
//                   65.50800323486328, 431.9440002441406, 99.95674133300781,
//                   440.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 126,
//               type: "text",
//               content: "Description",
//               coordinates: {
//                 x: 108.05999755859375,
//                 y: 431.9440002441406,
//                 width: 38.75001525878906,
//                 height: 8.656768798828125,
//                 bbox: [
//                   108.05999755859375, 431.9440002441406, 146.8100128173828,
//                   440.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 127,
//               type: "text",
//               content: "Type of Coverage",
//               coordinates: {
//                 x: 220.5240020751953,
//                 y: 431.9440002441406,
//                 width: 61.13969421386719,
//                 height: 8.656768798828125,
//                 bbox: [
//                   220.5240020751953, 431.9440002441406, 281.6636962890625,
//                   440.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 128,
//               type: "text",
//               content: "Form No.",
//               coordinates: {
//                 x: 360.05999755859375,
//                 y: 431.9440002441406,
//                 width: 32.27099609375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   360.05999755859375, 431.9440002441406, 392.33099365234375,
//                   440.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 129,
//               type: "text",
//               content: "Edition Date",
//               coordinates: {
//                 x: 407.94000244140625,
//                 y: 431.9440002441406,
//                 width: 42.183197021484375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   407.94000244140625, 431.9440002441406, 450.1231994628906,
//                   440.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 130,
//               type: "text",
//               content: "Rate",
//               coordinates: {
//                 x: 459.05999755859375,
//                 y: 431.9440002441406,
//                 width: 16.3602294921875,
//                 height: 8.656768798828125,
//                 bbox: [
//                   459.05999755859375, 431.9440002441406, 475.42022705078125,
//                   440.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 131,
//               type: "text",
//               content: "Option Codes",
//               coordinates: {
//                 x: 508.59600830078125,
//                 y: 432.0159912109375,
//                 width: 47.3603515625,
//                 height: 8.656768798828125,
//                 bbox: [
//                   508.59600830078125, 432.0159912109375, 555.9563598632812,
//                   440.6727600097656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 132,
//               type: "text",
//               content: "Limit 1",
//               coordinates: {
//                 x: 27.059999465942383,
//                 y: 454.4079895019531,
//                 width: 22.808256149291992,
//                 height: 8.656768798828125,
//                 bbox: [
//                   27.059999465942383, 454.4079895019531, 49.868255615234375,
//                   463.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 133,
//               type: "text",
//               content: "Limit 2",
//               coordinates: {
//                 x: 90.05999755859375,
//                 y: 454.4079895019531,
//                 width: 22.808242797851562,
//                 height: 8.656768798828125,
//                 bbox: [
//                   90.05999755859375, 454.4079895019531, 112.86824035644531,
//                   463.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 134,
//               type: "text",
//               content: "Limit 3",
//               coordinates: {
//                 x: 153.05999755859375,
//                 y: 454.4079895019531,
//                 width: 22.808258056640625,
//                 height: 8.656768798828125,
//                 bbox: [
//                   153.05999755859375, 454.4079895019531, 175.86825561523438,
//                   463.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 135,
//               type: "text",
//               content: "Ded 1",
//               coordinates: {
//                 x: 216.05999755859375,
//                 y: 454.4079895019531,
//                 width: 20.669265747070312,
//                 height: 8.656768798828125,
//                 bbox: [
//                   216.05999755859375, 454.4079895019531, 236.72926330566406,
//                   463.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 136,
//               type: "text",
//               content: "Deductible Type 1",
//               coordinates: {
//                 x: 265.59600830078125,
//                 y: 454.4079895019531,
//                 width: 61.860443115234375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   265.59600830078125, 454.4079895019531, 327.4564514160156,
//                   463.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 137,
//               type: "text",
//               content: "Ded 2",
//               coordinates: {
//                 x: 373.6679992675781,
//                 y: 454.4079895019531,
//                 width: 20.669219970703125,
//                 height: 8.656768798828125,
//                 bbox: [
//                   373.6679992675781, 454.4079895019531, 394.33721923828125,
//                   463.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 138,
//               type: "text",
//               content: "Deductible Type 2",
//               coordinates: {
//                 x: 423.05999755859375,
//                 y: 454.4079895019531,
//                 width: 61.860443115234375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   423.05999755859375, 454.4079895019531, 484.9204406738281,
//                   463.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 139,
//               type: "text",
//               content: "Premium",
//               coordinates: {
//                 x: 530.9879760742188,
//                 y: 454.4079895019531,
//                 width: 30.9923095703125,
//                 height: 8.656768798828125,
//                 bbox: [
//                   530.9879760742188, 454.4079895019531, 561.9802856445312,
//                   463.06475830078125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 140,
//               type: "text",
//               content: "Loc # ST",
//               coordinates: {
//                 x: 23.964000701904297,
//                 y: 485.9440002441406,
//                 width: 34.87300109863281,
//                 height: 8.656768798828125,
//                 bbox: [
//                   23.964000701904297, 485.9440002441406, 58.83700180053711,
//                   494.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 141,
//               type: "text",
//               content: "Cov Code",
//               coordinates: {
//                 x: 65.50800323486328,
//                 y: 485.9440002441406,
//                 width: 34.44873809814453,
//                 height: 8.656768798828125,
//                 bbox: [
//                   65.50800323486328, 485.9440002441406, 99.95674133300781,
//                   494.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 142,
//               type: "text",
//               content: "Description",
//               coordinates: {
//                 x: 108.05999755859375,
//                 y: 485.9440002441406,
//                 width: 38.75001525878906,
//                 height: 8.656768798828125,
//                 bbox: [
//                   108.05999755859375, 485.9440002441406, 146.8100128173828,
//                   494.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 143,
//               type: "text",
//               content: "Type of Coverage",
//               coordinates: {
//                 x: 220.5240020751953,
//                 y: 485.9440002441406,
//                 width: 61.13969421386719,
//                 height: 8.656768798828125,
//                 bbox: [
//                   220.5240020751953, 485.9440002441406, 281.6636962890625,
//                   494.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 144,
//               type: "text",
//               content: "Form No.",
//               coordinates: {
//                 x: 360.05999755859375,
//                 y: 485.9440002441406,
//                 width: 32.27099609375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   360.05999755859375, 485.9440002441406, 392.33099365234375,
//                   494.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 145,
//               type: "text",
//               content: "Edition Date",
//               coordinates: {
//                 x: 407.94000244140625,
//                 y: 485.9440002441406,
//                 width: 42.183197021484375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   407.94000244140625, 485.9440002441406, 450.1231994628906,
//                   494.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 146,
//               type: "text",
//               content: "Rate",
//               coordinates: {
//                 x: 459.05999755859375,
//                 y: 485.9440002441406,
//                 width: 16.3602294921875,
//                 height: 8.656768798828125,
//                 bbox: [
//                   459.05999755859375, 485.9440002441406, 475.42022705078125,
//                   494.60076904296875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 147,
//               type: "text",
//               content: "Option Codes",
//               coordinates: {
//                 x: 508.59600830078125,
//                 y: 486.0159912109375,
//                 width: 47.3603515625,
//                 height: 8.656768798828125,
//                 bbox: [
//                   508.59600830078125, 486.0159912109375, 555.9563598632812,
//                   494.6727600097656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 148,
//               type: "text",
//               content: "Limit 1",
//               coordinates: {
//                 x: 27.059999465942383,
//                 y: 508.4079895019531,
//                 width: 22.808256149291992,
//                 height: 8.656768798828125,
//                 bbox: [
//                   27.059999465942383, 508.4079895019531, 49.868255615234375,
//                   517.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 149,
//               type: "text",
//               content: "Limit 2",
//               coordinates: {
//                 x: 90.05999755859375,
//                 y: 508.4079895019531,
//                 width: 22.808242797851562,
//                 height: 8.656768798828125,
//                 bbox: [
//                   90.05999755859375, 508.4079895019531, 112.86824035644531,
//                   517.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 150,
//               type: "text",
//               content: "Limit 3",
//               coordinates: {
//                 x: 153.05999755859375,
//                 y: 508.4079895019531,
//                 width: 22.808258056640625,
//                 height: 8.656768798828125,
//                 bbox: [
//                   153.05999755859375, 508.4079895019531, 175.86825561523438,
//                   517.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 151,
//               type: "text",
//               content: "Ded 1",
//               coordinates: {
//                 x: 216.05999755859375,
//                 y: 508.4079895019531,
//                 width: 20.669265747070312,
//                 height: 8.656768798828125,
//                 bbox: [
//                   216.05999755859375, 508.4079895019531, 236.72926330566406,
//                   517.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 152,
//               type: "text",
//               content: "Deductible Type 1",
//               coordinates: {
//                 x: 265.59600830078125,
//                 y: 508.4079895019531,
//                 width: 61.860443115234375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   265.59600830078125, 508.4079895019531, 327.4564514160156,
//                   517.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 153,
//               type: "text",
//               content: "Ded 2",
//               coordinates: {
//                 x: 373.6679992675781,
//                 y: 508.4079895019531,
//                 width: 20.669219970703125,
//                 height: 8.656768798828125,
//                 bbox: [
//                   373.6679992675781, 508.4079895019531, 394.33721923828125,
//                   517.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 154,
//               type: "text",
//               content: "Deductible Type 2",
//               coordinates: {
//                 x: 423.05999755859375,
//                 y: 508.4079895019531,
//                 width: 61.860443115234375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   423.05999755859375, 508.4079895019531, 484.9204406738281,
//                   517.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 155,
//               type: "text",
//               content: "Premium",
//               coordinates: {
//                 x: 530.9879760742188,
//                 y: 508.4079895019531,
//                 width: 30.9923095703125,
//                 height: 8.656768798828125,
//                 bbox: [
//                   530.9879760742188, 508.4079895019531, 561.9802856445312,
//                   517.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 156,
//               type: "text",
//               content: "Loc # ST",
//               coordinates: {
//                 x: 23.964000701904297,
//                 y: 539.9440307617188,
//                 width: 34.87300109863281,
//                 height: 8.65673828125,
//                 bbox: [
//                   23.964000701904297, 539.9440307617188, 58.83700180053711,
//                   548.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 157,
//               type: "text",
//               content: "Cov Code",
//               coordinates: {
//                 x: 65.50800323486328,
//                 y: 539.9440307617188,
//                 width: 34.44873809814453,
//                 height: 8.65673828125,
//                 bbox: [
//                   65.50800323486328, 539.9440307617188, 99.95674133300781,
//                   548.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 158,
//               type: "text",
//               content: "Description",
//               coordinates: {
//                 x: 108.05999755859375,
//                 y: 539.9440307617188,
//                 width: 38.75001525878906,
//                 height: 8.65673828125,
//                 bbox: [
//                   108.05999755859375, 539.9440307617188, 146.8100128173828,
//                   548.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 159,
//               type: "text",
//               content: "Type of Coverage",
//               coordinates: {
//                 x: 220.5240020751953,
//                 y: 539.9440307617188,
//                 width: 61.13969421386719,
//                 height: 8.65673828125,
//                 bbox: [
//                   220.5240020751953, 539.9440307617188, 281.6636962890625,
//                   548.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 160,
//               type: "text",
//               content: "Form No.",
//               coordinates: {
//                 x: 360.05999755859375,
//                 y: 539.9440307617188,
//                 width: 32.27099609375,
//                 height: 8.65673828125,
//                 bbox: [
//                   360.05999755859375, 539.9440307617188, 392.33099365234375,
//                   548.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 161,
//               type: "text",
//               content: "Edition Date",
//               coordinates: {
//                 x: 407.94000244140625,
//                 y: 539.9440307617188,
//                 width: 42.183197021484375,
//                 height: 8.65673828125,
//                 bbox: [
//                   407.94000244140625, 539.9440307617188, 450.1231994628906,
//                   548.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 162,
//               type: "text",
//               content: "Rate",
//               coordinates: {
//                 x: 459.05999755859375,
//                 y: 539.9440307617188,
//                 width: 16.3602294921875,
//                 height: 8.65673828125,
//                 bbox: [
//                   459.05999755859375, 539.9440307617188, 475.42022705078125,
//                   548.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 163,
//               type: "text",
//               content: "Option Codes",
//               coordinates: {
//                 x: 508.59600830078125,
//                 y: 540.0160522460938,
//                 width: 47.3603515625,
//                 height: 8.65673828125,
//                 bbox: [
//                   508.59600830078125, 540.0160522460938, 555.9563598632812,
//                   548.6727905273438
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 164,
//               type: "text",
//               content: "Limit 1",
//               coordinates: {
//                 x: 27.059999465942383,
//                 y: 562.4080200195312,
//                 width: 22.808256149291992,
//                 height: 8.65673828125,
//                 bbox: [
//                   27.059999465942383, 562.4080200195312, 49.868255615234375,
//                   571.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 165,
//               type: "text",
//               content: "Limit 2",
//               coordinates: {
//                 x: 90.05999755859375,
//                 y: 562.4080200195312,
//                 width: 22.808242797851562,
//                 height: 8.65673828125,
//                 bbox: [
//                   90.05999755859375, 562.4080200195312, 112.86824035644531,
//                   571.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 166,
//               type: "text",
//               content: "Limit 3",
//               coordinates: {
//                 x: 153.05999755859375,
//                 y: 562.4080200195312,
//                 width: 22.808258056640625,
//                 height: 8.65673828125,
//                 bbox: [
//                   153.05999755859375, 562.4080200195312, 175.86825561523438,
//                   571.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 167,
//               type: "text",
//               content: "Ded 1",
//               coordinates: {
//                 x: 216.05999755859375,
//                 y: 562.4080200195312,
//                 width: 20.669265747070312,
//                 height: 8.65673828125,
//                 bbox: [
//                   216.05999755859375, 562.4080200195312, 236.72926330566406,
//                   571.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 168,
//               type: "text",
//               content: "Deductible Type 1",
//               coordinates: {
//                 x: 265.59600830078125,
//                 y: 562.4080200195312,
//                 width: 61.860443115234375,
//                 height: 8.65673828125,
//                 bbox: [
//                   265.59600830078125, 562.4080200195312, 327.4564514160156,
//                   571.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 169,
//               type: "text",
//               content: "Ded 2",
//               coordinates: {
//                 x: 373.6679992675781,
//                 y: 562.4080200195312,
//                 width: 20.669219970703125,
//                 height: 8.65673828125,
//                 bbox: [
//                   373.6679992675781, 562.4080200195312, 394.33721923828125,
//                   571.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 170,
//               type: "text",
//               content: "Deductible Type 2",
//               coordinates: {
//                 x: 423.05999755859375,
//                 y: 562.4080200195312,
//                 width: 61.860443115234375,
//                 height: 8.65673828125,
//                 bbox: [
//                   423.05999755859375, 562.4080200195312, 484.9204406738281,
//                   571.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 171,
//               type: "text",
//               content: "Premium",
//               coordinates: {
//                 x: 530.9879760742188,
//                 y: 562.4080200195312,
//                 width: 30.9923095703125,
//                 height: 8.65673828125,
//                 bbox: [
//                   530.9879760742188, 562.4080200195312, 561.9802856445312,
//                   571.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 172,
//               type: "text",
//               content: "Loc # ST",
//               coordinates: {
//                 x: 23.964000701904297,
//                 y: 593.9440307617188,
//                 width: 34.87300109863281,
//                 height: 8.65673828125,
//                 bbox: [
//                   23.964000701904297, 593.9440307617188, 58.83700180053711,
//                   602.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 173,
//               type: "text",
//               content: "Cov Code",
//               coordinates: {
//                 x: 65.50800323486328,
//                 y: 593.9440307617188,
//                 width: 34.44873809814453,
//                 height: 8.65673828125,
//                 bbox: [
//                   65.50800323486328, 593.9440307617188, 99.95674133300781,
//                   602.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 174,
//               type: "text",
//               content: "Description",
//               coordinates: {
//                 x: 108.05999755859375,
//                 y: 593.9440307617188,
//                 width: 38.75001525878906,
//                 height: 8.65673828125,
//                 bbox: [
//                   108.05999755859375, 593.9440307617188, 146.8100128173828,
//                   602.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 175,
//               type: "text",
//               content: "Type of Coverage",
//               coordinates: {
//                 x: 220.5240020751953,
//                 y: 593.9440307617188,
//                 width: 61.13969421386719,
//                 height: 8.65673828125,
//                 bbox: [
//                   220.5240020751953, 593.9440307617188, 281.6636962890625,
//                   602.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 176,
//               type: "text",
//               content: "Form No.",
//               coordinates: {
//                 x: 360.05999755859375,
//                 y: 593.9440307617188,
//                 width: 32.27099609375,
//                 height: 8.65673828125,
//                 bbox: [
//                   360.05999755859375, 593.9440307617188, 392.33099365234375,
//                   602.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 177,
//               type: "text",
//               content: "Edition Date",
//               coordinates: {
//                 x: 407.94000244140625,
//                 y: 593.9440307617188,
//                 width: 42.183197021484375,
//                 height: 8.65673828125,
//                 bbox: [
//                   407.94000244140625, 593.9440307617188, 450.1231994628906,
//                   602.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 178,
//               type: "text",
//               content: "Rate",
//               coordinates: {
//                 x: 459.05999755859375,
//                 y: 593.9440307617188,
//                 width: 16.3602294921875,
//                 height: 8.65673828125,
//                 bbox: [
//                   459.05999755859375, 593.9440307617188, 475.42022705078125,
//                   602.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 179,
//               type: "text",
//               content: "Option Codes",
//               coordinates: {
//                 x: 508.59600830078125,
//                 y: 594.0160522460938,
//                 width: 47.3603515625,
//                 height: 8.65673828125,
//                 bbox: [
//                   508.59600830078125, 594.0160522460938, 555.9563598632812,
//                   602.6727905273438
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 180,
//               type: "text",
//               content: "Limit 1",
//               coordinates: {
//                 x: 27.059999465942383,
//                 y: 616.4080200195312,
//                 width: 22.808256149291992,
//                 height: 8.65673828125,
//                 bbox: [
//                   27.059999465942383, 616.4080200195312, 49.868255615234375,
//                   625.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 181,
//               type: "text",
//               content: "Limit 2",
//               coordinates: {
//                 x: 90.05999755859375,
//                 y: 616.4080200195312,
//                 width: 22.808242797851562,
//                 height: 8.65673828125,
//                 bbox: [
//                   90.05999755859375, 616.4080200195312, 112.86824035644531,
//                   625.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 182,
//               type: "text",
//               content: "Limit 3",
//               coordinates: {
//                 x: 153.05999755859375,
//                 y: 616.4080200195312,
//                 width: 22.808258056640625,
//                 height: 8.65673828125,
//                 bbox: [
//                   153.05999755859375, 616.4080200195312, 175.86825561523438,
//                   625.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 183,
//               type: "text",
//               content: "Ded 1",
//               coordinates: {
//                 x: 216.05999755859375,
//                 y: 616.4080200195312,
//                 width: 20.669265747070312,
//                 height: 8.65673828125,
//                 bbox: [
//                   216.05999755859375, 616.4080200195312, 236.72926330566406,
//                   625.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 184,
//               type: "text",
//               content: "Deductible Type 1",
//               coordinates: {
//                 x: 265.59600830078125,
//                 y: 616.4080200195312,
//                 width: 61.860443115234375,
//                 height: 8.65673828125,
//                 bbox: [
//                   265.59600830078125, 616.4080200195312, 327.4564514160156,
//                   625.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 185,
//               type: "text",
//               content: "Ded 2",
//               coordinates: {
//                 x: 373.6679992675781,
//                 y: 616.4080200195312,
//                 width: 20.669219970703125,
//                 height: 8.65673828125,
//                 bbox: [
//                   373.6679992675781, 616.4080200195312, 394.33721923828125,
//                   625.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 186,
//               type: "text",
//               content: "Deductible Type 2",
//               coordinates: {
//                 x: 423.05999755859375,
//                 y: 616.4080200195312,
//                 width: 61.860443115234375,
//                 height: 8.65673828125,
//                 bbox: [
//                   423.05999755859375, 616.4080200195312, 484.9204406738281,
//                   625.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 187,
//               type: "text",
//               content: "Premium",
//               coordinates: {
//                 x: 530.9879760742188,
//                 y: 616.4080200195312,
//                 width: 30.9923095703125,
//                 height: 8.65673828125,
//                 bbox: [
//                   530.9879760742188, 616.4080200195312, 561.9802856445312,
//                   625.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 188,
//               type: "text",
//               content: "Loc # ST",
//               coordinates: {
//                 x: 23.964000701904297,
//                 y: 647.9440307617188,
//                 width: 34.87300109863281,
//                 height: 8.65673828125,
//                 bbox: [
//                   23.964000701904297, 647.9440307617188, 58.83700180053711,
//                   656.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 189,
//               type: "text",
//               content: "Cov Code",
//               coordinates: {
//                 x: 65.50800323486328,
//                 y: 647.9440307617188,
//                 width: 34.44873809814453,
//                 height: 8.65673828125,
//                 bbox: [
//                   65.50800323486328, 647.9440307617188, 99.95674133300781,
//                   656.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 190,
//               type: "text",
//               content: "Description",
//               coordinates: {
//                 x: 108.05999755859375,
//                 y: 647.9440307617188,
//                 width: 38.75001525878906,
//                 height: 8.65673828125,
//                 bbox: [
//                   108.05999755859375, 647.9440307617188, 146.8100128173828,
//                   656.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 191,
//               type: "text",
//               content: "Type of Coverage",
//               coordinates: {
//                 x: 220.5240020751953,
//                 y: 647.9440307617188,
//                 width: 61.13969421386719,
//                 height: 8.65673828125,
//                 bbox: [
//                   220.5240020751953, 647.9440307617188, 281.6636962890625,
//                   656.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 192,
//               type: "text",
//               content: "Form No.",
//               coordinates: {
//                 x: 360.05999755859375,
//                 y: 647.9440307617188,
//                 width: 32.27099609375,
//                 height: 8.65673828125,
//                 bbox: [
//                   360.05999755859375, 647.9440307617188, 392.33099365234375,
//                   656.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 193,
//               type: "text",
//               content: "Edition Date",
//               coordinates: {
//                 x: 407.94000244140625,
//                 y: 647.9440307617188,
//                 width: 42.183197021484375,
//                 height: 8.65673828125,
//                 bbox: [
//                   407.94000244140625, 647.9440307617188, 450.1231994628906,
//                   656.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 194,
//               type: "text",
//               content: "Rate",
//               coordinates: {
//                 x: 459.05999755859375,
//                 y: 647.9440307617188,
//                 width: 16.3602294921875,
//                 height: 8.65673828125,
//                 bbox: [
//                   459.05999755859375, 647.9440307617188, 475.42022705078125,
//                   656.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 195,
//               type: "text",
//               content: "Option Codes",
//               coordinates: {
//                 x: 508.59600830078125,
//                 y: 648.0160522460938,
//                 width: 47.3603515625,
//                 height: 8.65673828125,
//                 bbox: [
//                   508.59600830078125, 648.0160522460938, 555.9563598632812,
//                   656.6727905273438
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 196,
//               type: "text",
//               content: "Limit 1",
//               coordinates: {
//                 x: 27.059999465942383,
//                 y: 670.4080200195312,
//                 width: 22.808256149291992,
//                 height: 8.65673828125,
//                 bbox: [
//                   27.059999465942383, 670.4080200195312, 49.868255615234375,
//                   679.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 197,
//               type: "text",
//               content: "Limit 2",
//               coordinates: {
//                 x: 90.05999755859375,
//                 y: 670.4080200195312,
//                 width: 22.808242797851562,
//                 height: 8.65673828125,
//                 bbox: [
//                   90.05999755859375, 670.4080200195312, 112.86824035644531,
//                   679.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 198,
//               type: "text",
//               content: "Limit 3",
//               coordinates: {
//                 x: 153.05999755859375,
//                 y: 670.4080200195312,
//                 width: 22.808258056640625,
//                 height: 8.65673828125,
//                 bbox: [
//                   153.05999755859375, 670.4080200195312, 175.86825561523438,
//                   679.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 199,
//               type: "text",
//               content: "Ded 1",
//               coordinates: {
//                 x: 216.05999755859375,
//                 y: 670.4080200195312,
//                 width: 20.669265747070312,
//                 height: 8.65673828125,
//                 bbox: [
//                   216.05999755859375, 670.4080200195312, 236.72926330566406,
//                   679.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 200,
//               type: "text",
//               content: "Deductible Type 1",
//               coordinates: {
//                 x: 265.59600830078125,
//                 y: 670.4080200195312,
//                 width: 61.860443115234375,
//                 height: 8.65673828125,
//                 bbox: [
//                   265.59600830078125, 670.4080200195312, 327.4564514160156,
//                   679.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 201,
//               type: "text",
//               content: "Ded 2",
//               coordinates: {
//                 x: 373.6679992675781,
//                 y: 670.4080200195312,
//                 width: 20.669219970703125,
//                 height: 8.65673828125,
//                 bbox: [
//                   373.6679992675781, 670.4080200195312, 394.33721923828125,
//                   679.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 202,
//               type: "text",
//               content: "Deductible Type 2",
//               coordinates: {
//                 x: 423.05999755859375,
//                 y: 670.4080200195312,
//                 width: 61.860443115234375,
//                 height: 8.65673828125,
//                 bbox: [
//                   423.05999755859375, 670.4080200195312, 484.9204406738281,
//                   679.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 203,
//               type: "text",
//               content: "Premium",
//               coordinates: {
//                 x: 530.9879760742188,
//                 y: 670.4080200195312,
//                 width: 30.9923095703125,
//                 height: 8.65673828125,
//                 bbox: [
//                   530.9879760742188, 670.4080200195312, 561.9802856445312,
//                   679.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 204,
//               type: "text",
//               content: "Loc # ST",
//               coordinates: {
//                 x: 23.964000701904297,
//                 y: 701.9440307617188,
//                 width: 34.87300109863281,
//                 height: 8.65673828125,
//                 bbox: [
//                   23.964000701904297, 701.9440307617188, 58.83700180053711,
//                   710.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 205,
//               type: "text",
//               content: "Cov Code",
//               coordinates: {
//                 x: 65.50800323486328,
//                 y: 701.9440307617188,
//                 width: 34.44873809814453,
//                 height: 8.65673828125,
//                 bbox: [
//                   65.50800323486328, 701.9440307617188, 99.95674133300781,
//                   710.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 206,
//               type: "text",
//               content: "Description",
//               coordinates: {
//                 x: 108.05999755859375,
//                 y: 701.9440307617188,
//                 width: 38.75001525878906,
//                 height: 8.65673828125,
//                 bbox: [
//                   108.05999755859375, 701.9440307617188, 146.8100128173828,
//                   710.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 207,
//               type: "text",
//               content: "Type of Coverage",
//               coordinates: {
//                 x: 220.5240020751953,
//                 y: 701.9440307617188,
//                 width: 61.13969421386719,
//                 height: 8.65673828125,
//                 bbox: [
//                   220.5240020751953, 701.9440307617188, 281.6636962890625,
//                   710.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 208,
//               type: "text",
//               content: "Form No.",
//               coordinates: {
//                 x: 360.05999755859375,
//                 y: 701.9440307617188,
//                 width: 32.27099609375,
//                 height: 8.65673828125,
//                 bbox: [
//                   360.05999755859375, 701.9440307617188, 392.33099365234375,
//                   710.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 209,
//               type: "text",
//               content: "Edition Date",
//               coordinates: {
//                 x: 407.94000244140625,
//                 y: 701.9440307617188,
//                 width: 42.183197021484375,
//                 height: 8.65673828125,
//                 bbox: [
//                   407.94000244140625, 701.9440307617188, 450.1231994628906,
//                   710.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 210,
//               type: "text",
//               content: "Rate",
//               coordinates: {
//                 x: 459.05999755859375,
//                 y: 701.9440307617188,
//                 width: 16.3602294921875,
//                 height: 8.65673828125,
//                 bbox: [
//                   459.05999755859375, 701.9440307617188, 475.42022705078125,
//                   710.6007690429688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 211,
//               type: "text",
//               content: "Option Codes",
//               coordinates: {
//                 x: 508.59600830078125,
//                 y: 702.0159912109375,
//                 width: 47.3603515625,
//                 height: 8.65673828125,
//                 bbox: [
//                   508.59600830078125, 702.0159912109375, 555.9563598632812,
//                   710.6727294921875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 212,
//               type: "text",
//               content: "Limit 1",
//               coordinates: {
//                 x: 27.059999465942383,
//                 y: 724.4080200195312,
//                 width: 22.808256149291992,
//                 height: 8.65673828125,
//                 bbox: [
//                   27.059999465942383, 724.4080200195312, 49.868255615234375,
//                   733.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 213,
//               type: "text",
//               content: "Limit 2",
//               coordinates: {
//                 x: 90.05999755859375,
//                 y: 724.4080200195312,
//                 width: 22.808242797851562,
//                 height: 8.65673828125,
//                 bbox: [
//                   90.05999755859375, 724.4080200195312, 112.86824035644531,
//                   733.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 214,
//               type: "text",
//               content: "Limit 3",
//               coordinates: {
//                 x: 153.05999755859375,
//                 y: 724.4080200195312,
//                 width: 22.808258056640625,
//                 height: 8.65673828125,
//                 bbox: [
//                   153.05999755859375, 724.4080200195312, 175.86825561523438,
//                   733.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 215,
//               type: "text",
//               content: "Ded 1",
//               coordinates: {
//                 x: 216.05999755859375,
//                 y: 724.4080200195312,
//                 width: 20.669265747070312,
//                 height: 8.65673828125,
//                 bbox: [
//                   216.05999755859375, 724.4080200195312, 236.72926330566406,
//                   733.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 216,
//               type: "text",
//               content: "Deductible Type 1",
//               coordinates: {
//                 x: 265.59600830078125,
//                 y: 724.4080200195312,
//                 width: 61.860443115234375,
//                 height: 8.65673828125,
//                 bbox: [
//                   265.59600830078125, 724.4080200195312, 327.4564514160156,
//                   733.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 217,
//               type: "text",
//               content: "Ded 2",
//               coordinates: {
//                 x: 373.6679992675781,
//                 y: 724.4080200195312,
//                 width: 20.669219970703125,
//                 height: 8.65673828125,
//                 bbox: [
//                   373.6679992675781, 724.4080200195312, 394.33721923828125,
//                   733.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 218,
//               type: "text",
//               content: "Deductible Type 2",
//               coordinates: {
//                 x: 423.05999755859375,
//                 y: 724.4080200195312,
//                 width: 61.860443115234375,
//                 height: 8.65673828125,
//                 bbox: [
//                   423.05999755859375, 724.4080200195312, 484.9204406738281,
//                   733.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 219,
//               type: "text",
//               content: "Premium",
//               coordinates: {
//                 x: 530.9879760742188,
//                 y: 724.4080200195312,
//                 width: 30.9923095703125,
//                 height: 8.65673828125,
//                 bbox: [
//                   530.9879760742188, 724.4080200195312, 561.9802856445312,
//                   733.0647583007812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 220,
//               type: "text",
//               content: "OFBAADCV",
//               coordinates: {
//                 x: 27.059999465942383,
//                 y: 749.176025390625,
//                 width: 42.58624839782715,
//                 height: 8.65673828125,
//                 bbox: [
//                   27.059999465942383, 749.176025390625, 69.64624786376953,
//                   757.832763671875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 221,
//               type: "text",
//               content: "Copyright 2000, AMS Services, Inc",
//               coordinates: {
//                 x: 470.364013671875,
//                 y: 749.85595703125,
//                 width: 110.30828857421875,
//                 height: 7.539794921875,
//                 bbox: [
//                   470.364013671875, 749.85595703125, 580.6723022460938,
//                   757.395751953125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 22.56,
//                 y: 22.31323841260223,
//                 width: 568.32,
//                 height: 739.215995152984,
//                 bbox: [22.56, 22.31323841260223, 590.88, 761.5292335655862]
//               },
//               properties: {
//                 rows: 40,
//                 columns: 16,
//                 accuracy: 78.761
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 222,
//           table_count: 1,
//           total_elements: 223
//         }
//       },
//       {
//         page_number: 14,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 415.20001220703125,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   415.20001220703125, 25.188751220703125, 447.44805908203125,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "04/04/2025",
//               coordinates: {
//                 x: 532.9550170898438,
//                 y: 55.188751220703125,
//                 width: 36.2645263671875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   532.9550170898438, 55.188751220703125, 569.2195434570312,
//                   63.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "UIS Insurance & Investments",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 79.18875122070312,
//                 width: 93.81499099731445,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 79.18875122070312, 116.614990234375,
//                   87.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "25-26",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 103.18875122070312,
//                 width: 18.538253784179688,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 103.18875122070312, 41.338253021240234,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "05/18/2025",
//               coordinates: {
//                 x: 259.3550109863281,
//                 y: 103.18875122070312,
//                 width: 36.2645263671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   259.3550109863281, 103.18875122070312, 295.6195373535156,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "Submissions",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 79.18875122070312,
//                 width: 41.08575439453125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 79.18875122070312, 351.8857421875,
//                   87.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "Buckeye Premier Cleaning, LLC",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 103.18875122070312,
//                 width: 103.10223388671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 103.18875122070312, 413.9022216796875,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "2,000,000",
//               coordinates: {
//                 x: 411.6000061035156,
//                 y: 157.18875122070312,
//                 width: 32.2335205078125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   411.6000061035156, 157.18875122070312, 443.8335266113281,
//                   165.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "2,000,000",
//               coordinates: {
//                 x: 411.6000061035156,
//                 y: 193.18875122070312,
//                 width: 32.2335205078125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   411.6000061035156, 193.18875122070312, 443.8335266113281,
//                   201.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "1,000,000",
//               coordinates: {
//                 x: 411.6000061035156,
//                 y: 205.18875122070312,
//                 width: 32.2335205078125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   411.6000061035156, 205.18875122070312, 443.8335266113281,
//                   213.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "1,000,000",
//               coordinates: {
//                 x: 411.6000061035156,
//                 y: 217.18875122070312,
//                 width: 32.2335205078125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   411.6000061035156, 217.18875122070312, 443.8335266113281,
//                   225.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "100,000",
//               coordinates: {
//                 x: 411.6000061035156,
//                 y: 229.18875122070312,
//                 width: 26.19427490234375,
//                 height: 8.098251342773438,
//                 bbox: [
//                   411.6000061035156, 229.18875122070312, 437.7942810058594,
//                   237.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "10,000",
//               coordinates: {
//                 x: 411.6000061035156,
//                 y: 241.18875122070312,
//                 width: 22.16326904296875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   411.6000061035156, 241.18875122070312, 433.7632751464844,
//                   249.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "1",
//               coordinates: {
//                 x: 34.283748626708984,
//                 y: 373.1887512207031,
//                 width: 4.031002044677734,
//                 height: 8.098236083984375,
//                 bbox: [
//                   34.283748626708984, 373.1887512207031, 38.31475067138672,
//                   381.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "P",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 373.1887512207031,
//                 width: 4.8285064697265625,
//                 height: 8.098236083984375,
//                 bbox: [
//                   145.1999969482422, 373.1887512207031, 150.02850341796875,
//                   381.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "27,400",
//               coordinates: {
//                 x: 195.60000610351562,
//                 y: 373.1887512207031,
//                 width: 22.163284301757812,
//                 height: 8.098236083984375,
//                 bbox: [
//                   195.60000610351562, 373.1887512207031, 217.76329040527344,
//                   381.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "Janitorial Services",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 397.1887512207031,
//                 width: 58.79750442504883,
//                 height: 8.098236083984375,
//                 bbox: [
//                   22.799999237060547, 397.1887512207031, 81.59750366210938,
//                   405.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 637.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 637.188720703125, 586.1170043945312,
//                   645.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 673.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 673.188720703125, 586.1170043945312,
//                   681.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 317.0350036621094,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   317.0350036621094, 26.379987716674805, 408.8182373046875,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "EFFECTIVE DATE",
//               coordinates: {
//                 x: 252.97500610351562,
//                 y: 92.54002380371094,
//                 width: 48.3919677734375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   252.97500610351562, 92.54002380371094, 301.3669738769531,
//                   98.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content: "NAIC CODE",
//               coordinates: {
//                 x: 543.9000244140625,
//                 y: 68.54002380371094,
//                 width: 32.24029541015625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   543.9000244140625, 68.54002380371094, 576.1403198242188,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "CARRIER",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 67.17997741699219,
//                 width: 35.28570556640625,
//                 height: 8.656745910644531,
//                 bbox: [
//                   309.8999938964844, 67.17997741699219, 345.1856994628906,
//                   75.83672332763672
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "POLICY NUMBER",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 92.54002380371094,
//                 width: 48.09299659729004,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 92.54002380371094, 69.99299621582031,
//                   98.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "APPLICANT / FIRST NAMED INSURED",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 93.13999938964844,
//                 width: 104.35659790039062,
//                 height: 6.422752380371094,
//                 bbox: [
//                   309.8999938964844, 93.13999938964844, 414.256591796875,
//                   99.56275177001953
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content: "AGENCY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 68.54002380371094,
//                 width: 24.58125114440918,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 68.54002380371094, 46.48125076293945,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: "4.  RETROACTIVE DATE:",
//               coordinates: {
//                 x: 291.8999938964844,
//                 y: 735.9599609375,
//                 width: 78.53631591796875,
//                 height: 7.539794921875,
//                 bbox: [
//                   291.8999938964844, 735.9599609375, 370.4363098144531,
//                   743.499755859375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content:
//                 "3.  NUMBER OF EMPLOYEES COVERED BY EMPLOYEE BENEFITS PLANS:",
//               coordinates: {
//                 x: 291.8999938964844,
//                 y: 723.9599609375,
//                 width: 238.90298461914062,
//                 height: 7.539794921875,
//                 bbox: [
//                   291.8999938964844, 723.9599609375, 530.802978515625,
//                   731.499755859375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content: "2.  NUMBER OF EMPLOYEES:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 735.9599609375,
//                 width: 95.1614933013916,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 735.9599609375, 117.06149291992188,
//                   743.499755859375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 129.89999389648438,
//                 y: 723.3599853515625,
//                 width: 3.7530059814453125,
//                 height: 7.539794921875,
//                 bbox: [
//                   129.89999389648438, 723.3599853515625, 133.6529998779297,
//                   730.8997802734375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content: "1.  DEDUCTIBLE PER CLAIM:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 723.3599853515625,
//                 width: 92.17124366760254,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 723.3599853515625, 114.07124328613281,
//                   730.8997802734375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content: "EMPLOYEE BENEFITS LIABILITY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 710.3800048828125,
//                 width: 122.55848121643066,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 710.3800048828125, 144.45848083496094,
//                   719.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content: "© 1993-2016 ACORD CORPORATION.  All rights reserved.",
//               coordinates: {
//                 x: 380.0174865722656,
//                 y: 745.780029296875,
//                 width: 211.10989379882812,
//                 height: 8.65673828125,
//                 bbox: [
//                   380.0174865722656, 745.780029296875, 591.1273803710938,
//                   754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content: "ACORD 126 (2016/09)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 745.780029296875,
//                 width: 78.78650093078613,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 745.780029296875, 100.6865005493164,
//                   754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content: "The ACORD name and logo are registered marks of ACORD",
//               coordinates: {
//                 x: 196.4737548828125,
//                 y: 757.780029296875,
//                 width: 218.86770629882812,
//                 height: 8.65673828125,
//                 bbox: [
//                   196.4737548828125, 757.780029296875, 415.3414611816406,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content: "Y / N",
//               coordinates: {
//                 x: 577.1612548828125,
//                 y: 602.5400390625,
//                 width: 12.65582275390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   577.1612548828125, 602.5400390625, 589.8170776367188,
//                   608.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content:
//                 "4.  WAS TAIL COVERAGE PURCHASED UNDER ANY PREVIOUS POLICY?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 674.1599731445312,
//                 width: 232.17978858947754,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 674.1599731445312, 254.0797882080078,
//                   681.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content:
//                 "3.  HAS ANY PRODUCT, WORK, ACCIDENT, OR LOCATION BEEN EXCLUDED, UNINSURED OR SELF-INSURED FROM ANY PREVIOUS COVERAGE?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 638.1599731445312,
//                 width: 467.9846134185791,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 638.1599731445312, 489.8846130371094,
//                   645.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content: 'EXPLAIN ALL "YES" RESPONSES',
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 603.1400146484375,
//                 width: 93.20748329162598,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 603.1400146484375, 115.10748291015625,
//                   609.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content:
//                 "2.  ENTRY DATE INTO UNINTERRUPTED CLAIMS MADE COVERAGE:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 626.1599731445312,
//                 width: 219.05105018615723,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 626.1599731445312, 240.9510498046875,
//                   633.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content: "1.  PROPOSED RETROACTIVE DATE:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 614.1599731445312,
//                 width: 118.62449073791504,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 614.1599731445312, 140.5244903564453,
//                   621.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content: 'CLAIMS MADE (Explain all "Yes" responses)',
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 590.3800048828125,
//                 width: 163.9590244293213,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 590.3800048828125, 185.85902404785156,
//                   599.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content: "DATE (MM/DD/YYYY)",
//               coordinates: {
//                 x: 522.563720703125,
//                 y: 44.54002380371094,
//                 width: 57.02288818359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   522.563720703125, 44.54002380371094, 579.5866088867188,
//                   50.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content: "COMMERCIAL GENERAL LIABILITY SECTION",
//               coordinates: {
//                 x: 149.0712432861328,
//                 y: 45.701271057128906,
//                 width: 299.1587371826172,
//                 height: 15.358749389648438,
//                 bbox: [
//                   149.0712432861328, 45.701271057128906, 448.22998046875,
//                   61.060020446777344
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 13.75,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content: "LOC #",
//               coordinates: {
//                 x: 27.533750534057617,
//                 y: 356.5400085449219,
//                 width: 16.9164981842041,
//                 height: 6.4227294921875,
//                 bbox: [
//                   27.533750534057617, 356.5400085449219, 44.45024871826172,
//                   362.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content: "CLASSIFICATION DESCRIPTION",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 386.5400085449219,
//                 width: 88.60747718811035,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 386.5400085449219, 110.50747680664062,
//                   392.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content: "CLASS",
//               coordinates: {
//                 x: 101.85624694824219,
//                 y: 352.94000244140625,
//                 width: 19.46949005126953,
//                 height: 6.4227294921875,
//                 bbox: [
//                   101.85624694824219, 352.94000244140625, 121.32573699951172,
//                   359.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content: "CODE",
//               coordinates: {
//                 x: 103.59375,
//                 y: 360.1400146484375,
//                 width: 16.600242614746094,
//                 height: 6.4227294921875,
//                 bbox: [
//                   103.59375, 360.1400146484375, 120.1939926147461,
//                   366.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content: "PREMIUM",
//               coordinates: {
//                 x: 152.32374572753906,
//                 y: 352.94000244140625,
//                 width: 27.134246826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   152.32374572753906, 352.94000244140625, 179.45799255371094,
//                   359.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content: "BASIS",
//               coordinates: {
//                 x: 157.11375427246094,
//                 y: 360.1400146484375,
//                 width: 17.55474853515625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   157.11375427246094, 360.1400146484375, 174.6685028076172,
//                   366.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content: "TERR",
//               coordinates: {
//                 x: 301.77374267578125,
//                 y: 356.5400085449219,
//                 width: 15.639984130859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   301.77374267578125, 356.5400085449219, 317.4137268066406,
//                   362.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content: "EXPOSURE",
//               coordinates: {
//                 x: 223.7237548828125,
//                 y: 356.5400085449219,
//                 width: 31.918243408203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   223.7237548828125, 356.5400085449219, 255.64199829101562,
//                   362.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 52,
//               type: "text",
//               content: "HAZ #",
//               coordinates: {
//                 x: 62.193748474121094,
//                 y: 356.5400085449219,
//                 width: 16.600242614746094,
//                 height: 6.4227294921875,
//                 bbox: [
//                   62.193748474121094, 356.5400085449219, 78.79399108886719,
//                   362.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 53,
//               type: "text",
//               content: "(T) OTHER",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 576.4400024414062,
//                 width: 29.037506103515625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 576.4400024414062, 482.9375,
//                   582.8627319335938
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 54,
//               type: "text",
//               content: "(U) UNIT - PER UNIT",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 568.6400146484375,
//                 width: 54.78021240234375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 568.6400146484375, 508.6802062988281,
//                   575.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 55,
//               type: "text",
//               content: "(M) ADMISSIONS - PER 1,000/ADM",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 576.4400024414062,
//                 width: 93.20742797851562,
//                 height: 6.4227294921875,
//                 bbox: [
//                   309.8999938964844, 576.4400024414062, 403.107421875,
//                   582.8627319335938
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 56,
//               type: "text",
//               content: "(C) TOTAL COST - PER $1,000/COST",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 568.6400146484375,
//                 width: 98.31344604492188,
//                 height: 6.4227294921875,
//                 bbox: [
//                   309.8999938964844, 568.6400146484375, 408.21343994140625,
//                   575.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 57,
//               type: "text",
//               content: "(A) AREA - PER 1,000/SQ FT",
//               coordinates: {
//                 x: 165.89999389648438,
//                 y: 576.4400024414062,
//                 width: 75.64122009277344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   165.89999389648438, 576.4400024414062, 241.5412139892578,
//                   582.8627319335938
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 58,
//               type: "text",
//               content: "(P) PAYROLL - PER $1,000/PAY",
//               coordinates: {
//                 x: 165.89999389648438,
//                 y: 568.6400146484375,
//                 width: 83.00120544433594,
//                 height: 6.4227294921875,
//                 bbox: [
//                   165.89999389648438, 568.6400146484375, 248.9011993408203,
//                   575.062744140625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 59,
//               type: "text",
//               content: "(S) GROSS SALES - PER $1,000/SALES",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 576.4400024414062,
//                 width: 106.29447364807129,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 576.4400024414062, 128.19447326660156,
//                   582.8627319335938
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 60,
//               type: "text",
//               content: "RATING AND PREMIUM BASIS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 567.739990234375,
//                 width: 83.30598640441895,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 567.739990234375, 105.20598602294922,
//                   574.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 61,
//               type: "text",
//               content: "PRODUCTS",
//               coordinates: {
//                 x: 543.967529296875,
//                 y: 362.5400085449219,
//                 width: 32.24029541015625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   543.967529296875, 362.5400085449219, 576.2078247070312,
//                   368.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 62,
//               type: "text",
//               content: "PREMIUM",
//               coordinates: {
//                 x: 514.123779296875,
//                 y: 350.5400085449219,
//                 width: 27.13427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   514.123779296875, 350.5400085449219, 541.258056640625,
//                   356.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 63,
//               type: "text",
//               content: "RATE",
//               coordinates: {
//                 x: 386.5874938964844,
//                 y: 350.5400085449219,
//                 width: 15.2144775390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   386.5874938964844, 350.5400085449219, 401.8019714355469,
//                   356.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 64,
//               type: "text",
//               content:
//                 "SCHEDULE OF HAZARDS  (ACORD 211, Schedule of Hazards, may be attached if more space is required)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 338.3799743652344,
//                 width: 387.24419593811035,
//                 height: 8.656768798828125,
//                 bbox: [
//                   21.899999618530273, 338.3799743652344, 409.1441955566406,
//                   347.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 65,
//               type: "text",
//               content: "IS NOT AVAILABLE.",
//               coordinates: {
//                 x: 421.5,
//                 y: 326.5400085449219,
//                 width: 54.13616943359375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   421.5, 326.5400085449219, 475.63616943359375,
//                   332.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 66,
//               type: "text",
//               content: "IS",
//               coordinates: {
//                 x: 385.5,
//                 y: 326.5400085449219,
//                 width: 5.4222412109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   385.5, 326.5400085449219, 390.9222412109375, 332.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 67,
//               type: "text",
//               content: "2.  MEDICAL PAYMENTS COVERAGE",
//               coordinates: {
//                 x: 252.3000030517578,
//                 y: 326.5400085449219,
//                 width: 101.07914733886719,
//                 height: 6.4227294921875,
//                 bbox: [
//                   252.3000030517578, 326.5400085449219, 353.379150390625,
//                   332.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 68,
//               type: "text",
//               content: "IS NOT AVAILABLE.",
//               coordinates: {
//                 x: 155.10000610351562,
//                 y: 326.5400085449219,
//                 width: 54.13623046875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   155.10000610351562, 326.5400085449219, 209.23623657226562,
//                   332.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 69,
//               type: "text",
//               content: "IS",
//               coordinates: {
//                 x: 119.0999984741211,
//                 y: 326.5400085449219,
//                 width: 5.422248840332031,
//                 height: 6.4227294921875,
//                 bbox: [
//                   119.0999984741211, 326.5400085449219, 124.52224731445312,
//                   332.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 70,
//               type: "text",
//               content: "1.  UM / UIM COVERAGE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 326.5400085449219,
//                 width: 66.69999122619629,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 326.5400085449219, 88.59999084472656,
//                   332.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 71,
//               type: "text",
//               content:
//                 "APPLICABLE ONLY IN WISCONSIN:   IF NON-OWNED ONLY AUTO COVERAGE IS TO BE PROVIDED UNDER THE POLICY:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 314.5400085449219,
//                 width: 332.0047855377197,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 314.5400085449219, 353.90478515625,
//                   320.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 72,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 403.5,
//                 y: 268.94000244140625,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   403.5, 268.94000244140625, 406.6969909667969,
//                   275.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 73,
//               type: "text",
//               content: "OTHER:",
//               coordinates: {
//                 x: 371.1000061035156,
//                 y: 185.23997497558594,
//                 width: 21.700469970703125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   371.1000061035156, 185.23997497558594, 392.80047607421875,
//                   191.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 74,
//               type: "text",
//               content: "LOCATION",
//               coordinates: {
//                 x: 371.1000061035156,
//                 y: 173.23997497558594,
//                 width: 28.939697265625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   371.1000061035156, 173.23997497558594, 400.0397033691406,
//                   179.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 75,
//               type: "text",
//               content: "PROJECT",
//               coordinates: {
//                 x: 320.70001220703125,
//                 y: 185.23997497558594,
//                 width: 26.812225341796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   320.70001220703125, 185.23997497558594, 347.5122375488281,
//                   191.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 76,
//               type: "text",
//               content: "POLICY",
//               coordinates: {
//                 x: 320.70001220703125,
//                 y: 173.23997497558594,
//                 width: 21.067962646484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   320.70001220703125, 173.23997497558594, 341.7679748535156,
//                   179.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 77,
//               type: "text",
//               content: "LIMIT APPLIES PER:",
//               coordinates: {
//                 x: 234.3000030517578,
//                 y: 170.54002380371094,
//                 width: 56.25798034667969,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   234.3000030517578, 170.54002380371094, 290.5579833984375,
//                   176.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 78,
//               type: "text",
//               content: "GENERAL AGGREGATE",
//               coordinates: {
//                 x: 234.3000030517578,
//                 y: 158.54002380371094,
//                 width: 65.96397399902344,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   234.3000030517578, 158.54002380371094, 300.26397705078125,
//                   164.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 79,
//               type: "text",
//               content: "PRODUCTS & COMPLETED OPERATIONS AGGREGATE",
//               coordinates: {
//                 x: 234.3000030517578,
//                 y: 196.3400115966797,
//                 width: 152.76585388183594,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   234.3000030517578, 196.3400115966797, 387.06585693359375,
//                   202.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 80,
//               type: "text",
//               content: "PERSONAL & ADVERTISING INJURY",
//               coordinates: {
//                 x: 234.3000030517578,
//                 y: 208.3400115966797,
//                 width: 100.64787292480469,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   234.3000030517578, 208.3400115966797, 334.9478759765625,
//                   214.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 81,
//               type: "text",
//               content: "EACH OCCURRENCE",
//               coordinates: {
//                 x: 234.3000030517578,
//                 y: 220.3400115966797,
//                 width: 59.06391906738281,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   234.3000030517578, 220.3400115966797, 293.3639221191406,
//                   226.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 82,
//               type: "text",
//               content: "DAMAGE TO RENTED PREMISES (each occurrence)",
//               coordinates: {
//                 x: 234.3000030517578,
//                 y: 232.3400115966797,
//                 width: 142.5884552001953,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   234.3000030517578, 232.3400115966797, 376.8884582519531,
//                   238.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 83,
//               type: "text",
//               content: "MEDICAL EXPENSE (Any one person)",
//               coordinates: {
//                 x: 234.3000030517578,
//                 y: 244.3400115966797,
//                 width: 103.62074279785156,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   234.3000030517578, 244.3400115966797, 337.9207458496094,
//                   250.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 84,
//               type: "text",
//               content: "EMPLOYEE BENEFITS",
//               coordinates: {
//                 x: 234.3000030517578,
//                 y: 256.34002685546875,
//                 width: 61.90446472167969,
//                 height: 6.4227294921875,
//                 bbox: [
//                   234.3000030517578, 256.34002685546875, 296.2044677734375,
//                   262.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 85,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 403.5,
//                 y: 160.3400115966797,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   403.5, 160.3400115966797, 406.6969909667969,
//                   166.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 86,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 403.5,
//                 y: 196.3400115966797,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   403.5, 196.3400115966797, 406.6969909667969,
//                   202.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 87,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 403.5,
//                 y: 208.3400115966797,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   403.5, 208.3400115966797, 406.6969909667969,
//                   214.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 88,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 403.5,
//                 y: 220.3400115966797,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   403.5, 220.3400115966797, 406.6969909667969,
//                   226.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 89,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 403.5,
//                 y: 232.3400115966797,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   403.5, 232.3400115966797, 406.6969909667969,
//                   238.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 90,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 403.5,
//                 y: 244.3400115966797,
//                 width: 3.196990966796875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   403.5, 244.3400115966797, 406.6969909667969,
//                   250.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 91,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 403.5,
//                 y: 256.34002685546875,
//                 width: 3.196990966796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   403.5, 256.34002685546875, 406.6969909667969,
//                   262.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 92,
//               type: "text",
//               content: "COVERAGES",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 146.37998962402344,
//                 width: 49.47599983215332,
//                 height: 8.656753540039062,
//                 bbox: [
//                   21.899999618530273, 146.37998962402344, 71.3759994506836,
//                   155.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 93,
//               type: "text",
//               content: "LIMITS",
//               coordinates: {
//                 x: 234.3000030517578,
//                 y: 146.37998962402344,
//                 width: 25.365737915039062,
//                 height: 8.656753540039062,
//                 bbox: [
//                   234.3000030517578, 146.37998962402344, 259.6657409667969,
//                   155.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 94,
//               type: "text",
//               content: "TOTAL",
//               coordinates: {
//                 x: 497.1000061035156,
//                 y: 241.9399871826172,
//                 width: 18.612762451171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   497.1000061035156, 241.9399871826172, 515.7127685546875,
//                   248.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 95,
//               type: "text",
//               content: "OTHER",
//               coordinates: {
//                 x: 497.1000061035156,
//                 y: 217.9399871826172,
//                 width: 20.107757568359375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   497.1000061035156, 217.9399871826172, 517.207763671875,
//                   224.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 96,
//               type: "text",
//               content: "PRODUCTS",
//               coordinates: {
//                 x: 497.1000061035156,
//                 y: 193.9399871826172,
//                 width: 32.240264892578125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   497.1000061035156, 193.9399871826172, 529.3402709960938,
//                   200.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 97,
//               type: "text",
//               content: "PREMISES/OPERATIONS",
//               coordinates: {
//                 x: 497.1000061035156,
//                 y: 169.9399871826172,
//                 width: 68.82778930664062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   497.1000061035156, 169.9399871826172, 565.9277954101562,
//                   176.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 98,
//               type: "text",
//               content: "PREMIUMS",
//               coordinates: {
//                 x: 528.1062622070312,
//                 y: 160.3400115966797,
//                 width: 30.96380615234375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   528.1062622070312, 160.3400115966797, 559.070068359375,
//                   166.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 99,
//               type: "text",
//               content: "OCCURRENCE",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 246.8200225830078,
//                 width: 34.02427673339844,
//                 height: 5.305755615234375,
//                 bbox: [
//                   191.10000610351562, 246.8200225830078, 225.12428283691406,
//                   252.1257781982422
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 4.75,
//                 color: 0
//               }
//             },
//             {
//               id: 100,
//               type: "text",
//               content: "PER",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 240.8200225830078,
//                 width: 9.756500244140625,
//                 height: 5.305755615234375,
//                 bbox: [
//                   191.10000610351562, 240.8200225830078, 200.85650634765625,
//                   246.1257781982422
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 4.75,
//                 color: 0
//               }
//             },
//             {
//               id: 101,
//               type: "text",
//               content: "CLAIM",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 234.21998596191406,
//                 width: 14.506515502929688,
//                 height: 5.305755615234375,
//                 bbox: [
//                   191.10000610351562, 234.21998596191406, 205.6065216064453,
//                   239.52574157714844
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 4.75,
//                 color: 0
//               }
//             },
//             {
//               id: 102,
//               type: "text",
//               content: "PER",
//               coordinates: {
//                 x: 191.10000610351562,
//                 y: 228.8200225830078,
//                 width: 9.756500244140625,
//                 height: 5.305755615234375,
//                 bbox: [
//                   191.10000610351562, 228.8200225830078, 200.85650634765625,
//                   234.1257781982422
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 4.75,
//                 color: 0
//               }
//             },
//             {
//               id: 103,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 114.30000305175781,
//                 y: 245.23997497558594,
//                 width: 3.1969985961914062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   114.30000305175781, 245.23997497558594, 117.49700164794922,
//                   251.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 104,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 114.30000305175781,
//                 y: 233.23997497558594,
//                 width: 3.1969985961914062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   114.30000305175781, 233.23997497558594, 117.49700164794922,
//                   239.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 105,
//               type: "text",
//               content: "BODILY INJURY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 233.23997497558594,
//                 width: 42.77998733520508,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 233.23997497558594, 79.07998657226562,
//                   239.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 106,
//               type: "text",
//               content: "$",
//               coordinates: {
//                 x: 113.60124969482422,
//                 y: 221.23997497558594,
//                 width: 3.1969985961914062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   113.60124969482422, 221.23997497558594, 116.79824829101562,
//                   227.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 107,
//               type: "text",
//               content: "PROPERTY DAMAGE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 221.23997497558594,
//                 width: 57.87948989868164,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 221.23997497558594, 94.17948913574219,
//                   227.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 108,
//               type: "text",
//               content: "DEDUCTIBLES",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 206.54002380371094,
//                 width: 40.853750228881836,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 206.54002380371094, 62.75374984741211,
//                   212.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 109,
//               type: "text",
//               content: "OCCURRENCE",
//               coordinates: {
//                 x: 140.6999969482422,
//                 y: 173.23997497558594,
//                 width: 41.18727111816406,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   140.6999969482422, 173.23997497558594, 181.88726806640625,
//                   179.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 110,
//               type: "text",
//               content: "CLAIMS MADE",
//               coordinates: {
//                 x: 50.70000076293945,
//                 y: 173.23997497558594,
//                 width: 39.58298873901367,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   50.70000076293945, 173.23997497558594, 90.28298950195312,
//                   179.6627197265625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 111,
//               type: "text",
//               content: "OWNER'S & CONTRACTOR'S PROTECTIVE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 184.3400115966797,
//                 width: 118.78921890258789,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 184.3400115966797, 155.08921813964844,
//                   190.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 112,
//               type: "text",
//               content: "COMMERCIAL GENERAL LIABILITY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 158.54002380371094,
//                 width: 98.0834846496582,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 158.54002380371094, 134.38348388671875,
//                   164.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 113,
//               type: "text",
//               content:
//                 "OTHER COVERAGES, RESTRICTIONS AND/OR ENDORSEMENTS (For hired/non-owned auto coverages attach the applicable state Business Auto Section, ACORD 137)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 279.1400146484375,
//                 width: 457.38360023498535,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 279.1400146484375, 479.2835998535156,
//                   285.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 114,
//               type: "text",
//               content:
//                 "IMPORTANT - If CLAIMS MADE is checked in the COVERAGE / LIMITS section below, this is an application for a claims-made policy.",
//               coordinates: {
//                 x: 25.5,
//                 y: 119.37998962402344,
//                 width: 484.6231384277344,
//                 height: 8.656753540039062,
//                 bbox: [
//                   25.5, 119.37998962402344, 510.1231384277344, 128.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 115,
//               type: "text",
//               content: "Read all provisions of the policy carefully.",
//               coordinates: {
//                 x: 25.5,
//                 y: 128.9800262451172,
//                 width: 154.28700256347656,
//                 height: 8.656753540039062,
//                 bbox: [
//                   25.5, 128.9800262451172, 179.78700256347656,
//                   137.63677978515625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 116,
//               type: "text",
//               content: "Attach to ACORD 125",
//               coordinates: {
//                 x: 266.8275146484375,
//                 y: 745.780029296875,
//                 width: 78.89495849609375,
//                 height: 8.65673828125,
//                 bbox: [
//                   266.8275146484375, 745.780029296875, 345.72247314453125,
//                   754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 117,
//               type: "text",
//               content: "PREM / OPS",
//               coordinates: {
//                 x: 476.72625732421875,
//                 y: 362.5400085449219,
//                 width: 33.505218505859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   476.72625732421875, 362.5400085449219, 510.2314758300781,
//                   368.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 118,
//               type: "text",
//               content: "PREM / OPS",
//               coordinates: {
//                 x: 343.5262451171875,
//                 y: 362.5400085449219,
//                 width: 33.505218505859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   343.5262451171875, 362.5400085449219, 377.0314636230469,
//                   368.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 119,
//               type: "text",
//               content: "PRODUCTS",
//               coordinates: {
//                 x: 410.7674865722656,
//                 y: 362.5400085449219,
//                 width: 32.240203857421875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   410.7674865722656, 362.5400085449219, 443.0076904296875,
//                   368.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 120,
//               type: "text",
//               content: "LOC #",
//               coordinates: {
//                 x: 27.533750534057617,
//                 y: 428.5400085449219,
//                 width: 16.9164981842041,
//                 height: 6.4227294921875,
//                 bbox: [
//                   27.533750534057617, 428.5400085449219, 44.45024871826172,
//                   434.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 121,
//               type: "text",
//               content: "HAZ #",
//               coordinates: {
//                 x: 62.193748474121094,
//                 y: 428.5400085449219,
//                 width: 16.600242614746094,
//                 height: 6.4227294921875,
//                 bbox: [
//                   62.193748474121094, 428.5400085449219, 78.79399108886719,
//                   434.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 122,
//               type: "text",
//               content: "CLASS",
//               coordinates: {
//                 x: 101.85624694824219,
//                 y: 424.94000244140625,
//                 width: 19.46949005126953,
//                 height: 6.4227294921875,
//                 bbox: [
//                   101.85624694824219, 424.94000244140625, 121.32573699951172,
//                   431.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 123,
//               type: "text",
//               content: "CODE",
//               coordinates: {
//                 x: 103.59375,
//                 y: 432.1400146484375,
//                 width: 16.600242614746094,
//                 height: 6.4227294921875,
//                 bbox: [
//                   103.59375, 432.1400146484375, 120.1939926147461,
//                   438.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 124,
//               type: "text",
//               content: "PREMIUM",
//               coordinates: {
//                 x: 152.32374572753906,
//                 y: 424.94000244140625,
//                 width: 27.134246826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   152.32374572753906, 424.94000244140625, 179.45799255371094,
//                   431.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 125,
//               type: "text",
//               content: "BASIS",
//               coordinates: {
//                 x: 157.11375427246094,
//                 y: 432.1400146484375,
//                 width: 17.55474853515625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   157.11375427246094, 432.1400146484375, 174.6685028076172,
//                   438.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 126,
//               type: "text",
//               content: "CLASSIFICATION DESCRIPTION",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 530.5400390625,
//                 width: 88.60747718811035,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 530.5400390625, 110.50747680664062,
//                   536.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 127,
//               type: "text",
//               content: "EXPOSURE",
//               coordinates: {
//                 x: 223.7237548828125,
//                 y: 428.5400085449219,
//                 width: 31.918243408203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   223.7237548828125, 428.5400085449219, 255.64199829101562,
//                   434.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 128,
//               type: "text",
//               content: "TERR",
//               coordinates: {
//                 x: 301.77374267578125,
//                 y: 428.5400085449219,
//                 width: 15.639984130859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   301.77374267578125, 428.5400085449219, 317.4137268066406,
//                   434.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 129,
//               type: "text",
//               content: "PREM / OPS",
//               coordinates: {
//                 x: 343.5262451171875,
//                 y: 434.5400085449219,
//                 width: 33.505218505859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   343.5262451171875, 434.5400085449219, 377.0314636230469,
//                   440.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 130,
//               type: "text",
//               content: "RATE",
//               coordinates: {
//                 x: 386.5874938964844,
//                 y: 422.5400085449219,
//                 width: 15.2144775390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   386.5874938964844, 422.5400085449219, 401.8019714355469,
//                   428.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 131,
//               type: "text",
//               content: "PRODUCTS",
//               coordinates: {
//                 x: 410.7674865722656,
//                 y: 434.5400085449219,
//                 width: 32.240203857421875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   410.7674865722656, 434.5400085449219, 443.0076904296875,
//                   440.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 132,
//               type: "text",
//               content: "PREM / OPS",
//               coordinates: {
//                 x: 476.72625732421875,
//                 y: 434.5400085449219,
//                 width: 33.505218505859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   476.72625732421875, 434.5400085449219, 510.2314758300781,
//                   440.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 133,
//               type: "text",
//               content: "PREMIUM",
//               coordinates: {
//                 x: 514.123779296875,
//                 y: 422.5400085449219,
//                 width: 27.13427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   514.123779296875, 422.5400085449219, 541.258056640625,
//                   428.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 134,
//               type: "text",
//               content: "PRODUCTS",
//               coordinates: {
//                 x: 543.967529296875,
//                 y: 434.5400085449219,
//                 width: 32.24029541015625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   543.967529296875, 434.5400085449219, 576.2078247070312,
//                   440.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 135,
//               type: "text",
//               content: "LOC #",
//               coordinates: {
//                 x: 27.533750534057617,
//                 y: 500.5400085449219,
//                 width: 16.9164981842041,
//                 height: 6.4227294921875,
//                 bbox: [
//                   27.533750534057617, 500.5400085449219, 44.45024871826172,
//                   506.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 136,
//               type: "text",
//               content: "HAZ #",
//               coordinates: {
//                 x: 62.193748474121094,
//                 y: 500.5400085449219,
//                 width: 16.600242614746094,
//                 height: 6.4227294921875,
//                 bbox: [
//                   62.193748474121094, 500.5400085449219, 78.79399108886719,
//                   506.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 137,
//               type: "text",
//               content: "CLASS",
//               coordinates: {
//                 x: 101.85624694824219,
//                 y: 496.94000244140625,
//                 width: 19.46949005126953,
//                 height: 6.4227294921875,
//                 bbox: [
//                   101.85624694824219, 496.94000244140625, 121.32573699951172,
//                   503.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 138,
//               type: "text",
//               content: "CODE",
//               coordinates: {
//                 x: 103.59375,
//                 y: 504.1400146484375,
//                 width: 16.600242614746094,
//                 height: 6.4227294921875,
//                 bbox: [
//                   103.59375, 504.1400146484375, 120.1939926147461,
//                   510.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 139,
//               type: "text",
//               content: "PREMIUM",
//               coordinates: {
//                 x: 152.32374572753906,
//                 y: 496.94000244140625,
//                 width: 27.134246826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   152.32374572753906, 496.94000244140625, 179.45799255371094,
//                   503.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 140,
//               type: "text",
//               content: "BASIS",
//               coordinates: {
//                 x: 157.11375427246094,
//                 y: 504.1400146484375,
//                 width: 17.55474853515625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   157.11375427246094, 504.1400146484375, 174.6685028076172,
//                   510.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 141,
//               type: "text",
//               content: "EXPOSURE",
//               coordinates: {
//                 x: 223.7237548828125,
//                 y: 500.5400085449219,
//                 width: 31.918243408203125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   223.7237548828125, 500.5400085449219, 255.64199829101562,
//                   506.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 142,
//               type: "text",
//               content: "TERR",
//               coordinates: {
//                 x: 301.77374267578125,
//                 y: 500.5400085449219,
//                 width: 15.639984130859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   301.77374267578125, 500.5400085449219, 317.4137268066406,
//                   506.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 143,
//               type: "text",
//               content: "PREM / OPS",
//               coordinates: {
//                 x: 343.5262451171875,
//                 y: 506.5400085449219,
//                 width: 33.505218505859375,
//                 height: 6.422760009765625,
//                 bbox: [
//                   343.5262451171875, 506.5400085449219, 377.0314636230469,
//                   512.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 144,
//               type: "text",
//               content: "PRODUCTS",
//               coordinates: {
//                 x: 410.7674865722656,
//                 y: 506.5400085449219,
//                 width: 32.240203857421875,
//                 height: 6.422760009765625,
//                 bbox: [
//                   410.7674865722656, 506.5400085449219, 443.0076904296875,
//                   512.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 145,
//               type: "text",
//               content: "RATE",
//               coordinates: {
//                 x: 386.5874938964844,
//                 y: 494.5400085449219,
//                 width: 15.2144775390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   386.5874938964844, 494.5400085449219, 401.8019714355469,
//                   500.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 146,
//               type: "text",
//               content: "PREM / OPS",
//               coordinates: {
//                 x: 476.72625732421875,
//                 y: 506.5400085449219,
//                 width: 33.505218505859375,
//                 height: 6.422760009765625,
//                 bbox: [
//                   476.72625732421875, 506.5400085449219, 510.2314758300781,
//                   512.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 147,
//               type: "text",
//               content: "PRODUCTS",
//               coordinates: {
//                 x: 543.967529296875,
//                 y: 506.5400085449219,
//                 width: 32.24029541015625,
//                 height: 6.422760009765625,
//                 bbox: [
//                   543.967529296875, 506.5400085449219, 576.2078247070312,
//                   512.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 148,
//               type: "text",
//               content: "PREMIUM",
//               coordinates: {
//                 x: 514.123779296875,
//                 y: 494.5400085449219,
//                 width: 27.13427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   514.123779296875, 494.5400085449219, 541.258056640625,
//                   500.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 149,
//               type: "text",
//               content: "CLASSIFICATION DESCRIPTION",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 458.5400085449219,
//                 width: 88.60747718811035,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 458.5400085449219, 110.50747680664062,
//                   464.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 41.26749469857623,
//                 width: 577.68,
//                 height: 103.40866404119959,
//                 bbox: [
//                   17.28, 41.26749469857623, 594.9599999999999,
//                   144.67615873977581
//                 ]
//               },
//               properties: {
//                 rows: 4,
//                 columns: 5,
//                 accuracy: 86.253
//               }
//             },
//             {
//               id: 1,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 155.232959709179,
//                 width: 577.68,
//                 height: 181.38503483792795,
//                 bbox: [
//                   17.28, 155.232959709179, 594.9599999999999, 336.61799454710695
//                 ]
//               },
//               properties: {
//                 rows: 13,
//                 columns: 19,
//                 accuracy: 65.938
//               }
//             },
//             {
//               id: 2,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 347.4147228112693,
//                 width: 577.4399999999999,
//                 height: 241.36685852771888,
//                 bbox: [
//                   17.52, 347.4147228112693, 594.9599999999999, 588.7815813389882
//                 ]
//               },
//               properties: {
//                 rows: 13,
//                 columns: 10,
//                 accuracy: 86.272
//               }
//             },
//             {
//               id: 3,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 599.3383823083914,
//                 width: 577.68,
//                 height: 109.40684641017879,
//                 bbox: [
//                   17.28, 599.3383823083914, 594.9599999999999, 708.7452287185702
//                 ]
//               },
//               properties: {
//                 rows: 5,
//                 columns: 2,
//                 accuracy: 100
//               }
//             },
//             {
//               id: 4,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 719.3020296879733,
//                 width: 577.68,
//                 height: 25.43229324447134,
//                 bbox: [
//                   17.28, 719.3020296879733, 594.9599999999999, 744.7343229324447
//                 ]
//               },
//               properties: {
//                 rows: 2,
//                 columns: 2,
//                 accuracy: 100
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 150,
//           table_count: 5,
//           total_elements: 155
//         }
//       },
//       {
//         page_number: 15,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 415.20001220703125,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   415.20001220703125, 25.188751220703125, 447.44805908203125,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 55.188751220703125,
//                 width: 5.2344970703125,
//                 height: 8.098247528076172,
//                 bbox: [
//                   580.8825073242188, 55.188751220703125, 586.1170043945312,
//                   63.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 91.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 91.18875122070312, 586.1170043945312,
//                   99.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 127.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 127.18875122070312, 586.1170043945312,
//                   135.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 163.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 163.18875122070312, 586.1170043945312,
//                   171.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 199.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 199.18875122070312, 586.1170043945312,
//                   207.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 235.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 235.18875122070312, 586.1170043945312,
//                   243.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 415.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 415.1887512207031, 586.1170043945312,
//                   423.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 451.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 451.1887512207031, 586.1170043945312,
//                   459.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 463.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 463.1887512207031, 586.1170043945312,
//                   471.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 499.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 499.1887512207031, 586.1170043945312,
//                   507.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 535.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 535.188720703125, 586.1170043945312,
//                   543.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 571.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 571.188720703125, 586.1170043945312,
//                   579.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 607.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 607.188720703125, 586.1170043945312,
//                   615.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 643.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 643.188720703125, 586.1170043945312,
//                   651.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 679.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 679.188720703125, 586.1170043945312,
//                   687.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 715.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 715.188720703125, 586.1170043945312,
//                   723.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "Page 2 of 4",
//               coordinates: {
//                 x: 285.84124755859375,
//                 y: 757.780029296875,
//                 width: 40.873504638671875,
//                 height: 8.65673828125,
//                 bbox: [
//                   285.84124755859375, 757.780029296875, 326.7147521972656,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 317.0350036621094,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   317.0350036621094, 26.379987716674805, 408.8182373046875,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "CONTRACTORS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 32.37998962402344,
//                 width: 60.0935001373291,
//                 height: 8.656749725341797,
//                 bbox: [
//                   21.899999618530273, 32.37998962402344, 81.99349975585938,
//                   41.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "TIME STAFF:",
//               coordinates: {
//                 x: 515.0999755859375,
//                 y: 276.1400146484375,
//                 width: 35.30511474609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   515.0999755859375, 276.1400146484375, 550.4050903320312,
//                   282.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content: "# PART-",
//               coordinates: {
//                 x: 515.0999755859375,
//                 y: 270.739990234375,
//                 width: 21.60284423828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   515.0999755859375, 270.739990234375, 536.7028198242188,
//                   277.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "TIME STAFF:",
//               coordinates: {
//                 x: 428.70001220703125,
//                 y: 276.1400146484375,
//                 width: 35.305023193359375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   428.70001220703125, 276.1400146484375, 464.0050354003906,
//                   282.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "# FULL-",
//               coordinates: {
//                 x: 428.70001220703125,
//                 y: 270.739990234375,
//                 width: 21.378509521484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   428.70001220703125, 270.739990234375, 450.0785217285156,
//                   277.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "SUBCONTRACTED:",
//               coordinates: {
//                 x: 335.1000061035156,
//                 y: 276.1400146484375,
//                 width: 54.2684326171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   335.1000061035156, 276.1400146484375, 389.3684387207031,
//                   282.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content: "% OF WORK",
//               coordinates: {
//                 x: 335.1000061035156,
//                 y: 270.739990234375,
//                 width: 34.4654541015625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   335.1000061035156, 270.739990234375, 369.5654602050781,
//                   277.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: "CONTRACTORS:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 276.1400146484375,
//                 width: 46.50028991699219,
//                 height: 6.4227294921875,
//                 bbox: [
//                   212.6999969482422, 276.1400146484375, 259.2002868652344,
//                   282.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content: "$ PAID TO SUB-",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 270.739990234375,
//                 width: 43.19398498535156,
//                 height: 6.4227294921875,
//                 bbox: [
//                   212.6999969482422, 270.739990234375, 255.89398193359375,
//                   277.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content: "DESCRIBE THE TYPE OF WORK SUBCONTRACTED",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 272.5400390625,
//                 width: 142.6575107574463,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 272.5400390625, 164.55751037597656,
//                   278.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content:
//                 "6.  DOES APPLICANT LEASE EQUIPMENT TO OTHERS WITH OR WITHOUT OPERATORS?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 236.1599884033203,
//                 width: 285.349573135376,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 236.1599884033203, 307.24957275390625,
//                   243.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content:
//                 "5.  ARE SUBCONTRACTORS ALLOWED TO WORK WITHOUT PROVIDING YOU WITH A CERTIFICATE OF INSURANCE?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 200.1599884033203,
//                 width: 374.8951358795166,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 200.1599884033203, 396.7951354980469,
//                   207.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content:
//                 "4.  DO YOUR SUBCONTRACTORS CARRY COVERAGES OR LIMITS LESS THAN YOURS?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 164.1599884033203,
//                 width: 282.5213260650635,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 164.1599884033203, 304.42132568359375,
//                   171.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content:
//                 "3.  DO ANY OPERATIONS INCLUDE EXCAVATION, TUNNELING, UNDERGROUND WORK OR EARTH MOVING?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 128.1599884033203,
//                 width: 348.3271427154541,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 128.1599884033203, 370.2271423339844,
//                   135.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content:
//                 "2.  DO ANY OPERATIONS INCLUDE BLASTING OR UTILIZE OR STORE EXPLOSIVE MATERIAL?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 92.15998840332031,
//                 width: 301.46856117248535,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 92.15998840332031, 323.3685607910156,
//                   99.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content:
//                 "1.  DOES APPLICANT DRAW PLANS, DESIGNS, OR SPECIFICATIONS FOR OTHERS?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 56.15998840332031,
//                 width: 268.85930824279785,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 56.15998840332031, 290.7593078613281,
//                   63.699737548828125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content: "Y / N",
//               coordinates: {
//                 x: 577.1612548828125,
//                 y: 44.54002380371094,
//                 width: 12.65582275390625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   577.1612548828125, 44.54002380371094, 589.8170776367188,
//                   50.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content:
//                 'EXPLAIN ALL "YES" RESPONSES (For all past or present operations)',
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 44.54002380371094,
//                 width: 189.9110507965088,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 44.54002380371094, 211.81105041503906,
//                   50.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content: "PRODUCTS / COMPLETED OPERATIONS",
//               coordinates: {
//                 x: 25.5,
//                 y: 308.3799743652344,
//                 width: 151.26449584960938,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 308.3799743652344, 176.76449584960938, 317.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content: "PRINCIPAL COMPONENTS",
//               coordinates: {
//                 x: 498.26873779296875,
//                 y: 322.34002685546875,
//                 width: 73.1976318359375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   498.26873779296875, 322.34002685546875, 571.4663696289062,
//                   328.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content: "INTENDED USE",
//               coordinates: {
//                 x: 392.5950012207031,
//                 y: 322.34002685546875,
//                 width: 42.7684326171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   392.5950012207031, 322.34002685546875, 435.3634338378906,
//                   328.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content: "LIFE",
//               coordinates: {
//                 x: 328.5712585449219,
//                 y: 324.1400146484375,
//                 width: 12.437255859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   328.5712585449219, 324.1400146484375, 341.0085144042969,
//                   330.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content: "EXPECTED",
//               coordinates: {
//                 x: 319.3037414550781,
//                 y: 318.7400207519531,
//                 width: 30.957977294921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   319.3037414550781, 318.7400207519531, 350.26171875,
//                   325.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content: "MARKET",
//               coordinates: {
//                 x: 286.50250244140625,
//                 y: 324.1400146484375,
//                 width: 24.58123779296875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   286.50250244140625, 324.1400146484375, 311.083740234375,
//                   330.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content: "TIME IN",
//               coordinates: {
//                 x: 288.5587463378906,
//                 y: 318.7400207519531,
//                 width: 21.056488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   288.5587463378906, 318.7400207519531, 309.615234375,
//                   325.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content: "# OF UNITS",
//               coordinates: {
//                 x: 225.68624877929688,
//                 y: 322.34002685546875,
//                 width: 31.59051513671875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   225.68624877929688, 322.34002685546875, 257.2767639160156,
//                   328.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content: "ANNUAL GROSS SALES",
//               coordinates: {
//                 x: 128.3487548828125,
//                 y: 322.34002685546875,
//                 width: 67.24050903320312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   128.3487548828125, 322.34002685546875, 195.58926391601562,
//                   328.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content: "PRODUCTS",
//               coordinates: {
//                 x: 54.36750030517578,
//                 y: 322.34002685546875,
//                 width: 32.240234375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   54.36750030517578, 322.34002685546875, 86.60773468017578,
//                   328.76275634765625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content: "Y / N",
//               coordinates: {
//                 x: 577.1612548828125,
//                 y: 404.5400085449219,
//                 width: 12.65582275390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   577.1612548828125, 404.5400085449219, 589.8170776367188,
//                   410.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content:
//                 'EXPLAIN ALL "YES" RESPONSES (For all past or present products or operations)    PLEASE ATTACH LITERATURE, BROCHURES, LABELS, WARNINGS, ETC.',
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 404.5400085449219,
//                 width: 431.8994998931885,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 404.5400085449219, 453.79949951171875,
//                   410.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content:
//                 "1.   DOES APPLICANT INSTALL, SERVICE OR DEMONSTRATE PRODUCTS?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 416.15997314453125,
//                 width: 239.6655216217041,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 416.15997314453125, 261.5655212402344,
//                   423.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content:
//                 '2.   FOREIGN PRODUCTS SOLD, DISTRIBUTED, USED AS COMPONENTS?  (If "YES", attach ACORD 815)',
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 452.15997314453125,
//                 width: 330.736536026001,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 452.15997314453125, 352.63653564453125,
//                   459.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content:
//                 "3.   RESEARCH AND DEVELOPMENT CONDUCTED OR NEW PRODUCTS PLANNED?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 464.15997314453125,
//                 width: 268.9200687408447,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 464.15997314453125, 290.820068359375,
//                   471.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 52,
//               type: "text",
//               content: "4.   GUARANTEES, WARRANTIES, HOLD HARMLESS AGREEMENTS?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 500.15997314453125,
//                 width: 220.05681800842285,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 500.15997314453125, 241.95681762695312,
//                   507.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 53,
//               type: "text",
//               content: "5.   PRODUCTS RELATED TO AIRCRAFT/SPACE INDUSTRY?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 536.1599731445312,
//                 width: 191.95652198791504,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 536.1599731445312, 213.8565216064453,
//                   543.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 54,
//               type: "text",
//               content: "6.   PRODUCTS RECALLED, DISCONTINUED, CHANGED?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 572.1599731445312,
//                 width: 182.8575382232666,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 572.1599731445312, 204.75753784179688,
//                   579.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 55,
//               type: "text",
//               content:
//                 "7.   PRODUCTS OF OTHERS SOLD OR RE-PACKAGED UNDER APPLICANT LABEL?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 608.1599731445312,
//                 width: 264.2828311920166,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 608.1599731445312, 286.1828308105469,
//                   615.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 56,
//               type: "text",
//               content: "8.   PRODUCTS UNDER LABEL OF OTHERS?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 644.1599731445312,
//                 width: 142.50599098205566,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 644.1599731445312, 164.40599060058594,
//                   651.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 57,
//               type: "text",
//               content: "9.   VENDORS COVERAGE REQUIRED?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 680.1599731445312,
//                 width: 125.89425086975098,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 680.1599731445312, 147.79425048828125,
//                   687.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 58,
//               type: "text",
//               content:
//                 "10. DOES ANY NAMED INSURED SELL TO OTHER NAMED INSUREDS?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 716.1599731445312,
//                 width: 225.33529090881348,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 716.1599731445312, 247.23529052734375,
//                   723.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 59,
//               type: "text",
//               content: "ACORD 126 (2016/09)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 757.780029296875,
//                 width: 78.78650093078613,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 757.780029296875, 100.6865005493164,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 41.26749469857623,
//                 width: 577.68,
//                 height: 265.3595880036352,
//                 bbox: [
//                   17.28, 41.26749469857623, 594.9599999999999,
//                   306.62708270221145
//                 ]
//               },
//               properties: {
//                 rows: 9,
//                 columns: 6,
//                 accuracy: 88.261
//               }
//             },
//             {
//               id: 1,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 317.4238109663738,
//                 width: 577.4399999999999,
//                 height: 439.30687670402904,
//                 bbox: [
//                   17.52, 317.4238109663738, 594.9599999999999, 756.7306876704029
//                 ]
//               },
//               properties: {
//                 rows: 15,
//                 columns: 8,
//                 accuracy: 78.039
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 60,
//           table_count: 2,
//           total_elements: 62
//         }
//       },
//       {
//         page_number: 16,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 415.20001220703125,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   415.20001220703125, 25.188751220703125, 447.44805908203125,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "Buckingham Managment",
//               coordinates: {
//                 x: 127.19999694824219,
//                 y: 73.18875122070312,
//                 width: 80.16331481933594,
//                 height: 8.098251342773438,
//                 bbox: [
//                   127.19999694824219, 73.18875122070312, 207.36331176757812,
//                   81.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "144 S Entertainment Ave Ste",
//               coordinates: {
//                 x: 127.19999694824219,
//                 y: 85.18875122070312,
//                 width: 92.8798828125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   127.19999694824219, 85.18875122070312, 220.0798797607422,
//                   93.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "Boise",
//               coordinates: {
//                 x: 127.19999694824219,
//                 y: 109.18875122070312,
//                 width: 18.125015258789062,
//                 height: 8.098251342773438,
//                 bbox: [
//                   127.19999694824219, 109.18875122070312, 145.32501220703125,
//                   117.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 357.6000061035156,
//                 y: 109.18875122070312,
//                 width: 10.86773681640625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   357.6000061035156, 109.18875122070312, 368.4677429199219,
//                   117.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "83709",
//               coordinates: {
//                 x: 375.6000061035156,
//                 y: 109.18875122070312,
//                 width: 20.155029296875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   375.6000061035156, 109.18875122070312, 395.7550354003906,
//                   117.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 169.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 169.18875122070312, 586.1170043945312,
//                   177.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 205.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 205.18875122070312, 586.1170043945312,
//                   213.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 241.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 241.18875122070312, 586.1170043945312,
//                   249.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 289.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 289.1887512207031, 586.1170043945312,
//                   297.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 337.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 337.1887512207031, 586.1170043945312,
//                   345.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 385.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 385.1887512207031, 586.1170043945312,
//                   393.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 421.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 421.1887512207031, 586.1170043945312,
//                   429.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 457.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 457.1887512207031, 586.1170043945312,
//                   465.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 493.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 493.1887512207031, 586.1170043945312,
//                   501.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 565.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 565.188720703125, 586.1170043945312,
//                   573.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 589.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 589.188720703125, 586.1170043945312,
//                   597.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 679.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 679.188720703125, 586.1170043945312,
//                   687.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 715.188720703125,
//                 width: 5.2344970703125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   580.8825073242188, 715.188720703125, 586.1170043945312,
//                   723.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 317.0350036621094,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   317.0350036621094, 26.379987716674805, 408.8182373046875,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "Page 3 of 4",
//               coordinates: {
//                 x: 285.84124755859375,
//                 y: 757.780029296875,
//                 width: 40.873504638671875,
//                 height: 8.65673828125,
//                 bbox: [
//                   285.84124755859375, 757.780029296875, 326.7147521972656,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 126.30000305175781,
//                 y: 134.54002380371094,
//                 width: 63.1925048828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   126.30000305175781, 134.54002380371094, 189.4925079345703,
//                   140.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 241.5,
//                 y: 50.54002380371094,
//                 width: 31.279998779296875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   241.5, 50.54002380371094, 272.7799987792969, 56.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 194.6999969482422,
//                 y: 50.54002380371094,
//                 width: 18.520767211914062,
//                 height: 6.422752380371094,
//                 bbox: [
//                   194.6999969482422, 50.54002380371094, 213.22076416015625,
//                   56.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 295.5,
//                 y: 50.54002380371094,
//                 width: 37.547454833984375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   295.5, 50.54002380371094, 333.0474548339844, 56.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 126.30000305175781,
//                 y: 50.54002380371094,
//                 width: 60.23126220703125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   126.30000305175781, 50.54002380371094, 186.53126525878906,
//                   56.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: "ACORD 45 attached for additional names",
//               coordinates: {
//                 x: 263.1000061035156,
//                 y: 38.98002624511719,
//                 width: 151.02423095703125,
//                 height: 8.656749725341797,
//                 bbox: [
//                   263.1000061035156, 38.98002624511719, 414.1242370605469,
//                   47.636775970458984
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content: "ADDITIONAL INTEREST / CERTIFICATE RECIPIENT",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 38.37998962402344,
//                 width: 188.5187168121338,
//                 height: 8.656749725341797,
//                 bbox: [
//                   21.899999618530273, 38.37998962402344, 210.41871643066406,
//                   47.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content: "ITEM:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 74.54002380371094,
//                 width: 15.63427734375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   525.9000244140625, 74.54002380371094, 541.5343017578125,
//                   80.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content: "CLASS:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 77.54002380371094,
//                 width: 21.384246826171875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   453.8999938964844, 77.54002380371094, 475.28424072265625,
//                   83.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content: "ITEM",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 72.13999938964844,
//                 width: 13.719512939453125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   453.8999938964844, 72.13999938964844, 467.6195068359375,
//                   78.56275177001953
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content: "ITEM DESCRIPTION",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 86.54002380371094,
//                 width: 54.56744384765625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   453.8999938964844, 86.54002380371094, 508.4674377441406,
//                   92.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content: "BUILDING:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 64.34001159667969,
//                 width: 29.6815185546875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   525.9000244140625, 64.34001159667969, 555.58154296875,
//                   70.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 64.34001159667969,
//                 width: 31.486968994140625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   453.8999938964844, 64.34001159667969, 485.386962890625,
//                   70.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 52.34001159667969,
//                 width: 77.8665771484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   483.3275146484375, 52.34001159667969, 561.194091796875,
//                   58.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content: "EMPLOYEE AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 74.54002380371094,
//                 width: 66.48147964477539,
//                 height: 6.422752380371094,
//                 bbox: [
//                   36.29999923706055, 74.54002380371094, 102.78147888183594,
//                   80.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 98.54002380371094,
//                 width: 37.34049606323242,
//                 height: 6.422752380371094,
//                 bbox: [
//                   36.29999923706055, 98.54002380371094, 73.64049530029297,
//                   104.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content: "MORTGAGEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 122.54002380371094,
//                 width: 37.66249465942383,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 122.54002380371094, 73.96249389648438,
//                   128.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 110.54002380371094,
//                 width: 35.747745513916016,
//                 height: 6.422752380371094,
//                 bbox: [
//                   36.29999923706055, 110.54002380371094, 72.04774475097656,
//                   116.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content: "ADDITIONAL INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 62.54002380371094,
//                 width: 62.77273178100586,
//                 height: 6.422752380371094,
//                 bbox: [
//                   36.29999923706055, 62.54002380371094, 99.0727310180664,
//                   68.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 50.54002380371094,
//                 width: 28.399248123168945,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 50.54002380371094, 50.29924774169922,
//                   56.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content: "LARGE EQUIPMENT",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 374.84002685546875,
//                 width: 55.217193603515625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   414.29998779296875, 374.84002685546875, 469.5171813964844,
//                   381.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content: "SMALL TOOLS",
//               coordinates: {
//                 x: 349.5,
//                 y: 374.84002685546875,
//                 width: 39.485260009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   349.5, 374.84002685546875, 388.9852600097656,
//                   381.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content: "EQUIPMENT",
//               coordinates: {
//                 x: 39.900001525878906,
//                 y: 350.5400085449219,
//                 width: 34.14924621582031,
//                 height: 6.4227294921875,
//                 bbox: [
//                   39.900001525878906, 350.5400085449219, 74.04924774169922,
//                   356.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content: "INSTRUCTION GIVEN (Y/N)",
//               coordinates: {
//                 x: 478.2037353515625,
//                 y: 350.5400085449219,
//                 width: 73.715087890625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   478.2037353515625, 350.5400085449219, 551.9188232421875,
//                   356.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content: "LARGE EQUIPMENT",
//               coordinates: {
//                 x: 414.29998779296875,
//                 y: 362.84002685546875,
//                 width: 55.217193603515625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   414.29998779296875, 362.84002685546875, 469.5171813964844,
//                   369.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content: "SMALL TOOLS",
//               coordinates: {
//                 x: 349.5,
//                 y: 362.84002685546875,
//                 width: 39.485260009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   349.5, 362.84002685546875, 388.9852600097656,
//                   369.26275634765625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content: "TYPE OF EQUIPMENT",
//               coordinates: {
//                 x: 373.010009765625,
//                 y: 350.5400085449219,
//                 width: 60.30596923828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   373.010009765625, 350.5400085449219, 433.31597900390625,
//                   356.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content: "DO YOU RENT OR LOAN EQUIPMENT TO OTHERS?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 338.15997314453125,
//                 width: 165.36151504516602,
//                 height: 7.539764404296875,
//                 bbox: [
//                   36.29999923706055, 338.15997314453125, 201.66151428222656,
//                   345.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content: "5.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 338.15997314453125,
//                 width: 5.622751235961914,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 338.15997314453125, 27.522750854492188,
//                   345.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content: "ANY DEMOLITION EXPOSURE CONTEMPLATED?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 716.1599731445312,
//                 width: 157.49776077270508,
//                 height: 7.539794921875,
//                 bbox: [
//                   36.29999923706055, 716.1599731445312, 193.79776000976562,
//                   723.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content: "15.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 716.1599731445312,
//                 width: 9.375749588012695,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 716.1599731445312, 31.27574920654297,
//                   723.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 52,
//               type: "text",
//               content: "ANY STRUCTURAL ALTERATIONS CONTEMPLATED?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 680.1599731445312,
//                 width: 168.62175369262695,
//                 height: 7.539794921875,
//                 bbox: [
//                   36.29999923706055, 680.1599731445312, 204.9217529296875,
//                   687.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 53,
//               type: "text",
//               content: "14.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 680.1599731445312,
//                 width: 9.375749588012695,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 680.1599731445312, 31.27574920654297,
//                   687.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 54,
//               type: "text",
//               content: "CONTACT",
//               coordinates: {
//                 x: 409.1600036621094,
//                 y: 637.9400024414062,
//                 width: 27.6632080078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   409.1600036621094, 637.9400024414062, 436.8232116699219,
//                   644.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 55,
//               type: "text",
//               content: "SPORT (Y/N)",
//               coordinates: {
//                 x: 405.5899963378906,
//                 y: 645.1400146484375,
//                 width: 34.78173828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   405.5899963378906, 645.1400146484375, 440.3717346191406,
//                   651.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 56,
//               type: "text",
//               content: "EXTENT OF SPONSORSHIP:",
//               coordinates: {
//                 x: 302.70001220703125,
//                 y: 668.5400390625,
//                 width: 77.86068725585938,
//                 height: 6.4227294921875,
//                 bbox: [
//                   302.70001220703125, 668.5400390625, 380.5606994628906,
//                   674.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 57,
//               type: "text",
//               content: "OVER 18",
//               coordinates: {
//                 x: 522.2999877929688,
//                 y: 656.8400268554688,
//                 width: 24.26513671875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   522.2999877929688, 656.8400268554688, 546.5651245117188,
//                   663.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 58,
//               type: "text",
//               content: "13 - 18",
//               coordinates: {
//                 x: 522.2999877929688,
//                 y: 644.8400268554688,
//                 width: 17.88836669921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   522.2999877929688, 644.8400268554688, 540.1883544921875,
//                   651.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 59,
//               type: "text",
//               content: "12 & UNDER",
//               coordinates: {
//                 x: 461.1000061035156,
//                 y: 656.8400268554688,
//                 width: 33.84442138671875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   461.1000061035156, 656.8400268554688, 494.9444274902344,
//                   663.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 60,
//               type: "text",
//               content: "AGE GROUP",
//               coordinates: {
//                 x: 446.70001220703125,
//                 y: 641.5400390625,
//                 width: 35.10943603515625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   446.70001220703125, 641.5400390625, 481.8094482421875,
//                   647.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 61,
//               type: "text",
//               content: "TYPE OF SPORT",
//               coordinates: {
//                 x: 302.70001220703125,
//                 y: 638.5400390625,
//                 width: 45.942474365234375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   302.70001220703125, 638.5400390625, 348.6424865722656,
//                   644.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 62,
//               type: "text",
//               content: "CONTACT",
//               coordinates: {
//                 x: 146.36000061035156,
//                 y: 637.9400024414062,
//                 width: 27.66326904296875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   146.36000061035156, 637.9400024414062, 174.0232696533203,
//                   644.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 63,
//               type: "text",
//               content: "SPORT (Y/N)",
//               coordinates: {
//                 x: 142.7899932861328,
//                 y: 645.1400146484375,
//                 width: 34.78173828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   142.7899932861328, 645.1400146484375, 177.5717315673828,
//                   651.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 64,
//               type: "text",
//               content: "EXTENT OF SPONSORSHIP:",
//               coordinates: {
//                 x: 39.900001525878906,
//                 y: 668.5400390625,
//                 width: 77.86072540283203,
//                 height: 6.4227294921875,
//                 bbox: [
//                   39.900001525878906, 668.5400390625, 117.76072692871094,
//                   674.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 65,
//               type: "text",
//               content: "OVER 18",
//               coordinates: {
//                 x: 259.5,
//                 y: 656.8400268554688,
//                 width: 24.26495361328125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   259.5, 656.8400268554688, 283.76495361328125,
//                   663.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 66,
//               type: "text",
//               content: "13 - 18",
//               coordinates: {
//                 x: 259.5,
//                 y: 644.8400268554688,
//                 width: 17.888214111328125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   259.5, 644.8400268554688, 277.3882141113281, 651.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 67,
//               type: "text",
//               content: "12 & UNDER",
//               coordinates: {
//                 x: 198.3000030517578,
//                 y: 656.8400268554688,
//                 width: 33.844512939453125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   198.3000030517578, 656.8400268554688, 232.14451599121094,
//                   663.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 68,
//               type: "text",
//               content: "AGE GROUP",
//               coordinates: {
//                 x: 183.89999389648438,
//                 y: 641.5400390625,
//                 width: 35.10948181152344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   183.89999389648438, 641.5400390625, 219.0094757080078,
//                   647.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 69,
//               type: "text",
//               content: "TYPE OF SPORT",
//               coordinates: {
//                 x: 39.900001525878906,
//                 y: 638.5400390625,
//                 width: 45.94248962402344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   39.900001525878906, 638.5400390625, 85.84249114990234,
//                   644.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 70,
//               type: "text",
//               content: "ARE ATHLETIC TEAMS SPONSORED?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 626.1599731445312,
//                 width: 121.14900588989258,
//                 height: 7.539794921875,
//                 bbox: [
//                   36.29999923706055, 626.1599731445312, 157.44900512695312,
//                   633.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 71,
//               type: "text",
//               content: "13.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 626.1599731445312,
//                 width: 9.375749588012695,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 626.1599731445312, 31.27574920654297,
//                   633.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 72,
//               type: "text",
//               content: "ARE SOCIAL EVENTS SPONSORED?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 590.1599731445312,
//                 width: 117.77400588989258,
//                 height: 7.539794921875,
//                 bbox: [
//                   36.29999923706055, 590.1599731445312, 154.07400512695312,
//                   597.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 73,
//               type: "text",
//               content: "12.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 590.1599731445312,
//                 width: 9.375749588012695,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 590.1599731445312, 31.27574920654297,
//                   597.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 74,
//               type: "text",
//               content: "LIFE GUARD",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 578.8400268554688,
//                 width: 34.47119140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 578.8400268554688, 488.3711853027344,
//                   585.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 75,
//               type: "text",
//               content: "IN GROUND",
//               coordinates: {
//                 x: 392.70001220703125,
//                 y: 578.8400268554688,
//                 width: 32.87841796875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   392.70001220703125, 578.8400268554688, 425.57843017578125,
//                   585.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 76,
//               type: "text",
//               content: "ABOVE GROUND",
//               coordinates: {
//                 x: 320.70001220703125,
//                 y: 578.8400268554688,
//                 width: 46.919921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   320.70001220703125, 578.8400268554688, 367.61993408203125,
//                   585.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 77,
//               type: "text",
//               content: "DIVING BOARD",
//               coordinates: {
//                 x: 209.10000610351562,
//                 y: 578.8400268554688,
//                 width: 41.8082275390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   209.10000610351562, 578.8400268554688, 250.90823364257812,
//                   585.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 78,
//               type: "text",
//               content: "LIMITED ACCESS",
//               coordinates: {
//                 x: 133.5,
//                 y: 578.8400268554688,
//                 width: 47.55824279785156,
//                 height: 6.4227294921875,
//                 bbox: [
//                   133.5, 578.8400268554688, 181.05824279785156,
//                   585.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 79,
//               type: "text",
//               content:
//                 "IS THERE A SWIMMING POOL ON PREMISES?  (Check all that apply)",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 566.1599731445312,
//                 width: 214.33961868286133,
//                 height: 7.539794921875,
//                 bbox: [
//                   36.29999923706055, 566.1599731445312, 250.63961791992188,
//                   573.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 80,
//               type: "text",
//               content: "11.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 566.1599731445312,
//                 width: 8.876249313354492,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 566.1599731445312, 30.776248931884766,
//                   573.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 81,
//               type: "text",
//               content: "APPROVED FENCE",
//               coordinates: {
//                 x: 54.29999923706055,
//                 y: 578.8400268554688,
//                 width: 52.9804801940918,
//                 height: 6.4227294921875,
//                 bbox: [
//                   54.29999923706055, 578.8400268554688, 107.28047943115234,
//                   585.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 82,
//               type: "text",
//               content: "SLIDE",
//               coordinates: {
//                 x: 277.5,
//                 y: 578.8400268554688,
//                 width: 16.6002197265625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   277.5, 578.8400268554688, 294.1002197265625, 585.2627563476562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 83,
//               type: "text",
//               content: "DESCRIBE OTHER LODGING OPERATIONS",
//               coordinates: {
//                 x: 151.5,
//                 y: 542.5400390625,
//                 width: 118.93295288085938,
//                 height: 6.4227294921875,
//                 bbox: [
//                   151.5, 542.5400390625, 270.4329528808594, 548.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 84,
//               type: "text",
//               content: "Sq. Ft.",
//               coordinates: {
//                 x: 126.51625061035156,
//                 y: 554.5400390625,
//                 width: 17.537490844726562,
//                 height: 6.4227294921875,
//                 bbox: [
//                   126.51625061035156, 554.5400390625, 144.05374145507812,
//                   560.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 85,
//               type: "text",
//               content: "TOTAL APT AREA",
//               coordinates: {
//                 x: 87.0562515258789,
//                 y: 542.5400390625,
//                 width: 49.04174041748047,
//                 height: 6.4227294921875,
//                 bbox: [
//                   87.0562515258789, 542.5400390625, 136.09799194335938,
//                   548.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 86,
//               type: "text",
//               content: "# APTS",
//               coordinates: {
//                 x: 46.14125061035156,
//                 y: 542.5400390625,
//                 width: 19.894996643066406,
//                 height: 6.4227294921875,
//                 bbox: [
//                   46.14125061035156, 542.5400390625, 66.03624725341797,
//                   548.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 87,
//               type: "text",
//               content:
//                 'ARE THERE ANY LODGING OPERATIONS INCLUDING APARTMENTS?  (If "YES", answer the following):',
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 530.1599731445312,
//                 width: 320.7870063781738,
//                 height: 7.539794921875,
//                 bbox: [
//                   36.29999923706055, 530.1599731445312, 357.0870056152344,
//                   537.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 88,
//               type: "text",
//               content: "10.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 530.1599731445312,
//                 width: 9.375749588012695,
//                 height: 7.539794921875,
//                 bbox: [
//                   21.899999618530273, 530.1599731445312, 31.27574920654297,
//                   537.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 89,
//               type: "text",
//               content: "GENERAL INFORMATION",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 146.37998962402344,
//                 width: 93.92225074768066,
//                 height: 8.656753540039062,
//                 bbox: [
//                   21.899999618530273, 146.37998962402344, 115.82225036621094,
//                   155.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 90,
//               type: "text",
//               content: "9.    RECREATION FACILITIES PROVIDED?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 494.15997314453125,
//                 width: 135.11475563049316,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 494.15997314453125, 157.01475524902344,
//                   501.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 91,
//               type: "text",
//               content: "8.    IS A FEE CHARGED FOR PARKING?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 458.15997314453125,
//                 width: 127.2442569732666,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 458.15997314453125, 149.14425659179688,
//                   465.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 92,
//               type: "text",
//               content: "7.    ANY PARKING FACILITIES OWNED/RENTED?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 422.15997314453125,
//                 width: 156.72152137756348,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 422.15997314453125, 178.62152099609375,
//                   429.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 93,
//               type: "text",
//               content:
//                 "6.    ANY WATERCRAFT, DOCKS, FLOATS OWNED, HIRED OR LEASED?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 386.15997314453125,
//                 width: 227.5290470123291,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 386.15997314453125, 249.42904663085938,
//                   393.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 94,
//               type: "text",
//               content:
//                 "4.    ANY OPERATIONS SOLD, ACQUIRED, OR DISCONTINUED IN LAST FIVE (5) YEARS?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 290.15997314453125,
//                 width: 280.8608646392822,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 290.15997314453125, 302.7608642578125,
//                   297.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 95,
//               type: "text",
//               content: "3.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 243.95997619628906,
//                 width: 5.622751235961914,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 243.95997619628906, 27.522750854492188,
//                   251.49972534179688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 96,
//               type: "text",
//               content:
//                 "DO/HAVE PAST, PRESENT OR DISCONTINUED OPERATIONS INVOLVE(D) STORING, TREATING, DISCHARGING, APPLYING, DISPOSING, OR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 243.95997619628906,
//                 width: 446.9312934875488,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   36.29999923706055, 243.95997619628906, 483.2312927246094,
//                   251.49972534179688
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 97,
//               type: "text",
//               content:
//                 "TRANSPORTING OF HAZARDOUS MATERIAL? (e.g. landfills, wastes, fuel tanks, etc)",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 252.36000061035156,
//                 width: 259.80754470825195,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   36.29999923706055, 252.36000061035156, 296.1075439453125,
//                   259.8997497558594
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 98,
//               type: "text",
//               content: "2.    ANY EXPOSURE TO RADIOACTIVE/NUCLEAR MATERIALS?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 206.1599884033203,
//                 width: 201.8250217437744,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 206.1599884033203, 223.7250213623047,
//                   213.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 99,
//               type: "text",
//               content:
//                 "1.    ANY MEDICAL FACILITIES PROVIDED OR MEDICAL PROFESSIONALS EMPLOYED OR CONTRACTED?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 170.1599884033203,
//                 width: 338.8298587799072,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 170.1599884033203, 360.7298583984375,
//                   177.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 100,
//               type: "text",
//               content: "Y / N",
//               coordinates: {
//                 x: 577.1612548828125,
//                 y: 158.54002380371094,
//                 width: 12.65582275390625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   577.1612548828125, 158.54002380371094, 589.8170776367188,
//                   164.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 101,
//               type: "text",
//               content:
//                 'EXPLAIN ALL "YES" RESPONSES (For all past or present operations)',
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 158.54002380371094,
//                 width: 189.9110507965088,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 158.54002380371094, 211.81105041503906,
//                   164.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 102,
//               type: "text",
//               content: "LENDER'S LOSS PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 86.54002380371094,
//                 width: 73.61149215698242,
//                 height: 6.422752380371094,
//                 bbox: [
//                   36.29999923706055, 86.54002380371094, 109.91149139404297,
//                   92.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 103,
//               type: "text",
//               content: "ACORD 126 (2016/09)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 757.780029296875,
//                 width: 78.78650093078613,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 757.780029296875, 100.6865005493164,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 35.98909421387464,
//                 width: 577.4399999999999,
//                 height: 108.68706452590118,
//                 bbox: [
//                   17.52, 35.98909421387464, 594.9599999999999,
//                   144.67615873977581
//                 ]
//               },
//               properties: {
//                 rows: 9,
//                 columns: 12,
//                 accuracy: 87.938
//               }
//             },
//             {
//               id: 1,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 155.232959709179,
//                 width: 577.4399999999999,
//                 height: 601.4977279612239,
//                 bbox: [
//                   17.52, 155.232959709179, 594.9599999999999, 756.7306876704029
//                 ]
//               },
//               properties: {
//                 rows: 25,
//                 columns: 36,
//                 accuracy: 54.972
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 104,
//           table_count: 2,
//           total_elements: 106
//         }
//       },
//       {
//         page_number: 17,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 415.20001220703125,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   415.20001220703125, 25.188751220703125, 447.44805908203125,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 55.188751220703125,
//                 width: 5.2344970703125,
//                 height: 8.098247528076172,
//                 bbox: [
//                   580.8825073242188, 55.188751220703125, 586.1170043945312,
//                   63.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 91.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 91.18875122070312, 586.1170043945312,
//                   99.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 151.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 151.18875122070312, 586.1170043945312,
//                   159.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 187.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 187.18875122070312, 586.1170043945312,
//                   195.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 223.18875122070312,
//                 width: 5.2344970703125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   580.8825073242188, 223.18875122070312, 586.1170043945312,
//                   231.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 259.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 259.1887512207031, 586.1170043945312,
//                   267.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "N",
//               coordinates: {
//                 x: 580.8825073242188,
//                 y: 295.1887512207031,
//                 width: 5.2344970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   580.8825073242188, 295.1887512207031, 586.1170043945312,
//                   303.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "WORKERS",
//               coordinates: {
//                 x: 496.1862487792969,
//                 y: 103.34001159667969,
//                 width: 30.003509521484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   496.1862487792969, 103.34001159667969, 526.1897583007812,
//                   109.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "COMPENSATION",
//               coordinates: {
//                 x: 487.9337463378906,
//                 y: 110.54002380371094,
//                 width: 46.494598388671875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   487.9337463378906, 110.54002380371094, 534.4283447265625,
//                   116.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "COVERAGE CARRIED (Y/N)",
//               coordinates: {
//                 x: 473.34375,
//                 y: 118.34001159667969,
//                 width: 75.64697265625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   473.34375, 118.34001159667969, 548.99072265625,
//                   124.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "LEASE FROM",
//               coordinates: {
//                 x: 302.70001220703125,
//                 y: 113.54002380371094,
//                 width: 37.65673828125,
//                 height: 6.422752380371094,
//                 bbox: [
//                   302.70001220703125, 113.54002380371094, 340.35675048828125,
//                   119.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "WORKERS",
//               coordinates: {
//                 x: 233.38624572753906,
//                 y: 103.34001159667969,
//                 width: 30.003494262695312,
//                 height: 6.422752380371094,
//                 bbox: [
//                   233.38624572753906, 103.34001159667969, 263.3897399902344,
//                   109.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "COMPENSATION",
//               coordinates: {
//                 x: 225.1337432861328,
//                 y: 110.54002380371094,
//                 width: 46.49446105957031,
//                 height: 6.422752380371094,
//                 bbox: [
//                   225.1337432861328, 110.54002380371094, 271.6282043457031,
//                   116.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "COVERAGE CARRIED (Y/N)",
//               coordinates: {
//                 x: 210.5437469482422,
//                 y: 118.34001159667969,
//                 width: 75.64695739746094,
//                 height: 6.422752380371094,
//                 bbox: [
//                   210.5437469482422, 118.34001159667969, 286.1907043457031,
//                   124.76276397705078
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "LEASE TO",
//               coordinates: {
//                 x: 39.900001525878906,
//                 y: 113.54002380371094,
//                 width: 28.61199951171875,
//                 height: 6.422752380371094,
//                 bbox: [
//                   39.900001525878906, 113.54002380371094, 68.51200103759766,
//                   119.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "DO YOU LEASE EMPLOYEES TO OR FROM OTHER EMPLOYERS?",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 92.15998840332031,
//                 width: 211.3222999572754,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   36.29999923706055, 92.15998840332031, 247.62229919433594,
//                   99.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "17.",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 91.56001281738281,
//                 width: 9.375749588012695,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 91.56001281738281, 31.27574920654297,
//                   99.09976196289062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content:
//                 "16.  HAS APPLICANT BEEN ACTIVE IN OR IS CURRENTLY ACTIVE IN JOINT VENTURES?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 56.15998840332031,
//                 width: 281.2455997467041,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 56.15998840332031, 303.1455993652344,
//                   63.699737548828125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 317.0350036621094,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   317.0350036621094, 26.379987716674805, 408.8182373046875,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content:
//                 "18.  IS THERE A LABOR INTERCHANGE WITH ANY OTHER BUSINESS OR SUBSIDIARIES?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 152.1599884033203,
//                 width: 285.9841251373291,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 152.1599884033203, 307.8841247558594,
//                   159.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content: "19.  ARE DAY CARE FACILITIES OPERATED OR CONTROLLED?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 188.1599884033203,
//                 width: 201.96004676818848,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 188.1599884033203, 223.86004638671875,
//                   195.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content:
//                 "REMARKS (ACORD 101, Additional Remarks Schedule, may be attached if more space is required)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 332.3799743652344,
//                 width: 362.0179386138916,
//                 height: 8.656768798828125,
//                 bbox: [
//                   21.899999618530273, 332.3799743652344, 383.9179382324219,
//                   341.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "GENERAL INFORMATION (continued)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 32.37998962402344,
//                 width: 138.21346473693848,
//                 height: 8.656749725341797,
//                 bbox: [
//                   21.899999618530273, 32.37998962402344, 160.11346435546875,
//                   41.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "Y / N",
//               coordinates: {
//                 x: 577.1612548828125,
//                 y: 44.54002380371094,
//                 width: 12.65582275390625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   577.1612548828125, 44.54002380371094, 589.8170776367188,
//                   50.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content:
//                 'EXPLAIN ALL "YES" RESPONSES (For all past or present operations)',
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 44.54002380371094,
//                 width: 189.9110507965088,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 44.54002380371094, 211.81105041503906,
//                   50.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: "Page 4 of 4",
//               coordinates: {
//                 x: 285.84124755859375,
//                 y: 757.780029296875,
//                 width: 40.873504638671875,
//                 height: 8.65673828125,
//                 bbox: [
//                   285.84124755859375, 757.780029296875, 326.7147521972656,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content:
//                 "22.  DOES THE BUSINESSES' PROMOTIONAL LITERATURE MAKE ANY REPRESENTATIONS ABOUT THE SAFETY OR SECURITY OF THE PREMISES?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 296.15997314453125,
//                 width: 474.4578800201416,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 296.15997314453125, 496.3578796386719,
//                   303.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content:
//                 "21.  IS THERE A FORMAL, WRITTEN SAFETY AND SECURITY POLICY IN EFFECT?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 260.15997314453125,
//                 width: 260.6175479888916,
//                 height: 7.539764404296875,
//                 bbox: [
//                   21.899999618530273, 260.15997314453125, 282.5175476074219,
//                   267.6997375488281
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content:
//                 "20.  HAVE ANY CRIMES OCCURRED OR BEEN ATTEMPTED ON YOUR PREMISES WITHIN THE LAST THREE (3) YEARS?",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 224.1599884033203,
//                 width: 381.91521644592285,
//                 height: 7.5397491455078125,
//                 bbox: [
//                   21.899999618530273, 224.1599884033203, 403.8152160644531,
//                   231.69973754882812
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content: "SIGNATURE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 362.3799743652344,
//                 width: 45.02750587463379,
//                 height: 8.656768798828125,
//                 bbox: [
//                   21.899999618530273, 362.3799743652344, 66.92750549316406,
//                   371.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content: "Applicable in OR:",
//               coordinates: {
//                 x: 25.5,
//                 y: 602.6799926757812,
//                 width: 64.51101684570312,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 602.6799926757812, 90.01101684570312, 611.3367309570312
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content:
//                 " Any person who knowingly and with intent to defraud or solicit another to defraud the insurer by submitting an application containing a",
//               coordinates: {
//                 x: 90.01101684570312,
//                 y: 602.6799926757812,
//                 width: 460.9772033691406,
//                 height: 8.65673828125,
//                 bbox: [
//                   90.01101684570312, 602.6799926757812, 550.9882202148438,
//                   611.3367309570312
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content:
//                 "false statement as to any material fact may be violating state law.",
//               coordinates: {
//                 x: 25.5,
//                 y: 611.9800415039062,
//                 width: 222.9520263671875,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 611.9800415039062, 248.4520263671875, 620.6367797851562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content: "Applicable in NJ:",
//               coordinates: {
//                 x: 25.5,
//                 y: 584.6799926757812,
//                 width: 62.79826354980469,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 584.6799926757812, 88.29826354980469, 593.3367309570312
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content:
//                 " Any person who includes any false or misleading information on an application for an insurance policy is subject to criminal and civil",
//               coordinates: {
//                 x: 88.29826354980469,
//                 y: 584.6799926757812,
//                 width: 454.09034729003906,
//                 height: 8.65673828125,
//                 bbox: [
//                   88.29826354980469, 584.6799926757812, 542.3886108398438,
//                   593.3367309570312
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content: "penalties.",
//               coordinates: {
//                 x: 25.5,
//                 y: 593.9800415039062,
//                 width: 33.154510498046875,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 593.9800415039062, 58.654510498046875, 602.6367797851562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content: "Applicable in KY, NY, OH and PA:",
//               coordinates: {
//                 x: 25.5,
//                 y: 525.8800048828125,
//                 width: 121.14801025390625,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 525.8800048828125, 146.64801025390625, 534.5367431640625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content:
//                 " Any person who knowingly and with intent to defraud any insurance company or other person files an application for",
//               coordinates: {
//                 x: 146.64801025390625,
//                 y: 525.8800048828125,
//                 width: 400.36016845703125,
//                 height: 8.65673828125,
//                 bbox: [
//                   146.64801025390625, 525.8800048828125, 547.0081787109375,
//                   534.5367431640625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content:
//                 "insurance or statement of claim containing any materially false information or conceals for the purpose of misleading, information concerning any fact material",
//               coordinates: {
//                 x: 25.5,
//                 y: 535.1799926757812,
//                 width: 539.3998413085938,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 535.1799926757812, 564.8998413085938, 543.8367309570312
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content:
//                 "thereto commits a fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties (not to exceed five thousand dollars and",
//               coordinates: {
//                 x: 25.5,
//                 y: 544.780029296875,
//                 width: 535.9667358398438,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 544.780029296875, 561.4667358398438, 553.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content:
//                 "the stated value of the claim for each such violation)*. *Applies in NY Only.",
//               coordinates: {
//                 x: 25.5,
//                 y: 553.780029296875,
//                 width: 254.52560424804688,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 553.780029296875, 280.0256042480469, 562.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content: "Applicable in PR:",
//               coordinates: {
//                 x: 25.5,
//                 y: 622.4800415039062,
//                 width: 63.65076446533203,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 622.4800415039062, 89.15076446533203, 631.1367797851562
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content:
//                 " Any person who knowingly and with the intention of defrauding presents false information in an insurance application, or presents, helps,",
//               coordinates: {
//                 x: 89.15076446533203,
//                 y: 622.4800415039062,
//                 width: 470.89208221435547,
//                 height: 8.65673828125,
//                 bbox: [
//                   89.15076446533203, 622.4800415039062, 560.0428466796875,
//                   631.1367797851562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content:
//                 "or causes the presentation of a fraudulent claim for the payment of a loss or any other benefit, or presents more than one claim for the same damage or loss,",
//               coordinates: {
//                 x: 25.5,
//                 y: 631.780029296875,
//                 width: 536.7882080078125,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 631.780029296875, 562.2882080078125, 640.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content:
//                 "shall incur a felony and, upon conviction, shall be sanctioned for each violation by a fine of not less than five thousand dollars ($5,000) and not more than ten",
//               coordinates: {
//                 x: 25.5,
//                 y: 640.780029296875,
//                 width: 536.8423461914062,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 640.780029296875, 562.3423461914062, 649.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content:
//                 "thousand dollars ($10,000), or a fixed term of imprisonment for three (3) years, or both penalties.  Should aggravating circumstances [be] present, the penalty",
//               coordinates: {
//                 x: 25.5,
//                 y: 650.3800048828125,
//                 width: 538.5241088867188,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 650.3800048828125, 564.0241088867188, 659.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content:
//                 "thus established may be increased to a maximum of five (5) years, if extenuating circumstances are present, it may be reduced to a minimum of two (2)",
//               coordinates: {
//                 x: 25.5,
//                 y: 659.3800048828125,
//                 width: 517.83154296875,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 659.3800048828125, 543.33154296875, 668.0367431640625
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content: "years.",
//               coordinates: {
//                 x: 25.5,
//                 y: 668.9800415039062,
//                 width: 21.095504760742188,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 668.9800415039062, 46.59550476074219, 677.6367797851562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content: "Applicable in ME, TN, VA and WA:",
//               coordinates: {
//                 x: 25.5,
//                 y: 565.4800415039062,
//                 width: 123.85275268554688,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 565.4800415039062, 149.35275268554688, 574.1367797851562
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content:
//                 " It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose",
//               coordinates: {
//                 x: 149.35275268554688,
//                 y: 565.4800415039062,
//                 width: 407.6553649902344,
//                 height: 8.65673828125,
//                 bbox: [
//                   149.35275268554688, 565.4800415039062, 557.0081176757812,
//                   574.1367797851562
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content:
//                 "of defrauding the company.  Penalties (may)* include imprisonment, fines and denial of insurance benefits. *Applies in ME Only.",
//               coordinates: {
//                 x: 25.5,
//                 y: 574.780029296875,
//                 width: 436.2164306640625,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 574.780029296875, 461.7164306640625, 583.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 52,
//               type: "text",
//               content: "Applicable in KS",
//               coordinates: {
//                 x: 25.5,
//                 y: 470.67999267578125,
//                 width: 61.07001495361328,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 470.67999267578125, 86.57001495361328, 479.3367614746094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 53,
//               type: "text",
//               content:
//                 ":  Any person who, knowingly and with intent to defraud, presents, causes to be presented or prepares with knowledge or belief that it will be",
//               coordinates: {
//                 x: 86.05000305175781,
//                 y: 470.67999267578125,
//                 width: 479.11265563964844,
//                 height: 8.656768798828125,
//                 bbox: [
//                   86.05000305175781, 470.67999267578125, 565.1626586914062,
//                   479.3367614746094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 54,
//               type: "text",
//               content:
//                 "presented to or by an insurer, purported insurer, broker or any agent thereof, any written, electronic, electronic impulse, facsimile, magnetic, oral, or",
//               coordinates: {
//                 x: 25.5,
//                 y: 479.97998046875,
//                 width: 503.2073974609375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 479.97998046875, 528.7073974609375, 488.6367492675781
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 55,
//               type: "text",
//               content:
//                 "telephonic communication or statement as part of, or in support of, an application for the issuance of, or the rating of an insurance policy for personal or",
//               coordinates: {
//                 x: 25.5,
//                 y: 488.97998046875,
//                 width: 517.4208984375,
//                 height: 8.656768798828125,
//                 bbox: [25.5, 488.97998046875, 542.9208984375, 497.6367492675781]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 56,
//               type: "text",
//               content:
//                 "commercial insurance, or a claim for payment or other benefit pursuant to an insurance policy for commercial or personal insurance which such person knows",
//               coordinates: {
//                 x: 25.5,
//                 y: 497.97998046875,
//                 width: 539.8648681640625,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 497.97998046875, 565.3648681640625, 506.6367492675781
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 57,
//               type: "text",
//               content:
//                 "to contain materially false information concerning any fact material thereto; or conceals, for the purpose of misleading, information concerning any fact",
//               coordinates: {
//                 x: 25.5,
//                 y: 507.5799865722656,
//                 width: 513.1273193359375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 507.5799865722656, 538.6273193359375, 516.2367553710938
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 58,
//               type: "text",
//               content: "material thereto commits a fraudulent insurance act.",
//               coordinates: {
//                 x: 25.5,
//                 y: 516.5800170898438,
//                 width: 178.21128845214844,
//                 height: 8.65673828125,
//                 bbox: [
//                   25.5, 516.5800170898438, 203.71128845214844, 525.2367553710938
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 59,
//               type: "text",
//               content: "Applicable in FL and OK:",
//               coordinates: {
//                 x: 25.5,
//                 y: 449.67999267578125,
//                 width: 91.88401794433594,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 449.67999267578125, 117.38401794433594,
//                   458.3367614746094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 60,
//               type: "text",
//               content:
//                 " Any person who knowingly and with intent to injure, defraud, or deceive any insurer files a statement of claim or an application",
//               coordinates: {
//                 x: 117.38401794433594,
//                 y: 449.67999267578125,
//                 width: 434.7312774658203,
//                 height: 8.656768798828125,
//                 bbox: [
//                   117.38401794433594, 449.67999267578125, 552.1152954101562,
//                   458.3367614746094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 61,
//               type: "text",
//               content:
//                 "containing any false, incomplete, or misleading information is guilty of a felony (of the third degree)*. *Applies in FL Only.",
//               coordinates: {
//                 x: 25.5,
//                 y: 458.97998046875,
//                 width: 411.501708984375,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 458.97998046875, 437.001708984375, 467.6367492675781
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 62,
//               type: "text",
//               content: "Applicable in CO:",
//               coordinates: {
//                 x: 25.5,
//                 y: 402.2799987792969,
//                 width: 64.51101684570312,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 402.2799987792969, 90.01101684570312, 410.936767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 63,
//               type: "text",
//               content:
//                 " It is unlawful to knowingly provide false, incomplete, or misleading facts or information to an insurance company for the purpose of",
//               coordinates: {
//                 x: 90.01101684570312,
//                 y: 402.2799987792969,
//                 width: 448.8871765136719,
//                 height: 8.656768798828125,
//                 bbox: [
//                   90.01101684570312, 402.2799987792969, 538.898193359375,
//                   410.936767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 64,
//               type: "text",
//               content:
//                 "defrauding or attempting to defraud the company.  Penalties may include imprisonment, fines, denial of insurance and civil damages.  Any insurance",
//               coordinates: {
//                 x: 25.5,
//                 y: 411.5799865722656,
//                 width: 506.5631103515625,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 411.5799865722656, 532.0631103515625, 420.23675537109375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 65,
//               type: "text",
//               content:
//                 "company or agent of an insurance company who knowingly provides false, incomplete, or misleading facts or information to a policyholder or claimant for the",
//               coordinates: {
//                 x: 25.5,
//                 y: 420.5799865722656,
//                 width: 535.9744262695312,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 420.5799865722656, 561.4744262695312, 429.23675537109375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 66,
//               type: "text",
//               content:
//                 "purpose of defrauding or attempting to defraud the policyholder or claimant with regard to a settlement or award payable from insurance proceeds shall be",
//               coordinates: {
//                 x: 25.5,
//                 y: 430.17999267578125,
//                 width: 527.3796997070312,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 430.17999267578125, 552.8796997070312, 438.8367614746094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 67,
//               type: "text",
//               content:
//                 "reported to the Colorado Division of Insurance within the Department of Regulatory Agencies.",
//               coordinates: {
//                 x: 25.5,
//                 y: 439.17999267578125,
//                 width: 319.4239807128906,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 439.17999267578125, 344.9239807128906, 447.8367614746094
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 68,
//               type: "text",
//               content: "Applicable in AL, AR, DC, LA, MD, NM, RI and WV:",
//               coordinates: {
//                 x: 25.5,
//                 y: 373.47998046875,
//                 width: 183.05494689941406,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 373.47998046875, 208.55494689941406, 382.1367492675781
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 69,
//               type: "text",
//               content:
//                 " Any person who knowingly (or willfully)* presents a false or fraudulent claim for payment of a loss or",
//               coordinates: {
//                 x: 208.55494689941406,
//                 y: 373.47998046875,
//                 width: 345.26853942871094,
//                 height: 8.656768798828125,
//                 bbox: [
//                   208.55494689941406, 373.47998046875, 553.823486328125,
//                   382.1367492675781
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 70,
//               type: "text",
//               content:
//                 "benefit or knowingly (or willfully)* presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in",
//               coordinates: {
//                 x: 25.5,
//                 y: 382.7799987792969,
//                 width: 536.3619384765625,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 382.7799987792969, 561.8619384765625, 391.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 71,
//               type: "text",
//               content: "prison. *Applies in MD Only.",
//               coordinates: {
//                 x: 25.5,
//                 y: 391.7799987792969,
//                 width: 95.83649444580078,
//                 height: 8.656768798828125,
//                 bbox: [
//                   25.5, 391.7799987792969, 121.33649444580078, 400.436767578125
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 72,
//               type: "text",
//               content: "NATIONAL PRODUCER NUMBER",
//               coordinates: {
//                 x: 498.646240234375,
//                 y: 733.3400268554688,
//                 width: 90.447509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   498.646240234375, 733.3400268554688, 589.09375,
//                   739.7627563476562
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 73,
//               type: "text",
//               content: "(Required in Florida)",
//               coordinates: {
//                 x: 497.1000061035156,
//                 y: 713.5400390625,
//                 width: 56.154693603515625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   497.1000061035156, 713.5400390625, 553.2546997070312,
//                   719.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 74,
//               type: "text",
//               content: "PRODUCER'S SIGNATURE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 710.5400390625,
//                 width: 73.07673835754395,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 710.5400390625, 94.97673797607422,
//                   716.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 75,
//               type: "text",
//               content: "DATE",
//               coordinates: {
//                 x: 425.1000061035156,
//                 y: 734.5400390625,
//                 width: 15.2144775390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   425.1000061035156, 734.5400390625, 440.3144836425781,
//                   740.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 76,
//               type: "text",
//               content: "APPLICANT'S SIGNATURE",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 734.5400390625,
//                 width: 73.06524085998535,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 734.5400390625, 94.96524047851562,
//                   740.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 77,
//               type: "text",
//               content: "PRODUCER'S NAME (Please Print)",
//               coordinates: {
//                 x: 259.5,
//                 y: 711.1400146484375,
//                 width: 94.89791870117188,
//                 height: 6.4227294921875,
//                 bbox: [
//                   259.5, 711.1400146484375, 354.3979187011719, 717.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 78,
//               type: "text",
//               content: "STATE PRODUCER LICENSE NO",
//               coordinates: {
//                 x: 497.1000061035156,
//                 y: 708.1400146484375,
//                 width: 89.14822387695312,
//                 height: 6.4227294921875,
//                 bbox: [
//                   497.1000061035156, 708.1400146484375, 586.2482299804688,
//                   714.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 79,
//               type: "text",
//               content:
//                 "THE UNDERSIGNED IS AN AUTHORIZED REPRESENTATIVE OF THE APPLICANT AND REPRESENTS THAT REASONABLE INQUIRY HAS BEEN MADE TO OBTAIN THE",
//               coordinates: {
//                 x: 25.5,
//                 y: 680.760009765625,
//                 width: 525.885986328125,
//                 height: 7.539794921875,
//                 bbox: [25.5, 680.760009765625, 551.385986328125, 688.2998046875]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 80,
//               type: "text",
//               content:
//                 "ANSWERS TO QUESTIONS ON THIS APPLICATION.  HE/SHE REPRESENTS THAT THE ANSWERS ARE TRUE, CORRECT AND COMPLETE TO THE BEST OF HIS/HER",
//               coordinates: {
//                 x: 25.5,
//                 y: 689.1599731445312,
//                 width: 522.3692626953125,
//                 height: 7.539794921875,
//                 bbox: [
//                   25.5, 689.1599731445312, 547.8692626953125, 696.6997680664062
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 81,
//               type: "text",
//               content: "KNOWLEDGE.",
//               coordinates: {
//                 x: 25.5,
//                 y: 696.9599609375,
//                 width: 45.71099853515625,
//                 height: 7.539794921875,
//                 bbox: [
//                   25.5, 696.9599609375, 71.21099853515625, 704.499755859375
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 6.75,
//                 color: 0
//               }
//             },
//             {
//               id: 82,
//               type: "text",
//               content: "ACORD 126 (2016/09)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 757.780029296875,
//                 width: 78.78650093078613,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 757.780029296875, 100.6865005493164,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 41.26749469857623,
//                 width: 577.4399999999999,
//                 height: 289.35231747955163,
//                 bbox: [
//                   17.52, 41.26749469857623, 594.9599999999999,
//                   330.61981217812786
//                 ]
//               },
//               properties: {
//                 rows: 11,
//                 columns: 8,
//                 accuracy: 88.66
//               }
//             },
//             {
//               id: 1,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 371.4074522871857,
//                 width: 577.68,
//                 height: 385.32323538321714,
//                 bbox: [
//                   17.28, 371.4074522871857, 594.9599999999999, 756.7306876704029
//                 ]
//               },
//               properties: {
//                 rows: 4,
//                 columns: 4,
//                 accuracy: 57.767
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 83,
//           table_count: 2,
//           total_elements: 85
//         }
//       },
//       {
//         page_number: 18,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 415.20001220703125,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   415.20001220703125, 25.188751220703125, 447.44805908203125,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "UIS Insurance & Investments",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 73.18875122070312,
//                 width: 93.81499099731445,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 73.18875122070312, 116.614990234375,
//                   81.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "25-26",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 97.18875122070312,
//                 width: 18.538253784179688,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 97.18875122070312, 41.338253021240234,
//                   105.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "05/18/2025",
//               coordinates: {
//                 x: 259.3550109863281,
//                 y: 97.18875122070312,
//                 width: 36.2645263671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   259.3550109863281, 97.18875122070312, 295.6195373535156,
//                   105.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "Submissions",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 73.18875122070312,
//                 width: 41.08575439453125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 73.18875122070312, 351.8857421875,
//                   81.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "Buckeye Premier Cleaning, LLC",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 97.18875122070312,
//                 width: 103.10223388671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 97.18875122070312, 413.9022216796875,
//                   105.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "Blanket Additional Insured",
//               coordinates: {
//                 x: 199.1999969482422,
//                 y: 133.18875122070312,
//                 width: 83.77381896972656,
//                 height: 8.098251342773438,
//                 bbox: [
//                   199.1999969482422, 133.18875122070312, 282.97381591796875,
//                   141.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "Blanket Waiver of Sub",
//               coordinates: {
//                 x: 199.1999969482422,
//                 y: 145.18875122070312,
//                 width: 71.39805603027344,
//                 height: 8.098251342773438,
//                 bbox: [
//                   199.1999969482422, 145.18875122070312, 270.5980529785156,
//                   153.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "EFFECTIVE DATE",
//               coordinates: {
//                 x: 252.97500610351562,
//                 y: 86.54002380371094,
//                 width: 48.3919677734375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   252.97500610351562, 86.54002380371094, 301.3669738769531,
//                   92.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "NAMED INSURED(S)",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 86.54002380371094,
//                 width: 56.183197021484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   309.8999938964844, 86.54002380371094, 366.08319091796875,
//                   92.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "POLICY NUMBER",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 86.54002380371094,
//                 width: 48.09299659729004,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 86.54002380371094, 69.99299621582031,
//                   92.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "NAIC CODE",
//               coordinates: {
//                 x: 547.5,
//                 y: 62.54002380371094,
//                 width: 32.24029541015625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   547.5, 62.54002380371094, 579.7402954101562, 68.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "CARRIER",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 61.17997741699219,
//                 width: 35.28570556640625,
//                 height: 8.656745910644531,
//                 bbox: [
//                   309.8999938964844, 61.17997741699219, 345.1856994628906,
//                   69.83672332763672
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "AGENCY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 62.54002380371094,
//                 width: 24.58125114440918,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 62.54002380371094, 46.48125076293945,
//                   68.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "FORM NAME",
//               coordinates: {
//                 x: 299.37249755859375,
//                 y: 124.93998718261719,
//                 width: 35.431488037109375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   299.37249755859375, 124.93998718261719, 334.8039855957031,
//                   131.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "ITEM #",
//               coordinates: {
//                 x: 100.83499908447266,
//                 y: 124.93998718261719,
//                 width: 18.509246826171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   100.83499908447266, 124.93998718261719, 119.34424591064453,
//                   131.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "BOAT #",
//               coordinates: {
//                 x: 74.27124786376953,
//                 y: 124.93998718261719,
//                 width: 20.642494201660156,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   74.27124786376953, 124.93998718261719, 94.91374206542969,
//                   131.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "VEH #",
//               coordinates: {
//                 x: 51.091251373291016,
//                 y: 124.93998718261719,
//                 width: 16.60024642944336,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   51.091251373291016, 124.93998718261719, 67.69149780273438,
//                   131.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "FORMS AND ENDORSEMENTS",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 110.37998962402344,
//                 width: 114.14972877502441,
//                 height: 8.656745910644531,
//                 bbox: [
//                   21.899999618530273, 110.37998962402344, 136.0497283935547,
//                   119.03673553466797
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "LOC #",
//               coordinates: {
//                 x: 23.93375015258789,
//                 y: 124.93998718261719,
//                 width: 16.916500091552734,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   23.93375015258789, 124.93998718261719, 40.850250244140625,
//                   131.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "FORM NUMBER",
//               coordinates: {
//                 x: 136.82000732421875,
//                 y: 124.93998718261719,
//                 width: 43.73451232910156,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   136.82000732421875, 124.93998718261719, 180.5545196533203,
//                   131.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content: "EDITION DATE",
//               coordinates: {
//                 x: 442.8287353515625,
//                 y: 124.93998718261719,
//                 width: 40.100433349609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   442.8287353515625, 124.93998718261719, 482.9291687011719,
//                   131.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "COPYRIGHT OWNER CODE",
//               coordinates: {
//                 x: 501.9849853515625,
//                 y: 124.93998718261719,
//                 width: 75.9576416015625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   501.9849853515625, 124.93998718261719, 577.942626953125,
//                   131.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "ACORD 829 (2009/05)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 745.780029296875,
//                 width: 78.78650093078613,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 745.780029296875, 100.6865005493164,
//                   754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "The ACORD name and logo are registered marks of ACORD",
//               coordinates: {
//                 x: 196.4737548828125,
//                 y: 757.780029296875,
//                 width: 218.86770629882812,
//                 height: 8.65673828125,
//                 bbox: [
//                   196.4737548828125, 757.780029296875, 415.3414611816406,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content: "© 2009 ACORD CORPORATION.  All rights reserved.",
//               coordinates: {
//                 x: 397.4375,
//                 y: 745.780029296875,
//                 width: 191.293212890625,
//                 height: 8.65673828125,
//                 bbox: [
//                   397.4375, 745.780029296875, 588.730712890625, 754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: "of",
//               coordinates: {
//                 x: 560.0999755859375,
//                 y: 42.5000114440918,
//                 width: 8.25128173828125,
//                 height: 9.773750305175781,
//                 bbox: [
//                   560.0999755859375, 42.5000114440918, 568.3512573242188,
//                   52.27376174926758
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 8.75,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content: "Page",
//               coordinates: {
//                 x: 511.5,
//                 y: 42.5000114440918,
//                 width: 20.89501953125,
//                 height: 9.773750305175781,
//                 bbox: [
//                   511.5, 42.5000114440918, 532.39501953125, 52.27376174926758
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 8.75,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content: "FORMS AND ENDORSEMENTS SCHEDULE",
//               coordinates: {
//                 x: 157.72999572753906,
//                 y: 39.701271057128906,
//                 width: 281.90245056152344,
//                 height: 15.358749389648438,
//                 bbox: [
//                   157.72999572753906, 39.701271057128906, 439.6324462890625,
//                   55.060020446777344
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 13.75,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 317.1000061035156,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   317.1000061035156, 26.379987716674805, 408.88323974609375,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 59.26204180551349,
//                 width: 577.68,
//                 height: 49.4250227203878,
//                 bbox: [
//                   17.28, 59.26204180551349, 594.9599999999999,
//                   108.68706452590129
//                 ]
//               },
//               properties: {
//                 rows: 2,
//                 columns: 4,
//                 accuracy: 100
//               }
//             },
//             {
//               id: 1,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 119.24386549530448,
//                 width: 577.4399999999999,
//                 height: 625.4904574371402,
//                 bbox: [
//                   17.52, 119.24386549530448, 594.9599999999999,
//                   744.7343229324447
//                 ]
//               },
//               properties: {
//                 rows: 52,
//                 columns: 8,
//                 accuracy: 100
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 30,
//           table_count: 2,
//           total_elements: 32
//         }
//       },
//       {
//         page_number: 19,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 415.20001220703125,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   415.20001220703125, 25.188751220703125, 447.44805908203125,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "04/04/2025",
//               coordinates: {
//                 x: 532.9550170898438,
//                 y: 55.188751220703125,
//                 width: 36.2645263671875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   532.9550170898438, 55.188751220703125, 569.2195434570312,
//                   63.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "UIS Insurance & Investments",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 79.18875122070312,
//                 width: 93.81499099731445,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 79.18875122070312, 116.614990234375,
//                   87.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "25-26",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 103.18875122070312,
//                 width: 18.538253784179688,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 103.18875122070312, 41.338253021240234,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "05/18/2025",
//               coordinates: {
//                 x: 259.3550109863281,
//                 y: 103.18875122070312,
//                 width: 36.2645263671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   259.3550109863281, 103.18875122070312, 295.6195373535156,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "Submissions",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 79.18875122070312,
//                 width: 41.08575439453125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 79.18875122070312, 351.8857421875,
//                   87.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "Buckeye Premier Cleaning, LLC",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 103.18875122070312,
//                 width: 103.10223388671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 103.18875122070312, 413.9022216796875,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "Noneman Real Estate Company",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 151.18875122070312,
//                 width: 103.91433715820312,
//                 height: 8.098251342773438,
//                 bbox: [
//                   145.1999969482422, 151.18875122070312, 249.1143341064453,
//                   159.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "3519 Secor Road",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 163.18875122070312,
//                 width: 56.39781188964844,
//                 height: 8.098251342773438,
//                 bbox: [
//                   145.1999969482422, 163.18875122070312, 201.59780883789062,
//                   171.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "Toledo",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 187.18875122070312,
//                 width: 21.3585205078125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   145.1999969482422, 187.18875122070312, 166.5585174560547,
//                   195.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 321.6000061035156,
//                 y: 187.18875122070312,
//                 width: 10.86773681640625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   321.6000061035156, 187.18875122070312, 332.4677429199219,
//                   195.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "43606",
//               coordinates: {
//                 x: 343.20001220703125,
//                 y: 187.18875122070312,
//                 width: 20.155029296875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   343.20001220703125, 187.18875122070312, 363.35504150390625,
//                   195.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "BSCM Services, LLC",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 271.1887512207031,
//                 width: 68.04129028320312,
//                 height: 8.098236083984375,
//                 bbox: [
//                   145.1999969482422, 271.1887512207031, 213.2412872314453,
//                   279.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "Amherst Villiae Apartments",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 391.1887512207031,
//                 width: 86.840576171875,
//                 height: 8.098236083984375,
//                 bbox: [
//                   145.1999969482422, 391.1887512207031, 232.0405731201172,
//                   399.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "1520 Clough Street",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 403.1887512207031,
//                 width: 62.42982482910156,
//                 height: 8.098236083984375,
//                 bbox: [
//                   145.1999969482422, 403.1887512207031, 207.62982177734375,
//                   411.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "Bowling Green",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 427.1887512207031,
//                 width: 47.52378845214844,
//                 height: 8.098236083984375,
//                 bbox: [
//                   145.1999969482422, 427.1887512207031, 192.72378540039062,
//                   435.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 321.6000061035156,
//                 y: 427.1887512207031,
//                 width: 10.86773681640625,
//                 height: 8.098236083984375,
//                 bbox: [
//                   321.6000061035156, 427.1887512207031, 332.4677429199219,
//                   435.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "43402",
//               coordinates: {
//                 x: 343.20001220703125,
//                 y: 427.1887512207031,
//                 width: 20.155029296875,
//                 height: 8.098236083984375,
//                 bbox: [
//                   343.20001220703125, 427.1887512207031, 363.35504150390625,
//                   435.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "Horizon Findlay Fartner LLC",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 511.1887512207031,
//                 width: 91.00930786132812,
//                 height: 8.098236083984375,
//                 bbox: [
//                   145.1999969482422, 511.1887512207031, 236.2093048095703,
//                   519.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "1090 W S Boundary Suite 100",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 523.188720703125,
//                 width: 97.45462036132812,
//                 height: 8.0982666015625,
//                 bbox: [
//                   145.1999969482422, 523.188720703125, 242.6546173095703,
//                   531.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "Perrysburg",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 547.188720703125,
//                 width: 35.44526672363281,
//                 height: 8.0982666015625,
//                 bbox: [
//                   145.1999969482422, 547.188720703125, 180.645263671875,
//                   555.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 321.6000061035156,
//                 y: 547.188720703125,
//                 width: 10.86773681640625,
//                 height: 8.0982666015625,
//                 bbox: [
//                   321.6000061035156, 547.188720703125, 332.4677429199219,
//                   555.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "43551",
//               coordinates: {
//                 x: 343.20001220703125,
//                 y: 547.188720703125,
//                 width: 20.155029296875,
//                 height: 8.0982666015625,
//                 bbox: [
//                   343.20001220703125, 547.188720703125, 363.35504150390625,
//                   555.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "Buckingham Investment Corporation",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 631.188720703125,
//                 width: 117.20359802246094,
//                 height: 8.0982666015625,
//                 bbox: [
//                   145.1999969482422, 631.188720703125, 262.4035949707031,
//                   639.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 317.0350036621094,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   317.0350036621094, 26.379987716674805, 408.8182373046875,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content:
//                 "ADDITIONAL INTEREST (Not all fields apply to all scenarios - provide only the necessary data)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 116.37998962402344,
//                 width: 347.02166175842285,
//                 height: 8.656745910644531,
//                 bbox: [
//                   21.899999618530273, 116.37998962402344, 368.9216613769531,
//                   125.03673553466797
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: "EFFECTIVE DATE",
//               coordinates: {
//                 x: 252.97500610351562,
//                 y: 92.54002380371094,
//                 width: 48.3919677734375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   252.97500610351562, 92.54002380371094, 301.3669738769531,
//                   98.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content: "NAMED INSURED(S)",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 92.54002380371094,
//                 width: 56.183197021484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   309.8999938964844, 92.54002380371094, 366.08319091796875,
//                   98.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content: "POLICY NUMBER",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 92.54002380371094,
//                 width: 48.09299659729004,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 92.54002380371094, 69.99299621582031,
//                   98.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content: "NAIC CODE",
//               coordinates: {
//                 x: 547.5,
//                 y: 68.54002380371094,
//                 width: 32.24029541015625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   547.5, 68.54002380371094, 579.7402954101562, 74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content: "CARRIER",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 67.17997741699219,
//                 width: 35.28570556640625,
//                 height: 8.656745910644531,
//                 bbox: [
//                   309.8999938964844, 67.17997741699219, 345.1856994628906,
//                   75.83672332763672
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content: "AGENCY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 68.54002380371094,
//                 width: 24.58125114440918,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 68.54002380371094, 46.48125076293945,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content: "The ACORD name and logo are registered marks of ACORD",
//               coordinates: {
//                 x: 203.6737518310547,
//                 y: 757.780029296875,
//                 width: 218.86769104003906,
//                 height: 8.65673828125,
//                 bbox: [
//                   203.6737518310547, 757.780029296875, 422.54144287109375,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content: "ACORD 45 (2016/03)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 745.780029296875,
//                 width: 74.47750282287598,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 745.780029296875, 96.37750244140625,
//                   754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content: "© 1993-2016 ACORD CORPORATION.  All rights reserved.",
//               coordinates: {
//                 x: 377.0174865722656,
//                 y: 745.780029296875,
//                 width: 211.10989379882812,
//                 height: 8.65673828125,
//                 bbox: [
//                   377.0174865722656, 745.780029296875, 588.1273803710938,
//                   754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content: "E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 236.54002380371094,
//                 width: 51.071502685546875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   299.1000061035156, 236.54002380371094, 350.1715087890625,
//                   242.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content: "REASON FOR INTEREST:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 236.54002380371094,
//                 width: 69.57499122619629,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 236.54002380371094, 91.47499084472656,
//                   242.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 192.13999938964844,
//                 width: 22.022499084472656,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 192.13999938964844, 58.3224983215332,
//                   198.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content: "LEASEBACK",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 186.13999938964844,
//                 width: 35.75349044799805,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 186.13999938964844, 72.0534896850586,
//                   192.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content: "WARRANTY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 156.13999938964844,
//                 width: 33.200504302978516,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 156.13999938964844, 69.50050354003906,
//                   162.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content: "BREACH OF",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 150.13999938964844,
//                 width: 34.15500259399414,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 150.13999938964844, 70.45500183105469,
//                   156.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content: "TRUSTEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 188.54002380371094,
//                 width: 26.806488037109375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   97.5, 188.54002380371094, 124.30648803710938,
//                   194.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content: "REGISTRANT",
//               coordinates: {
//                 x: 97.5,
//                 y: 176.54002380371094,
//                 width: 37.34049987792969,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   97.5, 176.54002380371094, 134.8404998779297, 182.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content: "PHONE (A/C, No, Ext):",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 224.54002380371094,
//                 width: 60.633697509765625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   299.1000061035156, 224.54002380371094, 359.73370361328125,
//                   230.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content: "LIEN AMOUNT:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 224.54002380371094,
//                 width: 40.96299743652344,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   144.3000030517578, 224.54002380371094, 185.26300048828125,
//                   230.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content: "INTEREST END DATE:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 212.54002380371094,
//                 width: 60.846435546875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   299.1000061035156, 212.54002380371094, 359.9464416503906,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content: "ITEM:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 176.54002380371094,
//                 width: 15.63427734375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   525.9000244140625, 176.54002380371094, 541.5343017578125,
//                   182.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content: "AIRPORT:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 164.54002380371094,
//                 width: 27.13421630859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 164.54002380371094, 481.0342102050781,
//                   170.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content: "AIRCRAFT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 164.54002380371094,
//                 width: 30.6474609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   525.9000244140625, 164.54002380371094, 556.5474853515625,
//                   170.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content: "CO-OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 164.54002380371094,
//                 width: 32.55649948120117,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 164.54002380371094, 68.85649871826172,
//                   170.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 97.5,
//                 y: 164.54002380371094,
//                 width: 22.022491455078125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   97.5, 164.54002380371094, 119.52249145507812,
//                   170.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content: "SEND BILL",
//               coordinates: {
//                 x: 417.8999938964844,
//                 y: 130.9399871826172,
//                 width: 30.31396484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   417.8999938964844, 130.9399871826172, 448.2139587402344,
//                   137.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 52,
//               type: "text",
//               content: "POLICY",
//               coordinates: {
//                 x: 374.70001220703125,
//                 y: 130.9399871826172,
//                 width: 21.37847900390625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   374.70001220703125, 130.9399871826172, 396.0784912109375,
//                   137.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 53,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 259.5,
//                 y: 129.73997497558594,
//                 width: 31.27996826171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   259.5, 129.73997497558594, 290.77996826171875,
//                   136.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 54,
//               type: "text",
//               content: "AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 180.13999938964844,
//                 width: 33.18899154663086,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 180.13999938964844, 69.4889907836914,
//                   186.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 55,
//               type: "text",
//               content: "INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 144.13999938964844,
//                 width: 25.857749938964844,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 144.13999938964844, 62.15774917602539,
//                   150.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 56,
//               type: "text",
//               content: "ITEM DESCRIPTION",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 200.54002380371094,
//                 width: 54.56744384765625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 200.54002380371094, 508.4674377441406,
//                   206.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 57,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 129.73997497558594,
//                 width: 28.399248123168945,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 129.73997497558594, 50.29924774169922,
//                   136.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 58,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 129.73997497558594,
//                 width: 18.520767211914062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   212.6999969482422, 129.73997497558594, 231.22076416015625,
//                   136.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 59,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 129.73997497558594,
//                 width: 60.23126220703125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   144.3000030517578, 129.73997497558594, 204.53126525878906,
//                   136.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 60,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 212.54002380371094,
//                 width: 63.1925048828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   144.3000030517578, 212.54002380371094, 207.4925079345703,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 61,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 313.5,
//                 y: 130.9399871826172,
//                 width: 37.547454833984375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   313.5, 130.9399871826172, 351.0474548339844,
//                   137.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 62,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 129.13999938964844,
//                 width: 77.8665771484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   483.3275146484375, 129.13999938964844, 561.194091796875,
//                   135.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 63,
//               type: "text",
//               content: "ADDITIONAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 138.13999938964844,
//                 width: 35.42574691772461,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 138.13999938964844, 71.72574615478516,
//                   144.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 64,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 140.54002380371094,
//                 width: 35.74774169921875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   97.5, 140.54002380371094, 133.24774169921875,
//                   146.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 65,
//               type: "text",
//               content: "MORTGAGEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 152.54002380371094,
//                 width: 37.66249084472656,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   97.5, 152.54002380371094, 135.16249084472656,
//                   158.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 66,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 212.54002380371094,
//                 width: 37.34049606323242,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 212.54002380371094, 73.64049530029297,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 67,
//               type: "text",
//               content: "EMPLOYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 174.13999938964844,
//                 width: 31.912494659423828,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 174.13999938964844, 68.21249389648438,
//                   180.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 68,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 140.54002380371094,
//                 width: 31.486968994140625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 140.54002380371094, 485.386962890625,
//                   146.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 69,
//               type: "text",
//               content: "BUILDING:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 140.54002380371094,
//                 width: 29.6815185546875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   525.9000244140625, 140.54002380371094, 555.58154296875,
//                   146.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 70,
//               type: "text",
//               content: "VEHICLE:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 152.54002380371094,
//                 width: 26.806488037109375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 152.54002380371094, 480.70648193359375,
//                   158.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 71,
//               type: "text",
//               content: "BOAT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 152.54002380371094,
//                 width: 17.135009765625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   525.9000244140625, 152.54002380371094, 543.0350341796875,
//                   158.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 72,
//               type: "text",
//               content: "ITEM CLASS:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 188.54002380371094,
//                 width: 36.696502685546875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 188.54002380371094, 490.59649658203125,
//                   194.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 73,
//               type: "text",
//               content: "ADDITIONAL INTEREST SCHEDULE",
//               coordinates: {
//                 x: 181.20249938964844,
//                 y: 47.501258850097656,
//                 width: 235.5649871826172,
//                 height: 15.358749389648438,
//                 bbox: [
//                   181.20249938964844, 47.501258850097656, 416.7674865722656,
//                   62.860008239746094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 13.75,
//                 color: 0
//               }
//             },
//             {
//               id: 74,
//               type: "text",
//               content: "DATE (MM/DD/YYYY)",
//               coordinates: {
//                 x: 522.563720703125,
//                 y: 44.54002380371094,
//                 width: 57.02288818359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   522.563720703125, 44.54002380371094, 579.5866088867188,
//                   50.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 75,
//               type: "text",
//               content: "SCHED #:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 176.54002380371094,
//                 width: 26.817962646484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 176.54002380371094, 480.71795654296875,
//                   182.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 76,
//               type: "text",
//               content: "LENDER'S LOSS PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 200.54002380371094,
//                 width: 73.61149215698242,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 200.54002380371094, 109.91149139404297,
//                   206.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 77,
//               type: "text",
//               content: "E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 356.5400085449219,
//                 width: 51.071502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 356.5400085449219, 350.1715087890625,
//                   362.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 78,
//               type: "text",
//               content: "REASON FOR INTEREST:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 356.5400085449219,
//                 width: 69.57499122619629,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 356.5400085449219, 91.47499084472656,
//                   362.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 79,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 312.1400146484375,
//                 width: 22.022499084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 312.1400146484375, 58.3224983215332,
//                   318.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 80,
//               type: "text",
//               content: "LEASEBACK",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 306.1400146484375,
//                 width: 35.75349044799805,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 306.1400146484375, 72.0534896850586,
//                   312.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 81,
//               type: "text",
//               content: "WARRANTY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 276.1400146484375,
//                 width: 33.200504302978516,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 276.1400146484375, 69.50050354003906,
//                   282.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 82,
//               type: "text",
//               content: "BREACH OF",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 270.1400146484375,
//                 width: 34.15500259399414,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 270.1400146484375, 70.45500183105469,
//                   276.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 83,
//               type: "text",
//               content: "TRUSTEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 308.5400085449219,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 308.5400085449219, 124.30648803710938, 314.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 84,
//               type: "text",
//               content: "REGISTRANT",
//               coordinates: {
//                 x: 97.5,
//                 y: 296.5400085449219,
//                 width: 37.34049987792969,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 296.5400085449219, 134.8404998779297, 302.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 85,
//               type: "text",
//               content: "PHONE (A/C, No, Ext):",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 344.5400085449219,
//                 width: 60.633697509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 344.5400085449219, 359.73370361328125,
//                   350.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 86,
//               type: "text",
//               content: "LIEN AMOUNT:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 344.5400085449219,
//                 width: 40.96299743652344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 344.5400085449219, 185.26300048828125,
//                   350.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 87,
//               type: "text",
//               content: "INTEREST END DATE:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 332.5400085449219,
//                 width: 60.846435546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 332.5400085449219, 359.9464416503906,
//                   338.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 88,
//               type: "text",
//               content: "ITEM:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 296.5400085449219,
//                 width: 15.63427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 296.5400085449219, 541.5343017578125,
//                   302.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 89,
//               type: "text",
//               content: "AIRPORT:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 284.5400085449219,
//                 width: 27.13421630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 284.5400085449219, 481.0342102050781,
//                   290.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 90,
//               type: "text",
//               content: "AIRCRAFT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 284.5400085449219,
//                 width: 30.6474609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 284.5400085449219, 556.5474853515625,
//                   290.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 91,
//               type: "text",
//               content: "CO-OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 284.5400085449219,
//                 width: 32.55649948120117,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 284.5400085449219, 68.85649871826172,
//                   290.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 92,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 97.5,
//                 y: 284.5400085449219,
//                 width: 22.022491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 284.5400085449219, 119.52249145507812, 290.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 93,
//               type: "text",
//               content: "SEND BILL",
//               coordinates: {
//                 x: 417.8999938964844,
//                 y: 250.9399871826172,
//                 width: 30.31396484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   417.8999938964844, 250.9399871826172, 448.2139587402344,
//                   257.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 94,
//               type: "text",
//               content: "POLICY",
//               coordinates: {
//                 x: 374.70001220703125,
//                 y: 250.9399871826172,
//                 width: 21.37847900390625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   374.70001220703125, 250.9399871826172, 396.0784912109375,
//                   257.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 95,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 259.5,
//                 y: 249.73997497558594,
//                 width: 31.27996826171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   259.5, 249.73997497558594, 290.77996826171875,
//                   256.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 96,
//               type: "text",
//               content: "AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 300.1400146484375,
//                 width: 33.18899154663086,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 300.1400146484375, 69.4889907836914,
//                   306.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 97,
//               type: "text",
//               content: "INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 264.1400146484375,
//                 width: 25.857749938964844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 264.1400146484375, 62.15774917602539,
//                   270.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 98,
//               type: "text",
//               content: "ITEM DESCRIPTION",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 320.5400085449219,
//                 width: 54.56744384765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 320.5400085449219, 508.4674377441406,
//                   326.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 99,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 249.73997497558594,
//                 width: 28.399248123168945,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 249.73997497558594, 50.29924774169922,
//                   256.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 100,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 249.73997497558594,
//                 width: 18.520767211914062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   212.6999969482422, 249.73997497558594, 231.22076416015625,
//                   256.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 101,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 249.73997497558594,
//                 width: 60.23126220703125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   144.3000030517578, 249.73997497558594, 204.53126525878906,
//                   256.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 102,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 332.5400085449219,
//                 width: 63.1925048828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 332.5400085449219, 207.4925079345703,
//                   338.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 103,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 313.5,
//                 y: 250.9399871826172,
//                 width: 37.547454833984375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   313.5, 250.9399871826172, 351.0474548339844,
//                   257.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 104,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 249.13999938964844,
//                 width: 77.8665771484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   483.3275146484375, 249.13999938964844, 561.194091796875,
//                   255.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 105,
//               type: "text",
//               content: "ADDITIONAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 258.1400146484375,
//                 width: 35.42574691772461,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 258.1400146484375, 71.72574615478516,
//                   264.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 106,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 260.5400390625,
//                 width: 35.74774169921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 260.5400390625, 133.24774169921875, 266.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 107,
//               type: "text",
//               content: "MORTGAGEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 272.5400390625,
//                 width: 37.66249084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 272.5400390625, 135.16249084472656, 278.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 108,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 332.5400085449219,
//                 width: 37.34049606323242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 332.5400085449219, 73.64049530029297,
//                   338.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 109,
//               type: "text",
//               content: "EMPLOYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 294.1400146484375,
//                 width: 31.912494659423828,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 294.1400146484375, 68.21249389648438,
//                   300.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 110,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 260.5400390625,
//                 width: 31.486968994140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 260.5400390625, 485.386962890625,
//                   266.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 111,
//               type: "text",
//               content: "BUILDING:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 260.5400390625,
//                 width: 29.6815185546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 260.5400390625, 555.58154296875,
//                   266.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 112,
//               type: "text",
//               content: "VEHICLE:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 272.5400390625,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 272.5400390625, 480.70648193359375,
//                   278.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 113,
//               type: "text",
//               content: "BOAT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 272.5400390625,
//                 width: 17.135009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 272.5400390625, 543.0350341796875,
//                   278.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 114,
//               type: "text",
//               content: "ITEM CLASS:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 308.5400085449219,
//                 width: 36.696502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 308.5400085449219, 490.59649658203125,
//                   314.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 115,
//               type: "text",
//               content: "SCHED #:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 296.5400085449219,
//                 width: 26.817962646484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 296.5400085449219, 480.71795654296875,
//                   302.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 116,
//               type: "text",
//               content: "LENDER'S LOSS PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 320.5400085449219,
//                 width: 73.61149215698242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 320.5400085449219, 109.91149139404297,
//                   326.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 117,
//               type: "text",
//               content: "E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 476.5400085449219,
//                 width: 51.071502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 476.5400085449219, 350.1715087890625,
//                   482.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 118,
//               type: "text",
//               content: "REASON FOR INTEREST:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 476.5400085449219,
//                 width: 69.57499122619629,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 476.5400085449219, 91.47499084472656,
//                   482.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 119,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 432.1400146484375,
//                 width: 22.022499084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 432.1400146484375, 58.3224983215332,
//                   438.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 120,
//               type: "text",
//               content: "LEASEBACK",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 426.1400146484375,
//                 width: 35.75349044799805,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 426.1400146484375, 72.0534896850586,
//                   432.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 121,
//               type: "text",
//               content: "WARRANTY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 396.1400146484375,
//                 width: 33.200504302978516,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 396.1400146484375, 69.50050354003906,
//                   402.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 122,
//               type: "text",
//               content: "BREACH OF",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 390.1400146484375,
//                 width: 34.15500259399414,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 390.1400146484375, 70.45500183105469,
//                   396.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 123,
//               type: "text",
//               content: "TRUSTEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 428.5400085449219,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 428.5400085449219, 124.30648803710938, 434.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 124,
//               type: "text",
//               content: "REGISTRANT",
//               coordinates: {
//                 x: 97.5,
//                 y: 416.5400085449219,
//                 width: 37.34049987792969,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 416.5400085449219, 134.8404998779297, 422.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 125,
//               type: "text",
//               content: "PHONE (A/C, No, Ext):",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 464.5400085449219,
//                 width: 60.633697509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 464.5400085449219, 359.73370361328125,
//                   470.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 126,
//               type: "text",
//               content: "LIEN AMOUNT:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 464.5400085449219,
//                 width: 40.96299743652344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 464.5400085449219, 185.26300048828125,
//                   470.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 127,
//               type: "text",
//               content: "INTEREST END DATE:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 452.5400085449219,
//                 width: 60.846435546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 452.5400085449219, 359.9464416503906,
//                   458.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 128,
//               type: "text",
//               content: "ITEM:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 416.5400085449219,
//                 width: 15.63427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 416.5400085449219, 541.5343017578125,
//                   422.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 129,
//               type: "text",
//               content: "AIRPORT:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 404.5400085449219,
//                 width: 27.13421630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 404.5400085449219, 481.0342102050781,
//                   410.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 130,
//               type: "text",
//               content: "AIRCRAFT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 404.5400085449219,
//                 width: 30.6474609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 404.5400085449219, 556.5474853515625,
//                   410.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 131,
//               type: "text",
//               content: "CO-OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 404.5400085449219,
//                 width: 32.55649948120117,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 404.5400085449219, 68.85649871826172,
//                   410.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 132,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 97.5,
//                 y: 404.5400085449219,
//                 width: 22.022491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 404.5400085449219, 119.52249145507812, 410.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 133,
//               type: "text",
//               content: "SEND BILL",
//               coordinates: {
//                 x: 417.8999938964844,
//                 y: 370.94000244140625,
//                 width: 30.31396484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   417.8999938964844, 370.94000244140625, 448.2139587402344,
//                   377.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 134,
//               type: "text",
//               content: "POLICY",
//               coordinates: {
//                 x: 374.70001220703125,
//                 y: 370.94000244140625,
//                 width: 21.37847900390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   374.70001220703125, 370.94000244140625, 396.0784912109375,
//                   377.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 135,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 259.5,
//                 y: 369.7400207519531,
//                 width: 31.27996826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   259.5, 369.7400207519531, 290.77996826171875,
//                   376.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 136,
//               type: "text",
//               content: "AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 420.1400146484375,
//                 width: 33.18899154663086,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 420.1400146484375, 69.4889907836914,
//                   426.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 137,
//               type: "text",
//               content: "INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 384.1400146484375,
//                 width: 25.857749938964844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 384.1400146484375, 62.15774917602539,
//                   390.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 138,
//               type: "text",
//               content: "ITEM DESCRIPTION",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 440.5400085449219,
//                 width: 54.56744384765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 440.5400085449219, 508.4674377441406,
//                   446.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 139,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 369.7400207519531,
//                 width: 28.399248123168945,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 369.7400207519531, 50.29924774169922,
//                   376.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 140,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 369.7400207519531,
//                 width: 18.520767211914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   212.6999969482422, 369.7400207519531, 231.22076416015625,
//                   376.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 141,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 369.7400207519531,
//                 width: 60.23126220703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 369.7400207519531, 204.53126525878906,
//                   376.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 142,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 452.5400085449219,
//                 width: 63.1925048828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 452.5400085449219, 207.4925079345703,
//                   458.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 143,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 313.5,
//                 y: 370.94000244140625,
//                 width: 37.547454833984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   313.5, 370.94000244140625, 351.0474548339844,
//                   377.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 144,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 369.1400146484375,
//                 width: 77.8665771484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   483.3275146484375, 369.1400146484375, 561.194091796875,
//                   375.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 145,
//               type: "text",
//               content: "ADDITIONAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 378.1400146484375,
//                 width: 35.42574691772461,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 378.1400146484375, 71.72574615478516,
//                   384.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 146,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 380.5400085449219,
//                 width: 35.74774169921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 380.5400085449219, 133.24774169921875, 386.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 147,
//               type: "text",
//               content: "MORTGAGEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 392.5400085449219,
//                 width: 37.66249084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 392.5400085449219, 135.16249084472656, 398.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 148,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 452.5400085449219,
//                 width: 37.34049606323242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 452.5400085449219, 73.64049530029297,
//                   458.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 149,
//               type: "text",
//               content: "EMPLOYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 414.1400146484375,
//                 width: 31.912494659423828,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 414.1400146484375, 68.21249389648438,
//                   420.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 150,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 380.5400085449219,
//                 width: 31.486968994140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 380.5400085449219, 485.386962890625,
//                   386.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 151,
//               type: "text",
//               content: "BUILDING:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 380.5400085449219,
//                 width: 29.6815185546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 380.5400085449219, 555.58154296875,
//                   386.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 152,
//               type: "text",
//               content: "VEHICLE:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 392.5400085449219,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 392.5400085449219, 480.70648193359375,
//                   398.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 153,
//               type: "text",
//               content: "BOAT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 392.5400085449219,
//                 width: 17.135009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 392.5400085449219, 543.0350341796875,
//                   398.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 154,
//               type: "text",
//               content: "ITEM CLASS:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 428.5400085449219,
//                 width: 36.696502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 428.5400085449219, 490.59649658203125,
//                   434.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 155,
//               type: "text",
//               content: "SCHED #:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 416.5400085449219,
//                 width: 26.817962646484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 416.5400085449219, 480.71795654296875,
//                   422.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 156,
//               type: "text",
//               content: "LENDER'S LOSS PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 440.5400085449219,
//                 width: 73.61149215698242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 440.5400085449219, 109.91149139404297,
//                   446.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 157,
//               type: "text",
//               content: "E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 596.5400390625,
//                 width: 51.071502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 596.5400390625, 350.1715087890625,
//                   602.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 158,
//               type: "text",
//               content: "REASON FOR INTEREST:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 596.5400390625,
//                 width: 69.57499122619629,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 596.5400390625, 91.47499084472656,
//                   602.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 159,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 552.1400146484375,
//                 width: 22.022499084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 552.1400146484375, 58.3224983215332,
//                   558.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 160,
//               type: "text",
//               content: "LEASEBACK",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 546.1400146484375,
//                 width: 35.75349044799805,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 546.1400146484375, 72.0534896850586,
//                   552.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 161,
//               type: "text",
//               content: "WARRANTY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 516.1400146484375,
//                 width: 33.200504302978516,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 516.1400146484375, 69.50050354003906,
//                   522.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 162,
//               type: "text",
//               content: "BREACH OF",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 510.1400146484375,
//                 width: 34.15500259399414,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 510.1400146484375, 70.45500183105469,
//                   516.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 163,
//               type: "text",
//               content: "TRUSTEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 548.5400390625,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 548.5400390625, 124.30648803710938, 554.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 164,
//               type: "text",
//               content: "REGISTRANT",
//               coordinates: {
//                 x: 97.5,
//                 y: 536.5400390625,
//                 width: 37.34049987792969,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 536.5400390625, 134.8404998779297, 542.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 165,
//               type: "text",
//               content: "PHONE (A/C, No, Ext):",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 584.5400390625,
//                 width: 60.633697509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 584.5400390625, 359.73370361328125,
//                   590.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 166,
//               type: "text",
//               content: "LIEN AMOUNT:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 584.5400390625,
//                 width: 40.96299743652344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 584.5400390625, 185.26300048828125,
//                   590.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 167,
//               type: "text",
//               content: "INTEREST END DATE:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 572.5400390625,
//                 width: 60.846435546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 572.5400390625, 359.9464416503906,
//                   578.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 168,
//               type: "text",
//               content: "ITEM:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 536.5400390625,
//                 width: 15.63427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 536.5400390625, 541.5343017578125,
//                   542.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 169,
//               type: "text",
//               content: "AIRPORT:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 524.5400390625,
//                 width: 27.13421630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 524.5400390625, 481.0342102050781,
//                   530.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 170,
//               type: "text",
//               content: "AIRCRAFT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 524.5400390625,
//                 width: 30.6474609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 524.5400390625, 556.5474853515625,
//                   530.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 171,
//               type: "text",
//               content: "CO-OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 524.5400390625,
//                 width: 32.55649948120117,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 524.5400390625, 68.85649871826172,
//                   530.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 172,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 97.5,
//                 y: 524.5400390625,
//                 width: 22.022491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 524.5400390625, 119.52249145507812, 530.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 173,
//               type: "text",
//               content: "SEND BILL",
//               coordinates: {
//                 x: 417.8999938964844,
//                 y: 490.94000244140625,
//                 width: 30.31396484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   417.8999938964844, 490.94000244140625, 448.2139587402344,
//                   497.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 174,
//               type: "text",
//               content: "POLICY",
//               coordinates: {
//                 x: 374.70001220703125,
//                 y: 490.94000244140625,
//                 width: 21.37847900390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   374.70001220703125, 490.94000244140625, 396.0784912109375,
//                   497.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 175,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 259.5,
//                 y: 489.7400207519531,
//                 width: 31.27996826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   259.5, 489.7400207519531, 290.77996826171875,
//                   496.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 176,
//               type: "text",
//               content: "AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 540.1400146484375,
//                 width: 33.18899154663086,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 540.1400146484375, 69.4889907836914,
//                   546.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 177,
//               type: "text",
//               content: "INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 504.1400146484375,
//                 width: 25.857749938964844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 504.1400146484375, 62.15774917602539,
//                   510.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 178,
//               type: "text",
//               content: "ITEM DESCRIPTION",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 560.5400390625,
//                 width: 54.56744384765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 560.5400390625, 508.4674377441406,
//                   566.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 179,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 489.7400207519531,
//                 width: 28.399248123168945,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 489.7400207519531, 50.29924774169922,
//                   496.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 180,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 489.7400207519531,
//                 width: 18.520767211914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   212.6999969482422, 489.7400207519531, 231.22076416015625,
//                   496.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 181,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 489.7400207519531,
//                 width: 60.23126220703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 489.7400207519531, 204.53126525878906,
//                   496.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 182,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 572.5400390625,
//                 width: 63.1925048828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 572.5400390625, 207.4925079345703,
//                   578.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 183,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 313.5,
//                 y: 490.94000244140625,
//                 width: 37.547454833984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   313.5, 490.94000244140625, 351.0474548339844,
//                   497.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 184,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 489.1400146484375,
//                 width: 77.8665771484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   483.3275146484375, 489.1400146484375, 561.194091796875,
//                   495.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 185,
//               type: "text",
//               content: "ADDITIONAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 498.1400146484375,
//                 width: 35.42574691772461,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 498.1400146484375, 71.72574615478516,
//                   504.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 186,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 500.5400085449219,
//                 width: 35.74774169921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 500.5400085449219, 133.24774169921875, 506.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 187,
//               type: "text",
//               content: "MORTGAGEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 512.5400390625,
//                 width: 37.66249084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 512.5400390625, 135.16249084472656, 518.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 188,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 572.5400390625,
//                 width: 37.34049606323242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 572.5400390625, 73.64049530029297,
//                   578.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 189,
//               type: "text",
//               content: "EMPLOYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 534.1400146484375,
//                 width: 31.912494659423828,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 534.1400146484375, 68.21249389648438,
//                   540.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 190,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 500.5400085449219,
//                 width: 31.486968994140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 500.5400085449219, 485.386962890625,
//                   506.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 191,
//               type: "text",
//               content: "BUILDING:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 500.5400085449219,
//                 width: 29.6815185546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 500.5400085449219, 555.58154296875,
//                   506.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 192,
//               type: "text",
//               content: "VEHICLE:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 512.5400390625,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 512.5400390625, 480.70648193359375,
//                   518.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 193,
//               type: "text",
//               content: "BOAT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 512.5400390625,
//                 width: 17.135009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 512.5400390625, 543.0350341796875,
//                   518.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 194,
//               type: "text",
//               content: "ITEM CLASS:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 548.5400390625,
//                 width: 36.696502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 548.5400390625, 490.59649658203125,
//                   554.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 195,
//               type: "text",
//               content: "SCHED #:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 536.5400390625,
//                 width: 26.817962646484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 536.5400390625, 480.71795654296875,
//                   542.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 196,
//               type: "text",
//               content: "LENDER'S LOSS PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 560.5400390625,
//                 width: 73.61149215698242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 560.5400390625, 109.91149139404297,
//                   566.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 197,
//               type: "text",
//               content: "E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 716.5400390625,
//                 width: 51.071502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 716.5400390625, 350.1715087890625,
//                   722.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 198,
//               type: "text",
//               content: "REASON FOR INTEREST:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 716.5400390625,
//                 width: 69.57499122619629,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 716.5400390625, 91.47499084472656,
//                   722.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 199,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 672.1400146484375,
//                 width: 22.022499084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 672.1400146484375, 58.3224983215332,
//                   678.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 200,
//               type: "text",
//               content: "LEASEBACK",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 666.1400146484375,
//                 width: 35.75349044799805,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 666.1400146484375, 72.0534896850586,
//                   672.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 201,
//               type: "text",
//               content: "WARRANTY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 636.1400146484375,
//                 width: 33.200504302978516,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 636.1400146484375, 69.50050354003906,
//                   642.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 202,
//               type: "text",
//               content: "BREACH OF",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 630.1400146484375,
//                 width: 34.15500259399414,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 630.1400146484375, 70.45500183105469,
//                   636.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 203,
//               type: "text",
//               content: "TRUSTEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 668.5400390625,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 668.5400390625, 124.30648803710938, 674.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 204,
//               type: "text",
//               content: "REGISTRANT",
//               coordinates: {
//                 x: 97.5,
//                 y: 656.5400390625,
//                 width: 37.34049987792969,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 656.5400390625, 134.8404998779297, 662.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 205,
//               type: "text",
//               content: "PHONE (A/C, No, Ext):",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 704.5400390625,
//                 width: 60.633697509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 704.5400390625, 359.73370361328125,
//                   710.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 206,
//               type: "text",
//               content: "LIEN AMOUNT:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 704.5400390625,
//                 width: 40.96299743652344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 704.5400390625, 185.26300048828125,
//                   710.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 207,
//               type: "text",
//               content: "INTEREST END DATE:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 692.5400390625,
//                 width: 60.846435546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 692.5400390625, 359.9464416503906,
//                   698.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 208,
//               type: "text",
//               content: "ITEM:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 656.5400390625,
//                 width: 15.63427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 656.5400390625, 541.5343017578125,
//                   662.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 209,
//               type: "text",
//               content: "AIRPORT:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 644.5400390625,
//                 width: 27.13421630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 644.5400390625, 481.0342102050781,
//                   650.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 210,
//               type: "text",
//               content: "AIRCRAFT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 644.5400390625,
//                 width: 30.6474609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 644.5400390625, 556.5474853515625,
//                   650.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 211,
//               type: "text",
//               content: "CO-OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 644.5400390625,
//                 width: 32.55649948120117,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 644.5400390625, 68.85649871826172,
//                   650.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 212,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 97.5,
//                 y: 644.5400390625,
//                 width: 22.022491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 644.5400390625, 119.52249145507812, 650.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 213,
//               type: "text",
//               content: "SEND BILL",
//               coordinates: {
//                 x: 417.8999938964844,
//                 y: 610.9400024414062,
//                 width: 30.31396484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   417.8999938964844, 610.9400024414062, 448.2139587402344,
//                   617.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 214,
//               type: "text",
//               content: "POLICY",
//               coordinates: {
//                 x: 374.70001220703125,
//                 y: 610.9400024414062,
//                 width: 21.37847900390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   374.70001220703125, 610.9400024414062, 396.0784912109375,
//                   617.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 215,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 259.5,
//                 y: 609.739990234375,
//                 width: 31.27996826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   259.5, 609.739990234375, 290.77996826171875, 616.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 216,
//               type: "text",
//               content: "AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 660.1400146484375,
//                 width: 33.18899154663086,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 660.1400146484375, 69.4889907836914,
//                   666.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 217,
//               type: "text",
//               content: "INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 624.1400146484375,
//                 width: 25.857749938964844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 624.1400146484375, 62.15774917602539,
//                   630.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 218,
//               type: "text",
//               content: "ITEM DESCRIPTION",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 680.5400390625,
//                 width: 54.56744384765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 680.5400390625, 508.4674377441406,
//                   686.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 219,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 609.739990234375,
//                 width: 28.399248123168945,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 609.739990234375, 50.29924774169922,
//                   616.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 220,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 609.739990234375,
//                 width: 18.520767211914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   212.6999969482422, 609.739990234375, 231.22076416015625,
//                   616.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 221,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 609.739990234375,
//                 width: 60.23126220703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 609.739990234375, 204.53126525878906,
//                   616.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 222,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 692.5400390625,
//                 width: 63.1925048828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 692.5400390625, 207.4925079345703,
//                   698.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 223,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 313.5,
//                 y: 610.9400024414062,
//                 width: 37.547454833984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   313.5, 610.9400024414062, 351.0474548339844, 617.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 224,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 609.1400146484375,
//                 width: 77.8665771484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   483.3275146484375, 609.1400146484375, 561.194091796875,
//                   615.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 225,
//               type: "text",
//               content: "ADDITIONAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 618.1400146484375,
//                 width: 35.42574691772461,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 618.1400146484375, 71.72574615478516,
//                   624.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 226,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 620.5400390625,
//                 width: 35.74774169921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 620.5400390625, 133.24774169921875, 626.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 227,
//               type: "text",
//               content: "MORTGAGEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 632.5400390625,
//                 width: 37.66249084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 632.5400390625, 135.16249084472656, 638.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 228,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 692.5400390625,
//                 width: 37.34049606323242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 692.5400390625, 73.64049530029297,
//                   698.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 229,
//               type: "text",
//               content: "EMPLOYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 654.1400146484375,
//                 width: 31.912494659423828,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 654.1400146484375, 68.21249389648438,
//                   660.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 230,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 620.5400390625,
//                 width: 31.486968994140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 620.5400390625, 485.386962890625,
//                   626.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 231,
//               type: "text",
//               content: "BUILDING:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 620.5400390625,
//                 width: 29.6815185546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 620.5400390625, 555.58154296875,
//                   626.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 232,
//               type: "text",
//               content: "VEHICLE:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 632.5400390625,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 632.5400390625, 480.70648193359375,
//                   638.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 233,
//               type: "text",
//               content: "BOAT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 632.5400390625,
//                 width: 17.135009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 632.5400390625, 543.0350341796875,
//                   638.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 234,
//               type: "text",
//               content: "ITEM CLASS:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 668.5400390625,
//                 width: 36.696502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 668.5400390625, 490.59649658203125,
//                   674.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 235,
//               type: "text",
//               content: "SCHED #:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 656.5400390625,
//                 width: 26.817962646484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 656.5400390625, 480.71795654296875,
//                   662.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 236,
//               type: "text",
//               content: "LENDER'S LOSS PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 680.5400390625,
//                 width: 73.61149215698242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 680.5400390625, 109.91149139404297,
//                   686.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 41.26749469857623,
//                 width: 577.68,
//                 height: 73.41775219630415,
//                 bbox: [
//                   17.28, 41.26749469857623, 594.9599999999999,
//                   114.68524689488038
//                 ]
//               },
//               properties: {
//                 rows: 3,
//                 columns: 5,
//                 accuracy: 89.795
//               }
//             },
//             {
//               id: 1,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 125.24204786428356,
//                 width: 577.4399999999999,
//                 height: 619.4922750681611,
//                 bbox: [
//                   17.52, 125.24204786428356, 594.9599999999999,
//                   744.7343229324447
//                 ]
//               },
//               properties: {
//                 rows: 51,
//                 columns: 14,
//                 accuracy: 92.318
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 237,
//           table_count: 2,
//           total_elements: 239
//         }
//       },
//       {
//         page_number: 20,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 415.20001220703125,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   415.20001220703125, 25.188751220703125, 447.44805908203125,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "04/04/2025",
//               coordinates: {
//                 x: 532.9550170898438,
//                 y: 55.188751220703125,
//                 width: 36.2645263671875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   532.9550170898438, 55.188751220703125, 569.2195434570312,
//                   63.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "UIS Insurance & Investments",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 79.18875122070312,
//                 width: 93.81499099731445,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 79.18875122070312, 116.614990234375,
//                   87.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "25-26",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 103.18875122070312,
//                 width: 18.538253784179688,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 103.18875122070312, 41.338253021240234,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "05/18/2025",
//               coordinates: {
//                 x: 259.3550109863281,
//                 y: 103.18875122070312,
//                 width: 36.2645263671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   259.3550109863281, 103.18875122070312, 295.6195373535156,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "Submissions",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 79.18875122070312,
//                 width: 41.08575439453125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 79.18875122070312, 351.8857421875,
//                   87.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "Buckeye Premier Cleaning, LLC",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 103.18875122070312,
//                 width: 103.10223388671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 103.18875122070312, 413.9022216796875,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "MRD Apartments",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 151.18875122070312,
//                 width: 55.165283203125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   145.1999969482422, 151.18875122070312, 200.3652801513672,
//                   159.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "321 Woodland Pass",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 163.18875122070312,
//                 width: 64.7208251953125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   145.1999969482422, 163.18875122070312, 209.9208221435547,
//                   171.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "East Lansing",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 187.18875122070312,
//                 width: 41.89054870605469,
//                 height: 8.098251342773438,
//                 bbox: [
//                   145.1999969482422, 187.18875122070312, 187.09054565429688,
//                   195.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "MI",
//               coordinates: {
//                 x: 321.6000061035156,
//                 y: 187.18875122070312,
//                 width: 8.0474853515625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   321.6000061035156, 187.18875122070312, 329.6474914550781,
//                   195.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "48823",
//               coordinates: {
//                 x: 343.20001220703125,
//                 y: 187.18875122070312,
//                 width: 20.155029296875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   343.20001220703125, 187.18875122070312, 363.35504150390625,
//                   195.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "Denizen Management",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 271.1887512207031,
//                 width: 70.90505981445312,
//                 height: 8.098236083984375,
//                 bbox: [
//                   145.1999969482422, 271.1887512207031, 216.1050567626953,
//                   279.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "20 W Carmel Dr Suite 101",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 283.1887512207031,
//                 width: 84.549560546875,
//                 height: 8.098236083984375,
//                 bbox: [
//                   145.1999969482422, 283.1887512207031, 229.7495574951172,
//                   291.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "Carmel",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 307.1887512207031,
//                 width: 23.3594970703125,
//                 height: 8.098236083984375,
//                 bbox: [
//                   145.1999969482422, 307.1887512207031, 168.5594940185547,
//                   315.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "IN",
//               coordinates: {
//                 x: 321.6000061035156,
//                 y: 307.1887512207031,
//                 width: 7.24273681640625,
//                 height: 8.098236083984375,
//                 bbox: [
//                   321.6000061035156, 307.1887512207031, 328.8427429199219,
//                   315.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "46032",
//               coordinates: {
//                 x: 343.20001220703125,
//                 y: 307.1887512207031,
//                 width: 20.155029296875,
//                 height: 8.098236083984375,
//                 bbox: [
//                   343.20001220703125, 307.1887512207031, 363.35504150390625,
//                   315.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "University Courts and Village",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 391.1887512207031,
//                 width: 92.89431762695312,
//                 height: 8.098236083984375,
//                 bbox: [
//                   145.1999969482422, 391.1887512207031, 238.0943145751953,
//                   399.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "1520 Clough Street",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 403.1887512207031,
//                 width: 62.42982482910156,
//                 height: 8.098236083984375,
//                 bbox: [
//                   145.1999969482422, 403.1887512207031, 207.62982177734375,
//                   411.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "Bowling Green",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 427.1887512207031,
//                 width: 47.52378845214844,
//                 height: 8.098236083984375,
//                 bbox: [
//                   145.1999969482422, 427.1887512207031, 192.72378540039062,
//                   435.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 321.6000061035156,
//                 y: 427.1887512207031,
//                 width: 10.86773681640625,
//                 height: 8.098236083984375,
//                 bbox: [
//                   321.6000061035156, 427.1887512207031, 332.4677429199219,
//                   435.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content: "43402",
//               coordinates: {
//                 x: 343.20001220703125,
//                 y: 427.1887512207031,
//                 width: 20.155029296875,
//                 height: 8.098236083984375,
//                 bbox: [
//                   343.20001220703125, 427.1887512207031, 363.35504150390625,
//                   435.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "Towne Properties Asset MGT CO.",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 511.1887512207031,
//                 width: 108.56884765625,
//                 height: 8.098236083984375,
//                 bbox: [
//                   145.1999969482422, 511.1887512207031, 253.7688446044922,
//                   519.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "PO BOX 55071",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 523.188720703125,
//                 width: 49.92356872558594,
//                 height: 8.0982666015625,
//                 bbox: [
//                   145.1999969482422, 523.188720703125, 195.12356567382812,
//                   531.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "Boston",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 547.188720703125,
//                 width: 22.554779052734375,
//                 height: 8.0982666015625,
//                 bbox: [
//                   145.1999969482422, 547.188720703125, 167.75477600097656,
//                   555.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content: "MA",
//               coordinates: {
//                 x: 321.6000061035156,
//                 y: 547.188720703125,
//                 width: 10.86773681640625,
//                 height: 8.0982666015625,
//                 bbox: [
//                   321.6000061035156, 547.188720703125, 332.4677429199219,
//                   555.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: "02205",
//               coordinates: {
//                 x: 343.20001220703125,
//                 y: 547.188720703125,
//                 width: 20.155029296875,
//                 height: 8.0982666015625,
//                 bbox: [
//                   343.20001220703125, 547.188720703125, 363.35504150390625,
//                   555.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content: "Buckingham Construction Corporation",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 631.188720703125,
//                 width: 122.44532775878906,
//                 height: 8.0982666015625,
//                 bbox: [
//                   145.1999969482422, 631.188720703125, 267.64532470703125,
//                   639.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content: "19801 SW 72nd Ave Suite 300",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 643.188720703125,
//                 width: 98.54214477539062,
//                 height: 8.0982666015625,
//                 bbox: [
//                   145.1999969482422, 643.188720703125, 243.7421417236328,
//                   651.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content: "Tualatin",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 667.188720703125,
//                 width: 25.505523681640625,
//                 height: 8.0982666015625,
//                 bbox: [
//                   145.1999969482422, 667.188720703125, 170.7055206298828,
//                   675.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content: "OR",
//               coordinates: {
//                 x: 321.6000061035156,
//                 y: 667.188720703125,
//                 width: 10.86773681640625,
//                 height: 8.0982666015625,
//                 bbox: [
//                   321.6000061035156, 667.188720703125, 332.4677429199219,
//                   675.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content: "97062",
//               coordinates: {
//                 x: 343.20001220703125,
//                 y: 667.188720703125,
//                 width: 20.155029296875,
//                 height: 8.0982666015625,
//                 bbox: [
//                   343.20001220703125, 667.188720703125, 363.35504150390625,
//                   675.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 317.0350036621094,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   317.0350036621094, 26.379987716674805, 408.8182373046875,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content:
//                 "ADDITIONAL INTEREST (Not all fields apply to all scenarios - provide only the necessary data)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 116.37998962402344,
//                 width: 347.02166175842285,
//                 height: 8.656745910644531,
//                 bbox: [
//                   21.899999618530273, 116.37998962402344, 368.9216613769531,
//                   125.03673553466797
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content: "EFFECTIVE DATE",
//               coordinates: {
//                 x: 252.97500610351562,
//                 y: 92.54002380371094,
//                 width: 48.3919677734375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   252.97500610351562, 92.54002380371094, 301.3669738769531,
//                   98.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content: "NAMED INSURED(S)",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 92.54002380371094,
//                 width: 56.183197021484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   309.8999938964844, 92.54002380371094, 366.08319091796875,
//                   98.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content: "POLICY NUMBER",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 92.54002380371094,
//                 width: 48.09299659729004,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 92.54002380371094, 69.99299621582031,
//                   98.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content: "NAIC CODE",
//               coordinates: {
//                 x: 547.5,
//                 y: 68.54002380371094,
//                 width: 32.24029541015625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   547.5, 68.54002380371094, 579.7402954101562, 74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content: "CARRIER",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 67.17997741699219,
//                 width: 35.28570556640625,
//                 height: 8.656745910644531,
//                 bbox: [
//                   309.8999938964844, 67.17997741699219, 345.1856994628906,
//                   75.83672332763672
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content: "AGENCY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 68.54002380371094,
//                 width: 24.58125114440918,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 68.54002380371094, 46.48125076293945,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content: "The ACORD name and logo are registered marks of ACORD",
//               coordinates: {
//                 x: 203.6737518310547,
//                 y: 757.780029296875,
//                 width: 218.86769104003906,
//                 height: 8.65673828125,
//                 bbox: [
//                   203.6737518310547, 757.780029296875, 422.54144287109375,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content: "ACORD 45 (2016/03)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 745.780029296875,
//                 width: 74.47750282287598,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 745.780029296875, 96.37750244140625,
//                   754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content: "© 1993-2016 ACORD CORPORATION.  All rights reserved.",
//               coordinates: {
//                 x: 377.0174865722656,
//                 y: 745.780029296875,
//                 width: 211.10989379882812,
//                 height: 8.65673828125,
//                 bbox: [
//                   377.0174865722656, 745.780029296875, 588.1273803710938,
//                   754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content: "E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 236.54002380371094,
//                 width: 51.071502685546875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   299.1000061035156, 236.54002380371094, 350.1715087890625,
//                   242.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content: "REASON FOR INTEREST:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 236.54002380371094,
//                 width: 69.57499122619629,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 236.54002380371094, 91.47499084472656,
//                   242.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 192.13999938964844,
//                 width: 22.022499084472656,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 192.13999938964844, 58.3224983215332,
//                   198.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content: "LEASEBACK",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 186.13999938964844,
//                 width: 35.75349044799805,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 186.13999938964844, 72.0534896850586,
//                   192.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content: "WARRANTY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 156.13999938964844,
//                 width: 33.200504302978516,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 156.13999938964844, 69.50050354003906,
//                   162.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content: "BREACH OF",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 150.13999938964844,
//                 width: 34.15500259399414,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 150.13999938964844, 70.45500183105469,
//                   156.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content: "TRUSTEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 188.54002380371094,
//                 width: 26.806488037109375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   97.5, 188.54002380371094, 124.30648803710938,
//                   194.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content: "REGISTRANT",
//               coordinates: {
//                 x: 97.5,
//                 y: 176.54002380371094,
//                 width: 37.34049987792969,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   97.5, 176.54002380371094, 134.8404998779297, 182.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content: "PHONE (A/C, No, Ext):",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 224.54002380371094,
//                 width: 60.633697509765625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   299.1000061035156, 224.54002380371094, 359.73370361328125,
//                   230.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 52,
//               type: "text",
//               content: "LIEN AMOUNT:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 224.54002380371094,
//                 width: 40.96299743652344,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   144.3000030517578, 224.54002380371094, 185.26300048828125,
//                   230.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 53,
//               type: "text",
//               content: "INTEREST END DATE:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 212.54002380371094,
//                 width: 60.846435546875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   299.1000061035156, 212.54002380371094, 359.9464416503906,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 54,
//               type: "text",
//               content: "ITEM:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 176.54002380371094,
//                 width: 15.63427734375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   525.9000244140625, 176.54002380371094, 541.5343017578125,
//                   182.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 55,
//               type: "text",
//               content: "AIRPORT:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 164.54002380371094,
//                 width: 27.13421630859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 164.54002380371094, 481.0342102050781,
//                   170.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 56,
//               type: "text",
//               content: "AIRCRAFT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 164.54002380371094,
//                 width: 30.6474609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   525.9000244140625, 164.54002380371094, 556.5474853515625,
//                   170.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 57,
//               type: "text",
//               content: "CO-OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 164.54002380371094,
//                 width: 32.55649948120117,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 164.54002380371094, 68.85649871826172,
//                   170.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 58,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 97.5,
//                 y: 164.54002380371094,
//                 width: 22.022491455078125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   97.5, 164.54002380371094, 119.52249145507812,
//                   170.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 59,
//               type: "text",
//               content: "SEND BILL",
//               coordinates: {
//                 x: 417.8999938964844,
//                 y: 130.9399871826172,
//                 width: 30.31396484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   417.8999938964844, 130.9399871826172, 448.2139587402344,
//                   137.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 60,
//               type: "text",
//               content: "POLICY",
//               coordinates: {
//                 x: 374.70001220703125,
//                 y: 130.9399871826172,
//                 width: 21.37847900390625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   374.70001220703125, 130.9399871826172, 396.0784912109375,
//                   137.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 61,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 259.5,
//                 y: 129.73997497558594,
//                 width: 31.27996826171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   259.5, 129.73997497558594, 290.77996826171875,
//                   136.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 62,
//               type: "text",
//               content: "AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 180.13999938964844,
//                 width: 33.18899154663086,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 180.13999938964844, 69.4889907836914,
//                   186.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 63,
//               type: "text",
//               content: "INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 144.13999938964844,
//                 width: 25.857749938964844,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 144.13999938964844, 62.15774917602539,
//                   150.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 64,
//               type: "text",
//               content: "ITEM DESCRIPTION",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 200.54002380371094,
//                 width: 54.56744384765625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 200.54002380371094, 508.4674377441406,
//                   206.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 65,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 129.73997497558594,
//                 width: 28.399248123168945,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 129.73997497558594, 50.29924774169922,
//                   136.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 66,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 129.73997497558594,
//                 width: 18.520767211914062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   212.6999969482422, 129.73997497558594, 231.22076416015625,
//                   136.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 67,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 129.73997497558594,
//                 width: 60.23126220703125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   144.3000030517578, 129.73997497558594, 204.53126525878906,
//                   136.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 68,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 212.54002380371094,
//                 width: 63.1925048828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   144.3000030517578, 212.54002380371094, 207.4925079345703,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 69,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 313.5,
//                 y: 130.9399871826172,
//                 width: 37.547454833984375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   313.5, 130.9399871826172, 351.0474548339844,
//                   137.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 70,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 129.13999938964844,
//                 width: 77.8665771484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   483.3275146484375, 129.13999938964844, 561.194091796875,
//                   135.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 71,
//               type: "text",
//               content: "ADDITIONAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 138.13999938964844,
//                 width: 35.42574691772461,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 138.13999938964844, 71.72574615478516,
//                   144.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 72,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 140.54002380371094,
//                 width: 35.74774169921875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   97.5, 140.54002380371094, 133.24774169921875,
//                   146.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 73,
//               type: "text",
//               content: "MORTGAGEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 152.54002380371094,
//                 width: 37.66249084472656,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   97.5, 152.54002380371094, 135.16249084472656,
//                   158.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 74,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 212.54002380371094,
//                 width: 37.34049606323242,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 212.54002380371094, 73.64049530029297,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 75,
//               type: "text",
//               content: "EMPLOYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 174.13999938964844,
//                 width: 31.912494659423828,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 174.13999938964844, 68.21249389648438,
//                   180.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 76,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 140.54002380371094,
//                 width: 31.486968994140625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 140.54002380371094, 485.386962890625,
//                   146.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 77,
//               type: "text",
//               content: "BUILDING:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 140.54002380371094,
//                 width: 29.6815185546875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   525.9000244140625, 140.54002380371094, 555.58154296875,
//                   146.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 78,
//               type: "text",
//               content: "VEHICLE:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 152.54002380371094,
//                 width: 26.806488037109375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 152.54002380371094, 480.70648193359375,
//                   158.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 79,
//               type: "text",
//               content: "BOAT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 152.54002380371094,
//                 width: 17.135009765625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   525.9000244140625, 152.54002380371094, 543.0350341796875,
//                   158.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 80,
//               type: "text",
//               content: "ITEM CLASS:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 188.54002380371094,
//                 width: 36.696502685546875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 188.54002380371094, 490.59649658203125,
//                   194.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 81,
//               type: "text",
//               content: "ADDITIONAL INTEREST SCHEDULE",
//               coordinates: {
//                 x: 181.20249938964844,
//                 y: 47.501258850097656,
//                 width: 235.5649871826172,
//                 height: 15.358749389648438,
//                 bbox: [
//                   181.20249938964844, 47.501258850097656, 416.7674865722656,
//                   62.860008239746094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 13.75,
//                 color: 0
//               }
//             },
//             {
//               id: 82,
//               type: "text",
//               content: "DATE (MM/DD/YYYY)",
//               coordinates: {
//                 x: 522.563720703125,
//                 y: 44.54002380371094,
//                 width: 57.02288818359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   522.563720703125, 44.54002380371094, 579.5866088867188,
//                   50.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 83,
//               type: "text",
//               content: "SCHED #:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 176.54002380371094,
//                 width: 26.817962646484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 176.54002380371094, 480.71795654296875,
//                   182.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 84,
//               type: "text",
//               content: "LENDER'S LOSS PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 200.54002380371094,
//                 width: 73.61149215698242,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 200.54002380371094, 109.91149139404297,
//                   206.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 85,
//               type: "text",
//               content: "E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 356.5400085449219,
//                 width: 51.071502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 356.5400085449219, 350.1715087890625,
//                   362.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 86,
//               type: "text",
//               content: "REASON FOR INTEREST:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 356.5400085449219,
//                 width: 69.57499122619629,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 356.5400085449219, 91.47499084472656,
//                   362.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 87,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 312.1400146484375,
//                 width: 22.022499084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 312.1400146484375, 58.3224983215332,
//                   318.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 88,
//               type: "text",
//               content: "LEASEBACK",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 306.1400146484375,
//                 width: 35.75349044799805,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 306.1400146484375, 72.0534896850586,
//                   312.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 89,
//               type: "text",
//               content: "WARRANTY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 276.1400146484375,
//                 width: 33.200504302978516,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 276.1400146484375, 69.50050354003906,
//                   282.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 90,
//               type: "text",
//               content: "BREACH OF",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 270.1400146484375,
//                 width: 34.15500259399414,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 270.1400146484375, 70.45500183105469,
//                   276.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 91,
//               type: "text",
//               content: "TRUSTEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 308.5400085449219,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 308.5400085449219, 124.30648803710938, 314.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 92,
//               type: "text",
//               content: "REGISTRANT",
//               coordinates: {
//                 x: 97.5,
//                 y: 296.5400085449219,
//                 width: 37.34049987792969,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 296.5400085449219, 134.8404998779297, 302.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 93,
//               type: "text",
//               content: "PHONE (A/C, No, Ext):",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 344.5400085449219,
//                 width: 60.633697509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 344.5400085449219, 359.73370361328125,
//                   350.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 94,
//               type: "text",
//               content: "LIEN AMOUNT:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 344.5400085449219,
//                 width: 40.96299743652344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 344.5400085449219, 185.26300048828125,
//                   350.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 95,
//               type: "text",
//               content: "INTEREST END DATE:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 332.5400085449219,
//                 width: 60.846435546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 332.5400085449219, 359.9464416503906,
//                   338.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 96,
//               type: "text",
//               content: "ITEM:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 296.5400085449219,
//                 width: 15.63427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 296.5400085449219, 541.5343017578125,
//                   302.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 97,
//               type: "text",
//               content: "AIRPORT:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 284.5400085449219,
//                 width: 27.13421630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 284.5400085449219, 481.0342102050781,
//                   290.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 98,
//               type: "text",
//               content: "AIRCRAFT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 284.5400085449219,
//                 width: 30.6474609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 284.5400085449219, 556.5474853515625,
//                   290.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 99,
//               type: "text",
//               content: "CO-OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 284.5400085449219,
//                 width: 32.55649948120117,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 284.5400085449219, 68.85649871826172,
//                   290.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 100,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 97.5,
//                 y: 284.5400085449219,
//                 width: 22.022491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 284.5400085449219, 119.52249145507812, 290.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 101,
//               type: "text",
//               content: "SEND BILL",
//               coordinates: {
//                 x: 417.8999938964844,
//                 y: 250.9399871826172,
//                 width: 30.31396484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   417.8999938964844, 250.9399871826172, 448.2139587402344,
//                   257.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 102,
//               type: "text",
//               content: "POLICY",
//               coordinates: {
//                 x: 374.70001220703125,
//                 y: 250.9399871826172,
//                 width: 21.37847900390625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   374.70001220703125, 250.9399871826172, 396.0784912109375,
//                   257.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 103,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 259.5,
//                 y: 249.73997497558594,
//                 width: 31.27996826171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   259.5, 249.73997497558594, 290.77996826171875,
//                   256.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 104,
//               type: "text",
//               content: "AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 300.1400146484375,
//                 width: 33.18899154663086,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 300.1400146484375, 69.4889907836914,
//                   306.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 105,
//               type: "text",
//               content: "INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 264.1400146484375,
//                 width: 25.857749938964844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 264.1400146484375, 62.15774917602539,
//                   270.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 106,
//               type: "text",
//               content: "ITEM DESCRIPTION",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 320.5400085449219,
//                 width: 54.56744384765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 320.5400085449219, 508.4674377441406,
//                   326.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 107,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 249.73997497558594,
//                 width: 28.399248123168945,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 249.73997497558594, 50.29924774169922,
//                   256.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 108,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 249.73997497558594,
//                 width: 18.520767211914062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   212.6999969482422, 249.73997497558594, 231.22076416015625,
//                   256.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 109,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 249.73997497558594,
//                 width: 60.23126220703125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   144.3000030517578, 249.73997497558594, 204.53126525878906,
//                   256.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 110,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 332.5400085449219,
//                 width: 63.1925048828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 332.5400085449219, 207.4925079345703,
//                   338.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 111,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 313.5,
//                 y: 250.9399871826172,
//                 width: 37.547454833984375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   313.5, 250.9399871826172, 351.0474548339844,
//                   257.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 112,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 249.13999938964844,
//                 width: 77.8665771484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   483.3275146484375, 249.13999938964844, 561.194091796875,
//                   255.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 113,
//               type: "text",
//               content: "ADDITIONAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 258.1400146484375,
//                 width: 35.42574691772461,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 258.1400146484375, 71.72574615478516,
//                   264.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 114,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 260.5400390625,
//                 width: 35.74774169921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 260.5400390625, 133.24774169921875, 266.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 115,
//               type: "text",
//               content: "MORTGAGEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 272.5400390625,
//                 width: 37.66249084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 272.5400390625, 135.16249084472656, 278.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 116,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 332.5400085449219,
//                 width: 37.34049606323242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 332.5400085449219, 73.64049530029297,
//                   338.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 117,
//               type: "text",
//               content: "EMPLOYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 294.1400146484375,
//                 width: 31.912494659423828,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 294.1400146484375, 68.21249389648438,
//                   300.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 118,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 260.5400390625,
//                 width: 31.486968994140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 260.5400390625, 485.386962890625,
//                   266.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 119,
//               type: "text",
//               content: "BUILDING:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 260.5400390625,
//                 width: 29.6815185546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 260.5400390625, 555.58154296875,
//                   266.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 120,
//               type: "text",
//               content: "VEHICLE:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 272.5400390625,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 272.5400390625, 480.70648193359375,
//                   278.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 121,
//               type: "text",
//               content: "BOAT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 272.5400390625,
//                 width: 17.135009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 272.5400390625, 543.0350341796875,
//                   278.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 122,
//               type: "text",
//               content: "ITEM CLASS:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 308.5400085449219,
//                 width: 36.696502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 308.5400085449219, 490.59649658203125,
//                   314.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 123,
//               type: "text",
//               content: "SCHED #:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 296.5400085449219,
//                 width: 26.817962646484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 296.5400085449219, 480.71795654296875,
//                   302.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 124,
//               type: "text",
//               content: "LENDER'S LOSS PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 320.5400085449219,
//                 width: 73.61149215698242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 320.5400085449219, 109.91149139404297,
//                   326.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 125,
//               type: "text",
//               content: "E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 476.5400085449219,
//                 width: 51.071502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 476.5400085449219, 350.1715087890625,
//                   482.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 126,
//               type: "text",
//               content: "REASON FOR INTEREST:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 476.5400085449219,
//                 width: 69.57499122619629,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 476.5400085449219, 91.47499084472656,
//                   482.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 127,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 432.1400146484375,
//                 width: 22.022499084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 432.1400146484375, 58.3224983215332,
//                   438.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 128,
//               type: "text",
//               content: "LEASEBACK",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 426.1400146484375,
//                 width: 35.75349044799805,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 426.1400146484375, 72.0534896850586,
//                   432.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 129,
//               type: "text",
//               content: "WARRANTY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 396.1400146484375,
//                 width: 33.200504302978516,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 396.1400146484375, 69.50050354003906,
//                   402.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 130,
//               type: "text",
//               content: "BREACH OF",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 390.1400146484375,
//                 width: 34.15500259399414,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 390.1400146484375, 70.45500183105469,
//                   396.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 131,
//               type: "text",
//               content: "TRUSTEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 428.5400085449219,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 428.5400085449219, 124.30648803710938, 434.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 132,
//               type: "text",
//               content: "REGISTRANT",
//               coordinates: {
//                 x: 97.5,
//                 y: 416.5400085449219,
//                 width: 37.34049987792969,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 416.5400085449219, 134.8404998779297, 422.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 133,
//               type: "text",
//               content: "PHONE (A/C, No, Ext):",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 464.5400085449219,
//                 width: 60.633697509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 464.5400085449219, 359.73370361328125,
//                   470.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 134,
//               type: "text",
//               content: "LIEN AMOUNT:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 464.5400085449219,
//                 width: 40.96299743652344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 464.5400085449219, 185.26300048828125,
//                   470.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 135,
//               type: "text",
//               content: "INTEREST END DATE:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 452.5400085449219,
//                 width: 60.846435546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 452.5400085449219, 359.9464416503906,
//                   458.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 136,
//               type: "text",
//               content: "ITEM:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 416.5400085449219,
//                 width: 15.63427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 416.5400085449219, 541.5343017578125,
//                   422.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 137,
//               type: "text",
//               content: "AIRPORT:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 404.5400085449219,
//                 width: 27.13421630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 404.5400085449219, 481.0342102050781,
//                   410.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 138,
//               type: "text",
//               content: "AIRCRAFT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 404.5400085449219,
//                 width: 30.6474609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 404.5400085449219, 556.5474853515625,
//                   410.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 139,
//               type: "text",
//               content: "CO-OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 404.5400085449219,
//                 width: 32.55649948120117,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 404.5400085449219, 68.85649871826172,
//                   410.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 140,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 97.5,
//                 y: 404.5400085449219,
//                 width: 22.022491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 404.5400085449219, 119.52249145507812, 410.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 141,
//               type: "text",
//               content: "SEND BILL",
//               coordinates: {
//                 x: 417.8999938964844,
//                 y: 370.94000244140625,
//                 width: 30.31396484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   417.8999938964844, 370.94000244140625, 448.2139587402344,
//                   377.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 142,
//               type: "text",
//               content: "POLICY",
//               coordinates: {
//                 x: 374.70001220703125,
//                 y: 370.94000244140625,
//                 width: 21.37847900390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   374.70001220703125, 370.94000244140625, 396.0784912109375,
//                   377.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 143,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 259.5,
//                 y: 369.7400207519531,
//                 width: 31.27996826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   259.5, 369.7400207519531, 290.77996826171875,
//                   376.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 144,
//               type: "text",
//               content: "AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 420.1400146484375,
//                 width: 33.18899154663086,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 420.1400146484375, 69.4889907836914,
//                   426.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 145,
//               type: "text",
//               content: "INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 384.1400146484375,
//                 width: 25.857749938964844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 384.1400146484375, 62.15774917602539,
//                   390.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 146,
//               type: "text",
//               content: "ITEM DESCRIPTION",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 440.5400085449219,
//                 width: 54.56744384765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 440.5400085449219, 508.4674377441406,
//                   446.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 147,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 369.7400207519531,
//                 width: 28.399248123168945,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 369.7400207519531, 50.29924774169922,
//                   376.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 148,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 369.7400207519531,
//                 width: 18.520767211914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   212.6999969482422, 369.7400207519531, 231.22076416015625,
//                   376.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 149,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 369.7400207519531,
//                 width: 60.23126220703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 369.7400207519531, 204.53126525878906,
//                   376.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 150,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 452.5400085449219,
//                 width: 63.1925048828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 452.5400085449219, 207.4925079345703,
//                   458.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 151,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 313.5,
//                 y: 370.94000244140625,
//                 width: 37.547454833984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   313.5, 370.94000244140625, 351.0474548339844,
//                   377.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 152,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 369.1400146484375,
//                 width: 77.8665771484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   483.3275146484375, 369.1400146484375, 561.194091796875,
//                   375.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 153,
//               type: "text",
//               content: "ADDITIONAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 378.1400146484375,
//                 width: 35.42574691772461,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 378.1400146484375, 71.72574615478516,
//                   384.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 154,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 380.5400085449219,
//                 width: 35.74774169921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 380.5400085449219, 133.24774169921875, 386.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 155,
//               type: "text",
//               content: "MORTGAGEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 392.5400085449219,
//                 width: 37.66249084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 392.5400085449219, 135.16249084472656, 398.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 156,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 452.5400085449219,
//                 width: 37.34049606323242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 452.5400085449219, 73.64049530029297,
//                   458.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 157,
//               type: "text",
//               content: "EMPLOYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 414.1400146484375,
//                 width: 31.912494659423828,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 414.1400146484375, 68.21249389648438,
//                   420.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 158,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 380.5400085449219,
//                 width: 31.486968994140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 380.5400085449219, 485.386962890625,
//                   386.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 159,
//               type: "text",
//               content: "BUILDING:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 380.5400085449219,
//                 width: 29.6815185546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 380.5400085449219, 555.58154296875,
//                   386.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 160,
//               type: "text",
//               content: "VEHICLE:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 392.5400085449219,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 392.5400085449219, 480.70648193359375,
//                   398.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 161,
//               type: "text",
//               content: "BOAT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 392.5400085449219,
//                 width: 17.135009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 392.5400085449219, 543.0350341796875,
//                   398.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 162,
//               type: "text",
//               content: "ITEM CLASS:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 428.5400085449219,
//                 width: 36.696502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 428.5400085449219, 490.59649658203125,
//                   434.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 163,
//               type: "text",
//               content: "SCHED #:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 416.5400085449219,
//                 width: 26.817962646484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 416.5400085449219, 480.71795654296875,
//                   422.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 164,
//               type: "text",
//               content: "LENDER'S LOSS PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 440.5400085449219,
//                 width: 73.61149215698242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 440.5400085449219, 109.91149139404297,
//                   446.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 165,
//               type: "text",
//               content: "E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 596.5400390625,
//                 width: 51.071502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 596.5400390625, 350.1715087890625,
//                   602.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 166,
//               type: "text",
//               content: "REASON FOR INTEREST:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 596.5400390625,
//                 width: 69.57499122619629,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 596.5400390625, 91.47499084472656,
//                   602.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 167,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 552.1400146484375,
//                 width: 22.022499084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 552.1400146484375, 58.3224983215332,
//                   558.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 168,
//               type: "text",
//               content: "LEASEBACK",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 546.1400146484375,
//                 width: 35.75349044799805,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 546.1400146484375, 72.0534896850586,
//                   552.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 169,
//               type: "text",
//               content: "WARRANTY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 516.1400146484375,
//                 width: 33.200504302978516,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 516.1400146484375, 69.50050354003906,
//                   522.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 170,
//               type: "text",
//               content: "BREACH OF",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 510.1400146484375,
//                 width: 34.15500259399414,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 510.1400146484375, 70.45500183105469,
//                   516.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 171,
//               type: "text",
//               content: "TRUSTEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 548.5400390625,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 548.5400390625, 124.30648803710938, 554.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 172,
//               type: "text",
//               content: "REGISTRANT",
//               coordinates: {
//                 x: 97.5,
//                 y: 536.5400390625,
//                 width: 37.34049987792969,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 536.5400390625, 134.8404998779297, 542.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 173,
//               type: "text",
//               content: "PHONE (A/C, No, Ext):",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 584.5400390625,
//                 width: 60.633697509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 584.5400390625, 359.73370361328125,
//                   590.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 174,
//               type: "text",
//               content: "LIEN AMOUNT:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 584.5400390625,
//                 width: 40.96299743652344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 584.5400390625, 185.26300048828125,
//                   590.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 175,
//               type: "text",
//               content: "INTEREST END DATE:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 572.5400390625,
//                 width: 60.846435546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 572.5400390625, 359.9464416503906,
//                   578.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 176,
//               type: "text",
//               content: "ITEM:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 536.5400390625,
//                 width: 15.63427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 536.5400390625, 541.5343017578125,
//                   542.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 177,
//               type: "text",
//               content: "AIRPORT:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 524.5400390625,
//                 width: 27.13421630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 524.5400390625, 481.0342102050781,
//                   530.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 178,
//               type: "text",
//               content: "AIRCRAFT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 524.5400390625,
//                 width: 30.6474609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 524.5400390625, 556.5474853515625,
//                   530.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 179,
//               type: "text",
//               content: "CO-OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 524.5400390625,
//                 width: 32.55649948120117,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 524.5400390625, 68.85649871826172,
//                   530.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 180,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 97.5,
//                 y: 524.5400390625,
//                 width: 22.022491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 524.5400390625, 119.52249145507812, 530.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 181,
//               type: "text",
//               content: "SEND BILL",
//               coordinates: {
//                 x: 417.8999938964844,
//                 y: 490.94000244140625,
//                 width: 30.31396484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   417.8999938964844, 490.94000244140625, 448.2139587402344,
//                   497.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 182,
//               type: "text",
//               content: "POLICY",
//               coordinates: {
//                 x: 374.70001220703125,
//                 y: 490.94000244140625,
//                 width: 21.37847900390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   374.70001220703125, 490.94000244140625, 396.0784912109375,
//                   497.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 183,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 259.5,
//                 y: 489.7400207519531,
//                 width: 31.27996826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   259.5, 489.7400207519531, 290.77996826171875,
//                   496.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 184,
//               type: "text",
//               content: "AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 540.1400146484375,
//                 width: 33.18899154663086,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 540.1400146484375, 69.4889907836914,
//                   546.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 185,
//               type: "text",
//               content: "INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 504.1400146484375,
//                 width: 25.857749938964844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 504.1400146484375, 62.15774917602539,
//                   510.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 186,
//               type: "text",
//               content: "ITEM DESCRIPTION",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 560.5400390625,
//                 width: 54.56744384765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 560.5400390625, 508.4674377441406,
//                   566.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 187,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 489.7400207519531,
//                 width: 28.399248123168945,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 489.7400207519531, 50.29924774169922,
//                   496.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 188,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 489.7400207519531,
//                 width: 18.520767211914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   212.6999969482422, 489.7400207519531, 231.22076416015625,
//                   496.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 189,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 489.7400207519531,
//                 width: 60.23126220703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 489.7400207519531, 204.53126525878906,
//                   496.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 190,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 572.5400390625,
//                 width: 63.1925048828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 572.5400390625, 207.4925079345703,
//                   578.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 191,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 313.5,
//                 y: 490.94000244140625,
//                 width: 37.547454833984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   313.5, 490.94000244140625, 351.0474548339844,
//                   497.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 192,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 489.1400146484375,
//                 width: 77.8665771484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   483.3275146484375, 489.1400146484375, 561.194091796875,
//                   495.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 193,
//               type: "text",
//               content: "ADDITIONAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 498.1400146484375,
//                 width: 35.42574691772461,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 498.1400146484375, 71.72574615478516,
//                   504.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 194,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 500.5400085449219,
//                 width: 35.74774169921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 500.5400085449219, 133.24774169921875, 506.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 195,
//               type: "text",
//               content: "MORTGAGEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 512.5400390625,
//                 width: 37.66249084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 512.5400390625, 135.16249084472656, 518.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 196,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 572.5400390625,
//                 width: 37.34049606323242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 572.5400390625, 73.64049530029297,
//                   578.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 197,
//               type: "text",
//               content: "EMPLOYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 534.1400146484375,
//                 width: 31.912494659423828,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 534.1400146484375, 68.21249389648438,
//                   540.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 198,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 500.5400085449219,
//                 width: 31.486968994140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 500.5400085449219, 485.386962890625,
//                   506.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 199,
//               type: "text",
//               content: "BUILDING:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 500.5400085449219,
//                 width: 29.6815185546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 500.5400085449219, 555.58154296875,
//                   506.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 200,
//               type: "text",
//               content: "VEHICLE:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 512.5400390625,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 512.5400390625, 480.70648193359375,
//                   518.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 201,
//               type: "text",
//               content: "BOAT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 512.5400390625,
//                 width: 17.135009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 512.5400390625, 543.0350341796875,
//                   518.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 202,
//               type: "text",
//               content: "ITEM CLASS:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 548.5400390625,
//                 width: 36.696502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 548.5400390625, 490.59649658203125,
//                   554.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 203,
//               type: "text",
//               content: "SCHED #:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 536.5400390625,
//                 width: 26.817962646484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 536.5400390625, 480.71795654296875,
//                   542.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 204,
//               type: "text",
//               content: "LENDER'S LOSS PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 560.5400390625,
//                 width: 73.61149215698242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 560.5400390625, 109.91149139404297,
//                   566.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 205,
//               type: "text",
//               content: "E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 716.5400390625,
//                 width: 51.071502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 716.5400390625, 350.1715087890625,
//                   722.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 206,
//               type: "text",
//               content: "REASON FOR INTEREST:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 716.5400390625,
//                 width: 69.57499122619629,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 716.5400390625, 91.47499084472656,
//                   722.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 207,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 672.1400146484375,
//                 width: 22.022499084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 672.1400146484375, 58.3224983215332,
//                   678.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 208,
//               type: "text",
//               content: "LEASEBACK",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 666.1400146484375,
//                 width: 35.75349044799805,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 666.1400146484375, 72.0534896850586,
//                   672.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 209,
//               type: "text",
//               content: "WARRANTY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 636.1400146484375,
//                 width: 33.200504302978516,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 636.1400146484375, 69.50050354003906,
//                   642.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 210,
//               type: "text",
//               content: "BREACH OF",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 630.1400146484375,
//                 width: 34.15500259399414,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 630.1400146484375, 70.45500183105469,
//                   636.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 211,
//               type: "text",
//               content: "TRUSTEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 668.5400390625,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 668.5400390625, 124.30648803710938, 674.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 212,
//               type: "text",
//               content: "REGISTRANT",
//               coordinates: {
//                 x: 97.5,
//                 y: 656.5400390625,
//                 width: 37.34049987792969,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 656.5400390625, 134.8404998779297, 662.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 213,
//               type: "text",
//               content: "PHONE (A/C, No, Ext):",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 704.5400390625,
//                 width: 60.633697509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 704.5400390625, 359.73370361328125,
//                   710.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 214,
//               type: "text",
//               content: "LIEN AMOUNT:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 704.5400390625,
//                 width: 40.96299743652344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 704.5400390625, 185.26300048828125,
//                   710.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 215,
//               type: "text",
//               content: "INTEREST END DATE:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 692.5400390625,
//                 width: 60.846435546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 692.5400390625, 359.9464416503906,
//                   698.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 216,
//               type: "text",
//               content: "ITEM:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 656.5400390625,
//                 width: 15.63427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 656.5400390625, 541.5343017578125,
//                   662.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 217,
//               type: "text",
//               content: "AIRPORT:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 644.5400390625,
//                 width: 27.13421630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 644.5400390625, 481.0342102050781,
//                   650.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 218,
//               type: "text",
//               content: "AIRCRAFT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 644.5400390625,
//                 width: 30.6474609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 644.5400390625, 556.5474853515625,
//                   650.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 219,
//               type: "text",
//               content: "CO-OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 644.5400390625,
//                 width: 32.55649948120117,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 644.5400390625, 68.85649871826172,
//                   650.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 220,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 97.5,
//                 y: 644.5400390625,
//                 width: 22.022491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 644.5400390625, 119.52249145507812, 650.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 221,
//               type: "text",
//               content: "SEND BILL",
//               coordinates: {
//                 x: 417.8999938964844,
//                 y: 610.9400024414062,
//                 width: 30.31396484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   417.8999938964844, 610.9400024414062, 448.2139587402344,
//                   617.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 222,
//               type: "text",
//               content: "POLICY",
//               coordinates: {
//                 x: 374.70001220703125,
//                 y: 610.9400024414062,
//                 width: 21.37847900390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   374.70001220703125, 610.9400024414062, 396.0784912109375,
//                   617.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 223,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 259.5,
//                 y: 609.739990234375,
//                 width: 31.27996826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   259.5, 609.739990234375, 290.77996826171875, 616.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 224,
//               type: "text",
//               content: "AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 660.1400146484375,
//                 width: 33.18899154663086,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 660.1400146484375, 69.4889907836914,
//                   666.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 225,
//               type: "text",
//               content: "INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 624.1400146484375,
//                 width: 25.857749938964844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 624.1400146484375, 62.15774917602539,
//                   630.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 226,
//               type: "text",
//               content: "ITEM DESCRIPTION",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 680.5400390625,
//                 width: 54.56744384765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 680.5400390625, 508.4674377441406,
//                   686.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 227,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 609.739990234375,
//                 width: 28.399248123168945,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 609.739990234375, 50.29924774169922,
//                   616.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 228,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 609.739990234375,
//                 width: 18.520767211914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   212.6999969482422, 609.739990234375, 231.22076416015625,
//                   616.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 229,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 609.739990234375,
//                 width: 60.23126220703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 609.739990234375, 204.53126525878906,
//                   616.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 230,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 692.5400390625,
//                 width: 63.1925048828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 692.5400390625, 207.4925079345703,
//                   698.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 231,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 313.5,
//                 y: 610.9400024414062,
//                 width: 37.547454833984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   313.5, 610.9400024414062, 351.0474548339844, 617.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 232,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 609.1400146484375,
//                 width: 77.8665771484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   483.3275146484375, 609.1400146484375, 561.194091796875,
//                   615.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 233,
//               type: "text",
//               content: "ADDITIONAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 618.1400146484375,
//                 width: 35.42574691772461,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 618.1400146484375, 71.72574615478516,
//                   624.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 234,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 620.5400390625,
//                 width: 35.74774169921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 620.5400390625, 133.24774169921875, 626.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 235,
//               type: "text",
//               content: "MORTGAGEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 632.5400390625,
//                 width: 37.66249084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 632.5400390625, 135.16249084472656, 638.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 236,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 692.5400390625,
//                 width: 37.34049606323242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 692.5400390625, 73.64049530029297,
//                   698.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 237,
//               type: "text",
//               content: "EMPLOYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 654.1400146484375,
//                 width: 31.912494659423828,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 654.1400146484375, 68.21249389648438,
//                   660.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 238,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 620.5400390625,
//                 width: 31.486968994140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 620.5400390625, 485.386962890625,
//                   626.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 239,
//               type: "text",
//               content: "BUILDING:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 620.5400390625,
//                 width: 29.6815185546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 620.5400390625, 555.58154296875,
//                   626.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 240,
//               type: "text",
//               content: "VEHICLE:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 632.5400390625,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 632.5400390625, 480.70648193359375,
//                   638.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 241,
//               type: "text",
//               content: "BOAT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 632.5400390625,
//                 width: 17.135009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 632.5400390625, 543.0350341796875,
//                   638.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 242,
//               type: "text",
//               content: "ITEM CLASS:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 668.5400390625,
//                 width: 36.696502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 668.5400390625, 490.59649658203125,
//                   674.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 243,
//               type: "text",
//               content: "SCHED #:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 656.5400390625,
//                 width: 26.817962646484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 656.5400390625, 480.71795654296875,
//                   662.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 244,
//               type: "text",
//               content: "LENDER'S LOSS PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 680.5400390625,
//                 width: 73.61149215698242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 680.5400390625, 109.91149139404297,
//                   686.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 41.26749469857623,
//                 width: 577.68,
//                 height: 73.41775219630415,
//                 bbox: [
//                   17.28, 41.26749469857623, 594.9599999999999,
//                   114.68524689488038
//                 ]
//               },
//               properties: {
//                 rows: 3,
//                 columns: 5,
//                 accuracy: 89.795
//               }
//             },
//             {
//               id: 1,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 125.24204786428356,
//                 width: 577.4399999999999,
//                 height: 619.4922750681611,
//                 bbox: [
//                   17.52, 125.24204786428356, 594.9599999999999,
//                   744.7343229324447
//                 ]
//               },
//               properties: {
//                 rows: 51,
//                 columns: 14,
//                 accuracy: 91.981
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 245,
//           table_count: 2,
//           total_elements: 247
//         }
//       },
//       {
//         page_number: 21,
//         dimensions: {
//           width: 612,
//           height: 792
//         },
//         elements: {
//           text: [
//             {
//               id: 0,
//               type: "text",
//               content: "00060962",
//               coordinates: {
//                 x: 415.20001220703125,
//                 y: 25.188751220703125,
//                 width: 32.248046875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   415.20001220703125, 25.188751220703125, 447.44805908203125,
//                   33.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 1,
//               type: "text",
//               content: "04/04/2025",
//               coordinates: {
//                 x: 532.9550170898438,
//                 y: 55.188751220703125,
//                 width: 36.2645263671875,
//                 height: 8.098247528076172,
//                 bbox: [
//                   532.9550170898438, 55.188751220703125, 569.2195434570312,
//                   63.2869987487793
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 2,
//               type: "text",
//               content: "UIS Insurance & Investments",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 79.18875122070312,
//                 width: 93.81499099731445,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 79.18875122070312, 116.614990234375,
//                   87.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 3,
//               type: "text",
//               content: "25-26",
//               coordinates: {
//                 x: 22.799999237060547,
//                 y: 103.18875122070312,
//                 width: 18.538253784179688,
//                 height: 8.098251342773438,
//                 bbox: [
//                   22.799999237060547, 103.18875122070312, 41.338253021240234,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 4,
//               type: "text",
//               content: "05/18/2025",
//               coordinates: {
//                 x: 259.3550109863281,
//                 y: 103.18875122070312,
//                 width: 36.2645263671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   259.3550109863281, 103.18875122070312, 295.6195373535156,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 5,
//               type: "text",
//               content: "Submissions",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 79.18875122070312,
//                 width: 41.08575439453125,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 79.18875122070312, 351.8857421875,
//                   87.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 6,
//               type: "text",
//               content: "Buckeye Premier Cleaning, LLC",
//               coordinates: {
//                 x: 310.79998779296875,
//                 y: 103.18875122070312,
//                 width: 103.10223388671875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   310.79998779296875, 103.18875122070312, 413.9022216796875,
//                   111.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 7,
//               type: "text",
//               content: "Villiage Green Management Company",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 151.18875122070312,
//                 width: 122.72084045410156,
//                 height: 8.098251342773438,
//                 bbox: [
//                   145.1999969482422, 151.18875122070312, 267.92083740234375,
//                   159.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 8,
//               type: "text",
//               content: "19801 SW 72nd Ave Suite 300",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 163.18875122070312,
//                 width: 98.54214477539062,
//                 height: 8.098251342773438,
//                 bbox: [
//                   145.1999969482422, 163.18875122070312, 243.7421417236328,
//                   171.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 9,
//               type: "text",
//               content: "Tualatin",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 187.18875122070312,
//                 width: 25.505523681640625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   145.1999969482422, 187.18875122070312, 170.7055206298828,
//                   195.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 10,
//               type: "text",
//               content: "OR",
//               coordinates: {
//                 x: 321.6000061035156,
//                 y: 187.18875122070312,
//                 width: 10.86773681640625,
//                 height: 8.098251342773438,
//                 bbox: [
//                   321.6000061035156, 187.18875122070312, 332.4677429199219,
//                   195.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 11,
//               type: "text",
//               content: "97062",
//               coordinates: {
//                 x: 343.20001220703125,
//                 y: 187.18875122070312,
//                 width: 20.155029296875,
//                 height: 8.098251342773438,
//                 bbox: [
//                   343.20001220703125, 187.18875122070312, 363.35504150390625,
//                   195.28700256347656
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 12,
//               type: "text",
//               content: "Mosaic at Levis Commons",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 271.1887512207031,
//                 width: 84.977294921875,
//                 height: 8.098236083984375,
//                 bbox: [
//                   145.1999969482422, 271.1887512207031, 230.1772918701172,
//                   279.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 13,
//               type: "text",
//               content: "1000 Hollister Ln",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 283.1887512207031,
//                 width: 54.37504577636719,
//                 height: 8.098236083984375,
//                 bbox: [
//                   145.1999969482422, 283.1887512207031, 199.57504272460938,
//                   291.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 14,
//               type: "text",
//               content: "Perrysburg",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 307.1887512207031,
//                 width: 35.44526672363281,
//                 height: 8.098236083984375,
//                 bbox: [
//                   145.1999969482422, 307.1887512207031, 180.645263671875,
//                   315.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 15,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 321.6000061035156,
//                 y: 307.1887512207031,
//                 width: 10.86773681640625,
//                 height: 8.098236083984375,
//                 bbox: [
//                   321.6000061035156, 307.1887512207031, 332.4677429199219,
//                   315.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 16,
//               type: "text",
//               content: "43551",
//               coordinates: {
//                 x: 343.20001220703125,
//                 y: 307.1887512207031,
//                 width: 20.155029296875,
//                 height: 8.098236083984375,
//                 bbox: [
//                   343.20001220703125, 307.1887512207031, 363.35504150390625,
//                   315.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 17,
//               type: "text",
//               content: "Buckingham Realty and Development",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 391.1887512207031,
//                 width: 121.24183654785156,
//                 height: 8.098236083984375,
//                 bbox: [
//                   145.1999969482422, 391.1887512207031, 266.44183349609375,
//                   399.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 18,
//               type: "text",
//               content: "Buckingham Development INC",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 511.1887512207031,
//                 width: 99.07856750488281,
//                 height: 8.098236083984375,
//                 bbox: [
//                   145.1999969482422, 511.1887512207031, 244.278564453125,
//                   519.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 19,
//               type: "text",
//               content: "Breton Blders Co. LTD",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 631.188720703125,
//                 width: 72.33331298828125,
//                 height: 8.0982666015625,
//                 bbox: [
//                   145.1999969482422, 631.188720703125, 217.53330993652344,
//                   639.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 20,
//               type: "text",
//               content: "1090 W S Boundary Suite 100",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 643.188720703125,
//                 width: 97.45462036132812,
//                 height: 8.0982666015625,
//                 bbox: [
//                   145.1999969482422, 643.188720703125, 242.6546173095703,
//                   651.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 21,
//               type: "text",
//               content: "Perrysburg",
//               coordinates: {
//                 x: 145.1999969482422,
//                 y: 667.188720703125,
//                 width: 35.44526672363281,
//                 height: 8.0982666015625,
//                 bbox: [
//                   145.1999969482422, 667.188720703125, 180.645263671875,
//                   675.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 22,
//               type: "text",
//               content: "OH",
//               coordinates: {
//                 x: 321.6000061035156,
//                 y: 667.188720703125,
//                 width: 10.86773681640625,
//                 height: 8.0982666015625,
//                 bbox: [
//                   321.6000061035156, 667.188720703125, 332.4677429199219,
//                   675.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 23,
//               type: "text",
//               content: "43402",
//               coordinates: {
//                 x: 343.20001220703125,
//                 y: 667.188720703125,
//                 width: 20.155029296875,
//                 height: 8.0982666015625,
//                 bbox: [
//                   343.20001220703125, 667.188720703125, 363.35504150390625,
//                   675.2869873046875
//                 ]
//               },
//               properties: {
//                 font: "ArialMT",
//                 font_size: 7.25,
//                 color: 0
//               }
//             },
//             {
//               id: 24,
//               type: "text",
//               content: "AGENCY CUSTOMER ID:",
//               coordinates: {
//                 x: 317.0350036621094,
//                 y: 26.379987716674805,
//                 width: 91.78323364257812,
//                 height: 8.65675163269043,
//                 bbox: [
//                   317.0350036621094, 26.379987716674805, 408.8182373046875,
//                   35.036739349365234
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 25,
//               type: "text",
//               content:
//                 "ADDITIONAL INTEREST (Not all fields apply to all scenarios - provide only the necessary data)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 116.37998962402344,
//                 width: 347.02166175842285,
//                 height: 8.656745910644531,
//                 bbox: [
//                   21.899999618530273, 116.37998962402344, 368.9216613769531,
//                   125.03673553466797
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 26,
//               type: "text",
//               content: "EFFECTIVE DATE",
//               coordinates: {
//                 x: 252.97500610351562,
//                 y: 92.54002380371094,
//                 width: 48.3919677734375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   252.97500610351562, 92.54002380371094, 301.3669738769531,
//                   98.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 27,
//               type: "text",
//               content: "NAMED INSURED(S)",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 92.54002380371094,
//                 width: 56.183197021484375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   309.8999938964844, 92.54002380371094, 366.08319091796875,
//                   98.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 28,
//               type: "text",
//               content: "POLICY NUMBER",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 92.54002380371094,
//                 width: 48.09299659729004,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 92.54002380371094, 69.99299621582031,
//                   98.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 29,
//               type: "text",
//               content: "NAIC CODE",
//               coordinates: {
//                 x: 547.5,
//                 y: 68.54002380371094,
//                 width: 32.24029541015625,
//                 height: 6.422752380371094,
//                 bbox: [
//                   547.5, 68.54002380371094, 579.7402954101562, 74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 30,
//               type: "text",
//               content: "CARRIER",
//               coordinates: {
//                 x: 309.8999938964844,
//                 y: 67.17997741699219,
//                 width: 35.28570556640625,
//                 height: 8.656745910644531,
//                 bbox: [
//                   309.8999938964844, 67.17997741699219, 345.1856994628906,
//                   75.83672332763672
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 31,
//               type: "text",
//               content: "AGENCY",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 68.54002380371094,
//                 width: 24.58125114440918,
//                 height: 6.422752380371094,
//                 bbox: [
//                   21.899999618530273, 68.54002380371094, 46.48125076293945,
//                   74.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 32,
//               type: "text",
//               content: "The ACORD name and logo are registered marks of ACORD",
//               coordinates: {
//                 x: 203.6737518310547,
//                 y: 757.780029296875,
//                 width: 218.86769104003906,
//                 height: 8.65673828125,
//                 bbox: [
//                   203.6737518310547, 757.780029296875, 422.54144287109375,
//                   766.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 33,
//               type: "text",
//               content: "ACORD 45 (2016/03)",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 745.780029296875,
//                 width: 74.47750282287598,
//                 height: 8.65673828125,
//                 bbox: [
//                   21.899999618530273, 745.780029296875, 96.37750244140625,
//                   754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 34,
//               type: "text",
//               content: "© 1993-2016 ACORD CORPORATION.  All rights reserved.",
//               coordinates: {
//                 x: 377.0174865722656,
//                 y: 745.780029296875,
//                 width: 211.10989379882812,
//                 height: 8.65673828125,
//                 bbox: [
//                   377.0174865722656, 745.780029296875, 588.1273803710938,
//                   754.436767578125
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 7.75,
//                 color: 0
//               }
//             },
//             {
//               id: 35,
//               type: "text",
//               content: "E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 236.54002380371094,
//                 width: 51.071502685546875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   299.1000061035156, 236.54002380371094, 350.1715087890625,
//                   242.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 36,
//               type: "text",
//               content: "REASON FOR INTEREST:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 236.54002380371094,
//                 width: 69.57499122619629,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 236.54002380371094, 91.47499084472656,
//                   242.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 37,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 192.13999938964844,
//                 width: 22.022499084472656,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 192.13999938964844, 58.3224983215332,
//                   198.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 38,
//               type: "text",
//               content: "LEASEBACK",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 186.13999938964844,
//                 width: 35.75349044799805,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 186.13999938964844, 72.0534896850586,
//                   192.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 39,
//               type: "text",
//               content: "WARRANTY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 156.13999938964844,
//                 width: 33.200504302978516,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 156.13999938964844, 69.50050354003906,
//                   162.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 40,
//               type: "text",
//               content: "BREACH OF",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 150.13999938964844,
//                 width: 34.15500259399414,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 150.13999938964844, 70.45500183105469,
//                   156.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 41,
//               type: "text",
//               content: "TRUSTEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 188.54002380371094,
//                 width: 26.806488037109375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   97.5, 188.54002380371094, 124.30648803710938,
//                   194.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 42,
//               type: "text",
//               content: "REGISTRANT",
//               coordinates: {
//                 x: 97.5,
//                 y: 176.54002380371094,
//                 width: 37.34049987792969,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   97.5, 176.54002380371094, 134.8404998779297, 182.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 43,
//               type: "text",
//               content: "PHONE (A/C, No, Ext):",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 224.54002380371094,
//                 width: 60.633697509765625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   299.1000061035156, 224.54002380371094, 359.73370361328125,
//                   230.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 44,
//               type: "text",
//               content: "LIEN AMOUNT:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 224.54002380371094,
//                 width: 40.96299743652344,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   144.3000030517578, 224.54002380371094, 185.26300048828125,
//                   230.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 45,
//               type: "text",
//               content: "INTEREST END DATE:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 212.54002380371094,
//                 width: 60.846435546875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   299.1000061035156, 212.54002380371094, 359.9464416503906,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 46,
//               type: "text",
//               content: "ITEM:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 176.54002380371094,
//                 width: 15.63427734375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   525.9000244140625, 176.54002380371094, 541.5343017578125,
//                   182.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 47,
//               type: "text",
//               content: "AIRPORT:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 164.54002380371094,
//                 width: 27.13421630859375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 164.54002380371094, 481.0342102050781,
//                   170.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 48,
//               type: "text",
//               content: "AIRCRAFT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 164.54002380371094,
//                 width: 30.6474609375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   525.9000244140625, 164.54002380371094, 556.5474853515625,
//                   170.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 49,
//               type: "text",
//               content: "CO-OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 164.54002380371094,
//                 width: 32.55649948120117,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 164.54002380371094, 68.85649871826172,
//                   170.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 50,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 97.5,
//                 y: 164.54002380371094,
//                 width: 22.022491455078125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   97.5, 164.54002380371094, 119.52249145507812,
//                   170.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 51,
//               type: "text",
//               content: "SEND BILL",
//               coordinates: {
//                 x: 417.8999938964844,
//                 y: 130.9399871826172,
//                 width: 30.31396484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   417.8999938964844, 130.9399871826172, 448.2139587402344,
//                   137.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 52,
//               type: "text",
//               content: "POLICY",
//               coordinates: {
//                 x: 374.70001220703125,
//                 y: 130.9399871826172,
//                 width: 21.37847900390625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   374.70001220703125, 130.9399871826172, 396.0784912109375,
//                   137.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 53,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 259.5,
//                 y: 129.73997497558594,
//                 width: 31.27996826171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   259.5, 129.73997497558594, 290.77996826171875,
//                   136.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 54,
//               type: "text",
//               content: "AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 180.13999938964844,
//                 width: 33.18899154663086,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 180.13999938964844, 69.4889907836914,
//                   186.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 55,
//               type: "text",
//               content: "INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 144.13999938964844,
//                 width: 25.857749938964844,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 144.13999938964844, 62.15774917602539,
//                   150.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 56,
//               type: "text",
//               content: "ITEM DESCRIPTION",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 200.54002380371094,
//                 width: 54.56744384765625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 200.54002380371094, 508.4674377441406,
//                   206.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 57,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 129.73997497558594,
//                 width: 28.399248123168945,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 129.73997497558594, 50.29924774169922,
//                   136.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 58,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 129.73997497558594,
//                 width: 18.520767211914062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   212.6999969482422, 129.73997497558594, 231.22076416015625,
//                   136.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 59,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 129.73997497558594,
//                 width: 60.23126220703125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   144.3000030517578, 129.73997497558594, 204.53126525878906,
//                   136.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 60,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 212.54002380371094,
//                 width: 63.1925048828125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   144.3000030517578, 212.54002380371094, 207.4925079345703,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 61,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 313.5,
//                 y: 130.9399871826172,
//                 width: 37.547454833984375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   313.5, 130.9399871826172, 351.0474548339844,
//                   137.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 62,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 129.13999938964844,
//                 width: 77.8665771484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   483.3275146484375, 129.13999938964844, 561.194091796875,
//                   135.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 63,
//               type: "text",
//               content: "ADDITIONAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 138.13999938964844,
//                 width: 35.42574691772461,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 138.13999938964844, 71.72574615478516,
//                   144.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 64,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 140.54002380371094,
//                 width: 35.74774169921875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   97.5, 140.54002380371094, 133.24774169921875,
//                   146.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 65,
//               type: "text",
//               content: "MORTGAGEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 152.54002380371094,
//                 width: 37.66249084472656,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   97.5, 152.54002380371094, 135.16249084472656,
//                   158.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 66,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 212.54002380371094,
//                 width: 37.34049606323242,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 212.54002380371094, 73.64049530029297,
//                   218.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 67,
//               type: "text",
//               content: "EMPLOYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 174.13999938964844,
//                 width: 31.912494659423828,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 174.13999938964844, 68.21249389648438,
//                   180.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 68,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 140.54002380371094,
//                 width: 31.486968994140625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 140.54002380371094, 485.386962890625,
//                   146.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 69,
//               type: "text",
//               content: "BUILDING:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 140.54002380371094,
//                 width: 29.6815185546875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   525.9000244140625, 140.54002380371094, 555.58154296875,
//                   146.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 70,
//               type: "text",
//               content: "VEHICLE:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 152.54002380371094,
//                 width: 26.806488037109375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 152.54002380371094, 480.70648193359375,
//                   158.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 71,
//               type: "text",
//               content: "BOAT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 152.54002380371094,
//                 width: 17.135009765625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   525.9000244140625, 152.54002380371094, 543.0350341796875,
//                   158.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 72,
//               type: "text",
//               content: "ITEM CLASS:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 188.54002380371094,
//                 width: 36.696502685546875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 188.54002380371094, 490.59649658203125,
//                   194.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 73,
//               type: "text",
//               content: "ADDITIONAL INTEREST SCHEDULE",
//               coordinates: {
//                 x: 181.20249938964844,
//                 y: 47.501258850097656,
//                 width: 235.5649871826172,
//                 height: 15.358749389648438,
//                 bbox: [
//                   181.20249938964844, 47.501258850097656, 416.7674865722656,
//                   62.860008239746094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 13.75,
//                 color: 0
//               }
//             },
//             {
//               id: 74,
//               type: "text",
//               content: "DATE (MM/DD/YYYY)",
//               coordinates: {
//                 x: 522.563720703125,
//                 y: 44.54002380371094,
//                 width: 57.02288818359375,
//                 height: 6.422752380371094,
//                 bbox: [
//                   522.563720703125, 44.54002380371094, 579.5866088867188,
//                   50.96277618408203
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 75,
//               type: "text",
//               content: "SCHED #:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 176.54002380371094,
//                 width: 26.817962646484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   453.8999938964844, 176.54002380371094, 480.71795654296875,
//                   182.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 76,
//               type: "text",
//               content: "LENDER'S LOSS PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 200.54002380371094,
//                 width: 73.61149215698242,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   36.29999923706055, 200.54002380371094, 109.91149139404297,
//                   206.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 77,
//               type: "text",
//               content: "E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 356.5400085449219,
//                 width: 51.071502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 356.5400085449219, 350.1715087890625,
//                   362.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 78,
//               type: "text",
//               content: "REASON FOR INTEREST:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 356.5400085449219,
//                 width: 69.57499122619629,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 356.5400085449219, 91.47499084472656,
//                   362.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 79,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 312.1400146484375,
//                 width: 22.022499084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 312.1400146484375, 58.3224983215332,
//                   318.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 80,
//               type: "text",
//               content: "LEASEBACK",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 306.1400146484375,
//                 width: 35.75349044799805,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 306.1400146484375, 72.0534896850586,
//                   312.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 81,
//               type: "text",
//               content: "WARRANTY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 276.1400146484375,
//                 width: 33.200504302978516,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 276.1400146484375, 69.50050354003906,
//                   282.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 82,
//               type: "text",
//               content: "BREACH OF",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 270.1400146484375,
//                 width: 34.15500259399414,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 270.1400146484375, 70.45500183105469,
//                   276.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 83,
//               type: "text",
//               content: "TRUSTEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 308.5400085449219,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 308.5400085449219, 124.30648803710938, 314.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 84,
//               type: "text",
//               content: "REGISTRANT",
//               coordinates: {
//                 x: 97.5,
//                 y: 296.5400085449219,
//                 width: 37.34049987792969,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 296.5400085449219, 134.8404998779297, 302.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 85,
//               type: "text",
//               content: "PHONE (A/C, No, Ext):",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 344.5400085449219,
//                 width: 60.633697509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 344.5400085449219, 359.73370361328125,
//                   350.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 86,
//               type: "text",
//               content: "LIEN AMOUNT:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 344.5400085449219,
//                 width: 40.96299743652344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 344.5400085449219, 185.26300048828125,
//                   350.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 87,
//               type: "text",
//               content: "INTEREST END DATE:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 332.5400085449219,
//                 width: 60.846435546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 332.5400085449219, 359.9464416503906,
//                   338.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 88,
//               type: "text",
//               content: "ITEM:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 296.5400085449219,
//                 width: 15.63427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 296.5400085449219, 541.5343017578125,
//                   302.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 89,
//               type: "text",
//               content: "AIRPORT:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 284.5400085449219,
//                 width: 27.13421630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 284.5400085449219, 481.0342102050781,
//                   290.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 90,
//               type: "text",
//               content: "AIRCRAFT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 284.5400085449219,
//                 width: 30.6474609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 284.5400085449219, 556.5474853515625,
//                   290.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 91,
//               type: "text",
//               content: "CO-OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 284.5400085449219,
//                 width: 32.55649948120117,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 284.5400085449219, 68.85649871826172,
//                   290.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 92,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 97.5,
//                 y: 284.5400085449219,
//                 width: 22.022491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 284.5400085449219, 119.52249145507812, 290.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 93,
//               type: "text",
//               content: "SEND BILL",
//               coordinates: {
//                 x: 417.8999938964844,
//                 y: 250.9399871826172,
//                 width: 30.31396484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   417.8999938964844, 250.9399871826172, 448.2139587402344,
//                   257.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 94,
//               type: "text",
//               content: "POLICY",
//               coordinates: {
//                 x: 374.70001220703125,
//                 y: 250.9399871826172,
//                 width: 21.37847900390625,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   374.70001220703125, 250.9399871826172, 396.0784912109375,
//                   257.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 95,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 259.5,
//                 y: 249.73997497558594,
//                 width: 31.27996826171875,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   259.5, 249.73997497558594, 290.77996826171875,
//                   256.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 96,
//               type: "text",
//               content: "AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 300.1400146484375,
//                 width: 33.18899154663086,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 300.1400146484375, 69.4889907836914,
//                   306.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 97,
//               type: "text",
//               content: "INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 264.1400146484375,
//                 width: 25.857749938964844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 264.1400146484375, 62.15774917602539,
//                   270.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 98,
//               type: "text",
//               content: "ITEM DESCRIPTION",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 320.5400085449219,
//                 width: 54.56744384765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 320.5400085449219, 508.4674377441406,
//                   326.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 99,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 249.73997497558594,
//                 width: 28.399248123168945,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   21.899999618530273, 249.73997497558594, 50.29924774169922,
//                   256.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 100,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 249.73997497558594,
//                 width: 18.520767211914062,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   212.6999969482422, 249.73997497558594, 231.22076416015625,
//                   256.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 101,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 249.73997497558594,
//                 width: 60.23126220703125,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   144.3000030517578, 249.73997497558594, 204.53126525878906,
//                   256.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 102,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 332.5400085449219,
//                 width: 63.1925048828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 332.5400085449219, 207.4925079345703,
//                   338.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 103,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 313.5,
//                 y: 250.9399871826172,
//                 width: 37.547454833984375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   313.5, 250.9399871826172, 351.0474548339844,
//                   257.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 104,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 249.13999938964844,
//                 width: 77.8665771484375,
//                 height: 6.4227447509765625,
//                 bbox: [
//                   483.3275146484375, 249.13999938964844, 561.194091796875,
//                   255.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 105,
//               type: "text",
//               content: "ADDITIONAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 258.1400146484375,
//                 width: 35.42574691772461,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 258.1400146484375, 71.72574615478516,
//                   264.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 106,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 260.5400390625,
//                 width: 35.74774169921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 260.5400390625, 133.24774169921875, 266.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 107,
//               type: "text",
//               content: "MORTGAGEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 272.5400390625,
//                 width: 37.66249084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 272.5400390625, 135.16249084472656, 278.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 108,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 332.5400085449219,
//                 width: 37.34049606323242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 332.5400085449219, 73.64049530029297,
//                   338.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 109,
//               type: "text",
//               content: "EMPLOYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 294.1400146484375,
//                 width: 31.912494659423828,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 294.1400146484375, 68.21249389648438,
//                   300.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 110,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 260.5400390625,
//                 width: 31.486968994140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 260.5400390625, 485.386962890625,
//                   266.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 111,
//               type: "text",
//               content: "BUILDING:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 260.5400390625,
//                 width: 29.6815185546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 260.5400390625, 555.58154296875,
//                   266.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 112,
//               type: "text",
//               content: "VEHICLE:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 272.5400390625,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 272.5400390625, 480.70648193359375,
//                   278.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 113,
//               type: "text",
//               content: "BOAT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 272.5400390625,
//                 width: 17.135009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 272.5400390625, 543.0350341796875,
//                   278.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 114,
//               type: "text",
//               content: "ITEM CLASS:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 308.5400085449219,
//                 width: 36.696502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 308.5400085449219, 490.59649658203125,
//                   314.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 115,
//               type: "text",
//               content: "SCHED #:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 296.5400085449219,
//                 width: 26.817962646484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 296.5400085449219, 480.71795654296875,
//                   302.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 116,
//               type: "text",
//               content: "LENDER'S LOSS PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 320.5400085449219,
//                 width: 73.61149215698242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 320.5400085449219, 109.91149139404297,
//                   326.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 117,
//               type: "text",
//               content: "E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 476.5400085449219,
//                 width: 51.071502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 476.5400085449219, 350.1715087890625,
//                   482.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 118,
//               type: "text",
//               content: "REASON FOR INTEREST:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 476.5400085449219,
//                 width: 69.57499122619629,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 476.5400085449219, 91.47499084472656,
//                   482.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 119,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 432.1400146484375,
//                 width: 22.022499084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 432.1400146484375, 58.3224983215332,
//                   438.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 120,
//               type: "text",
//               content: "LEASEBACK",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 426.1400146484375,
//                 width: 35.75349044799805,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 426.1400146484375, 72.0534896850586,
//                   432.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 121,
//               type: "text",
//               content: "WARRANTY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 396.1400146484375,
//                 width: 33.200504302978516,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 396.1400146484375, 69.50050354003906,
//                   402.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 122,
//               type: "text",
//               content: "BREACH OF",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 390.1400146484375,
//                 width: 34.15500259399414,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 390.1400146484375, 70.45500183105469,
//                   396.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 123,
//               type: "text",
//               content: "TRUSTEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 428.5400085449219,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 428.5400085449219, 124.30648803710938, 434.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 124,
//               type: "text",
//               content: "REGISTRANT",
//               coordinates: {
//                 x: 97.5,
//                 y: 416.5400085449219,
//                 width: 37.34049987792969,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 416.5400085449219, 134.8404998779297, 422.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 125,
//               type: "text",
//               content: "PHONE (A/C, No, Ext):",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 464.5400085449219,
//                 width: 60.633697509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 464.5400085449219, 359.73370361328125,
//                   470.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 126,
//               type: "text",
//               content: "LIEN AMOUNT:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 464.5400085449219,
//                 width: 40.96299743652344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 464.5400085449219, 185.26300048828125,
//                   470.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 127,
//               type: "text",
//               content: "INTEREST END DATE:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 452.5400085449219,
//                 width: 60.846435546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 452.5400085449219, 359.9464416503906,
//                   458.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 128,
//               type: "text",
//               content: "ITEM:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 416.5400085449219,
//                 width: 15.63427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 416.5400085449219, 541.5343017578125,
//                   422.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 129,
//               type: "text",
//               content: "AIRPORT:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 404.5400085449219,
//                 width: 27.13421630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 404.5400085449219, 481.0342102050781,
//                   410.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 130,
//               type: "text",
//               content: "AIRCRAFT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 404.5400085449219,
//                 width: 30.6474609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 404.5400085449219, 556.5474853515625,
//                   410.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 131,
//               type: "text",
//               content: "CO-OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 404.5400085449219,
//                 width: 32.55649948120117,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 404.5400085449219, 68.85649871826172,
//                   410.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 132,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 97.5,
//                 y: 404.5400085449219,
//                 width: 22.022491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 404.5400085449219, 119.52249145507812, 410.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 133,
//               type: "text",
//               content: "SEND BILL",
//               coordinates: {
//                 x: 417.8999938964844,
//                 y: 370.94000244140625,
//                 width: 30.31396484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   417.8999938964844, 370.94000244140625, 448.2139587402344,
//                   377.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 134,
//               type: "text",
//               content: "POLICY",
//               coordinates: {
//                 x: 374.70001220703125,
//                 y: 370.94000244140625,
//                 width: 21.37847900390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   374.70001220703125, 370.94000244140625, 396.0784912109375,
//                   377.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 135,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 259.5,
//                 y: 369.7400207519531,
//                 width: 31.27996826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   259.5, 369.7400207519531, 290.77996826171875,
//                   376.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 136,
//               type: "text",
//               content: "AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 420.1400146484375,
//                 width: 33.18899154663086,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 420.1400146484375, 69.4889907836914,
//                   426.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 137,
//               type: "text",
//               content: "INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 384.1400146484375,
//                 width: 25.857749938964844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 384.1400146484375, 62.15774917602539,
//                   390.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 138,
//               type: "text",
//               content: "ITEM DESCRIPTION",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 440.5400085449219,
//                 width: 54.56744384765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 440.5400085449219, 508.4674377441406,
//                   446.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 139,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 369.7400207519531,
//                 width: 28.399248123168945,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 369.7400207519531, 50.29924774169922,
//                   376.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 140,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 369.7400207519531,
//                 width: 18.520767211914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   212.6999969482422, 369.7400207519531, 231.22076416015625,
//                   376.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 141,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 369.7400207519531,
//                 width: 60.23126220703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 369.7400207519531, 204.53126525878906,
//                   376.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 142,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 452.5400085449219,
//                 width: 63.1925048828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 452.5400085449219, 207.4925079345703,
//                   458.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 143,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 313.5,
//                 y: 370.94000244140625,
//                 width: 37.547454833984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   313.5, 370.94000244140625, 351.0474548339844,
//                   377.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 144,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 369.1400146484375,
//                 width: 77.8665771484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   483.3275146484375, 369.1400146484375, 561.194091796875,
//                   375.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 145,
//               type: "text",
//               content: "ADDITIONAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 378.1400146484375,
//                 width: 35.42574691772461,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 378.1400146484375, 71.72574615478516,
//                   384.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 146,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 380.5400085449219,
//                 width: 35.74774169921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 380.5400085449219, 133.24774169921875, 386.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 147,
//               type: "text",
//               content: "MORTGAGEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 392.5400085449219,
//                 width: 37.66249084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 392.5400085449219, 135.16249084472656, 398.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 148,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 452.5400085449219,
//                 width: 37.34049606323242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 452.5400085449219, 73.64049530029297,
//                   458.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 149,
//               type: "text",
//               content: "EMPLOYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 414.1400146484375,
//                 width: 31.912494659423828,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 414.1400146484375, 68.21249389648438,
//                   420.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 150,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 380.5400085449219,
//                 width: 31.486968994140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 380.5400085449219, 485.386962890625,
//                   386.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 151,
//               type: "text",
//               content: "BUILDING:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 380.5400085449219,
//                 width: 29.6815185546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 380.5400085449219, 555.58154296875,
//                   386.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 152,
//               type: "text",
//               content: "VEHICLE:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 392.5400085449219,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 392.5400085449219, 480.70648193359375,
//                   398.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 153,
//               type: "text",
//               content: "BOAT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 392.5400085449219,
//                 width: 17.135009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 392.5400085449219, 543.0350341796875,
//                   398.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 154,
//               type: "text",
//               content: "ITEM CLASS:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 428.5400085449219,
//                 width: 36.696502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 428.5400085449219, 490.59649658203125,
//                   434.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 155,
//               type: "text",
//               content: "SCHED #:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 416.5400085449219,
//                 width: 26.817962646484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 416.5400085449219, 480.71795654296875,
//                   422.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 156,
//               type: "text",
//               content: "LENDER'S LOSS PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 440.5400085449219,
//                 width: 73.61149215698242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 440.5400085449219, 109.91149139404297,
//                   446.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 157,
//               type: "text",
//               content: "E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 596.5400390625,
//                 width: 51.071502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 596.5400390625, 350.1715087890625,
//                   602.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 158,
//               type: "text",
//               content: "REASON FOR INTEREST:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 596.5400390625,
//                 width: 69.57499122619629,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 596.5400390625, 91.47499084472656,
//                   602.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 159,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 552.1400146484375,
//                 width: 22.022499084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 552.1400146484375, 58.3224983215332,
//                   558.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 160,
//               type: "text",
//               content: "LEASEBACK",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 546.1400146484375,
//                 width: 35.75349044799805,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 546.1400146484375, 72.0534896850586,
//                   552.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 161,
//               type: "text",
//               content: "WARRANTY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 516.1400146484375,
//                 width: 33.200504302978516,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 516.1400146484375, 69.50050354003906,
//                   522.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 162,
//               type: "text",
//               content: "BREACH OF",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 510.1400146484375,
//                 width: 34.15500259399414,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 510.1400146484375, 70.45500183105469,
//                   516.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 163,
//               type: "text",
//               content: "TRUSTEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 548.5400390625,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 548.5400390625, 124.30648803710938, 554.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 164,
//               type: "text",
//               content: "REGISTRANT",
//               coordinates: {
//                 x: 97.5,
//                 y: 536.5400390625,
//                 width: 37.34049987792969,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 536.5400390625, 134.8404998779297, 542.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 165,
//               type: "text",
//               content: "PHONE (A/C, No, Ext):",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 584.5400390625,
//                 width: 60.633697509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 584.5400390625, 359.73370361328125,
//                   590.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 166,
//               type: "text",
//               content: "LIEN AMOUNT:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 584.5400390625,
//                 width: 40.96299743652344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 584.5400390625, 185.26300048828125,
//                   590.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 167,
//               type: "text",
//               content: "INTEREST END DATE:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 572.5400390625,
//                 width: 60.846435546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 572.5400390625, 359.9464416503906,
//                   578.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 168,
//               type: "text",
//               content: "ITEM:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 536.5400390625,
//                 width: 15.63427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 536.5400390625, 541.5343017578125,
//                   542.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 169,
//               type: "text",
//               content: "AIRPORT:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 524.5400390625,
//                 width: 27.13421630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 524.5400390625, 481.0342102050781,
//                   530.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 170,
//               type: "text",
//               content: "AIRCRAFT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 524.5400390625,
//                 width: 30.6474609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 524.5400390625, 556.5474853515625,
//                   530.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 171,
//               type: "text",
//               content: "CO-OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 524.5400390625,
//                 width: 32.55649948120117,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 524.5400390625, 68.85649871826172,
//                   530.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 172,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 97.5,
//                 y: 524.5400390625,
//                 width: 22.022491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 524.5400390625, 119.52249145507812, 530.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 173,
//               type: "text",
//               content: "SEND BILL",
//               coordinates: {
//                 x: 417.8999938964844,
//                 y: 490.94000244140625,
//                 width: 30.31396484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   417.8999938964844, 490.94000244140625, 448.2139587402344,
//                   497.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 174,
//               type: "text",
//               content: "POLICY",
//               coordinates: {
//                 x: 374.70001220703125,
//                 y: 490.94000244140625,
//                 width: 21.37847900390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   374.70001220703125, 490.94000244140625, 396.0784912109375,
//                   497.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 175,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 259.5,
//                 y: 489.7400207519531,
//                 width: 31.27996826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   259.5, 489.7400207519531, 290.77996826171875,
//                   496.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 176,
//               type: "text",
//               content: "AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 540.1400146484375,
//                 width: 33.18899154663086,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 540.1400146484375, 69.4889907836914,
//                   546.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 177,
//               type: "text",
//               content: "INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 504.1400146484375,
//                 width: 25.857749938964844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 504.1400146484375, 62.15774917602539,
//                   510.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 178,
//               type: "text",
//               content: "ITEM DESCRIPTION",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 560.5400390625,
//                 width: 54.56744384765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 560.5400390625, 508.4674377441406,
//                   566.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 179,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 489.7400207519531,
//                 width: 28.399248123168945,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 489.7400207519531, 50.29924774169922,
//                   496.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 180,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 489.7400207519531,
//                 width: 18.520767211914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   212.6999969482422, 489.7400207519531, 231.22076416015625,
//                   496.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 181,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 489.7400207519531,
//                 width: 60.23126220703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 489.7400207519531, 204.53126525878906,
//                   496.1627502441406
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 182,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 572.5400390625,
//                 width: 63.1925048828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 572.5400390625, 207.4925079345703,
//                   578.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 183,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 313.5,
//                 y: 490.94000244140625,
//                 width: 37.547454833984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   313.5, 490.94000244140625, 351.0474548339844,
//                   497.36273193359375
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 184,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 489.1400146484375,
//                 width: 77.8665771484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   483.3275146484375, 489.1400146484375, 561.194091796875,
//                   495.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 185,
//               type: "text",
//               content: "ADDITIONAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 498.1400146484375,
//                 width: 35.42574691772461,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 498.1400146484375, 71.72574615478516,
//                   504.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 186,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 500.5400085449219,
//                 width: 35.74774169921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 500.5400085449219, 133.24774169921875, 506.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 187,
//               type: "text",
//               content: "MORTGAGEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 512.5400390625,
//                 width: 37.66249084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 512.5400390625, 135.16249084472656, 518.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 188,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 572.5400390625,
//                 width: 37.34049606323242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 572.5400390625, 73.64049530029297,
//                   578.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 189,
//               type: "text",
//               content: "EMPLOYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 534.1400146484375,
//                 width: 31.912494659423828,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 534.1400146484375, 68.21249389648438,
//                   540.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 190,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 500.5400085449219,
//                 width: 31.486968994140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 500.5400085449219, 485.386962890625,
//                   506.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 191,
//               type: "text",
//               content: "BUILDING:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 500.5400085449219,
//                 width: 29.6815185546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 500.5400085449219, 555.58154296875,
//                   506.9627380371094
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 192,
//               type: "text",
//               content: "VEHICLE:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 512.5400390625,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 512.5400390625, 480.70648193359375,
//                   518.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 193,
//               type: "text",
//               content: "BOAT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 512.5400390625,
//                 width: 17.135009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 512.5400390625, 543.0350341796875,
//                   518.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 194,
//               type: "text",
//               content: "ITEM CLASS:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 548.5400390625,
//                 width: 36.696502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 548.5400390625, 490.59649658203125,
//                   554.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 195,
//               type: "text",
//               content: "SCHED #:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 536.5400390625,
//                 width: 26.817962646484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 536.5400390625, 480.71795654296875,
//                   542.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 196,
//               type: "text",
//               content: "LENDER'S LOSS PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 560.5400390625,
//                 width: 73.61149215698242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 560.5400390625, 109.91149139404297,
//                   566.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 197,
//               type: "text",
//               content: "E-MAIL ADDRESS:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 716.5400390625,
//                 width: 51.071502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 716.5400390625, 350.1715087890625,
//                   722.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 198,
//               type: "text",
//               content: "REASON FOR INTEREST:",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 716.5400390625,
//                 width: 69.57499122619629,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 716.5400390625, 91.47499084472656,
//                   722.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 199,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 672.1400146484375,
//                 width: 22.022499084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 672.1400146484375, 58.3224983215332,
//                   678.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 200,
//               type: "text",
//               content: "LEASEBACK",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 666.1400146484375,
//                 width: 35.75349044799805,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 666.1400146484375, 72.0534896850586,
//                   672.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 201,
//               type: "text",
//               content: "WARRANTY",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 636.1400146484375,
//                 width: 33.200504302978516,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 636.1400146484375, 69.50050354003906,
//                   642.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 202,
//               type: "text",
//               content: "BREACH OF",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 630.1400146484375,
//                 width: 34.15500259399414,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 630.1400146484375, 70.45500183105469,
//                   636.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 203,
//               type: "text",
//               content: "TRUSTEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 668.5400390625,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 668.5400390625, 124.30648803710938, 674.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 204,
//               type: "text",
//               content: "REGISTRANT",
//               coordinates: {
//                 x: 97.5,
//                 y: 656.5400390625,
//                 width: 37.34049987792969,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 656.5400390625, 134.8404998779297, 662.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 205,
//               type: "text",
//               content: "PHONE (A/C, No, Ext):",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 704.5400390625,
//                 width: 60.633697509765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 704.5400390625, 359.73370361328125,
//                   710.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 206,
//               type: "text",
//               content: "LIEN AMOUNT:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 704.5400390625,
//                 width: 40.96299743652344,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 704.5400390625, 185.26300048828125,
//                   710.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 207,
//               type: "text",
//               content: "INTEREST END DATE:",
//               coordinates: {
//                 x: 299.1000061035156,
//                 y: 692.5400390625,
//                 width: 60.846435546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   299.1000061035156, 692.5400390625, 359.9464416503906,
//                   698.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 208,
//               type: "text",
//               content: "ITEM:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 656.5400390625,
//                 width: 15.63427734375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 656.5400390625, 541.5343017578125,
//                   662.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 209,
//               type: "text",
//               content: "AIRPORT:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 644.5400390625,
//                 width: 27.13421630859375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 644.5400390625, 481.0342102050781,
//                   650.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 210,
//               type: "text",
//               content: "AIRCRAFT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 644.5400390625,
//                 width: 30.6474609375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 644.5400390625, 556.5474853515625,
//                   650.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 211,
//               type: "text",
//               content: "CO-OWNER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 644.5400390625,
//                 width: 32.55649948120117,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 644.5400390625, 68.85649871826172,
//                   650.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 212,
//               type: "text",
//               content: "OWNER",
//               coordinates: {
//                 x: 97.5,
//                 y: 644.5400390625,
//                 width: 22.022491455078125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 644.5400390625, 119.52249145507812, 650.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 213,
//               type: "text",
//               content: "SEND BILL",
//               coordinates: {
//                 x: 417.8999938964844,
//                 y: 610.9400024414062,
//                 width: 30.31396484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   417.8999938964844, 610.9400024414062, 448.2139587402344,
//                   617.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 214,
//               type: "text",
//               content: "POLICY",
//               coordinates: {
//                 x: 374.70001220703125,
//                 y: 610.9400024414062,
//                 width: 21.37847900390625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   374.70001220703125, 610.9400024414062, 396.0784912109375,
//                   617.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 215,
//               type: "text",
//               content: "EVIDENCE:",
//               coordinates: {
//                 x: 259.5,
//                 y: 609.739990234375,
//                 width: 31.27996826171875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   259.5, 609.739990234375, 290.77996826171875, 616.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 216,
//               type: "text",
//               content: "AS LESSOR",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 660.1400146484375,
//                 width: 33.18899154663086,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 660.1400146484375, 69.4889907836914,
//                   666.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 217,
//               type: "text",
//               content: "INSURED",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 624.1400146484375,
//                 width: 25.857749938964844,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 624.1400146484375, 62.15774917602539,
//                   630.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 218,
//               type: "text",
//               content: "ITEM DESCRIPTION",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 680.5400390625,
//                 width: 54.56744384765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 680.5400390625, 508.4674377441406,
//                   686.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 219,
//               type: "text",
//               content: "INTEREST",
//               coordinates: {
//                 x: 21.899999618530273,
//                 y: 609.739990234375,
//                 width: 28.399248123168945,
//                 height: 6.4227294921875,
//                 bbox: [
//                   21.899999618530273, 609.739990234375, 50.29924774169922,
//                   616.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 220,
//               type: "text",
//               content: "RANK:",
//               coordinates: {
//                 x: 212.6999969482422,
//                 y: 609.739990234375,
//                 width: 18.520767211914062,
//                 height: 6.4227294921875,
//                 bbox: [
//                   212.6999969482422, 609.739990234375, 231.22076416015625,
//                   616.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 221,
//               type: "text",
//               content: "NAME AND ADDRESS",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 609.739990234375,
//                 width: 60.23126220703125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 609.739990234375, 204.53126525878906,
//                   616.1627197265625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 222,
//               type: "text",
//               content: "REFERENCE / LOAN #:",
//               coordinates: {
//                 x: 144.3000030517578,
//                 y: 692.5400390625,
//                 width: 63.1925048828125,
//                 height: 6.4227294921875,
//                 bbox: [
//                   144.3000030517578, 692.5400390625, 207.4925079345703,
//                   698.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 223,
//               type: "text",
//               content: "CERTIFICATE",
//               coordinates: {
//                 x: 313.5,
//                 y: 610.9400024414062,
//                 width: 37.547454833984375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   313.5, 610.9400024414062, 351.0474548339844, 617.3627319335938
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 224,
//               type: "text",
//               content: "INTEREST IN ITEM NUMBER",
//               coordinates: {
//                 x: 483.3275146484375,
//                 y: 609.1400146484375,
//                 width: 77.8665771484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   483.3275146484375, 609.1400146484375, 561.194091796875,
//                   615.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 225,
//               type: "text",
//               content: "ADDITIONAL",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 618.1400146484375,
//                 width: 35.42574691772461,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 618.1400146484375, 71.72574615478516,
//                   624.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 226,
//               type: "text",
//               content: "LOSS PAYEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 620.5400390625,
//                 width: 35.74774169921875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 620.5400390625, 133.24774169921875, 626.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 227,
//               type: "text",
//               content: "MORTGAGEE",
//               coordinates: {
//                 x: 97.5,
//                 y: 632.5400390625,
//                 width: 37.66249084472656,
//                 height: 6.4227294921875,
//                 bbox: [
//                   97.5, 632.5400390625, 135.16249084472656, 638.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 228,
//               type: "text",
//               content: "LIENHOLDER",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 692.5400390625,
//                 width: 37.34049606323242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 692.5400390625, 73.64049530029297,
//                   698.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 229,
//               type: "text",
//               content: "EMPLOYEE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 654.1400146484375,
//                 width: 31.912494659423828,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 654.1400146484375, 68.21249389648438,
//                   660.562744140625
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 230,
//               type: "text",
//               content: "LOCATION:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 620.5400390625,
//                 width: 31.486968994140625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 620.5400390625, 485.386962890625,
//                   626.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 231,
//               type: "text",
//               content: "BUILDING:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 620.5400390625,
//                 width: 29.6815185546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 620.5400390625, 555.58154296875,
//                   626.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 232,
//               type: "text",
//               content: "VEHICLE:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 632.5400390625,
//                 width: 26.806488037109375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 632.5400390625, 480.70648193359375,
//                   638.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 233,
//               type: "text",
//               content: "BOAT:",
//               coordinates: {
//                 x: 525.9000244140625,
//                 y: 632.5400390625,
//                 width: 17.135009765625,
//                 height: 6.4227294921875,
//                 bbox: [
//                   525.9000244140625, 632.5400390625, 543.0350341796875,
//                   638.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 234,
//               type: "text",
//               content: "ITEM CLASS:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 668.5400390625,
//                 width: 36.696502685546875,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 668.5400390625, 490.59649658203125,
//                   674.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 235,
//               type: "text",
//               content: "SCHED #:",
//               coordinates: {
//                 x: 453.8999938964844,
//                 y: 656.5400390625,
//                 width: 26.817962646484375,
//                 height: 6.4227294921875,
//                 bbox: [
//                   453.8999938964844, 656.5400390625, 480.71795654296875,
//                   662.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             },
//             {
//               id: 236,
//               type: "text",
//               content: "LENDER'S LOSS PAYABLE",
//               coordinates: {
//                 x: 36.29999923706055,
//                 y: 680.5400390625,
//                 width: 73.61149215698242,
//                 height: 6.4227294921875,
//                 bbox: [
//                   36.29999923706055, 680.5400390625, 109.91149139404297,
//                   686.9627685546875
//                 ]
//               },
//               properties: {
//                 font: "Arial-BoldMT",
//                 font_size: 5.75,
//                 color: 0
//               }
//             }
//           ],
//           tables: [
//             {
//               id: 0,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.28,
//                 y: 41.26749469857623,
//                 width: 577.68,
//                 height: 73.41775219630415,
//                 bbox: [
//                   17.28, 41.26749469857623, 594.9599999999999,
//                   114.68524689488038
//                 ]
//               },
//               properties: {
//                 rows: 3,
//                 columns: 5,
//                 accuracy: 89.795
//               }
//             },
//             {
//               id: 1,
//               type: "table",
//               detection_method: "lattice",
//               coordinates: {
//                 x: 17.52,
//                 y: 125.24204786428356,
//                 width: 577.4399999999999,
//                 height: 619.4922750681611,
//                 bbox: [
//                   17.52, 125.24204786428356, 594.9599999999999,
//                   744.7343229324447
//                 ]
//               },
//               properties: {
//                 rows: 51,
//                 columns: 14,
//                 accuracy: 92.259
//               }
//             }
//           ]
//         },
//         statistics: {
//           text_count: 237,
//           table_count: 2,
//           total_elements: 239
//         }
//       }
//     ],
//     summary: {
//       total_text_elements: 3291,
//       total_tables: 48,
//       total_elements: 3339
//     }
//   }
// };
